//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class AdminClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getRolePermissionsById(roleId: number): Observable<RolePermissionsDto[]> {
        let url_ = this.baseUrl + "/api/Admin/GetRolePermissionsById/{roleId}";
        if (roleId === undefined || roleId === null)
            throw new globalThis.Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRolePermissionsById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRolePermissionsById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RolePermissionsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RolePermissionsDto[]>;
        }));
    }

    protected processGetRolePermissionsById(response: HttpResponseBase): Observable<RolePermissionsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RolePermissionsDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRoles(): Observable<RoleDto[]> {
        let url_ = this.baseUrl + "/api/Admin/GetRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto[]>;
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<RoleDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RoleDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPermissionGroups(): Observable<PermissionGroupDto[]> {
        let url_ = this.baseUrl + "/api/Admin/GetPermissionGroups";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPermissionGroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPermissionGroups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PermissionGroupDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PermissionGroupDto[]>;
        }));
    }

    protected processGetPermissionGroups(response: HttpResponseBase): Observable<PermissionGroupDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PermissionGroupDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createRolePermissions(command: CreateRolePermissionsCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Admin/CreateRolePermissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateRolePermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateRolePermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processCreateRolePermissions(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPotentialDuplicatePersonMatches(): Observable<PotentialDuplicatePersonMatchPairDto[]> {
        let url_ = this.baseUrl + "/api/Admin/GetPotentialDuplicatePersonMatches";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPotentialDuplicatePersonMatches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPotentialDuplicatePersonMatches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PotentialDuplicatePersonMatchPairDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PotentialDuplicatePersonMatchPairDto[]>;
        }));
    }

    protected processGetPotentialDuplicatePersonMatches(response: HttpResponseBase): Observable<PotentialDuplicatePersonMatchPairDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PotentialDuplicatePersonMatchPairDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLinkedEducatorsForMerge(): Observable<LinkedEducatorMatchPairDto[]> {
        let url_ = this.baseUrl + "/api/Admin/GetLinkedEducatorsForMerge";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLinkedEducatorsForMerge(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLinkedEducatorsForMerge(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LinkedEducatorMatchPairDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LinkedEducatorMatchPairDto[]>;
        }));
    }

    protected processGetLinkedEducatorsForMerge(response: HttpResponseBase): Observable<LinkedEducatorMatchPairDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LinkedEducatorMatchPairDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    rejectPotentialDuplicatePersonMatch(command: RejectPotentialDuplicatePersonMatchCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Admin/RejectPotentialDuplicatePersonMatch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRejectPotentialDuplicatePersonMatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRejectPotentialDuplicatePersonMatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processRejectPotentialDuplicatePersonMatch(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkMergeConflicts(command: CheckMergeConflictsCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Admin/CheckMergeConflicts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckMergeConflicts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckMergeConflicts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processCheckMergeConflicts(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    mergeDuplicateEducators(command: MergeDuplicateEducatorsCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Admin/MergeDuplicateEducators";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMergeDuplicateEducators(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMergeDuplicateEducators(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processMergeDuplicateEducators(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getExistingQualificationPaths(): Observable<QualificationPathConfigListItemDto[]> {
        let url_ = this.baseUrl + "/api/Admin/GetExistingQualificationPaths";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExistingQualificationPaths(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExistingQualificationPaths(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QualificationPathConfigListItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QualificationPathConfigListItemDto[]>;
        }));
    }

    protected processGetExistingQualificationPaths(response: HttpResponseBase): Observable<QualificationPathConfigListItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QualificationPathConfigListItemDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getQualificationPath(qualificationPathId?: number | undefined): Observable<QualificationPathConfigDto> {
        let url_ = this.baseUrl + "/api/Admin/GetQualificationPath?";
        if (qualificationPathId === null)
            throw new globalThis.Error("The parameter 'qualificationPathId' cannot be null.");
        else if (qualificationPathId !== undefined)
            url_ += "qualificationPathId=" + encodeURIComponent("" + qualificationPathId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQualificationPath(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQualificationPath(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QualificationPathConfigDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QualificationPathConfigDto>;
        }));
    }

    protected processGetQualificationPath(response: HttpResponseBase): Observable<QualificationPathConfigDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QualificationPathConfigDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteQualificationPath(command: DeleteQualificationPathCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Admin/DeleteQualificationPath";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteQualificationPath(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteQualificationPath(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteQualificationPath(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addOrUpdateQualificationPath(command: AddOrUpdateQualificationPathCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Admin/AddOrUpdateQualificationPath";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateQualificationPath(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateQualificationPath(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddOrUpdateQualificationPath(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getQualificationPathCodeTables(): Observable<QualificationPathCodeTablesDto> {
        let url_ = this.baseUrl + "/api/Admin";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQualificationPathCodeTables(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQualificationPathCodeTables(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QualificationPathCodeTablesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QualificationPathCodeTablesDto>;
        }));
    }

    protected processGetQualificationPathCodeTables(response: HttpResponseBase): Observable<QualificationPathCodeTablesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QualificationPathCodeTablesDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEvalCodeTables(query: GetEvalCodeTablesQuery): Observable<EvalCodeTablesDto> {
        let url_ = this.baseUrl + "/api/Admin/GetEvalCodeTables";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEvalCodeTables(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEvalCodeTables(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EvalCodeTablesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EvalCodeTablesDto>;
        }));
    }

    protected processGetEvalCodeTables(response: HttpResponseBase): Observable<EvalCodeTablesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EvalCodeTablesDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getExistingEvaluationsList(): Observable<EvaluationListItemDto[]> {
        let url_ = this.baseUrl + "/api/Admin/GetExistingEvaluationsList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExistingEvaluationsList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExistingEvaluationsList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EvaluationListItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EvaluationListItemDto[]>;
        }));
    }

    protected processGetExistingEvaluationsList(response: HttpResponseBase): Observable<EvaluationListItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EvaluationListItemDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEvaluation(id: number): Observable<EvaluationDto> {
        let url_ = this.baseUrl + "/api/Admin/GetEvaluation/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEvaluation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEvaluation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EvaluationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EvaluationDto>;
        }));
    }

    protected processGetEvaluation(response: HttpResponseBase): Observable<EvaluationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EvaluationDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEvalDenialStatutes(query: GetEvalDenialStatutesQuery): Observable<SimpleCodeDescriptionDto[]> {
        let url_ = this.baseUrl + "/api/Admin/GetEvalDenialStatutes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEvalDenialStatutes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEvalDenialStatutes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleCodeDescriptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleCodeDescriptionDto[]>;
        }));
    }

    protected processGetEvalDenialStatutes(response: HttpResponseBase): Observable<SimpleCodeDescriptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimpleCodeDescriptionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveEvaluation(command: CreateOrUpdateEvaluationCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Admin/SaveEvaluation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveEvaluation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveEvaluation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSaveEvaluation(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteEvaluation(command: DeleteEvaluationCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Admin/DeleteEvaluation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteEvaluation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEvaluation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteEvaluation(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllowableDeficiencyCodes(): Observable<SimpleCodeDescriptionDto[]> {
        let url_ = this.baseUrl + "/api/Admin/GetAllowableDeficiencyCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllowableDeficiencyCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllowableDeficiencyCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleCodeDescriptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleCodeDescriptionDto[]>;
        }));
    }

    protected processGetAllowableDeficiencyCodes(response: HttpResponseBase): Observable<SimpleCodeDescriptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimpleCodeDescriptionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCurrentSystemLockState(): Observable<CurrentSystemLockStateDto> {
        let url_ = this.baseUrl + "/api/Admin/GetCurrentSystemLockState";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentSystemLockState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentSystemLockState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurrentSystemLockStateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurrentSystemLockStateDto>;
        }));
    }

    protected processGetCurrentSystemLockState(response: HttpResponseBase): Observable<CurrentSystemLockStateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CurrentSystemLockStateDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    lockSystem(command: LockSystemCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Admin/LockSystem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLockSystem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLockSystem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processLockSystem(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    unlockSystem(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Admin/UnlockSystem";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlockSystem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlockSystem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUnlockSystem(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    endYear(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Admin/EndYear";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEndYear(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEndYear(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processEndYear(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    beginYear(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Admin/BeginYear";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBeginYear(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBeginYear(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processBeginYear(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCurrentWorkingOperationalYear(): Observable<CurrentOperationalYearStateDto> {
        let url_ = this.baseUrl + "/api/Admin/GetCurrentWorkingOperationalYear";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentWorkingOperationalYear(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentWorkingOperationalYear(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurrentOperationalYearStateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurrentOperationalYearStateDto>;
        }));
    }

    protected processGetCurrentWorkingOperationalYear(response: HttpResponseBase): Observable<CurrentOperationalYearStateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CurrentOperationalYearStateDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getYearBeginProgressStats(): Observable<YearBeginProgressStatsDto> {
        let url_ = this.baseUrl + "/api/Admin/GetYearBeginProgressStats";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetYearBeginProgressStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetYearBeginProgressStats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<YearBeginProgressStatsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<YearBeginProgressStatsDto>;
        }));
    }

    protected processGetYearBeginProgressStats(response: HttpResponseBase): Observable<YearBeginProgressStatsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as YearBeginProgressStatsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getYearEndProgressStats(): Observable<YearEndProgressStatsDto> {
        let url_ = this.baseUrl + "/api/Admin/GetYearEndProgressStats";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetYearEndProgressStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetYearEndProgressStats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<YearEndProgressStatsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<YearEndProgressStatsDto>;
        }));
    }

    protected processGetYearEndProgressStats(response: HttpResponseBase): Observable<YearEndProgressStatsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as YearEndProgressStatsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLeaEdOrgChanges(): Observable<LeaEdOrgChangeResultListDto> {
        let url_ = this.baseUrl + "/api/Admin/GetLeaEdOrgChanges";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaEdOrgChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaEdOrgChanges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaEdOrgChangeResultListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaEdOrgChangeResultListDto>;
        }));
    }

    protected processGetLeaEdOrgChanges(response: HttpResponseBase): Observable<LeaEdOrgChangeResultListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LeaEdOrgChangeResultListDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    refreshEdOrgSync(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Admin/RefreshEdOrgSync";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshEdOrgSync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshEdOrgSync(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processRefreshEdOrgSync(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPositionContentAreasForACReevaluation(): Observable<SimpleSelectOptionDto[]> {
        let url_ = this.baseUrl + "/api/Admin/GetPositionContentAreasForACReevaluation";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPositionContentAreasForACReevaluation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPositionContentAreasForACReevaluation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleSelectOptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleSelectOptionDto[]>;
        }));
    }

    protected processGetPositionContentAreasForACReevaluation(response: HttpResponseBase): Observable<SimpleSelectOptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimpleSelectOptionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCountActiveStaffAssignmentsForPositionContentArea(positionContentAreaId?: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/Admin/GetCountActiveStaffAssignmentsForPositionContentArea?";
        if (positionContentAreaId === null)
            throw new globalThis.Error("The parameter 'positionContentAreaId' cannot be null.");
        else if (positionContentAreaId !== undefined)
            url_ += "positionContentAreaId=" + encodeURIComponent("" + positionContentAreaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountActiveStaffAssignmentsForPositionContentArea(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountActiveStaffAssignmentsForPositionContentArea(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetCountActiveStaffAssignmentsForPositionContentArea(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    reevaluateACForPositionContentArea(command: ReevaluateACForPositionContentAreaCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Admin/ReevaluateACForPositionContentArea";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReevaluateACForPositionContentArea(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReevaluateACForPositionContentArea(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processReevaluateACForPositionContentArea(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    evaluateACForNewlyAddedAssignments(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Admin/EvaluateACForNewlyAddedAssignments";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEvaluateACForNewlyAddedAssignments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEvaluateACForNewlyAddedAssignments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processEvaluateACForNewlyAddedAssignments(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getStaffAssignmentACResearch(staffAssignmentId?: number | undefined): Observable<StaffAssignmentACResearchDto> {
        let url_ = this.baseUrl + "/api/Admin/GetStaffAssignmentACResearch?";
        if (staffAssignmentId === null)
            throw new globalThis.Error("The parameter 'staffAssignmentId' cannot be null.");
        else if (staffAssignmentId !== undefined)
            url_ += "staffAssignmentId=" + encodeURIComponent("" + staffAssignmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStaffAssignmentACResearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStaffAssignmentACResearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StaffAssignmentACResearchDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StaffAssignmentACResearchDto>;
        }));
    }

    protected processGetStaffAssignmentACResearch(response: HttpResponseBase): Observable<StaffAssignmentACResearchDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StaffAssignmentACResearchDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchStaffAssignmentsByEIN(ein?: string | undefined): Observable<StaffAssignmentSearchResultDto[]> {
        let url_ = this.baseUrl + "/api/Admin/SearchStaffAssignmentsByEIN?";
        if (ein === null)
            throw new globalThis.Error("The parameter 'ein' cannot be null.");
        else if (ein !== undefined)
            url_ += "ein=" + encodeURIComponent("" + ein) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchStaffAssignmentsByEIN(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchStaffAssignmentsByEIN(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StaffAssignmentSearchResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StaffAssignmentSearchResultDto[]>;
        }));
    }

    protected processSearchStaffAssignmentsByEIN(response: HttpResponseBase): Observable<StaffAssignmentSearchResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StaffAssignmentSearchResultDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTeacherPositionOptionsForACSearch(): Observable<SimpleSelectOptionDto[]> {
        let url_ = this.baseUrl + "/api/Admin/GetTeacherPositionOptionsForACSearch";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTeacherPositionOptionsForACSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTeacherPositionOptionsForACSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleSelectOptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleSelectOptionDto[]>;
        }));
    }

    protected processGetTeacherPositionOptionsForACSearch(response: HttpResponseBase): Observable<SimpleSelectOptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimpleSelectOptionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getContentAreaOptionsForACSearch(positionCodeId?: number | undefined): Observable<SimpleCodeDescriptionDto[]> {
        let url_ = this.baseUrl + "/api/Admin/GetContentAreaOptionsForACSearch?";
        if (positionCodeId === null)
            throw new globalThis.Error("The parameter 'positionCodeId' cannot be null.");
        else if (positionCodeId !== undefined)
            url_ += "positionCodeId=" + encodeURIComponent("" + positionCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContentAreaOptionsForACSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContentAreaOptionsForACSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleCodeDescriptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleCodeDescriptionDto[]>;
        }));
    }

    protected processGetContentAreaOptionsForACSearch(response: HttpResponseBase): Observable<SimpleCodeDescriptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimpleCodeDescriptionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchStaffAssignmentsByPositionContentArea(positionCodeId?: number | undefined, contentAreaCodeId?: number | undefined): Observable<StaffAssignmentPositionContentAreaSearchResultDto> {
        let url_ = this.baseUrl + "/api/Admin/SearchStaffAssignmentsByPositionContentArea?";
        if (positionCodeId === null)
            throw new globalThis.Error("The parameter 'positionCodeId' cannot be null.");
        else if (positionCodeId !== undefined)
            url_ += "positionCodeId=" + encodeURIComponent("" + positionCodeId) + "&";
        if (contentAreaCodeId === null)
            throw new globalThis.Error("The parameter 'contentAreaCodeId' cannot be null.");
        else if (contentAreaCodeId !== undefined)
            url_ += "contentAreaCodeId=" + encodeURIComponent("" + contentAreaCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchStaffAssignmentsByPositionContentArea(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchStaffAssignmentsByPositionContentArea(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StaffAssignmentPositionContentAreaSearchResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StaffAssignmentPositionContentAreaSearchResultDto>;
        }));
    }

    protected processSearchStaffAssignmentsByPositionContentArea(response: HttpResponseBase): Observable<StaffAssignmentPositionContentAreaSearchResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StaffAssignmentPositionContentAreaSearchResultDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    backfillLegacyWorkforceVerifications(command: BackfillLegacyWorkforceVerificationsCommand): Observable<WorkforceLegacyVerificationBackfillResultDto> {
        let url_ = this.baseUrl + "/api/Admin/BackfillLegacyWorkforceVerifications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBackfillLegacyWorkforceVerifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBackfillLegacyWorkforceVerifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkforceLegacyVerificationBackfillResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkforceLegacyVerificationBackfillResultDto>;
        }));
    }

    protected processBackfillLegacyWorkforceVerifications(response: HttpResponseBase): Observable<WorkforceLegacyVerificationBackfillResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkforceLegacyVerificationBackfillResultDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getReports(): Observable<LeaReportDto[]> {
        let url_ = this.baseUrl + "/api/Admin/GetReports";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaReportDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaReportDto[]>;
        }));
    }

    protected processGetReports(response: HttpResponseBase): Observable<LeaReportDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LeaReportDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addOrUpdateReport(command: AddOrUpdateReportCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Admin/AddOrUpdateReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddOrUpdateReport(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    toggleReportState(command: ToggleReportStateCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Admin/ToggleReportState";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processToggleReportState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processToggleReportState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processToggleReportState(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getVoucherReportProgramOptions(): Observable<SimpleSelectOptionDto[]> {
        let url_ = this.baseUrl + "/api/Admin/GetVoucherReportProgramOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVoucherReportProgramOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVoucherReportProgramOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleSelectOptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleSelectOptionDto[]>;
        }));
    }

    protected processGetVoucherReportProgramOptions(response: HttpResponseBase): Observable<SimpleSelectOptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimpleSelectOptionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getVoucherReportCycleOptions(voucherProgramId?: number | undefined): Observable<SimpleSelectOptionDto[]> {
        let url_ = this.baseUrl + "/api/Admin/GetVoucherReportCycleOptions?";
        if (voucherProgramId === null)
            throw new globalThis.Error("The parameter 'voucherProgramId' cannot be null.");
        else if (voucherProgramId !== undefined)
            url_ += "voucherProgramId=" + encodeURIComponent("" + voucherProgramId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVoucherReportCycleOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVoucherReportCycleOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleSelectOptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleSelectOptionDto[]>;
        }));
    }

    protected processGetVoucherReportCycleOptions(response: HttpResponseBase): Observable<SimpleSelectOptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimpleSelectOptionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getVoucherReport(voucherProgramId?: number | undefined, voucherDistributionCycleId?: number | null | undefined): Observable<VoucherReportDto> {
        let url_ = this.baseUrl + "/api/Admin/GetVoucherReport?";
        if (voucherProgramId === null)
            throw new globalThis.Error("The parameter 'voucherProgramId' cannot be null.");
        else if (voucherProgramId !== undefined)
            url_ += "voucherProgramId=" + encodeURIComponent("" + voucherProgramId) + "&";
        if (voucherDistributionCycleId !== undefined && voucherDistributionCycleId !== null)
            url_ += "voucherDistributionCycleId=" + encodeURIComponent("" + voucherDistributionCycleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVoucherReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVoucherReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoucherReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoucherReportDto>;
        }));
    }

    protected processGetVoucherReport(response: HttpResponseBase): Observable<VoucherReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VoucherReportDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSurveyInstances(): Observable<SurveyInstanceResultDto[]> {
        let url_ = this.baseUrl + "/api/Admin/GetSurveyInstances";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSurveyInstances(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveyInstances(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveyInstanceResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveyInstanceResultDto[]>;
        }));
    }

    protected processGetSurveyInstances(response: HttpResponseBase): Observable<SurveyInstanceResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SurveyInstanceResultDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSurveyManagementOptions(): Observable<SurveyManagementOptionsListDto> {
        let url_ = this.baseUrl + "/api/Admin/GetSurveyManagementOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSurveyManagementOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveyManagementOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveyManagementOptionsListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveyManagementOptionsListDto>;
        }));
    }

    protected processGetSurveyManagementOptions(response: HttpResponseBase): Observable<SurveyManagementOptionsListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SurveyManagementOptionsListDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addOrUpdateSurveyInstance(command: AddOrUpdateSurveyInstanceCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Admin/AddOrUpdateSurveyInstance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateSurveyInstance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateSurveyInstance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddOrUpdateSurveyInstance(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    closeSurveyInstance(command: CloseSurveyInstanceCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Admin/CloseSurveyInstance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCloseSurveyInstance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCloseSurveyInstance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCloseSurveyInstance(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSurveyInstanceForManagementById(surveyInstanceId?: number | undefined): Observable<SurveyInstanceForManagementDto> {
        let url_ = this.baseUrl + "/api/Admin/GetSurveyInstanceForManagementById?";
        if (surveyInstanceId === null)
            throw new globalThis.Error("The parameter 'surveyInstanceId' cannot be null.");
        else if (surveyInstanceId !== undefined)
            url_ += "surveyInstanceId=" + encodeURIComponent("" + surveyInstanceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSurveyInstanceForManagementById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveyInstanceForManagementById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveyInstanceForManagementDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveyInstanceForManagementDto>;
        }));
    }

    protected processGetSurveyInstanceForManagementById(response: HttpResponseBase): Observable<SurveyInstanceForManagementDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SurveyInstanceForManagementDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendSurveyAssignmentReminder(command: SendSurveyAssignmentReminderCommand): Observable<SurveyReminderResult> {
        let url_ = this.baseUrl + "/api/Admin/SendSurveyAssignmentReminder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendSurveyAssignmentReminder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendSurveyAssignmentReminder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveyReminderResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveyReminderResult>;
        }));
    }

    protected processSendSurveyAssignmentReminder(response: HttpResponseBase): Observable<SurveyReminderResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SurveyReminderResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getVoucherPrograms(): Observable<VoucherProgramDetailsDto[]> {
        let url_ = this.baseUrl + "/api/Admin/GetVoucherPrograms";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVoucherPrograms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVoucherPrograms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoucherProgramDetailsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoucherProgramDetailsDto[]>;
        }));
    }

    protected processGetVoucherPrograms(response: HttpResponseBase): Observable<VoucherProgramDetailsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VoucherProgramDetailsDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getVoucherProgramDetails(voucherProgramId?: number | undefined): Observable<VoucherProgramDetailsDto> {
        let url_ = this.baseUrl + "/api/Admin/GetVoucherProgramDetails?";
        if (voucherProgramId === null)
            throw new globalThis.Error("The parameter 'voucherProgramId' cannot be null.");
        else if (voucherProgramId !== undefined)
            url_ += "voucherProgramId=" + encodeURIComponent("" + voucherProgramId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVoucherProgramDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVoucherProgramDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoucherProgramDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoucherProgramDetailsDto>;
        }));
    }

    protected processGetVoucherProgramDetails(response: HttpResponseBase): Observable<VoucherProgramDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VoucherProgramDetailsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addOrUpdateVoucherProgram(command: AddOrUpdateVoucherProgramCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Admin/AddOrUpdateVoucherProgram";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateVoucherProgram(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateVoucherProgram(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddOrUpdateVoucherProgram(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteVoucherProgram(command: DeleteVoucherProgramCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Admin/DeleteVoucherProgram";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteVoucherProgram(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteVoucherProgram(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteVoucherProgram(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    endVoucherProgram(command: EndVoucherProgramCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Admin/EndVoucherProgram";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEndVoucherProgram(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEndVoucherProgram(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processEndVoucherProgram(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getExistingVoucherDistributionCycleDetailsForManagement(voucherDistributionCycleId?: number | undefined): Observable<VoucherDistributionCycleManagementDetailsDto> {
        let url_ = this.baseUrl + "/api/Admin/GetExistingVoucherDistributionCycleDetailsForManagement?";
        if (voucherDistributionCycleId === null)
            throw new globalThis.Error("The parameter 'voucherDistributionCycleId' cannot be null.");
        else if (voucherDistributionCycleId !== undefined)
            url_ += "voucherDistributionCycleId=" + encodeURIComponent("" + voucherDistributionCycleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExistingVoucherDistributionCycleDetailsForManagement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExistingVoucherDistributionCycleDetailsForManagement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoucherDistributionCycleManagementDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoucherDistributionCycleManagementDetailsDto>;
        }));
    }

    protected processGetExistingVoucherDistributionCycleDetailsForManagement(response: HttpResponseBase): Observable<VoucherDistributionCycleManagementDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VoucherDistributionCycleManagementDetailsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getVoucherDistributionCycleDistributedBy(voucherDistributionCycleId?: number | undefined): Observable<VoucherDistributorType> {
        let url_ = this.baseUrl + "/api/Admin/GetVoucherDistributionCycleDistributedBy?";
        if (voucherDistributionCycleId === null)
            throw new globalThis.Error("The parameter 'voucherDistributionCycleId' cannot be null.");
        else if (voucherDistributionCycleId !== undefined)
            url_ += "voucherDistributionCycleId=" + encodeURIComponent("" + voucherDistributionCycleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVoucherDistributionCycleDistributedBy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVoucherDistributionCycleDistributedBy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoucherDistributorType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoucherDistributorType>;
        }));
    }

    protected processGetVoucherDistributionCycleDistributedBy(response: HttpResponseBase): Observable<VoucherDistributorType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VoucherDistributorType;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getVoucherDistributionCycleInfoForConfigById(voucherDistributionCycleId?: number | undefined): Observable<VoucherDistributionCycleInfoForConfigDto> {
        let url_ = this.baseUrl + "/api/Admin/GetVoucherDistributionCycleInfoForConfigById?";
        if (voucherDistributionCycleId === null)
            throw new globalThis.Error("The parameter 'voucherDistributionCycleId' cannot be null.");
        else if (voucherDistributionCycleId !== undefined)
            url_ += "voucherDistributionCycleId=" + encodeURIComponent("" + voucherDistributionCycleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVoucherDistributionCycleInfoForConfigById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVoucherDistributionCycleInfoForConfigById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoucherDistributionCycleInfoForConfigDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoucherDistributionCycleInfoForConfigDto>;
        }));
    }

    protected processGetVoucherDistributionCycleInfoForConfigById(response: HttpResponseBase): Observable<VoucherDistributionCycleInfoForConfigDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VoucherDistributionCycleInfoForConfigDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllocationsForDistributionCycle(voucherDistributionCycleId?: number | undefined): Observable<VoucherAllocationDto[]> {
        let url_ = this.baseUrl + "/api/Admin/GetAllocationsForDistributionCycle?";
        if (voucherDistributionCycleId === null)
            throw new globalThis.Error("The parameter 'voucherDistributionCycleId' cannot be null.");
        else if (voucherDistributionCycleId !== undefined)
            url_ += "voucherDistributionCycleId=" + encodeURIComponent("" + voucherDistributionCycleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllocationsForDistributionCycle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllocationsForDistributionCycle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoucherAllocationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoucherAllocationDto[]>;
        }));
    }

    protected processGetAllocationsForDistributionCycle(response: HttpResponseBase): Observable<VoucherAllocationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VoucherAllocationDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getVoucherEligibleServiceItems(query: GetVoucherEligibleServiceItemsQuery): Observable<AgGridResponseOfVoucherEligibleServiceItemDto> {
        let url_ = this.baseUrl + "/api/Admin/GetVoucherEligibleServiceItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVoucherEligibleServiceItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVoucherEligibleServiceItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgGridResponseOfVoucherEligibleServiceItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgGridResponseOfVoucherEligibleServiceItemDto>;
        }));
    }

    protected processGetVoucherEligibleServiceItems(response: HttpResponseBase): Observable<AgGridResponseOfVoucherEligibleServiceItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AgGridResponseOfVoucherEligibleServiceItemDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportVoucherEligibleServiceItemsToExcel(query: ExportVoucherEligibleServiceItemsToExcelQuery): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Admin/ExportVoucherEligibleServiceItemsToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportVoucherEligibleServiceItemsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportVoucherEligibleServiceItemsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processExportVoucherEligibleServiceItemsToExcel(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addOrUpdateVoucherDistributionCycle(command: AddOrUpdateVoucherDistributionCycleCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Admin/AddOrUpdateVoucherDistributionCycle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateVoucherDistributionCycle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateVoucherDistributionCycle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddOrUpdateVoucherDistributionCycle(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    redeemRetroactiveVoucher(command: RedeemRetroactiveVoucherCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Admin/RedeemRetroactiveVoucher";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRedeemRetroactiveVoucher(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRedeemRetroactiveVoucher(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processRedeemRetroactiveVoucher(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteVoucherDistributionCycle(command: DeleteDistributionCycleCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Admin/DeleteVoucherDistributionCycle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteVoucherDistributionCycle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteVoucherDistributionCycle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteVoucherDistributionCycle(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEligibilityRuleOptions(): Observable<EligibilityRuleOptionsDto> {
        let url_ = this.baseUrl + "/api/Admin/GetEligibilityRuleOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEligibilityRuleOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEligibilityRuleOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EligibilityRuleOptionsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EligibilityRuleOptionsDto>;
        }));
    }

    protected processGetEligibilityRuleOptions(response: HttpResponseBase): Observable<EligibilityRuleOptionsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EligibilityRuleOptionsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addVoucherEligibilityRules(command: AddVoucherEligibilityRulesCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Admin/AddVoucherEligibilityRules";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddVoucherEligibilityRules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddVoucherEligibilityRules(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddVoucherEligibilityRules(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteVoucherEligibilityRule(command: DeleteVoucherEligibilityRuleCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Admin/DeleteVoucherEligibilityRule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteVoucherEligibilityRule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteVoucherEligibilityRule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteVoucherEligibilityRule(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllocationOptions(): Observable<AllocationOptionsDto> {
        let url_ = this.baseUrl + "/api/Admin/GetAllocationOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllocationOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllocationOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AllocationOptionsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AllocationOptionsDto>;
        }));
    }

    protected processGetAllocationOptions(response: HttpResponseBase): Observable<AllocationOptionsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AllocationOptionsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bulkAllocateVouchers(command: BulkAllocateVouchersCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Admin/BulkAllocateVouchers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkAllocateVouchers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkAllocateVouchers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processBulkAllocateVouchers(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateVoucherAllocations(command: UpdateVoucherAllocationsCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Admin/UpdateVoucherAllocations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateVoucherAllocations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateVoucherAllocations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdateVoucherAllocations(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteVoucherAllocations(command: DeleteVoucherAllocationsCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Admin/DeleteVoucherAllocations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteVoucherAllocations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteVoucherAllocations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteVoucherAllocations(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAzdeVoucherCreditDetails(voucherDistributionCycleId?: number | undefined): Observable<VoucherCreditManagementDetailsDto> {
        let url_ = this.baseUrl + "/api/Admin/GetAzdeVoucherCreditDetails?";
        if (voucherDistributionCycleId === null)
            throw new globalThis.Error("The parameter 'voucherDistributionCycleId' cannot be null.");
        else if (voucherDistributionCycleId !== undefined)
            url_ += "voucherDistributionCycleId=" + encodeURIComponent("" + voucherDistributionCycleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAzdeVoucherCreditDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAzdeVoucherCreditDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoucherCreditManagementDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoucherCreditManagementDetailsDto>;
        }));
    }

    protected processGetAzdeVoucherCreditDetails(response: HttpResponseBase): Observable<VoucherCreditManagementDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VoucherCreditManagementDetailsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAzdeVoucherPersons(lastName?: string | null | undefined, firstName?: string | null | undefined, eIN?: string | null | undefined): Observable<PersonSearchResultDto[]> {
        let url_ = this.baseUrl + "/api/Admin/GetAzdeVoucherPersons?";
        if (lastName !== undefined && lastName !== null)
            url_ += "LastName=" + encodeURIComponent("" + lastName) + "&";
        if (firstName !== undefined && firstName !== null)
            url_ += "FirstName=" + encodeURIComponent("" + firstName) + "&";
        if (eIN !== undefined && eIN !== null)
            url_ += "EIN=" + encodeURIComponent("" + eIN) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAzdeVoucherPersons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAzdeVoucherPersons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonSearchResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonSearchResultDto[]>;
        }));
    }

    protected processGetAzdeVoucherPersons(response: HttpResponseBase): Observable<PersonSearchResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PersonSearchResultDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getBulkAzdeVoucherPersons(commaSeparatedEins?: string | undefined): Observable<BulkPersonSearchResultDto> {
        let url_ = this.baseUrl + "/api/Admin/GetBulkAzdeVoucherPersons?";
        if (commaSeparatedEins === null)
            throw new globalThis.Error("The parameter 'commaSeparatedEins' cannot be null.");
        else if (commaSeparatedEins !== undefined)
            url_ += "CommaSeparatedEins=" + encodeURIComponent("" + commaSeparatedEins) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBulkAzdeVoucherPersons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBulkAzdeVoucherPersons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BulkPersonSearchResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BulkPersonSearchResultDto>;
        }));
    }

    protected processGetBulkAzdeVoucherPersons(response: HttpResponseBase): Observable<BulkPersonSearchResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkPersonSearchResultDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createAzdeVoucherCredits(command: CreateVoucherCreditsCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Admin/CreateAzdeVoucherCredits";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAzdeVoucherCredits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAzdeVoucherCredits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processCreateAzdeVoucherCredits(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateAzdeVoucherCredits(command: UpdateVoucherCreditsCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Admin/UpdateAzdeVoucherCredits";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAzdeVoucherCredits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAzdeVoucherCredits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdateAzdeVoucherCredits(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteAzdeVoucherCredits(command: DeleteVoucherCreditsCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Admin/DeleteAzdeVoucherCredits";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAzdeVoucherCredits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAzdeVoucherCredits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteAzdeVoucherCredits(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    reclaimUnassignedFunds(command: ReclaimUnassignedFundsCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Admin/ReclaimUnassignedFunds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReclaimUnassignedFunds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReclaimUnassignedFunds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processReclaimUnassignedFunds(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ApplicationLogClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    logEvent(command: LogApplicationEventCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/ApplicationLog/LogEvent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogEvent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processLogEvent(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ApplicationsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    createEducatorApplication(command: AddOrUpdateEducatorApplicationCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Applications/CreateEducatorApplication";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateEducatorApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEducatorApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateEducatorApplication(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateEducatorApplication(command: AddOrUpdateEducatorApplicationCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Applications/UpdateEducatorApplication";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEducatorApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEducatorApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateEducatorApplication(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addOrUpdateCertificateApplicationServiceItems(command: AddOrUpdateCertificateApplicationServiceItemCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Applications/AddOrUpdateCertificateApplicationServiceItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateCertificateApplicationServiceItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateCertificateApplicationServiceItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddOrUpdateCertificateApplicationServiceItems(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addOrUpdateNameChangeApplicationServiceItems(command: AddOrUpdateNameChangeServiceItemCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Applications/AddOrUpdateNameChangeApplicationServiceItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateNameChangeApplicationServiceItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateNameChangeApplicationServiceItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddOrUpdateNameChangeApplicationServiceItems(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCertificateServiceDetails(applicationId?: number | undefined): Observable<CertificateServiceItemDto[]> {
        let url_ = this.baseUrl + "/api/Applications/GetCertificateServiceDetails?";
        if (applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' cannot be null.");
        else if (applicationId !== undefined)
            url_ += "applicationId=" + encodeURIComponent("" + applicationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCertificateServiceDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCertificateServiceDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CertificateServiceItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CertificateServiceItemDto[]>;
        }));
    }

    protected processGetCertificateServiceDetails(response: HttpResponseBase): Observable<CertificateServiceItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CertificateServiceItemDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getNameChangeServiceDetails(applicationId?: number | undefined): Observable<NameChangeServiceDetailDto> {
        let url_ = this.baseUrl + "/api/Applications/GetNameChangeServiceDetails?";
        if (applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' cannot be null.");
        else if (applicationId !== undefined)
            url_ += "applicationId=" + encodeURIComponent("" + applicationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNameChangeServiceDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNameChangeServiceDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NameChangeServiceDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NameChangeServiceDetailDto>;
        }));
    }

    protected processGetNameChangeServiceDetails(response: HttpResponseBase): Observable<NameChangeServiceDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NameChangeServiceDetailDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSsnChangeServiceDetailsQuery(applicationId?: number | undefined): Observable<SsnChangeServiceDetailDto> {
        let url_ = this.baseUrl + "/api/Applications/GetSsnChangeServiceDetailsQuery?";
        if (applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' cannot be null.");
        else if (applicationId !== undefined)
            url_ += "applicationId=" + encodeURIComponent("" + applicationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSsnChangeServiceDetailsQuery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSsnChangeServiceDetailsQuery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SsnChangeServiceDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SsnChangeServiceDetailDto>;
        }));
    }

    protected processGetSsnChangeServiceDetailsQuery(response: HttpResponseBase): Observable<SsnChangeServiceDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SsnChangeServiceDetailDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getApplicationById(applicationId?: number | undefined): Observable<EducatorApplicationByIdDto> {
        let url_ = this.baseUrl + "/api/Applications/GetApplicationById?";
        if (applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' cannot be null.");
        else if (applicationId !== undefined)
            url_ += "applicationId=" + encodeURIComponent("" + applicationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApplicationById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApplicationById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EducatorApplicationByIdDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EducatorApplicationByIdDto>;
        }));
    }

    protected processGetApplicationById(response: HttpResponseBase): Observable<EducatorApplicationByIdDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EducatorApplicationByIdDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteApplicationServiceItem(command: DeleteApplicationServiceItemCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Applications/DeleteApplicationServiceItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteApplicationServiceItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteApplicationServiceItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteApplicationServiceItem(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getReturnedIncompleteReasonCodes(): Observable<ReturnedIncompleteReasonCodeQueryDto[]> {
        let url_ = this.baseUrl + "/api/Applications/GetReturnedIncompleteReasonCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReturnedIncompleteReasonCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReturnedIncompleteReasonCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReturnedIncompleteReasonCodeQueryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReturnedIncompleteReasonCodeQueryDto[]>;
        }));
    }

    protected processGetReturnedIncompleteReasonCodes(response: HttpResponseBase): Observable<ReturnedIncompleteReasonCodeQueryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReturnedIncompleteReasonCodeQueryDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addRILetterDocumentCommand(command: AddRILetterDocumentCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Applications/AddRILetterDocumentCommand";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddRILetterDocumentCommand(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddRILetterDocumentCommand(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddRILetterDocumentCommand(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getApplicationDetailsOptions(): Observable<ApplicationDetailsOptionsDto> {
        let url_ = this.baseUrl + "/api/Applications/GetApplicationDetailsOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApplicationDetailsOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApplicationDetailsOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationDetailsOptionsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationDetailsOptionsDto>;
        }));
    }

    protected processGetApplicationDetailsOptions(response: HttpResponseBase): Observable<ApplicationDetailsOptionsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationDetailsOptionsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveApplicationDetails(command: SaveApplicationDetailsCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Applications/SaveApplicationDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveApplicationDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveApplicationDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processSaveApplicationDetails(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getServiceFeeWaiverCodes(): Observable<ServiceFeeWaiverCodesDto[]> {
        let url_ = this.baseUrl + "/api/Applications/GetServiceFeeWaiverCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceFeeWaiverCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceFeeWaiverCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceFeeWaiverCodesDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceFeeWaiverCodesDto[]>;
        }));
    }

    protected processGetServiceFeeWaiverCodes(response: HttpResponseBase): Observable<ServiceFeeWaiverCodesDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ServiceFeeWaiverCodesDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getServiceFeeSummary(applicationId?: number | undefined, personId?: number | undefined): Observable<ServiceFeeSummaryDto> {
        let url_ = this.baseUrl + "/api/Applications/GetServiceFeeSummary?";
        if (applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' cannot be null.");
        else if (applicationId !== undefined)
            url_ += "applicationId=" + encodeURIComponent("" + applicationId) + "&";
        if (personId === null)
            throw new globalThis.Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceFeeSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceFeeSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceFeeSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceFeeSummaryDto>;
        }));
    }

    protected processGetServiceFeeSummary(response: HttpResponseBase): Observable<ServiceFeeSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ServiceFeeSummaryDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveApplicationPaymentInformation(command: SaveApplicationPaymentInformationCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Applications/SaveApplicationPaymentInformation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveApplicationPaymentInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveApplicationPaymentInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processSaveApplicationPaymentInformation(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getApplicationReviewDetails(applicationId?: number | undefined): Observable<ApplicationReviewDetailsDto> {
        let url_ = this.baseUrl + "/api/Applications/GetApplicationReviewDetails?";
        if (applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' cannot be null.");
        else if (applicationId !== undefined)
            url_ += "applicationId=" + encodeURIComponent("" + applicationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApplicationReviewDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApplicationReviewDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationReviewDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationReviewDetailsDto>;
        }));
    }

    protected processGetApplicationReviewDetails(response: HttpResponseBase): Observable<ApplicationReviewDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationReviewDetailsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getApplicationStatus(applicationId?: number | undefined): Observable<ApplicationStatusDto> {
        let url_ = this.baseUrl + "/api/Applications/GetApplicationStatus?";
        if (applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' cannot be null.");
        else if (applicationId !== undefined)
            url_ += "applicationId=" + encodeURIComponent("" + applicationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApplicationStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApplicationStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationStatusDto>;
        }));
    }

    protected processGetApplicationStatus(response: HttpResponseBase): Observable<ApplicationStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationStatusDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getApplicationReviewEvaluations(applicationId?: number | undefined): Observable<ApplicationReviewEvaluationDto[]> {
        let url_ = this.baseUrl + "/api/Applications/GetApplicationReviewEvaluations?";
        if (applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' cannot be null.");
        else if (applicationId !== undefined)
            url_ += "applicationId=" + encodeURIComponent("" + applicationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApplicationReviewEvaluations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApplicationReviewEvaluations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationReviewEvaluationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationReviewEvaluationDto[]>;
        }));
    }

    protected processGetApplicationReviewEvaluations(response: HttpResponseBase): Observable<ApplicationReviewEvaluationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationReviewEvaluationDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateApplicationFromReview(command: UpdateApplicationFromReviewCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Applications/UpdateApplicationFromReview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateApplicationFromReview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateApplicationFromReview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdateApplicationFromReview(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getApprovedAreasForAdd(applicationId?: number | null | undefined, applicationServiceItemId?: number | null | undefined): Observable<AddApprovedAreaDetailDto> {
        let url_ = this.baseUrl + "/api/Applications/GetApprovedAreasForAdd?";
        if (applicationId !== undefined && applicationId !== null)
            url_ += "applicationId=" + encodeURIComponent("" + applicationId) + "&";
        if (applicationServiceItemId !== undefined && applicationServiceItemId !== null)
            url_ += "applicationServiceItemId=" + encodeURIComponent("" + applicationServiceItemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApprovedAreasForAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApprovedAreasForAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddApprovedAreaDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddApprovedAreaDetailDto>;
        }));
    }

    protected processGetApprovedAreasForAdd(response: HttpResponseBase): Observable<AddApprovedAreaDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AddApprovedAreaDetailDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addApprovedAreaApplicationServiceItem(command: AddApprovedAreaApplicationServiceItemCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Applications/AddApprovedAreaApplicationServiceItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddApprovedAreaApplicationServiceItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddApprovedAreaApplicationServiceItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddApprovedAreaApplicationServiceItem(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEndorsementsForAdd(applicationId?: number | undefined): Observable<AddEndorsementDetailDto> {
        let url_ = this.baseUrl + "/api/Applications/GetEndorsementsForAdd?";
        if (applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' cannot be null.");
        else if (applicationId !== undefined)
            url_ += "applicationId=" + encodeURIComponent("" + applicationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEndorsementsForAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEndorsementsForAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddEndorsementDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddEndorsementDetailDto>;
        }));
    }

    protected processGetEndorsementsForAdd(response: HttpResponseBase): Observable<AddEndorsementDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AddEndorsementDetailDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addEndorsementApplicationServiceItem(command: AddEndorsementApplicationServiceItemCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Applications/AddEndorsementApplicationServiceItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddEndorsementApplicationServiceItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddEndorsementApplicationServiceItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddEndorsementApplicationServiceItem(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    validateApplication(command: ValidateApplicationCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Applications/ValidateApplication";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processValidateApplication(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getExtendableCertificatesServiceDetail(personId?: number | undefined, applicationId?: number | undefined): Observable<ExtendableCertificatesServiceDetailDto[]> {
        let url_ = this.baseUrl + "/api/Applications/GetExtendableCertificatesServiceDetail?";
        if (personId === null)
            throw new globalThis.Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        if (applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' cannot be null.");
        else if (applicationId !== undefined)
            url_ += "applicationId=" + encodeURIComponent("" + applicationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExtendableCertificatesServiceDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExtendableCertificatesServiceDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExtendableCertificatesServiceDetailDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExtendableCertificatesServiceDetailDto[]>;
        }));
    }

    protected processGetExtendableCertificatesServiceDetail(response: HttpResponseBase): Observable<ExtendableCertificatesServiceDetailDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExtendableCertificatesServiceDetailDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addOrUpdateCertificateExtensionServiceDetails(command: AddOrUpdateCertificateExtensionServiceItemCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Applications/AddOrUpdateCertificateExtensionServiceDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateCertificateExtensionServiceDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateCertificateExtensionServiceDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddOrUpdateCertificateExtensionServiceDetails(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEducatorCertificatesForRenewal(personId: number, applicationId: number): Observable<EducatorCertificateForRenewalDto[]> {
        let url_ = this.baseUrl + "/api/Applications/GetEducatorCertificatesForRenewal/{personId}/{applicationId}";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        if (applicationId === undefined || applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorCertificatesForRenewal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorCertificatesForRenewal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EducatorCertificateForRenewalDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EducatorCertificateForRenewalDto[]>;
        }));
    }

    protected processGetEducatorCertificatesForRenewal(response: HttpResponseBase): Observable<EducatorCertificateForRenewalDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EducatorCertificateForRenewalDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRenewableCertificates(personId: number, applicationId: number): Observable<RenewableCertificateDto[]> {
        let url_ = this.baseUrl + "/api/Applications/GetRenewableCertificates/{personId}/{applicationId}";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        if (applicationId === undefined || applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRenewableCertificates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRenewableCertificates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RenewableCertificateDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RenewableCertificateDto[]>;
        }));
    }

    protected processGetRenewableCertificates(response: HttpResponseBase): Observable<RenewableCertificateDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RenewableCertificateDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addOrUpdateRenewalApplicationServiceItems(command: AddOrUpdateRenewalApplicationServiceItemCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Applications/AddOrUpdateRenewalApplicationServiceItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateRenewalApplicationServiceItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateRenewalApplicationServiceItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddOrUpdateRenewalApplicationServiceItems(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEducatorCertificatesForCopy(personId: number, applicationId: number): Observable<EducatorCertificateForCopyDto[]> {
        let url_ = this.baseUrl + "/api/Applications/GetEducatorCertificatesForCopy/{personId}/{applicationId}";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        if (applicationId === undefined || applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorCertificatesForCopy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorCertificatesForCopy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EducatorCertificateForCopyDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EducatorCertificateForCopyDto[]>;
        }));
    }

    protected processGetEducatorCertificatesForCopy(response: HttpResponseBase): Observable<EducatorCertificateForCopyDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EducatorCertificateForCopyDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addOrUpdateCopyOfCertificateApplicationServiceItems(command: AddOrUpdateCopyOfCertificateApplicationServiceItemCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Applications/AddOrUpdateCopyOfCertificateApplicationServiceItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateCopyOfCertificateApplicationServiceItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateCopyOfCertificateApplicationServiceItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddOrUpdateCopyOfCertificateApplicationServiceItems(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllowableDeficienciesForRemoval(personId?: number | undefined, applicationId?: number | undefined): Observable<RemoveDeficiencyDetailDto> {
        let url_ = this.baseUrl + "/api/Applications/GetAllowableDeficienciesForRemoval?";
        if (personId === null)
            throw new globalThis.Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        if (applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' cannot be null.");
        else if (applicationId !== undefined)
            url_ += "applicationId=" + encodeURIComponent("" + applicationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllowableDeficienciesForRemoval(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllowableDeficienciesForRemoval(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RemoveDeficiencyDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RemoveDeficiencyDetailDto>;
        }));
    }

    protected processGetAllowableDeficienciesForRemoval(response: HttpResponseBase): Observable<RemoveDeficiencyDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RemoveDeficiencyDetailDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addRemoveDeficiencyApplicationServiceItem(command: AddRemoveDeficiencyApplicationServiceItemCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Applications/AddRemoveDeficiencyApplicationServiceItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddRemoveDeficiencyApplicationServiceItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddRemoveDeficiencyApplicationServiceItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddRemoveDeficiencyApplicationServiceItem(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addOrUpdateSsnChangeServiceItem(command: AddOrUpdateSsnChangeServiceItemCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Applications/AddOrUpdateSsnChangeServiceItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateSsnChangeServiceItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateSsnChangeServiceItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddOrUpdateSsnChangeServiceItem(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEducatorCertificateRecommendations(personId?: number | undefined, applicationId?: number | undefined): Observable<EducatorCertificateRecommendationDto[]> {
        let url_ = this.baseUrl + "/api/Applications/GetEducatorCertificateRecommendations?";
        if (personId === null)
            throw new globalThis.Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        if (applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' cannot be null.");
        else if (applicationId !== undefined)
            url_ += "applicationId=" + encodeURIComponent("" + applicationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorCertificateRecommendations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorCertificateRecommendations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EducatorCertificateRecommendationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EducatorCertificateRecommendationDto[]>;
        }));
    }

    protected processGetEducatorCertificateRecommendations(response: HttpResponseBase): Observable<EducatorCertificateRecommendationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EducatorCertificateRecommendationDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addOrUpdateIRCertificateApplicationServiceItems(command: AddOrUpdateIRCertificateApplicationServiceItemCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Applications/AddOrUpdateIRCertificateApplicationServiceItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateIRCertificateApplicationServiceItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateIRCertificateApplicationServiceItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddOrUpdateIRCertificateApplicationServiceItems(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEducatorEndorsementRecommendations(personId?: number | undefined, applicationId?: number | undefined): Observable<EducatorEndorsementRecommendationDto[]> {
        let url_ = this.baseUrl + "/api/Applications/GetEducatorEndorsementRecommendations?";
        if (personId === null)
            throw new globalThis.Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        if (applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' cannot be null.");
        else if (applicationId !== undefined)
            url_ += "applicationId=" + encodeURIComponent("" + applicationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorEndorsementRecommendations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorEndorsementRecommendations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EducatorEndorsementRecommendationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EducatorEndorsementRecommendationDto[]>;
        }));
    }

    protected processGetEducatorEndorsementRecommendations(response: HttpResponseBase): Observable<EducatorEndorsementRecommendationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EducatorEndorsementRecommendationDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addOrUpdateIREndorsementApplicationServiceItems(command: AddOrUpdateIREndorsementApplicationServiceItemCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Applications/AddOrUpdateIREndorsementApplicationServiceItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateIREndorsementApplicationServiceItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateIREndorsementApplicationServiceItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddOrUpdateIREndorsementApplicationServiceItems(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getApplicationServiceItemEvalState(applicationServiceItemId?: number | undefined): Observable<ServiceItemEvalStateDto> {
        let url_ = this.baseUrl + "/api/Applications/GetApplicationServiceItemEvalState?";
        if (applicationServiceItemId === null)
            throw new globalThis.Error("The parameter 'applicationServiceItemId' cannot be null.");
        else if (applicationServiceItemId !== undefined)
            url_ += "applicationServiceItemId=" + encodeURIComponent("" + applicationServiceItemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApplicationServiceItemEvalState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApplicationServiceItemEvalState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceItemEvalStateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceItemEvalStateDto>;
        }));
    }

    protected processGetApplicationServiceItemEvalState(response: HttpResponseBase): Observable<ServiceItemEvalStateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ServiceItemEvalStateDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEducatorCertificatesForReinstatement(personId: number, applicationId: number): Observable<EducatorCertificateForReinstatementDto[]> {
        let url_ = this.baseUrl + "/api/Applications/GetEducatorCertificatesForReinstatement/{personId}/{applicationId}";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        if (applicationId === undefined || applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorCertificatesForReinstatement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorCertificatesForReinstatement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EducatorCertificateForReinstatementDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EducatorCertificateForReinstatementDto[]>;
        }));
    }

    protected processGetEducatorCertificatesForReinstatement(response: HttpResponseBase): Observable<EducatorCertificateForReinstatementDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EducatorCertificateForReinstatementDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addOrUpdateReinstatementApplicationServiceItems(command: AddOrUpdateReinstatementApplicationServiceItemsCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Applications/AddOrUpdateReinstatementApplicationServiceItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateReinstatementApplicationServiceItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateReinstatementApplicationServiceItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddOrUpdateReinstatementApplicationServiceItems(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    rushServiceItem(command: RushServiceItemCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Applications/RushServiceItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRushServiceItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRushServiceItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processRushServiceItem(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTotalCountOfLeaRushRequests(): Observable<number> {
        let url_ = this.baseUrl + "/api/Applications/GetTotalCountOfLeaRushRequests";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTotalCountOfLeaRushRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTotalCountOfLeaRushRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetTotalCountOfLeaRushRequests(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkActivePrepProgramConflict(personId?: number | undefined, serviceCode?: string | undefined, certificateTypeCodeId?: number | null | undefined, endorsementCodeId?: number | null | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/Applications/CheckActivePrepProgramConflict?";
        if (personId === null)
            throw new globalThis.Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "PersonId=" + encodeURIComponent("" + personId) + "&";
        if (serviceCode === null)
            throw new globalThis.Error("The parameter 'serviceCode' cannot be null.");
        else if (serviceCode !== undefined)
            url_ += "ServiceCode=" + encodeURIComponent("" + serviceCode) + "&";
        if (certificateTypeCodeId !== undefined && certificateTypeCodeId !== null)
            url_ += "CertificateTypeCodeId=" + encodeURIComponent("" + certificateTypeCodeId) + "&";
        if (endorsementCodeId !== undefined && endorsementCodeId !== null)
            url_ += "EndorsementCodeId=" + encodeURIComponent("" + endorsementCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckActivePrepProgramConflict(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckActivePrepProgramConflict(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processCheckActivePrepProgramConflict(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    manuallyWithdrawFromCohortStudentProgram(command: ManuallyWithdrawFromCohortStudentProgramCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Applications/ManuallyWithdrawFromCohortStudentProgram";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processManuallyWithdrawFromCohortStudentProgram(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processManuallyWithdrawFromCohortStudentProgram(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processManuallyWithdrawFromCohortStudentProgram(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AuthClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    exchangeIdpToken(tokenExchangeCommand: ExchangeIdpTokenCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/Auth/ExchangeIdpToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tokenExchangeCommand);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExchangeIdpToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExchangeIdpToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExchangeIdpToken(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createNonProdUserToken(nonProdUserCommand: CreateNonProdUserTokenCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/Auth/CreateNonProdUserToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(nonProdUserCommand);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateNonProdUserToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateNonProdUserToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateNonProdUserToken(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    changeEdOrg(command: ChangeEducationOrganizationCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/Auth/ChangeEdOrg";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeEdOrg(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeEdOrg(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processChangeEdOrg(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEdOrgs(query: GetEdOrgsQuery): Observable<EdOrgDto[]> {
        let url_ = this.baseUrl + "/api/Auth/GetEdOrgs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEdOrgs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEdOrgs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EdOrgDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EdOrgDto[]>;
        }));
    }

    protected processGetEdOrgs(response: HttpResponseBase): Observable<EdOrgDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EdOrgDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAvailableEdOrgs(): Observable<AvailableEdOrgDto[]> {
        let url_ = this.baseUrl + "/api/Auth/GetAvailableEdOrgs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailableEdOrgs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailableEdOrgs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AvailableEdOrgDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AvailableEdOrgDto[]>;
        }));
    }

    protected processGetAvailableEdOrgs(response: HttpResponseBase): Observable<AvailableEdOrgDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AvailableEdOrgDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPolicyResults(): Observable<UserPolicyEvalDto> {
        let url_ = this.baseUrl + "/api/Auth/GetPolicyResults";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPolicyResults(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPolicyResults(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserPolicyEvalDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserPolicyEvalDto>;
        }));
    }

    protected processGetPolicyResults(response: HttpResponseBase): Observable<UserPolicyEvalDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserPolicyEvalDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    logout(command: UserLogoutCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Auth/Logout";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogout(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogout(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processLogout(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    keepAlive(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Auth/KeepAlive";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processKeepAlive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processKeepAlive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processKeepAlive(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    validateStateRules(query: ValidateStateRulesQuery): Observable<DataStateValidationResponseDto> {
        let url_ = this.baseUrl + "/api/Auth/ValidateStateRules";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateStateRules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateStateRules(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataStateValidationResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataStateValidationResponseDto>;
        }));
    }

    protected processValidateStateRules(response: HttpResponseBase): Observable<DataStateValidationResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DataStateValidationResponseDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    refreshToken(): Observable<TokenRefreshResult> {
        let url_ = this.baseUrl + "/api/Auth/RefreshToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TokenRefreshResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TokenRefreshResult>;
        }));
    }

    protected processRefreshToken(response: HttpResponseBase): Observable<TokenRefreshResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TokenRefreshResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CertificationContactsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getLeaOptionsForContacts(): Observable<SimpleCodeDescriptionDto[]> {
        let url_ = this.baseUrl + "/api/CertificationContacts/GetLeaOptionsForContacts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaOptionsForContacts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaOptionsForContacts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleCodeDescriptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleCodeDescriptionDto[]>;
        }));
    }

    protected processGetLeaOptionsForContacts(response: HttpResponseBase): Observable<SimpleCodeDescriptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimpleCodeDescriptionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMainContactInformation(leaCodeId?: number | undefined): Observable<MainContactInformationDto> {
        let url_ = this.baseUrl + "/api/CertificationContacts/GetMainContactInformation?";
        if (leaCodeId === null)
            throw new globalThis.Error("The parameter 'leaCodeId' cannot be null.");
        else if (leaCodeId !== undefined)
            url_ += "leaCodeId=" + encodeURIComponent("" + leaCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMainContactInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMainContactInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MainContactInformationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MainContactInformationDto>;
        }));
    }

    protected processGetMainContactInformation(response: HttpResponseBase): Observable<MainContactInformationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MainContactInformationDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAdminContactsForLea(leaCodeId?: number | undefined): Observable<CertAdminContactInfoDto[]> {
        let url_ = this.baseUrl + "/api/CertificationContacts/GetAdminContactsForLea?";
        if (leaCodeId === null)
            throw new globalThis.Error("The parameter 'leaCodeId' cannot be null.");
        else if (leaCodeId !== undefined)
            url_ += "leaCodeId=" + encodeURIComponent("" + leaCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdminContactsForLea(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdminContactsForLea(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CertAdminContactInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CertAdminContactInfoDto[]>;
        }));
    }

    protected processGetAdminContactsForLea(response: HttpResponseBase): Observable<CertAdminContactInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CertAdminContactInfoDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSiteContactsForLea(leaCodeId?: number | undefined): Observable<CertSiteContactInfoDto[]> {
        let url_ = this.baseUrl + "/api/CertificationContacts/GetSiteContactsForLea?";
        if (leaCodeId === null)
            throw new globalThis.Error("The parameter 'leaCodeId' cannot be null.");
        else if (leaCodeId !== undefined)
            url_ += "leaCodeId=" + encodeURIComponent("" + leaCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSiteContactsForLea(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSiteContactsForLea(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CertSiteContactInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CertSiteContactInfoDto[]>;
        }));
    }

    protected processGetSiteContactsForLea(response: HttpResponseBase): Observable<CertSiteContactInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CertSiteContactInfoDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    invalidateLeaSiteRoleContacts(command: InvalidateLeaSiteRoleContactsCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/CertificationContacts/InvalidateLeaSiteRoleContacts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInvalidateLeaSiteRoleContacts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInvalidateLeaSiteRoleContacts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processInvalidateLeaSiteRoleContacts(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    invalidateLeaRoleContacts(command: InvalidateLeaRoleContactsCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/CertificationContacts/InvalidateLeaRoleContacts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInvalidateLeaRoleContacts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInvalidateLeaRoleContacts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processInvalidateLeaRoleContacts(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportLeaContactRoleInformationToExcel(model: ExportLeaContactRoleInformationToExcelQuery): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/CertificationContacts/ExportLeaContactRoleInformationToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportLeaContactRoleInformationToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportLeaContactRoleInformationToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processExportLeaContactRoleInformationToExcel(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportLeaSiteContactRoleInformationToExcel(model: ExportLeaSiteContactRoleInformationToExcelQuery): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/CertificationContacts/ExportLeaSiteContactRoleInformationToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportLeaSiteContactRoleInformationToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportLeaSiteContactRoleInformationToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processExportLeaSiteContactRoleInformationToExcel(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportAllLeaContactRoleInformationToExcel(model: ExportAllLeaContactRoleInformationToExcelQuery): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/CertificationContacts/ExportAllLeaContactRoleInformationToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportAllLeaContactRoleInformationToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportAllLeaContactRoleInformationToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processExportAllLeaContactRoleInformationToExcel(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CodeTablesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getServiceCodes(): Observable<SimpleCodeDescriptionDto[]> {
        let url_ = this.baseUrl + "/api/CodeTables/GetServiceCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleCodeDescriptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleCodeDescriptionDto[]>;
        }));
    }

    protected processGetServiceCodes(response: HttpResponseBase): Observable<SimpleCodeDescriptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimpleCodeDescriptionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPersonGenderCodes(personId?: number | undefined): Observable<PersonGenderCodeDto[]> {
        let url_ = this.baseUrl + "/api/CodeTables/GetPersonGenderCodes?";
        if (personId === null)
            throw new globalThis.Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonGenderCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonGenderCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonGenderCodeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonGenderCodeDto[]>;
        }));
    }

    protected processGetPersonGenderCodes(response: HttpResponseBase): Observable<PersonGenderCodeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PersonGenderCodeDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPersonEthnicityCodes(personId?: number | undefined): Observable<PersonEthnicityCodeDto[]> {
        let url_ = this.baseUrl + "/api/CodeTables/GetPersonEthnicityCodes?";
        if (personId === null)
            throw new globalThis.Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonEthnicityCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonEthnicityCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonEthnicityCodeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonEthnicityCodeDto[]>;
        }));
    }

    protected processGetPersonEthnicityCodes(response: HttpResponseBase): Observable<PersonEthnicityCodeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PersonEthnicityCodeDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProfessionalPreparationInstitutions(): Observable<ProfessionalPreparationInstitutionDto[]> {
        let url_ = this.baseUrl + "/api/CodeTables/GetProfessionalPreparationInstitutions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfessionalPreparationInstitutions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfessionalPreparationInstitutions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfessionalPreparationInstitutionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfessionalPreparationInstitutionDto[]>;
        }));
    }

    protected processGetProfessionalPreparationInstitutions(response: HttpResponseBase): Observable<ProfessionalPreparationInstitutionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfessionalPreparationInstitutionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCertificateTypesByPPIId(professionalPreparationInstitutionId?: number | undefined): Observable<CertificateTypeCodeDto[]> {
        let url_ = this.baseUrl + "/api/CodeTables/GetCertificateTypesByPPIId?";
        if (professionalPreparationInstitutionId === null)
            throw new globalThis.Error("The parameter 'professionalPreparationInstitutionId' cannot be null.");
        else if (professionalPreparationInstitutionId !== undefined)
            url_ += "professionalPreparationInstitutionId=" + encodeURIComponent("" + professionalPreparationInstitutionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCertificateTypesByPPIId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCertificateTypesByPPIId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CertificateTypeCodeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CertificateTypeCodeDto[]>;
        }));
    }

    protected processGetCertificateTypesByPPIId(response: HttpResponseBase): Observable<CertificateTypeCodeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CertificateTypeCodeDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAccreditedInstitutions(): Observable<AccreditedInstitutionCodeDto[]> {
        let url_ = this.baseUrl + "/api/CodeTables/GetAccreditedInstitutions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccreditedInstitutions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccreditedInstitutions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccreditedInstitutionCodeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccreditedInstitutionCodeDto[]>;
        }));
    }

    protected processGetAccreditedInstitutions(response: HttpResponseBase): Observable<AccreditedInstitutionCodeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AccreditedInstitutionCodeDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPersonRaceCodes(personId?: number | undefined): Observable<PersonRaceCodeDto[]> {
        let url_ = this.baseUrl + "/api/CodeTables/GetPersonRaceCodes?";
        if (personId === null)
            throw new globalThis.Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonRaceCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonRaceCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonRaceCodeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonRaceCodeDto[]>;
        }));
    }

    protected processGetPersonRaceCodes(response: HttpResponseBase): Observable<PersonRaceCodeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PersonRaceCodeDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getGenderEthnicityRaceCodes(): Observable<GenderEthnicityRaceCodesDto> {
        let url_ = this.baseUrl + "/api/CodeTables/GetGenderEthnicityRaceCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGenderEthnicityRaceCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGenderEthnicityRaceCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenderEthnicityRaceCodesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenderEthnicityRaceCodesDto>;
        }));
    }

    protected processGetGenderEthnicityRaceCodes(response: HttpResponseBase): Observable<GenderEthnicityRaceCodesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GenderEthnicityRaceCodesDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getStates(): Observable<StateDto[]> {
        let url_ = this.baseUrl + "/api/CodeTables/GetStates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StateDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StateDto[]>;
        }));
    }

    protected processGetStates(response: HttpResponseBase): Observable<StateDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StateDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getStatesNoAZ(): Observable<StateDto[]> {
        let url_ = this.baseUrl + "/api/CodeTables/GetStatesNoAZ";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStatesNoAZ(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStatesNoAZ(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StateDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StateDto[]>;
        }));
    }

    protected processGetStatesNoAZ(response: HttpResponseBase): Observable<StateDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StateDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPersonPhoneCodes(personId?: number | undefined): Observable<PhoneCodeDto[]> {
        let url_ = this.baseUrl + "/api/CodeTables/GetPersonPhoneCodes?";
        if (personId === null)
            throw new globalThis.Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonPhoneCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonPhoneCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PhoneCodeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PhoneCodeDto[]>;
        }));
    }

    protected processGetPersonPhoneCodes(response: HttpResponseBase): Observable<PhoneCodeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PhoneCodeDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPersonEmailCodes(personId?: number | undefined): Observable<EmailCodeDto[]> {
        let url_ = this.baseUrl + "/api/CodeTables/GetPersonEmailCodes?";
        if (personId === null)
            throw new globalThis.Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonEmailCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonEmailCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailCodeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailCodeDto[]>;
        }));
    }

    protected processGetPersonEmailCodes(response: HttpResponseBase): Observable<EmailCodeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmailCodeDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTestCodes(): Observable<TestCodeDto[]> {
        let url_ = this.baseUrl + "/api/CodeTables/GetTestCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTestCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTestCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TestCodeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TestCodeDto[]>;
        }));
    }

    protected processGetTestCodes(response: HttpResponseBase): Observable<TestCodeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TestCodeDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDegreeCodes(): Observable<DegreeCodeDto[]> {
        let url_ = this.baseUrl + "/api/CodeTables/GetDegreeCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDegreeCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDegreeCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DegreeCodeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DegreeCodeDto[]>;
        }));
    }

    protected processGetDegreeCodes(response: HttpResponseBase): Observable<DegreeCodeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DegreeCodeDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDegreeTypeCodes(): Observable<DegreeTypeCodeDto[]> {
        let url_ = this.baseUrl + "/api/CodeTables/GetDegreeTypeCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDegreeTypeCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDegreeTypeCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DegreeTypeCodeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DegreeTypeCodeDto[]>;
        }));
    }

    protected processGetDegreeTypeCodes(response: HttpResponseBase): Observable<DegreeTypeCodeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DegreeTypeCodeDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMajorsCodes(): Observable<MajorCodeDto[]> {
        let url_ = this.baseUrl + "/api/CodeTables/GetMajorsCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMajorsCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMajorsCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MajorCodeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MajorCodeDto[]>;
        }));
    }

    protected processGetMajorsCodes(response: HttpResponseBase): Observable<MajorCodeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MajorCodeDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getApplicationOptionGroupCodes(): Observable<ApplicationOptionGroupCodeDto[]> {
        let url_ = this.baseUrl + "/api/CodeTables/GetApplicationOptionGroupCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApplicationOptionGroupCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApplicationOptionGroupCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationOptionGroupCodeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationOptionGroupCodeDto[]>;
        }));
    }

    protected processGetApplicationOptionGroupCodes(response: HttpResponseBase): Observable<ApplicationOptionGroupCodeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationOptionGroupCodeDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLeaCodes(): Observable<LeaCodeDto[]> {
        let url_ = this.baseUrl + "/api/CodeTables/GetLeaCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaCodeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaCodeDto[]>;
        }));
    }

    protected processGetLeaCodes(response: HttpResponseBase): Observable<LeaCodeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LeaCodeDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLeaCodeByEdOrgId(edOrgId?: string | undefined): Observable<LeaCodeDto> {
        let url_ = this.baseUrl + "/api/CodeTables/GetLeaCodeByEdOrgId?";
        if (edOrgId === null)
            throw new globalThis.Error("The parameter 'edOrgId' cannot be null.");
        else if (edOrgId !== undefined)
            url_ += "edOrgId=" + encodeURIComponent("" + edOrgId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaCodeByEdOrgId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaCodeByEdOrgId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaCodeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaCodeDto>;
        }));
    }

    protected processGetLeaCodeByEdOrgId(response: HttpResponseBase): Observable<LeaCodeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LeaCodeDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCertificateLevelCodes(): Observable<CertificateLevelCodeDto[]> {
        let url_ = this.baseUrl + "/api/CodeTables/GetCertificateLevelCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCertificateLevelCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCertificateLevelCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CertificateLevelCodeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CertificateLevelCodeDto[]>;
        }));
    }

    protected processGetCertificateLevelCodes(response: HttpResponseBase): Observable<CertificateLevelCodeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CertificateLevelCodeDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCertificateGroupCodes(): Observable<SimpleCodeDescriptionDto[]> {
        let url_ = this.baseUrl + "/api/CodeTables/GetCertificateGroupCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCertificateGroupCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCertificateGroupCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleCodeDescriptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleCodeDescriptionDto[]>;
        }));
    }

    protected processGetCertificateGroupCodes(response: HttpResponseBase): Observable<SimpleCodeDescriptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimpleCodeDescriptionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCertificateGradeRangeCodes(): Observable<SimpleCodeDescriptionDto[]> {
        let url_ = this.baseUrl + "/api/CodeTables/GetCertificateGradeRangeCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCertificateGradeRangeCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCertificateGradeRangeCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleCodeDescriptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleCodeDescriptionDto[]>;
        }));
    }

    protected processGetCertificateGradeRangeCodes(response: HttpResponseBase): Observable<SimpleCodeDescriptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimpleCodeDescriptionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFingerprintCardStatusCodes(): Observable<FingerprintCardStatusCodeDto[]> {
        let url_ = this.baseUrl + "/api/CodeTables/GetFingerprintCardStatusCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFingerprintCardStatusCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFingerprintCardStatusCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FingerprintCardStatusCodeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FingerprintCardStatusCodeDto[]>;
        }));
    }

    protected processGetFingerprintCardStatusCodes(response: HttpResponseBase): Observable<FingerprintCardStatusCodeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FingerprintCardStatusCodeDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getManualFingerprintCardStatusCodes(): Observable<FingerprintCardStatusCodeDto[]> {
        let url_ = this.baseUrl + "/api/CodeTables/GetManualFingerprintCardStatusCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetManualFingerprintCardStatusCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetManualFingerprintCardStatusCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FingerprintCardStatusCodeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FingerprintCardStatusCodeDto[]>;
        }));
    }

    protected processGetManualFingerprintCardStatusCodes(response: HttpResponseBase): Observable<FingerprintCardStatusCodeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FingerprintCardStatusCodeDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCertificateTypeCodesForPerson(personId?: number | undefined): Observable<CertificateTypeCodeDto[]> {
        let url_ = this.baseUrl + "/api/CodeTables/GetCertificateTypeCodesForPerson?";
        if (personId === null)
            throw new globalThis.Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCertificateTypeCodesForPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCertificateTypeCodesForPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CertificateTypeCodeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CertificateTypeCodeDto[]>;
        }));
    }

    protected processGetCertificateTypeCodesForPerson(response: HttpResponseBase): Observable<CertificateTypeCodeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CertificateTypeCodeDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCertificateTypeCodes(): Observable<CertificateTypeCodeDto[]> {
        let url_ = this.baseUrl + "/api/CodeTables/GetCertificateTypeCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCertificateTypeCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCertificateTypeCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CertificateTypeCodeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CertificateTypeCodeDto[]>;
        }));
    }

    protected processGetCertificateTypeCodes(response: HttpResponseBase): Observable<CertificateTypeCodeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CertificateTypeCodeDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getOutOfStateCertificateTypeCodes(): Observable<OutOfStateCertificateTypeCodeDto[]> {
        let url_ = this.baseUrl + "/api/CodeTables/GetOutOfStateCertificateTypeCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOutOfStateCertificateTypeCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOutOfStateCertificateTypeCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OutOfStateCertificateTypeCodeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OutOfStateCertificateTypeCodeDto[]>;
        }));
    }

    protected processGetOutOfStateCertificateTypeCodes(response: HttpResponseBase): Observable<OutOfStateCertificateTypeCodeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OutOfStateCertificateTypeCodeDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getContactTypeCodes(): Observable<ContactTypeCodeDto[]> {
        let url_ = this.baseUrl + "/api/CodeTables/GetContactTypeCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContactTypeCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContactTypeCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactTypeCodeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactTypeCodeDto[]>;
        }));
    }

    protected processGetContactTypeCodes(response: HttpResponseBase): Observable<ContactTypeCodeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContactTypeCodeDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCertificateTypeCodesByLevel(certificateLevelCodeId?: number | undefined, personId?: number | undefined): Observable<PersonCertificateTypeCodeDto[]> {
        let url_ = this.baseUrl + "/api/CodeTables/GetCertificateTypeCodesByLevel?";
        if (certificateLevelCodeId === null)
            throw new globalThis.Error("The parameter 'certificateLevelCodeId' cannot be null.");
        else if (certificateLevelCodeId !== undefined)
            url_ += "certificateLevelCodeId=" + encodeURIComponent("" + certificateLevelCodeId) + "&";
        if (personId === null)
            throw new globalThis.Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCertificateTypeCodesByLevel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCertificateTypeCodesByLevel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonCertificateTypeCodeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonCertificateTypeCodeDto[]>;
        }));
    }

    protected processGetCertificateTypeCodesByLevel(response: HttpResponseBase): Observable<PersonCertificateTypeCodeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PersonCertificateTypeCodeDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getApprovedAreaCodesByCertificateType(certificateTypeCodeId?: number | undefined): Observable<SimpleSelectOptionDto[]> {
        let url_ = this.baseUrl + "/api/CodeTables/GetApprovedAreaCodesByCertificateType?";
        if (certificateTypeCodeId === null)
            throw new globalThis.Error("The parameter 'certificateTypeCodeId' cannot be null.");
        else if (certificateTypeCodeId !== undefined)
            url_ += "certificateTypeCodeId=" + encodeURIComponent("" + certificateTypeCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApprovedAreaCodesByCertificateType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApprovedAreaCodesByCertificateType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleSelectOptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleSelectOptionDto[]>;
        }));
    }

    protected processGetApprovedAreaCodesByCertificateType(response: HttpResponseBase): Observable<SimpleSelectOptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimpleSelectOptionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getApprovedAreaCodes(): Observable<SimpleCodeDescriptionDto[]> {
        let url_ = this.baseUrl + "/api/CodeTables/GetApprovedAreaCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApprovedAreaCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApprovedAreaCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleCodeDescriptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleCodeDescriptionDto[]>;
        }));
    }

    protected processGetApprovedAreaCodes(response: HttpResponseBase): Observable<SimpleCodeDescriptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimpleCodeDescriptionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDocumentCodes(): Observable<DocumentCodeDto[]> {
        let url_ = this.baseUrl + "/api/CodeTables/GetDocumentCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentCodeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentCodeDto[]>;
        }));
    }

    protected processGetDocumentCodes(response: HttpResponseBase): Observable<DocumentCodeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentCodeDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPaymentTypeCodes(): Observable<PaymentTypeCodeDto[]> {
        let url_ = this.baseUrl + "/api/CodeTables/GetPaymentTypeCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentTypeCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentTypeCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaymentTypeCodeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaymentTypeCodeDto[]>;
        }));
    }

    protected processGetPaymentTypeCodes(response: HttpResponseBase): Observable<PaymentTypeCodeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PaymentTypeCodeDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPaymentTypeCodesForAmountPaid(amountPaid?: number | undefined): Observable<PaymentTypeCodeDto[]> {
        let url_ = this.baseUrl + "/api/CodeTables/GetPaymentTypeCodesForAmountPaid?";
        if (amountPaid === null)
            throw new globalThis.Error("The parameter 'amountPaid' cannot be null.");
        else if (amountPaid !== undefined)
            url_ += "amountPaid=" + encodeURIComponent("" + amountPaid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentTypeCodesForAmountPaid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentTypeCodesForAmountPaid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaymentTypeCodeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaymentTypeCodeDto[]>;
        }));
    }

    protected processGetPaymentTypeCodesForAmountPaid(response: HttpResponseBase): Observable<PaymentTypeCodeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PaymentTypeCodeDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLocationCodes(): Observable<LocationCodeDto2[]> {
        let url_ = this.baseUrl + "/api/CodeTables/GetLocationCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationCodeDto2[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationCodeDto2[]>;
        }));
    }

    protected processGetLocationCodes(response: HttpResponseBase): Observable<LocationCodeDto2[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LocationCodeDto2[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEndorsementLevelCodesByEndorsementCodeId(endorsementCodeId?: number | undefined): Observable<SimpleCodeDescriptionDto[]> {
        let url_ = this.baseUrl + "/api/CodeTables/GetEndorsementLevelCodesByEndorsementCodeId?";
        if (endorsementCodeId === null)
            throw new globalThis.Error("The parameter 'endorsementCodeId' cannot be null.");
        else if (endorsementCodeId !== undefined)
            url_ += "endorsementCodeId=" + encodeURIComponent("" + endorsementCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEndorsementLevelCodesByEndorsementCodeId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEndorsementLevelCodesByEndorsementCodeId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleCodeDescriptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleCodeDescriptionDto[]>;
        }));
    }

    protected processGetEndorsementLevelCodesByEndorsementCodeId(response: HttpResponseBase): Observable<SimpleCodeDescriptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimpleCodeDescriptionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAlertCodesForManualAdd(): Observable<AlertCodeDto[]> {
        let url_ = this.baseUrl + "/api/CodeTables/GetAlertCodesForManualAdd";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAlertCodesForManualAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAlertCodesForManualAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlertCodeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlertCodeDto[]>;
        }));
    }

    protected processGetAlertCodesForManualAdd(response: HttpResponseBase): Observable<AlertCodeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AlertCodeDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLanguageCodes(): Observable<LanguageCodeDto[]> {
        let url_ = this.baseUrl + "/api/CodeTables/GetLanguageCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLanguageCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguageCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LanguageCodeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LanguageCodeDto[]>;
        }));
    }

    protected processGetLanguageCodes(response: HttpResponseBase): Observable<LanguageCodeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LanguageCodeDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getInStateActionCodes(): Observable<InStateActionTypeCodeDto[]> {
        let url_ = this.baseUrl + "/api/CodeTables/GetInStateActionCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInStateActionCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInStateActionCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InStateActionTypeCodeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InStateActionTypeCodeDto[]>;
        }));
    }

    protected processGetInStateActionCodes(response: HttpResponseBase): Observable<InStateActionTypeCodeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InStateActionTypeCodeDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getOutOfStateActionCodes(): Observable<OutOfStateActionTypeCodeDto[]> {
        let url_ = this.baseUrl + "/api/CodeTables/GetOutOfStateActionCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOutOfStateActionCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOutOfStateActionCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OutOfStateActionTypeCodeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OutOfStateActionTypeCodeDto[]>;
        }));
    }

    protected processGetOutOfStateActionCodes(response: HttpResponseBase): Observable<OutOfStateActionTypeCodeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OutOfStateActionTypeCodeDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getApprovedAreaCodesForPerson(personId?: number | undefined): Observable<SimpleSelectOptionDto[]> {
        let url_ = this.baseUrl + "/api/CodeTables/GetApprovedAreaCodesForPerson?";
        if (personId === null)
            throw new globalThis.Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApprovedAreaCodesForPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApprovedAreaCodesForPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleSelectOptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleSelectOptionDto[]>;
        }));
    }

    protected processGetApprovedAreaCodesForPerson(response: HttpResponseBase): Observable<SimpleSelectOptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimpleSelectOptionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEndorsementCodes(): Observable<EndorsementCodeDto[]> {
        let url_ = this.baseUrl + "/api/CodeTables/GetEndorsementCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEndorsementCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEndorsementCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EndorsementCodeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EndorsementCodeDto[]>;
        }));
    }

    protected processGetEndorsementCodes(response: HttpResponseBase): Observable<EndorsementCodeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EndorsementCodeDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getActiveAllowableDeficiencyCodes(): Observable<AllowableDeficiencyDto[]> {
        let url_ = this.baseUrl + "/api/CodeTables/GetActiveAllowableDeficiencyCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveAllowableDeficiencyCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveAllowableDeficiencyCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AllowableDeficiencyDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AllowableDeficiencyDto[]>;
        }));
    }

    protected processGetActiveAllowableDeficiencyCodes(response: HttpResponseBase): Observable<AllowableDeficiencyDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AllowableDeficiencyDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCertificateStatusCodes(): Observable<SimpleCodeDescriptionDto[]> {
        let url_ = this.baseUrl + "/api/CodeTables/GetCertificateStatusCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCertificateStatusCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCertificateStatusCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleCodeDescriptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleCodeDescriptionDto[]>;
        }));
    }

    protected processGetCertificateStatusCodes(response: HttpResponseBase): Observable<SimpleCodeDescriptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimpleCodeDescriptionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEndorsementGroupCodes(): Observable<EndorsementGroupCodeDto[]> {
        let url_ = this.baseUrl + "/api/CodeTables/GetEndorsementGroupCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEndorsementGroupCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEndorsementGroupCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EndorsementGroupCodeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EndorsementGroupCodeDto[]>;
        }));
    }

    protected processGetEndorsementGroupCodes(response: HttpResponseBase): Observable<EndorsementGroupCodeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EndorsementGroupCodeDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEndorsementLevelCodes(): Observable<SimpleCodeDescriptionDto[]> {
        let url_ = this.baseUrl + "/api/CodeTables/GetEndorsementLevelCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEndorsementLevelCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEndorsementLevelCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleCodeDescriptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleCodeDescriptionDto[]>;
        }));
    }

    protected processGetEndorsementLevelCodes(response: HttpResponseBase): Observable<SimpleCodeDescriptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimpleCodeDescriptionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPositionClassificationCodes(): Observable<SimpleCodeDescriptionDto[]> {
        let url_ = this.baseUrl + "/api/CodeTables/GetPositionClassificationCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPositionClassificationCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPositionClassificationCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleCodeDescriptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleCodeDescriptionDto[]>;
        }));
    }

    protected processGetPositionClassificationCodes(response: HttpResponseBase): Observable<SimpleCodeDescriptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimpleCodeDescriptionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSpecialProgramCodes(): Observable<SpecialProgramCodeDto[]> {
        let url_ = this.baseUrl + "/api/CodeTables/GetSpecialProgramCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSpecialProgramCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSpecialProgramCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SpecialProgramCodeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SpecialProgramCodeDto[]>;
        }));
    }

    protected processGetSpecialProgramCodes(response: HttpResponseBase): Observable<SpecialProgramCodeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SpecialProgramCodeDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAppealResponseCodes(): Observable<SimpleCodeDescriptionDto[]> {
        let url_ = this.baseUrl + "/api/CodeTables/GetAppealResponseCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppealResponseCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppealResponseCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleCodeDescriptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleCodeDescriptionDto[]>;
        }));
    }

    protected processGetAppealResponseCodes(response: HttpResponseBase): Observable<SimpleCodeDescriptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimpleCodeDescriptionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProgramPathCodeOptions(): Observable<SimpleCodeDescriptionDto[]> {
        let url_ = this.baseUrl + "/api/CodeTables/GetProgramPathCodeOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProgramPathCodeOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProgramPathCodeOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleCodeDescriptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleCodeDescriptionDto[]>;
        }));
    }

    protected processGetProgramPathCodeOptions(response: HttpResponseBase): Observable<SimpleCodeDescriptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimpleCodeDescriptionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProfessionalDevelopmentTypeCodes(): Observable<SimpleSelectOptionDto[]> {
        let url_ = this.baseUrl + "/api/CodeTables/GetProfessionalDevelopmentTypeCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfessionalDevelopmentTypeCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfessionalDevelopmentTypeCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleSelectOptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleSelectOptionDto[]>;
        }));
    }

    protected processGetProfessionalDevelopmentTypeCodes(response: HttpResponseBase): Observable<SimpleSelectOptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimpleSelectOptionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getGradeLevelCodes(): Observable<SimpleSelectOptionDto[]> {
        let url_ = this.baseUrl + "/api/CodeTables/GetGradeLevelCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGradeLevelCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGradeLevelCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleSelectOptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleSelectOptionDto[]>;
        }));
    }

    protected processGetGradeLevelCodes(response: HttpResponseBase): Observable<SimpleSelectOptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimpleSelectOptionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ConfigClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    clientConfig(): Observable<CertificationClientConfigDto> {
        let url_ = this.baseUrl + "/api/Config/ClientConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClientConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClientConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CertificationClientConfigDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CertificationClientConfigDto>;
        }));
    }

    protected processClientConfig(response: HttpResponseBase): Observable<CertificationClientConfigDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CertificationClientConfigDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    renderView(request: RazorToStringQuery): Observable<string> {
        let url_ = this.baseUrl + "/api/Config/RenderView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRenderView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRenderView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processRenderView(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    reportError(command: ReportErrorCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Config/ReportError";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReportError(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReportError(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processReportError(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    featureConfig(): Observable<FeatureManagement> {
        let url_ = this.baseUrl + "/api/Config/FeatureConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFeatureConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFeatureConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FeatureManagement>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FeatureManagement>;
        }));
    }

    protected processFeatureConfig(response: HttpResponseBase): Observable<FeatureManagement> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FeatureManagement;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getScannerProductKey(): Observable<string> {
        let url_ = this.baseUrl + "/api/Config/GetScannerProductKey";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetScannerProductKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetScannerProductKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetScannerProductKey(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ConfigurationsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getCertificateTypeCodeResults(): Observable<CodeTableConfigurationResultDto[]> {
        let url_ = this.baseUrl + "/api/Configurations/GetCertificateTypeCodeResults";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCertificateTypeCodeResults(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCertificateTypeCodeResults(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CodeTableConfigurationResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CodeTableConfigurationResultDto[]>;
        }));
    }

    protected processGetCertificateTypeCodeResults(response: HttpResponseBase): Observable<CodeTableConfigurationResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CodeTableConfigurationResultDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCertificateTypeCodeForConfigById(certificateTypeCodeId?: number | undefined): Observable<CertificateTypeCodeInfoForConfigDto> {
        let url_ = this.baseUrl + "/api/Configurations/GetCertificateTypeCodeForConfigById?";
        if (certificateTypeCodeId === null)
            throw new globalThis.Error("The parameter 'certificateTypeCodeId' cannot be null.");
        else if (certificateTypeCodeId !== undefined)
            url_ += "certificateTypeCodeId=" + encodeURIComponent("" + certificateTypeCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCertificateTypeCodeForConfigById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCertificateTypeCodeForConfigById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CertificateTypeCodeInfoForConfigDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CertificateTypeCodeInfoForConfigDto>;
        }));
    }

    protected processGetCertificateTypeCodeForConfigById(response: HttpResponseBase): Observable<CertificateTypeCodeInfoForConfigDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CertificateTypeCodeInfoForConfigDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addOrUpdateCertificateConfiguration(command: AddOrUpdateCertificateConfigurationCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Configurations/AddOrUpdateCertificateConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateCertificateConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateCertificateConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddOrUpdateCertificateConfiguration(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deactivateCertificate(command: DeactivateCertificateCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Configurations/DeactivateCertificate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivateCertificate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivateCertificate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeactivateCertificate(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getGeneralCertificateTypeCodeDetails(certificateTypeCodeId?: number | undefined): Observable<GeneralCertificateTypeCodeDetailsDto> {
        let url_ = this.baseUrl + "/api/Configurations/GetGeneralCertificateTypeCodeDetails?";
        if (certificateTypeCodeId === null)
            throw new globalThis.Error("The parameter 'certificateTypeCodeId' cannot be null.");
        else if (certificateTypeCodeId !== undefined)
            url_ += "certificateTypeCodeId=" + encodeURIComponent("" + certificateTypeCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGeneralCertificateTypeCodeDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGeneralCertificateTypeCodeDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralCertificateTypeCodeDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralCertificateTypeCodeDetailsDto>;
        }));
    }

    protected processGetGeneralCertificateTypeCodeDetails(response: HttpResponseBase): Observable<GeneralCertificateTypeCodeDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GeneralCertificateTypeCodeDetailsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getActiveApprovedAreasForRelationshipConfiguration(): Observable<EntityConfigurationRelationshipDto[]> {
        let url_ = this.baseUrl + "/api/Configurations/GetActiveApprovedAreasForRelationshipConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveApprovedAreasForRelationshipConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveApprovedAreasForRelationshipConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityConfigurationRelationshipDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityConfigurationRelationshipDto[]>;
        }));
    }

    protected processGetActiveApprovedAreasForRelationshipConfiguration(response: HttpResponseBase): Observable<EntityConfigurationRelationshipDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EntityConfigurationRelationshipDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getExistingCertificateTypeApprovedAreasForCert(certificateTypeCodeId?: number | undefined): Observable<number[]> {
        let url_ = this.baseUrl + "/api/Configurations/GetExistingCertificateTypeApprovedAreasForCert?";
        if (certificateTypeCodeId === null)
            throw new globalThis.Error("The parameter 'certificateTypeCodeId' cannot be null.");
        else if (certificateTypeCodeId !== undefined)
            url_ += "certificateTypeCodeId=" + encodeURIComponent("" + certificateTypeCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExistingCertificateTypeApprovedAreasForCert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExistingCertificateTypeApprovedAreasForCert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processGetExistingCertificateTypeApprovedAreasForCert(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSupportedApprovedAreasForNonPrimaryAreaConfiguration(certificateTypeCodeId?: number | undefined): Observable<SelectableOptionDto[]> {
        let url_ = this.baseUrl + "/api/Configurations/GetSupportedApprovedAreasForNonPrimaryAreaConfiguration?";
        if (certificateTypeCodeId === null)
            throw new globalThis.Error("The parameter 'certificateTypeCodeId' cannot be null.");
        else if (certificateTypeCodeId !== undefined)
            url_ += "certificateTypeCodeId=" + encodeURIComponent("" + certificateTypeCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSupportedApprovedAreasForNonPrimaryAreaConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSupportedApprovedAreasForNonPrimaryAreaConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectableOptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectableOptionDto[]>;
        }));
    }

    protected processGetSupportedApprovedAreasForNonPrimaryAreaConfiguration(response: HttpResponseBase): Observable<SelectableOptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SelectableOptionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getExistingNonPrimaryAreaOnlyApprovedAreasForCert(certificateTypeCodeId?: number | undefined): Observable<number[]> {
        let url_ = this.baseUrl + "/api/Configurations/GetExistingNonPrimaryAreaOnlyApprovedAreasForCert?";
        if (certificateTypeCodeId === null)
            throw new globalThis.Error("The parameter 'certificateTypeCodeId' cannot be null.");
        else if (certificateTypeCodeId !== undefined)
            url_ += "certificateTypeCodeId=" + encodeURIComponent("" + certificateTypeCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExistingNonPrimaryAreaOnlyApprovedAreasForCert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExistingNonPrimaryAreaOnlyApprovedAreasForCert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processGetExistingNonPrimaryAreaOnlyApprovedAreasForCert(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addNonPrimaryOnlyFlag(command: AddNonPrimaryOnlyFlagCommand): Observable<number[]> {
        let url_ = this.baseUrl + "/api/Configurations/AddNonPrimaryOnlyFlag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddNonPrimaryOnlyFlag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddNonPrimaryOnlyFlag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processAddNonPrimaryOnlyFlag(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    removeNonPrimaryOnlyFlag(command: RemoveNonPrimaryOnlyFlagCommand): Observable<number[]> {
        let url_ = this.baseUrl + "/api/Configurations/RemoveNonPrimaryOnlyFlag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveNonPrimaryOnlyFlag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveNonPrimaryOnlyFlag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processRemoveNonPrimaryOnlyFlag(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addCertificateTypeApprovedAreaRelationship(command: AddCertificateTypeApprovedAreaRelationshipCommand): Observable<number[]> {
        let url_ = this.baseUrl + "/api/Configurations/AddCertificateTypeApprovedAreaRelationship";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCertificateTypeApprovedAreaRelationship(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCertificateTypeApprovedAreaRelationship(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processAddCertificateTypeApprovedAreaRelationship(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    removeCertificateTypeApprovedAreaRelationship(command: RemoveCertificateTypeApprovedAreaRelationshipCommand): Observable<number[]> {
        let url_ = this.baseUrl + "/api/Configurations/RemoveCertificateTypeApprovedAreaRelationship";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveCertificateTypeApprovedAreaRelationship(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveCertificateTypeApprovedAreaRelationship(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processRemoveCertificateTypeApprovedAreaRelationship(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addAllCertificateTypeApprovedAreaRelationships(command: AddAllCertificateTypeApprovedAreaRelationshipsCommand): Observable<number[]> {
        let url_ = this.baseUrl + "/api/Configurations/AddAllCertificateTypeApprovedAreaRelationships";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddAllCertificateTypeApprovedAreaRelationships(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddAllCertificateTypeApprovedAreaRelationships(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processAddAllCertificateTypeApprovedAreaRelationships(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    removeAllCertificateTypeApprovedAreaRelationships(command: RemoveAllCertificateTypeApprovedAreaRelationshipsCommand): Observable<number[]> {
        let url_ = this.baseUrl + "/api/Configurations/RemoveAllCertificateTypeApprovedAreaRelationships";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveAllCertificateTypeApprovedAreaRelationships(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveAllCertificateTypeApprovedAreaRelationships(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processRemoveAllCertificateTypeApprovedAreaRelationships(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getActiveEndorsementsForRelationshipConfiguration(): Observable<EntityConfigurationRelationshipDto[]> {
        let url_ = this.baseUrl + "/api/Configurations/GetActiveEndorsementsForRelationshipConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveEndorsementsForRelationshipConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveEndorsementsForRelationshipConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityConfigurationRelationshipDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityConfigurationRelationshipDto[]>;
        }));
    }

    protected processGetActiveEndorsementsForRelationshipConfiguration(response: HttpResponseBase): Observable<EntityConfigurationRelationshipDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EntityConfigurationRelationshipDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getExistingCertificateTypeEndorsementsForCert(certificateTypeCodeId?: number | undefined): Observable<number[]> {
        let url_ = this.baseUrl + "/api/Configurations/GetExistingCertificateTypeEndorsementsForCert?";
        if (certificateTypeCodeId === null)
            throw new globalThis.Error("The parameter 'certificateTypeCodeId' cannot be null.");
        else if (certificateTypeCodeId !== undefined)
            url_ += "certificateTypeCodeId=" + encodeURIComponent("" + certificateTypeCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExistingCertificateTypeEndorsementsForCert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExistingCertificateTypeEndorsementsForCert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processGetExistingCertificateTypeEndorsementsForCert(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addCertificateTypeEndorsementRelationship(command: AddCertificateTypeEndorsementRelationshipCommand): Observable<number[]> {
        let url_ = this.baseUrl + "/api/Configurations/AddCertificateTypeEndorsementRelationship";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCertificateTypeEndorsementRelationship(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCertificateTypeEndorsementRelationship(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processAddCertificateTypeEndorsementRelationship(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addAllCertificateTypeEndorsementRelationships(command: AddAllCertificateTypeEndorsementRelationshipsCommand): Observable<number[]> {
        let url_ = this.baseUrl + "/api/Configurations/AddAllCertificateTypeEndorsementRelationships";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddAllCertificateTypeEndorsementRelationships(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddAllCertificateTypeEndorsementRelationships(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processAddAllCertificateTypeEndorsementRelationships(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    removeAllCertificateTypeEndorsementRelationships(command: RemoveAllCertificateTypeEndorsementRelationshipsCommand): Observable<number[]> {
        let url_ = this.baseUrl + "/api/Configurations/RemoveAllCertificateTypeEndorsementRelationships";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveAllCertificateTypeEndorsementRelationships(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveAllCertificateTypeEndorsementRelationships(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processRemoveAllCertificateTypeEndorsementRelationships(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    removeCertificateTypeEndorsementRelationship(command: RemoveCertificateTypeEndorsementRelationshipCommand): Observable<number[]> {
        let url_ = this.baseUrl + "/api/Configurations/RemoveCertificateTypeEndorsementRelationship";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveCertificateTypeEndorsementRelationship(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveCertificateTypeEndorsementRelationship(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processRemoveCertificateTypeEndorsementRelationship(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllowableDeficiencyCertificateConfigurations(certificateTypeCodeId?: number | undefined): Observable<AllowableDeficiencyCertificateConfigurationDto[]> {
        let url_ = this.baseUrl + "/api/Configurations/GetAllowableDeficiencyCertificateConfigurations?";
        if (certificateTypeCodeId === null)
            throw new globalThis.Error("The parameter 'certificateTypeCodeId' cannot be null.");
        else if (certificateTypeCodeId !== undefined)
            url_ += "certificateTypeCodeId=" + encodeURIComponent("" + certificateTypeCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllowableDeficiencyCertificateConfigurations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllowableDeficiencyCertificateConfigurations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AllowableDeficiencyCertificateConfigurationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AllowableDeficiencyCertificateConfigurationDto[]>;
        }));
    }

    protected processGetAllowableDeficiencyCertificateConfigurations(response: HttpResponseBase): Observable<AllowableDeficiencyCertificateConfigurationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AllowableDeficiencyCertificateConfigurationDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getExistingAllowableDeficiencyCertificateConfiguration(allowableDeficiencyCertificateConfigurationId?: number | undefined): Observable<ExistingAllowableDeficiencyCertificateConfigurationDto> {
        let url_ = this.baseUrl + "/api/Configurations/GetExistingAllowableDeficiencyCertificateConfiguration?";
        if (allowableDeficiencyCertificateConfigurationId === null)
            throw new globalThis.Error("The parameter 'allowableDeficiencyCertificateConfigurationId' cannot be null.");
        else if (allowableDeficiencyCertificateConfigurationId !== undefined)
            url_ += "allowableDeficiencyCertificateConfigurationId=" + encodeURIComponent("" + allowableDeficiencyCertificateConfigurationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExistingAllowableDeficiencyCertificateConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExistingAllowableDeficiencyCertificateConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExistingAllowableDeficiencyCertificateConfigurationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExistingAllowableDeficiencyCertificateConfigurationDto>;
        }));
    }

    protected processGetExistingAllowableDeficiencyCertificateConfiguration(response: HttpResponseBase): Observable<ExistingAllowableDeficiencyCertificateConfigurationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExistingAllowableDeficiencyCertificateConfigurationDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDefaultValuesForAllowableDeficiencyCertificateConfiguration(allowableDeficiencyCodeId?: number | undefined): Observable<DefaultValuesForAllowableDeficiencyCertificateConfigurationDto> {
        let url_ = this.baseUrl + "/api/Configurations/GetDefaultValuesForAllowableDeficiencyCertificateConfiguration?";
        if (allowableDeficiencyCodeId === null)
            throw new globalThis.Error("The parameter 'allowableDeficiencyCodeId' cannot be null.");
        else if (allowableDeficiencyCodeId !== undefined)
            url_ += "allowableDeficiencyCodeId=" + encodeURIComponent("" + allowableDeficiencyCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDefaultValuesForAllowableDeficiencyCertificateConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDefaultValuesForAllowableDeficiencyCertificateConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DefaultValuesForAllowableDeficiencyCertificateConfigurationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DefaultValuesForAllowableDeficiencyCertificateConfigurationDto>;
        }));
    }

    protected processGetDefaultValuesForAllowableDeficiencyCertificateConfiguration(response: HttpResponseBase): Observable<DefaultValuesForAllowableDeficiencyCertificateConfigurationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DefaultValuesForAllowableDeficiencyCertificateConfigurationDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteAllowableDeficiencyCertificateConfiguration(command: DeleteAllowableDeficiencyCertificateConfigurationCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Configurations/DeleteAllowableDeficiencyCertificateConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAllowableDeficiencyCertificateConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAllowableDeficiencyCertificateConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteAllowableDeficiencyCertificateConfiguration(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addOrUpdateAllowableDeficiencyCertificateConfiguration(command: AddOrUpdateAllowableDeficiencyCertificateConfigurationCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Configurations/AddOrUpdateAllowableDeficiencyCertificateConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateAllowableDeficiencyCertificateConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateAllowableDeficiencyCertificateConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddOrUpdateAllowableDeficiencyCertificateConfiguration(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    reactivateCertificate(command: ReactivateCertificateTypeCodeCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Configurations/ReactivateCertificate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReactivateCertificate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReactivateCertificate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processReactivateCertificate(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getApprovedAreaCodeResults(): Observable<CodeTableConfigurationResultDto[]> {
        let url_ = this.baseUrl + "/api/Configurations/GetApprovedAreaCodeResults";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApprovedAreaCodeResults(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApprovedAreaCodeResults(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CodeTableConfigurationResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CodeTableConfigurationResultDto[]>;
        }));
    }

    protected processGetApprovedAreaCodeResults(response: HttpResponseBase): Observable<CodeTableConfigurationResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CodeTableConfigurationResultDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deactivateArea(command: DeactivateAreaCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Configurations/DeactivateArea";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivateArea(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivateArea(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeactivateArea(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    reactivateArea(command: ReactivateApprovedAreaCodeCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Configurations/ReactivateArea";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReactivateArea(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReactivateArea(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processReactivateArea(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getApprovedAreaCodeForConfigById(approvedAreaCodeId?: number | undefined): Observable<ApprovedAreaCodeInfoForConfigDto> {
        let url_ = this.baseUrl + "/api/Configurations/GetApprovedAreaCodeForConfigById?";
        if (approvedAreaCodeId === null)
            throw new globalThis.Error("The parameter 'approvedAreaCodeId' cannot be null.");
        else if (approvedAreaCodeId !== undefined)
            url_ += "approvedAreaCodeId=" + encodeURIComponent("" + approvedAreaCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApprovedAreaCodeForConfigById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApprovedAreaCodeForConfigById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApprovedAreaCodeInfoForConfigDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApprovedAreaCodeInfoForConfigDto>;
        }));
    }

    protected processGetApprovedAreaCodeForConfigById(response: HttpResponseBase): Observable<ApprovedAreaCodeInfoForConfigDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApprovedAreaCodeInfoForConfigDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addOrUpdateAreaConfiguration(command: AddOrUpdateAreaConfigurationCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Configurations/AddOrUpdateAreaConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateAreaConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateAreaConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddOrUpdateAreaConfiguration(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCertificatesWithAreaRelationshipsForArea(approvedAreaCodeId?: number | undefined): Observable<CertificateAreaRelationshipRowDto[]> {
        let url_ = this.baseUrl + "/api/Configurations/GetCertificatesWithAreaRelationshipsForArea?";
        if (approvedAreaCodeId === null)
            throw new globalThis.Error("The parameter 'approvedAreaCodeId' cannot be null.");
        else if (approvedAreaCodeId !== undefined)
            url_ += "approvedAreaCodeId=" + encodeURIComponent("" + approvedAreaCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCertificatesWithAreaRelationshipsForArea(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCertificatesWithAreaRelationshipsForArea(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CertificateAreaRelationshipRowDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CertificateAreaRelationshipRowDto[]>;
        }));
    }

    protected processGetCertificatesWithAreaRelationshipsForArea(response: HttpResponseBase): Observable<CertificateAreaRelationshipRowDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CertificateAreaRelationshipRowDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateCertificateAreaRelationshipDates(command: UpdateCertificateAreaRelationshipDatesCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Configurations/UpdateCertificateAreaRelationshipDates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCertificateAreaRelationshipDates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCertificateAreaRelationshipDates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdateCertificateAreaRelationshipDates(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    removeCertificateAreaRelationships(command: RemoveCertificateAreaRelationshipsCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Configurations/RemoveCertificateAreaRelationships";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveCertificateAreaRelationships(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveCertificateAreaRelationships(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processRemoveCertificateAreaRelationships(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addCertificateAreaRelationships(command: AddCertificateAreaRelationshipsCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Configurations/AddCertificateAreaRelationships";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCertificateAreaRelationships(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCertificateAreaRelationships(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddCertificateAreaRelationships(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAreasWithCertificateRelationshipsForCertificate(certificateTypeCodeId?: number | undefined): Observable<AreaRelationshipRowDto[]> {
        let url_ = this.baseUrl + "/api/Configurations/GetAreasWithCertificateRelationshipsForCertificate?";
        if (certificateTypeCodeId === null)
            throw new globalThis.Error("The parameter 'certificateTypeCodeId' cannot be null.");
        else if (certificateTypeCodeId !== undefined)
            url_ += "certificateTypeCodeId=" + encodeURIComponent("" + certificateTypeCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAreasWithCertificateRelationshipsForCertificate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAreasWithCertificateRelationshipsForCertificate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AreaRelationshipRowDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AreaRelationshipRowDto[]>;
        }));
    }

    protected processGetAreasWithCertificateRelationshipsForCertificate(response: HttpResponseBase): Observable<AreaRelationshipRowDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AreaRelationshipRowDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addCertificateAreaRelationshipsByCertificate(command: AddCertificateAreaRelationshipsByCertificateCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Configurations/AddCertificateAreaRelationshipsByCertificate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCertificateAreaRelationshipsByCertificate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCertificateAreaRelationshipsByCertificate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddCertificateAreaRelationshipsByCertificate(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    removeCertificateAreaRelationshipsByCertificate(command: RemoveCertificateAreaRelationshipsByCertificateCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Configurations/RemoveCertificateAreaRelationshipsByCertificate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveCertificateAreaRelationshipsByCertificate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveCertificateAreaRelationshipsByCertificate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processRemoveCertificateAreaRelationshipsByCertificate(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllowableDeficiencyCodeResults(): Observable<CodeTableConfigurationResultDto[]> {
        let url_ = this.baseUrl + "/api/Configurations/GetAllowableDeficiencyCodeResults";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllowableDeficiencyCodeResults(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllowableDeficiencyCodeResults(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CodeTableConfigurationResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CodeTableConfigurationResultDto[]>;
        }));
    }

    protected processGetAllowableDeficiencyCodeResults(response: HttpResponseBase): Observable<CodeTableConfigurationResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CodeTableConfigurationResultDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deactivateAllowableDeficiency(command: DeactivateAllowableDeficiencyCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Configurations/DeactivateAllowableDeficiency";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivateAllowableDeficiency(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivateAllowableDeficiency(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeactivateAllowableDeficiency(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    reactivateAllowableDeficiency(command: ReactivateAllowableDeficiencyCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Configurations/ReactivateAllowableDeficiency";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReactivateAllowableDeficiency(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReactivateAllowableDeficiency(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processReactivateAllowableDeficiency(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllowableDeficiencyCodeForConfigById(allowableDeficiencyCodeId?: number | undefined): Observable<AllowableDeficiencyCodeInfoForConfigDto> {
        let url_ = this.baseUrl + "/api/Configurations/GetAllowableDeficiencyCodeForConfigById?";
        if (allowableDeficiencyCodeId === null)
            throw new globalThis.Error("The parameter 'allowableDeficiencyCodeId' cannot be null.");
        else if (allowableDeficiencyCodeId !== undefined)
            url_ += "allowableDeficiencyCodeId=" + encodeURIComponent("" + allowableDeficiencyCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllowableDeficiencyCodeForConfigById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllowableDeficiencyCodeForConfigById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AllowableDeficiencyCodeInfoForConfigDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AllowableDeficiencyCodeInfoForConfigDto>;
        }));
    }

    protected processGetAllowableDeficiencyCodeForConfigById(response: HttpResponseBase): Observable<AllowableDeficiencyCodeInfoForConfigDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AllowableDeficiencyCodeInfoForConfigDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addOrUpdateAllowableDeficiencyConfiguration(command: AddOrUpdateAllowableDeficiencyConfigurationCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Configurations/AddOrUpdateAllowableDeficiencyConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateAllowableDeficiencyConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateAllowableDeficiencyConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddOrUpdateAllowableDeficiencyConfiguration(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEndorsementCodeResults(): Observable<CodeTableConfigurationResultDto[]> {
        let url_ = this.baseUrl + "/api/Configurations/GetEndorsementCodeResults";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEndorsementCodeResults(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEndorsementCodeResults(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CodeTableConfigurationResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CodeTableConfigurationResultDto[]>;
        }));
    }

    protected processGetEndorsementCodeResults(response: HttpResponseBase): Observable<CodeTableConfigurationResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CodeTableConfigurationResultDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deactivateEndorsementCode(command: DeactivateEndorsementCodeCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Configurations/DeactivateEndorsementCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivateEndorsementCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivateEndorsementCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeactivateEndorsementCode(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    reactivateEndorsementCode(command: ReactivateEndorsementCodeCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Configurations/ReactivateEndorsementCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReactivateEndorsementCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReactivateEndorsementCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processReactivateEndorsementCode(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEndorsementCodeForConfigById(endorsementCodeId?: number | undefined): Observable<EndorsementCodeInfoForConfigDto> {
        let url_ = this.baseUrl + "/api/Configurations/GetEndorsementCodeForConfigById?";
        if (endorsementCodeId === null)
            throw new globalThis.Error("The parameter 'endorsementCodeId' cannot be null.");
        else if (endorsementCodeId !== undefined)
            url_ += "endorsementCodeId=" + encodeURIComponent("" + endorsementCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEndorsementCodeForConfigById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEndorsementCodeForConfigById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EndorsementCodeInfoForConfigDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EndorsementCodeInfoForConfigDto>;
        }));
    }

    protected processGetEndorsementCodeForConfigById(response: HttpResponseBase): Observable<EndorsementCodeInfoForConfigDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EndorsementCodeInfoForConfigDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addOrUpdateEndorsementCode(command: AddOrUpdateEndorsementCodeCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Configurations/AddOrUpdateEndorsementCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateEndorsementCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateEndorsementCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddOrUpdateEndorsementCode(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getActiveCertificatesForRelationshipConfiguration(): Observable<EntityConfigurationRelationshipDto[]> {
        let url_ = this.baseUrl + "/api/Configurations/GetActiveCertificatesForRelationshipConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveCertificatesForRelationshipConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveCertificatesForRelationshipConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityConfigurationRelationshipDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityConfigurationRelationshipDto[]>;
        }));
    }

    protected processGetActiveCertificatesForRelationshipConfiguration(response: HttpResponseBase): Observable<EntityConfigurationRelationshipDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EntityConfigurationRelationshipDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPublicCertificateGroupCodeResults(): Observable<CodeTableConfigurationResultDto[]> {
        let url_ = this.baseUrl + "/api/Configurations/GetPublicCertificateGroupCodeResults";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPublicCertificateGroupCodeResults(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPublicCertificateGroupCodeResults(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CodeTableConfigurationResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CodeTableConfigurationResultDto[]>;
        }));
    }

    protected processGetPublicCertificateGroupCodeResults(response: HttpResponseBase): Observable<CodeTableConfigurationResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CodeTableConfigurationResultDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deactivatePublicCertificateGroupCode(command: DeactivatePublicCertificateGroupCodeCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Configurations/DeactivatePublicCertificateGroupCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivatePublicCertificateGroupCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivatePublicCertificateGroupCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeactivatePublicCertificateGroupCode(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    reactivatePublicCertificateGroupCode(command: ReactivatePublicCertificateGroupCodeCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Configurations/ReactivatePublicCertificateGroupCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReactivatePublicCertificateGroupCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReactivatePublicCertificateGroupCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processReactivatePublicCertificateGroupCode(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPublicCertificateGroupCodeForConfigById(publicCertificateGroupCodeId?: number | undefined): Observable<PublicCertificateGroupCodeInfoForConfigDto> {
        let url_ = this.baseUrl + "/api/Configurations/GetPublicCertificateGroupCodeForConfigById?";
        if (publicCertificateGroupCodeId === null)
            throw new globalThis.Error("The parameter 'publicCertificateGroupCodeId' cannot be null.");
        else if (publicCertificateGroupCodeId !== undefined)
            url_ += "publicCertificateGroupCodeId=" + encodeURIComponent("" + publicCertificateGroupCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPublicCertificateGroupCodeForConfigById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPublicCertificateGroupCodeForConfigById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PublicCertificateGroupCodeInfoForConfigDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PublicCertificateGroupCodeInfoForConfigDto>;
        }));
    }

    protected processGetPublicCertificateGroupCodeForConfigById(response: HttpResponseBase): Observable<PublicCertificateGroupCodeInfoForConfigDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PublicCertificateGroupCodeInfoForConfigDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addOrUpdatePublicCertificateGroupCode(command: AddOrUpdatePublicCertificateGroupCodeCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Configurations/AddOrUpdatePublicCertificateGroupCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdatePublicCertificateGroupCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdatePublicCertificateGroupCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddOrUpdatePublicCertificateGroupCode(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPublicEndorsementGroupCodeResults(): Observable<CodeTableConfigurationResultDto[]> {
        let url_ = this.baseUrl + "/api/Configurations/GetPublicEndorsementGroupCodeResults";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPublicEndorsementGroupCodeResults(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPublicEndorsementGroupCodeResults(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CodeTableConfigurationResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CodeTableConfigurationResultDto[]>;
        }));
    }

    protected processGetPublicEndorsementGroupCodeResults(response: HttpResponseBase): Observable<CodeTableConfigurationResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CodeTableConfigurationResultDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deactivatePublicEndorsementGroupCode(command: DeactivatePublicEndorsementGroupCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Configurations/DeactivatePublicEndorsementGroupCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivatePublicEndorsementGroupCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivatePublicEndorsementGroupCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeactivatePublicEndorsementGroupCode(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    reactivatePublicEndorsementGroupCode(command: ReactivatePublicEndorsementGroupCodeCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Configurations/ReactivatePublicEndorsementGroupCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReactivatePublicEndorsementGroupCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReactivatePublicEndorsementGroupCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processReactivatePublicEndorsementGroupCode(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPublicEndorsementGroupCodeById(publicEndorsementGroupCodeId?: number | undefined): Observable<PublicEndorsementGroupCodeInfoForConfigDto> {
        let url_ = this.baseUrl + "/api/Configurations/GetPublicEndorsementGroupCodeById?";
        if (publicEndorsementGroupCodeId === null)
            throw new globalThis.Error("The parameter 'publicEndorsementGroupCodeId' cannot be null.");
        else if (publicEndorsementGroupCodeId !== undefined)
            url_ += "publicEndorsementGroupCodeId=" + encodeURIComponent("" + publicEndorsementGroupCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPublicEndorsementGroupCodeById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPublicEndorsementGroupCodeById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PublicEndorsementGroupCodeInfoForConfigDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PublicEndorsementGroupCodeInfoForConfigDto>;
        }));
    }

    protected processGetPublicEndorsementGroupCodeById(response: HttpResponseBase): Observable<PublicEndorsementGroupCodeInfoForConfigDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PublicEndorsementGroupCodeInfoForConfigDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addOrUpdatePublicEndorsementGroupCode(command: AddOrUpdatePublicEndorsementGroupCodeCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Configurations/AddOrUpdatePublicEndorsementGroupCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdatePublicEndorsementGroupCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdatePublicEndorsementGroupCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddOrUpdatePublicEndorsementGroupCode(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPositionClassificationCodeResults(): Observable<CodeTableConfigurationResultDto[]> {
        let url_ = this.baseUrl + "/api/Configurations/GetPositionClassificationCodeResults";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPositionClassificationCodeResults(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPositionClassificationCodeResults(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CodeTableConfigurationResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CodeTableConfigurationResultDto[]>;
        }));
    }

    protected processGetPositionClassificationCodeResults(response: HttpResponseBase): Observable<CodeTableConfigurationResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CodeTableConfigurationResultDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPositionClassificationCodeForConfigById(positionClassificationCodeId?: number | undefined): Observable<PositionClassificationCodeInfoForConfigDto> {
        let url_ = this.baseUrl + "/api/Configurations/GetPositionClassificationCodeForConfigById?";
        if (positionClassificationCodeId === null)
            throw new globalThis.Error("The parameter 'positionClassificationCodeId' cannot be null.");
        else if (positionClassificationCodeId !== undefined)
            url_ += "PositionClassificationCodeId=" + encodeURIComponent("" + positionClassificationCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPositionClassificationCodeForConfigById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPositionClassificationCodeForConfigById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PositionClassificationCodeInfoForConfigDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PositionClassificationCodeInfoForConfigDto>;
        }));
    }

    protected processGetPositionClassificationCodeForConfigById(response: HttpResponseBase): Observable<PositionClassificationCodeInfoForConfigDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PositionClassificationCodeInfoForConfigDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addOrUpdatePositionClassificationCode(command: AddOrUpdatePositionClassificationCodeCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Configurations/AddOrUpdatePositionClassificationCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdatePositionClassificationCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdatePositionClassificationCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddOrUpdatePositionClassificationCode(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deactivatePositionClassificationCode(command: DeactivatePositionClassificationCodeCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Configurations/DeactivatePositionClassificationCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivatePositionClassificationCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivatePositionClassificationCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeactivatePositionClassificationCode(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    reactivatePositionClassificationCode(command: ReactivatePositionClassificationCodeCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Configurations/ReactivatePositionClassificationCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReactivatePositionClassificationCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReactivatePositionClassificationCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processReactivatePositionClassificationCode(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getContentAreaCodeResults(): Observable<CodeTableConfigurationResultDto[]> {
        let url_ = this.baseUrl + "/api/Configurations/GetContentAreaCodeResults";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContentAreaCodeResults(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContentAreaCodeResults(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CodeTableConfigurationResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CodeTableConfigurationResultDto[]>;
        }));
    }

    protected processGetContentAreaCodeResults(response: HttpResponseBase): Observable<CodeTableConfigurationResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CodeTableConfigurationResultDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getContentAreaCodeForConfigById(contentAreaCodeId?: number | undefined): Observable<ContentAreaCodeInfoForConfigDto> {
        let url_ = this.baseUrl + "/api/Configurations/GetContentAreaCodeForConfigById?";
        if (contentAreaCodeId === null)
            throw new globalThis.Error("The parameter 'contentAreaCodeId' cannot be null.");
        else if (contentAreaCodeId !== undefined)
            url_ += "ContentAreaCodeId=" + encodeURIComponent("" + contentAreaCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContentAreaCodeForConfigById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContentAreaCodeForConfigById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContentAreaCodeInfoForConfigDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContentAreaCodeInfoForConfigDto>;
        }));
    }

    protected processGetContentAreaCodeForConfigById(response: HttpResponseBase): Observable<ContentAreaCodeInfoForConfigDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContentAreaCodeInfoForConfigDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addOrUpdateContentAreaCode(command: AddOrUpdateContentAreaCodeCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Configurations/AddOrUpdateContentAreaCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateContentAreaCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateContentAreaCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddOrUpdateContentAreaCode(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deactivateContentAreaCode(command: DeactivateContentAreaCodeCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Configurations/DeactivateContentAreaCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivateContentAreaCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivateContentAreaCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeactivateContentAreaCode(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    reactivateContentAreaCode(command: ReactivateContentAreaCodeCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Configurations/ReactivateContentAreaCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReactivateContentAreaCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReactivateContentAreaCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processReactivateContentAreaCode(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRosterRemovalReasonResults(): Observable<RosterRemovalReasonResultDto[]> {
        let url_ = this.baseUrl + "/api/Configurations/GetRosterRemovalReasonResults";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRosterRemovalReasonResults(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRosterRemovalReasonResults(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RosterRemovalReasonResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RosterRemovalReasonResultDto[]>;
        }));
    }

    protected processGetRosterRemovalReasonResults(response: HttpResponseBase): Observable<RosterRemovalReasonResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RosterRemovalReasonResultDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRosterRemovalReasonForConfigById(rosterRemovalReasonId?: number | undefined): Observable<RosterRemovalReasonInfoForConfigDto> {
        let url_ = this.baseUrl + "/api/Configurations/GetRosterRemovalReasonForConfigById?";
        if (rosterRemovalReasonId === null)
            throw new globalThis.Error("The parameter 'rosterRemovalReasonId' cannot be null.");
        else if (rosterRemovalReasonId !== undefined)
            url_ += "rosterRemovalReasonId=" + encodeURIComponent("" + rosterRemovalReasonId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRosterRemovalReasonForConfigById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRosterRemovalReasonForConfigById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RosterRemovalReasonInfoForConfigDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RosterRemovalReasonInfoForConfigDto>;
        }));
    }

    protected processGetRosterRemovalReasonForConfigById(response: HttpResponseBase): Observable<RosterRemovalReasonInfoForConfigDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RosterRemovalReasonInfoForConfigDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addOrUpdateRosterRemovalReason(command: AddOrUpdateRosterRemovalReasonCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Configurations/AddOrUpdateRosterRemovalReason";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateRosterRemovalReason(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateRosterRemovalReason(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddOrUpdateRosterRemovalReason(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deactivateRosterRemovalReason(command: DeactivateRosterRemovalReasonCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Configurations/DeactivateRosterRemovalReason";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivateRosterRemovalReason(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivateRosterRemovalReason(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeactivateRosterRemovalReason(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    reactivateRosterRemovalReason(command: ReactivateRosterRemovalReasonCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Configurations/ReactivateRosterRemovalReason";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReactivateRosterRemovalReason(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReactivateRosterRemovalReason(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processReactivateRosterRemovalReason(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPositionContentAreaResults(): Observable<PositionContentAreaConfigurationResultDto[]> {
        let url_ = this.baseUrl + "/api/Configurations/GetPositionContentAreaResults";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPositionContentAreaResults(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPositionContentAreaResults(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PositionContentAreaConfigurationResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PositionContentAreaConfigurationResultDto[]>;
        }));
    }

    protected processGetPositionContentAreaResults(response: HttpResponseBase): Observable<PositionContentAreaConfigurationResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PositionContentAreaConfigurationResultDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPositionContentAreaForConfigById(positionContentAreaId?: number | undefined): Observable<PositionContentAreaInfoForConfigDto> {
        let url_ = this.baseUrl + "/api/Configurations/GetPositionContentAreaForConfigById?";
        if (positionContentAreaId === null)
            throw new globalThis.Error("The parameter 'positionContentAreaId' cannot be null.");
        else if (positionContentAreaId !== undefined)
            url_ += "PositionContentAreaId=" + encodeURIComponent("" + positionContentAreaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPositionContentAreaForConfigById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPositionContentAreaForConfigById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PositionContentAreaInfoForConfigDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PositionContentAreaInfoForConfigDto>;
        }));
    }

    protected processGetPositionContentAreaForConfigById(response: HttpResponseBase): Observable<PositionContentAreaInfoForConfigDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PositionContentAreaInfoForConfigDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPositionContentAreaConfigOptions(): Observable<PositionContentAreaConfigOptionsDto> {
        let url_ = this.baseUrl + "/api/Configurations/GetPositionContentAreaConfigOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPositionContentAreaConfigOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPositionContentAreaConfigOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PositionContentAreaConfigOptionsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PositionContentAreaConfigOptionsDto>;
        }));
    }

    protected processGetPositionContentAreaConfigOptions(response: HttpResponseBase): Observable<PositionContentAreaConfigOptionsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PositionContentAreaConfigOptionsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addOrUpdatePositionContentArea(command: AddOrUpdatePositionContentAreaCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Configurations/AddOrUpdatePositionContentArea";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdatePositionContentArea(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdatePositionContentArea(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddOrUpdatePositionContentArea(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deactivatePositionContentArea(command: DeactivatePositionContentAreaCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Configurations/DeactivatePositionContentArea";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivatePositionContentArea(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivatePositionContentArea(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeactivatePositionContentArea(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    reactivatePositionContentArea(command: ReactivatePositionContentAreaCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Configurations/ReactivatePositionContentArea";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReactivatePositionContentArea(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReactivatePositionContentArea(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processReactivatePositionContentArea(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPositionCodeResults(): Observable<PositionCodeResultDto[]> {
        let url_ = this.baseUrl + "/api/Configurations/GetPositionCodeResults";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPositionCodeResults(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPositionCodeResults(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PositionCodeResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PositionCodeResultDto[]>;
        }));
    }

    protected processGetPositionCodeResults(response: HttpResponseBase): Observable<PositionCodeResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PositionCodeResultDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPositionCodeForConfigById(positionCodeId?: number | undefined): Observable<PositionCodeInfoForConfigDto> {
        let url_ = this.baseUrl + "/api/Configurations/GetPositionCodeForConfigById?";
        if (positionCodeId === null)
            throw new globalThis.Error("The parameter 'positionCodeId' cannot be null.");
        else if (positionCodeId !== undefined)
            url_ += "PositionCodeId=" + encodeURIComponent("" + positionCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPositionCodeForConfigById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPositionCodeForConfigById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PositionCodeInfoForConfigDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PositionCodeInfoForConfigDto>;
        }));
    }

    protected processGetPositionCodeForConfigById(response: HttpResponseBase): Observable<PositionCodeInfoForConfigDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PositionCodeInfoForConfigDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addOrUpdatePositionCode(command: AddOrUpdatePositionCodeCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Configurations/AddOrUpdatePositionCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdatePositionCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdatePositionCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddOrUpdatePositionCode(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deactivatePositionCode(command: DeactivatePositionCodeCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Configurations/DeactivatePositionCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivatePositionCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivatePositionCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeactivatePositionCode(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    reactivatePositionCode(command: ReactivatePositionCodeCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Configurations/ReactivatePositionCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReactivatePositionCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReactivatePositionCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processReactivatePositionCode(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTitleIStatusCodeResults(): Observable<CodeTableConfigurationResultDto[]> {
        let url_ = this.baseUrl + "/api/Configurations/GetTitleIStatusCodeResults";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTitleIStatusCodeResults(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTitleIStatusCodeResults(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CodeTableConfigurationResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CodeTableConfigurationResultDto[]>;
        }));
    }

    protected processGetTitleIStatusCodeResults(response: HttpResponseBase): Observable<CodeTableConfigurationResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CodeTableConfigurationResultDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTitleIStatusCodeForConfigById(titleIStatusCodeId?: number | undefined): Observable<TitleIStatusCodeInfoForConfigDto> {
        let url_ = this.baseUrl + "/api/Configurations/GetTitleIStatusCodeForConfigById?";
        if (titleIStatusCodeId === null)
            throw new globalThis.Error("The parameter 'titleIStatusCodeId' cannot be null.");
        else if (titleIStatusCodeId !== undefined)
            url_ += "titleIStatusCodeId=" + encodeURIComponent("" + titleIStatusCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTitleIStatusCodeForConfigById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTitleIStatusCodeForConfigById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TitleIStatusCodeInfoForConfigDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TitleIStatusCodeInfoForConfigDto>;
        }));
    }

    protected processGetTitleIStatusCodeForConfigById(response: HttpResponseBase): Observable<TitleIStatusCodeInfoForConfigDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TitleIStatusCodeInfoForConfigDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addOrUpdateTitleIStatusCode(command: AddOrUpdateTitleIStatusCodeCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Configurations/AddOrUpdateTitleIStatusCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateTitleIStatusCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateTitleIStatusCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddOrUpdateTitleIStatusCode(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deactivateTitleIStatusCode(command: DeactivateTitleIStatusCodeCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Configurations/DeactivateTitleIStatusCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivateTitleIStatusCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivateTitleIStatusCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeactivateTitleIStatusCode(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    reactivateTitleIStatusCode(command: ReactivateTitleIStatusCodeCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Configurations/ReactivateTitleIStatusCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReactivateTitleIStatusCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReactivateTitleIStatusCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processReactivateTitleIStatusCode(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getModeOfInstructionCodeResults(): Observable<CodeTableConfigurationResultDto[]> {
        let url_ = this.baseUrl + "/api/Configurations/GetModeOfInstructionCodeResults";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetModeOfInstructionCodeResults(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetModeOfInstructionCodeResults(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CodeTableConfigurationResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CodeTableConfigurationResultDto[]>;
        }));
    }

    protected processGetModeOfInstructionCodeResults(response: HttpResponseBase): Observable<CodeTableConfigurationResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CodeTableConfigurationResultDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getModeOfInstructionCodeForConfigById(modeOfInstructionCodeId?: number | undefined): Observable<ModeOfInstructionCodeInfoForConfigDto> {
        let url_ = this.baseUrl + "/api/Configurations/GetModeOfInstructionCodeForConfigById?";
        if (modeOfInstructionCodeId === null)
            throw new globalThis.Error("The parameter 'modeOfInstructionCodeId' cannot be null.");
        else if (modeOfInstructionCodeId !== undefined)
            url_ += "modeOfInstructionCodeId=" + encodeURIComponent("" + modeOfInstructionCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetModeOfInstructionCodeForConfigById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetModeOfInstructionCodeForConfigById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ModeOfInstructionCodeInfoForConfigDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ModeOfInstructionCodeInfoForConfigDto>;
        }));
    }

    protected processGetModeOfInstructionCodeForConfigById(response: HttpResponseBase): Observable<ModeOfInstructionCodeInfoForConfigDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ModeOfInstructionCodeInfoForConfigDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addOrUpdateModeOfInstructionCode(command: AddOrUpdateModeOfInstructionCodeCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Configurations/AddOrUpdateModeOfInstructionCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateModeOfInstructionCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateModeOfInstructionCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddOrUpdateModeOfInstructionCode(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deactivateModeOfInstructionCode(command: DeactivateModeOfInstructionCodeCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Configurations/DeactivateModeOfInstructionCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivateModeOfInstructionCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivateModeOfInstructionCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeactivateModeOfInstructionCode(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    reactivateModeOfInstructionCode(command: ReactivateModeOfInstructionCodeCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Configurations/ReactivateModeOfInstructionCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReactivateModeOfInstructionCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReactivateModeOfInstructionCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processReactivateModeOfInstructionCode(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPositionStatusCodeResults(): Observable<CodeTableConfigurationResultDto[]> {
        let url_ = this.baseUrl + "/api/Configurations/GetPositionStatusCodeResults";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPositionStatusCodeResults(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPositionStatusCodeResults(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CodeTableConfigurationResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CodeTableConfigurationResultDto[]>;
        }));
    }

    protected processGetPositionStatusCodeResults(response: HttpResponseBase): Observable<CodeTableConfigurationResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CodeTableConfigurationResultDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPositionStatusCodeForConfigById(positionStatusCodeId?: number | undefined): Observable<PositionStatusCodeInfoForConfigDto> {
        let url_ = this.baseUrl + "/api/Configurations/GetPositionStatusCodeForConfigById?";
        if (positionStatusCodeId === null)
            throw new globalThis.Error("The parameter 'positionStatusCodeId' cannot be null.");
        else if (positionStatusCodeId !== undefined)
            url_ += "positionStatusCodeId=" + encodeURIComponent("" + positionStatusCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPositionStatusCodeForConfigById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPositionStatusCodeForConfigById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PositionStatusCodeInfoForConfigDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PositionStatusCodeInfoForConfigDto>;
        }));
    }

    protected processGetPositionStatusCodeForConfigById(response: HttpResponseBase): Observable<PositionStatusCodeInfoForConfigDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PositionStatusCodeInfoForConfigDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addOrUpdatePositionStatusCode(command: AddOrUpdatePositionStatusCodeCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Configurations/AddOrUpdatePositionStatusCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdatePositionStatusCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdatePositionStatusCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddOrUpdatePositionStatusCode(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deactivatePositionStatusCode(command: DeactivatePositionStatusCodeCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Configurations/DeactivatePositionStatusCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivatePositionStatusCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivatePositionStatusCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeactivatePositionStatusCode(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    reactivatePositionStatusCode(command: ReactivatePositionStatusCodeCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Configurations/ReactivatePositionStatusCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReactivatePositionStatusCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReactivatePositionStatusCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processReactivatePositionStatusCode(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAssignmentStatusCodeResults(): Observable<CodeTableConfigurationResultDto[]> {
        let url_ = this.baseUrl + "/api/Configurations/GetAssignmentStatusCodeResults";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssignmentStatusCodeResults(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssignmentStatusCodeResults(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CodeTableConfigurationResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CodeTableConfigurationResultDto[]>;
        }));
    }

    protected processGetAssignmentStatusCodeResults(response: HttpResponseBase): Observable<CodeTableConfigurationResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CodeTableConfigurationResultDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAssignmentStatusCodeForConfigById(assignmentStatusCodeId?: number | undefined): Observable<AssignmentStatusCodeInfoForConfigDto> {
        let url_ = this.baseUrl + "/api/Configurations/GetAssignmentStatusCodeForConfigById?";
        if (assignmentStatusCodeId === null)
            throw new globalThis.Error("The parameter 'assignmentStatusCodeId' cannot be null.");
        else if (assignmentStatusCodeId !== undefined)
            url_ += "assignmentStatusCodeId=" + encodeURIComponent("" + assignmentStatusCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssignmentStatusCodeForConfigById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssignmentStatusCodeForConfigById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssignmentStatusCodeInfoForConfigDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssignmentStatusCodeInfoForConfigDto>;
        }));
    }

    protected processGetAssignmentStatusCodeForConfigById(response: HttpResponseBase): Observable<AssignmentStatusCodeInfoForConfigDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AssignmentStatusCodeInfoForConfigDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addOrUpdateAssignmentStatusCode(command: AddOrUpdateAssignmentStatusCodeCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Configurations/AddOrUpdateAssignmentStatusCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateAssignmentStatusCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateAssignmentStatusCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddOrUpdateAssignmentStatusCode(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deactivateAssignmentStatusCode(command: DeactivateAssignmentStatusCodeCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Configurations/DeactivateAssignmentStatusCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivateAssignmentStatusCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivateAssignmentStatusCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeactivateAssignmentStatusCode(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    reactivateAssignmentStatusCode(command: ReactivateAssignmentStatusCodeCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Configurations/ReactivateAssignmentStatusCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReactivateAssignmentStatusCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReactivateAssignmentStatusCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processReactivateAssignmentStatusCode(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getStatutesResults(): Observable<StatuteResultDto[]> {
        let url_ = this.baseUrl + "/api/Configurations/GetStatutesResults";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStatutesResults(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStatutesResults(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StatuteResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StatuteResultDto[]>;
        }));
    }

    protected processGetStatutesResults(response: HttpResponseBase): Observable<StatuteResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StatuteResultDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getStatuteForConfigById(statuteId?: number | undefined): Observable<StatuteInfoForConfigDto> {
        let url_ = this.baseUrl + "/api/Configurations/GetStatuteForConfigById?";
        if (statuteId === null)
            throw new globalThis.Error("The parameter 'statuteId' cannot be null.");
        else if (statuteId !== undefined)
            url_ += "statuteId=" + encodeURIComponent("" + statuteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStatuteForConfigById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStatuteForConfigById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StatuteInfoForConfigDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StatuteInfoForConfigDto>;
        }));
    }

    protected processGetStatuteForConfigById(response: HttpResponseBase): Observable<StatuteInfoForConfigDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StatuteInfoForConfigDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getActiveCertificatesForStatuteRelationshipConfiguration(statuteId?: number | undefined): Observable<EntityConfigurationRelationshipDto[]> {
        let url_ = this.baseUrl + "/api/Configurations/GetActiveCertificatesForStatuteRelationshipConfiguration?";
        if (statuteId === null)
            throw new globalThis.Error("The parameter 'statuteId' cannot be null.");
        else if (statuteId !== undefined)
            url_ += "statuteId=" + encodeURIComponent("" + statuteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveCertificatesForStatuteRelationshipConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveCertificatesForStatuteRelationshipConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityConfigurationRelationshipDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityConfigurationRelationshipDto[]>;
        }));
    }

    protected processGetActiveCertificatesForStatuteRelationshipConfiguration(response: HttpResponseBase): Observable<EntityConfigurationRelationshipDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EntityConfigurationRelationshipDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getActiveEndorsementsForStatuteRelationshipConfiguration(statuteId?: number | undefined): Observable<EntityConfigurationRelationshipDto[]> {
        let url_ = this.baseUrl + "/api/Configurations/GetActiveEndorsementsForStatuteRelationshipConfiguration?";
        if (statuteId === null)
            throw new globalThis.Error("The parameter 'statuteId' cannot be null.");
        else if (statuteId !== undefined)
            url_ += "statuteId=" + encodeURIComponent("" + statuteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveEndorsementsForStatuteRelationshipConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveEndorsementsForStatuteRelationshipConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityConfigurationRelationshipDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityConfigurationRelationshipDto[]>;
        }));
    }

    protected processGetActiveEndorsementsForStatuteRelationshipConfiguration(response: HttpResponseBase): Observable<EntityConfigurationRelationshipDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EntityConfigurationRelationshipDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addOrUpdateStatute(command: AddOrUpdateStatuteCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Configurations/AddOrUpdateStatute";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateStatute(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateStatute(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddOrUpdateStatute(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getStatuteDenialReasonsForStatute(statuteId?: number | undefined): Observable<StatuteDenialReasonResultDto[]> {
        let url_ = this.baseUrl + "/api/Configurations/GetStatuteDenialReasonsForStatute?";
        if (statuteId === null)
            throw new globalThis.Error("The parameter 'statuteId' cannot be null.");
        else if (statuteId !== undefined)
            url_ += "statuteId=" + encodeURIComponent("" + statuteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStatuteDenialReasonsForStatute(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStatuteDenialReasonsForStatute(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StatuteDenialReasonResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StatuteDenialReasonResultDto[]>;
        }));
    }

    protected processGetStatuteDenialReasonsForStatute(response: HttpResponseBase): Observable<StatuteDenialReasonResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StatuteDenialReasonResultDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addOrUpdateStatuteDenialReason(command: AddOrUpdateStatuteDenialReasonCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Configurations/AddOrUpdateStatuteDenialReason";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateStatuteDenialReason(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateStatuteDenialReason(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddOrUpdateStatuteDenialReason(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteStatuteDenialReason(command: DeleteStatuteDenialReasonCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Configurations/DeleteStatuteDenialReason";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteStatuteDenialReason(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteStatuteDenialReason(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteStatuteDenialReason(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPreparationProgramResults(): Observable<PreparationProgramResultDto[]> {
        let url_ = this.baseUrl + "/api/Configurations/GetPreparationProgramResults";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPreparationProgramResults(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPreparationProgramResults(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PreparationProgramResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PreparationProgramResultDto[]>;
        }));
    }

    protected processGetPreparationProgramResults(response: HttpResponseBase): Observable<PreparationProgramResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PreparationProgramResultDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPreparationProgramForConfigById(preparationProgramId?: number | undefined): Observable<PreparationProgramInfoForConfigDto> {
        let url_ = this.baseUrl + "/api/Configurations/GetPreparationProgramForConfigById?";
        if (preparationProgramId === null)
            throw new globalThis.Error("The parameter 'preparationProgramId' cannot be null.");
        else if (preparationProgramId !== undefined)
            url_ += "preparationProgramId=" + encodeURIComponent("" + preparationProgramId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPreparationProgramForConfigById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPreparationProgramForConfigById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PreparationProgramInfoForConfigDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PreparationProgramInfoForConfigDto>;
        }));
    }

    protected processGetPreparationProgramForConfigById(response: HttpResponseBase): Observable<PreparationProgramInfoForConfigDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PreparationProgramInfoForConfigDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addOrUpdatePreparationProgram(command: AddOrUpdatePreparationProgramCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Configurations/AddOrUpdatePreparationProgram";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdatePreparationProgram(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdatePreparationProgram(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddOrUpdatePreparationProgram(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deactivatePreparationProgram(command: DeactivatePreparationProgramCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Configurations/DeactivatePreparationProgram";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivatePreparationProgram(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivatePreparationProgram(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeactivatePreparationProgram(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    reactivatePreparationProgram(command: ReactivatePreparationProgramCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Configurations/ReactivatePreparationProgram";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReactivatePreparationProgram(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReactivatePreparationProgram(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processReactivatePreparationProgram(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPreparationProgramSupportedCertificates(preparationProgramId?: number | undefined): Observable<PreparationProgramCertificateResultDto[]> {
        let url_ = this.baseUrl + "/api/Configurations/GetPreparationProgramSupportedCertificates?";
        if (preparationProgramId === null)
            throw new globalThis.Error("The parameter 'preparationProgramId' cannot be null.");
        else if (preparationProgramId !== undefined)
            url_ += "preparationProgramId=" + encodeURIComponent("" + preparationProgramId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPreparationProgramSupportedCertificates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPreparationProgramSupportedCertificates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PreparationProgramCertificateResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PreparationProgramCertificateResultDto[]>;
        }));
    }

    protected processGetPreparationProgramSupportedCertificates(response: HttpResponseBase): Observable<PreparationProgramCertificateResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PreparationProgramCertificateResultDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deletePreparationProgramCertificate(command: DeletePreparationProgramCertificateCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Configurations/DeletePreparationProgramCertificate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePreparationProgramCertificate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePreparationProgramCertificate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeletePreparationProgramCertificate(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPreparationProgramCertificateOptionsForCertificate(certificateTypeCodeId?: number | undefined): Observable<PreparationProgramCertificateOptions> {
        let url_ = this.baseUrl + "/api/Configurations/GetPreparationProgramCertificateOptionsForCertificate?";
        if (certificateTypeCodeId === null)
            throw new globalThis.Error("The parameter 'certificateTypeCodeId' cannot be null.");
        else if (certificateTypeCodeId !== undefined)
            url_ += "certificateTypeCodeId=" + encodeURIComponent("" + certificateTypeCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPreparationProgramCertificateOptionsForCertificate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPreparationProgramCertificateOptionsForCertificate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PreparationProgramCertificateOptions>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PreparationProgramCertificateOptions>;
        }));
    }

    protected processGetPreparationProgramCertificateOptionsForCertificate(response: HttpResponseBase): Observable<PreparationProgramCertificateOptions> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PreparationProgramCertificateOptions;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPreparationProgramCertificateForConfigById(preparationProgramCertificateTypeCodeId?: number | undefined): Observable<PreparationProgramCertificateInfoForConfigDto> {
        let url_ = this.baseUrl + "/api/Configurations/GetPreparationProgramCertificateForConfigById?";
        if (preparationProgramCertificateTypeCodeId === null)
            throw new globalThis.Error("The parameter 'preparationProgramCertificateTypeCodeId' cannot be null.");
        else if (preparationProgramCertificateTypeCodeId !== undefined)
            url_ += "preparationProgramCertificateTypeCodeId=" + encodeURIComponent("" + preparationProgramCertificateTypeCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPreparationProgramCertificateForConfigById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPreparationProgramCertificateForConfigById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PreparationProgramCertificateInfoForConfigDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PreparationProgramCertificateInfoForConfigDto>;
        }));
    }

    protected processGetPreparationProgramCertificateForConfigById(response: HttpResponseBase): Observable<PreparationProgramCertificateInfoForConfigDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PreparationProgramCertificateInfoForConfigDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addOrUpdatePreparationProgramCertificate(command: AddOrUpdatePreparationProgramCertificateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Configurations/AddOrUpdatePreparationProgramCertificate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdatePreparationProgramCertificate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdatePreparationProgramCertificate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddOrUpdatePreparationProgramCertificate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getActiveAreasForPrepProgramCertificateRelationshipConfiguration(preparationProgramCertificateTypeCodeId?: number | undefined): Observable<EntityConfigurationRelationshipDto[]> {
        let url_ = this.baseUrl + "/api/Configurations/GetActiveAreasForPrepProgramCertificateRelationshipConfiguration?";
        if (preparationProgramCertificateTypeCodeId === null)
            throw new globalThis.Error("The parameter 'preparationProgramCertificateTypeCodeId' cannot be null.");
        else if (preparationProgramCertificateTypeCodeId !== undefined)
            url_ += "preparationProgramCertificateTypeCodeId=" + encodeURIComponent("" + preparationProgramCertificateTypeCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveAreasForPrepProgramCertificateRelationshipConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveAreasForPrepProgramCertificateRelationshipConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityConfigurationRelationshipDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityConfigurationRelationshipDto[]>;
        }));
    }

    protected processGetActiveAreasForPrepProgramCertificateRelationshipConfiguration(response: HttpResponseBase): Observable<EntityConfigurationRelationshipDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EntityConfigurationRelationshipDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getActiveEndorsementsForPrepProgramCertificateRelationshipConfiguration(preparationProgramCertificateTypeCodeId?: number | undefined): Observable<EntityConfigurationRelationshipDto[]> {
        let url_ = this.baseUrl + "/api/Configurations/GetActiveEndorsementsForPrepProgramCertificateRelationshipConfiguration?";
        if (preparationProgramCertificateTypeCodeId === null)
            throw new globalThis.Error("The parameter 'preparationProgramCertificateTypeCodeId' cannot be null.");
        else if (preparationProgramCertificateTypeCodeId !== undefined)
            url_ += "preparationProgramCertificateTypeCodeId=" + encodeURIComponent("" + preparationProgramCertificateTypeCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveEndorsementsForPrepProgramCertificateRelationshipConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveEndorsementsForPrepProgramCertificateRelationshipConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityConfigurationRelationshipDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityConfigurationRelationshipDto[]>;
        }));
    }

    protected processGetActiveEndorsementsForPrepProgramCertificateRelationshipConfiguration(response: HttpResponseBase): Observable<EntityConfigurationRelationshipDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EntityConfigurationRelationshipDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getActiveDeficienciesForPrepProgramCertificateRelationshipConfiguration(preparationProgramCertificateTypeCodeId?: number | undefined): Observable<EntityConfigurationRelationshipDto[]> {
        let url_ = this.baseUrl + "/api/Configurations/GetActiveDeficienciesForPrepProgramCertificateRelationshipConfiguration?";
        if (preparationProgramCertificateTypeCodeId === null)
            throw new globalThis.Error("The parameter 'preparationProgramCertificateTypeCodeId' cannot be null.");
        else if (preparationProgramCertificateTypeCodeId !== undefined)
            url_ += "preparationProgramCertificateTypeCodeId=" + encodeURIComponent("" + preparationProgramCertificateTypeCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveDeficienciesForPrepProgramCertificateRelationshipConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveDeficienciesForPrepProgramCertificateRelationshipConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityConfigurationRelationshipDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityConfigurationRelationshipDto[]>;
        }));
    }

    protected processGetActiveDeficienciesForPrepProgramCertificateRelationshipConfiguration(response: HttpResponseBase): Observable<EntityConfigurationRelationshipDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EntityConfigurationRelationshipDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getExistingPrepProgramCertificateAreas(preparationProgramCertificateTypeCodeId?: number | undefined): Observable<number[]> {
        let url_ = this.baseUrl + "/api/Configurations/GetExistingPrepProgramCertificateAreas?";
        if (preparationProgramCertificateTypeCodeId === null)
            throw new globalThis.Error("The parameter 'preparationProgramCertificateTypeCodeId' cannot be null.");
        else if (preparationProgramCertificateTypeCodeId !== undefined)
            url_ += "preparationProgramCertificateTypeCodeId=" + encodeURIComponent("" + preparationProgramCertificateTypeCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExistingPrepProgramCertificateAreas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExistingPrepProgramCertificateAreas(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processGetExistingPrepProgramCertificateAreas(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getExistingPrepProgramCertificateEndorsements(preparationProgramCertificateTypeCodeId?: number | undefined): Observable<number[]> {
        let url_ = this.baseUrl + "/api/Configurations/GetExistingPrepProgramCertificateEndorsements?";
        if (preparationProgramCertificateTypeCodeId === null)
            throw new globalThis.Error("The parameter 'preparationProgramCertificateTypeCodeId' cannot be null.");
        else if (preparationProgramCertificateTypeCodeId !== undefined)
            url_ += "preparationProgramCertificateTypeCodeId=" + encodeURIComponent("" + preparationProgramCertificateTypeCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExistingPrepProgramCertificateEndorsements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExistingPrepProgramCertificateEndorsements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processGetExistingPrepProgramCertificateEndorsements(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getExistingPrepProgramCertificateDeficiencies(preparationProgramCertificateTypeCodeId?: number | undefined): Observable<number[]> {
        let url_ = this.baseUrl + "/api/Configurations/GetExistingPrepProgramCertificateDeficiencies?";
        if (preparationProgramCertificateTypeCodeId === null)
            throw new globalThis.Error("The parameter 'preparationProgramCertificateTypeCodeId' cannot be null.");
        else if (preparationProgramCertificateTypeCodeId !== undefined)
            url_ += "preparationProgramCertificateTypeCodeId=" + encodeURIComponent("" + preparationProgramCertificateTypeCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExistingPrepProgramCertificateDeficiencies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExistingPrepProgramCertificateDeficiencies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processGetExistingPrepProgramCertificateDeficiencies(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addPreparationProgramCertificateAreaRelationship(command: AddPreparationProgramCertificateAreaRelationshipCommand): Observable<number[]> {
        let url_ = this.baseUrl + "/api/Configurations/AddPreparationProgramCertificateAreaRelationship";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddPreparationProgramCertificateAreaRelationship(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPreparationProgramCertificateAreaRelationship(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processAddPreparationProgramCertificateAreaRelationship(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addPreparationProgramCertificateEndorsementRelationship(command: AddPreparationProgramCertificateEndorsementRelationshipCommand): Observable<number[]> {
        let url_ = this.baseUrl + "/api/Configurations/AddPreparationProgramCertificateEndorsementRelationship";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddPreparationProgramCertificateEndorsementRelationship(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPreparationProgramCertificateEndorsementRelationship(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processAddPreparationProgramCertificateEndorsementRelationship(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addPreparationProgramCertificateDeficiencyRelationship(command: AddPreparationProgramCertificateDeficiencyRelationshipCommand): Observable<number[]> {
        let url_ = this.baseUrl + "/api/Configurations/AddPreparationProgramCertificateDeficiencyRelationship";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddPreparationProgramCertificateDeficiencyRelationship(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPreparationProgramCertificateDeficiencyRelationship(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processAddPreparationProgramCertificateDeficiencyRelationship(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    removePreparationProgramCertificateAreaRelationship(command: RemovePreparationProgramCertificateAreaRelationshipCommand): Observable<number[]> {
        let url_ = this.baseUrl + "/api/Configurations/RemovePreparationProgramCertificateAreaRelationship";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemovePreparationProgramCertificateAreaRelationship(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemovePreparationProgramCertificateAreaRelationship(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processRemovePreparationProgramCertificateAreaRelationship(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    removePreparationProgramCertificateEndorsementRelationship(command: RemovePreparationProgramCertificateEndorsementRelationshipCommand): Observable<number[]> {
        let url_ = this.baseUrl + "/api/Configurations/RemovePreparationProgramCertificateEndorsementRelationship";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemovePreparationProgramCertificateEndorsementRelationship(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemovePreparationProgramCertificateEndorsementRelationship(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processRemovePreparationProgramCertificateEndorsementRelationship(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    removePreparationProgramCertificateDeficiencyRelationship(command: RemovePreparationProgramCertificateDeficiencyRelationshipCommand): Observable<number[]> {
        let url_ = this.baseUrl + "/api/Configurations/RemovePreparationProgramCertificateDeficiencyRelationship";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemovePreparationProgramCertificateDeficiencyRelationship(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemovePreparationProgramCertificateDeficiencyRelationship(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processRemovePreparationProgramCertificateDeficiencyRelationship(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProfessionalPreparationInstitutionResults(): Observable<ProfessionalPreparationInstitutionResultDto[]> {
        let url_ = this.baseUrl + "/api/Configurations/GetProfessionalPreparationInstitutionResults";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfessionalPreparationInstitutionResults(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfessionalPreparationInstitutionResults(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfessionalPreparationInstitutionResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfessionalPreparationInstitutionResultDto[]>;
        }));
    }

    protected processGetProfessionalPreparationInstitutionResults(response: HttpResponseBase): Observable<ProfessionalPreparationInstitutionResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfessionalPreparationInstitutionResultDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProfessionalPreparationInstitutionForConfigById(assignmentStatusCodeId?: number | undefined): Observable<ProfessionalPreparationInstitutionInfoForConfigDto> {
        let url_ = this.baseUrl + "/api/Configurations/GetProfessionalPreparationInstitutionForConfigById?";
        if (assignmentStatusCodeId === null)
            throw new globalThis.Error("The parameter 'assignmentStatusCodeId' cannot be null.");
        else if (assignmentStatusCodeId !== undefined)
            url_ += "assignmentStatusCodeId=" + encodeURIComponent("" + assignmentStatusCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfessionalPreparationInstitutionForConfigById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfessionalPreparationInstitutionForConfigById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfessionalPreparationInstitutionInfoForConfigDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfessionalPreparationInstitutionInfoForConfigDto>;
        }));
    }

    protected processGetProfessionalPreparationInstitutionForConfigById(response: HttpResponseBase): Observable<ProfessionalPreparationInstitutionInfoForConfigDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfessionalPreparationInstitutionInfoForConfigDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addOrUpdateProfessionalPreparationInstitution(command: AddOrUpdateProfessionalPreparationInstitutionCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Configurations/AddOrUpdateProfessionalPreparationInstitution";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateProfessionalPreparationInstitution(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateProfessionalPreparationInstitution(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddOrUpdateProfessionalPreparationInstitution(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deactivateProfessionalPreparationInstitution(command: DeactivateProfessionalPreparationInstitutionCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Configurations/DeactivateProfessionalPreparationInstitution";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivateProfessionalPreparationInstitution(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivateProfessionalPreparationInstitution(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeactivateProfessionalPreparationInstitution(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    reactivateProfessionalPreparationInstitution(command: ReactivateProfessionalPreparationInstitutionCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Configurations/ReactivateProfessionalPreparationInstitution";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReactivateProfessionalPreparationInstitution(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReactivateProfessionalPreparationInstitution(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processReactivateProfessionalPreparationInstitution(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEndorsementGroupCodeResults(): Observable<CodeTableConfigurationResultDto[]> {
        let url_ = this.baseUrl + "/api/Configurations/GetEndorsementGroupCodeResults";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEndorsementGroupCodeResults(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEndorsementGroupCodeResults(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CodeTableConfigurationResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CodeTableConfigurationResultDto[]>;
        }));
    }

    protected processGetEndorsementGroupCodeResults(response: HttpResponseBase): Observable<CodeTableConfigurationResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CodeTableConfigurationResultDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deactivateEndorsementGroup(command: DeactivateEndorsementGroupCodeCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Configurations/DeactivateEndorsementGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivateEndorsementGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivateEndorsementGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeactivateEndorsementGroup(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    reactivateEndorsementGroup(command: ReactivateEndorsementGroupCodeCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Configurations/ReactivateEndorsementGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReactivateEndorsementGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReactivateEndorsementGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processReactivateEndorsementGroup(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEndorsementGroupCodeForConfigById(endorsementGroupCodeId?: number | undefined): Observable<EndorsementGroupCodeInfoForConfigDto> {
        let url_ = this.baseUrl + "/api/Configurations/GetEndorsementGroupCodeForConfigById?";
        if (endorsementGroupCodeId === null)
            throw new globalThis.Error("The parameter 'endorsementGroupCodeId' cannot be null.");
        else if (endorsementGroupCodeId !== undefined)
            url_ += "endorsementGroupCodeId=" + encodeURIComponent("" + endorsementGroupCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEndorsementGroupCodeForConfigById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEndorsementGroupCodeForConfigById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EndorsementGroupCodeInfoForConfigDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EndorsementGroupCodeInfoForConfigDto>;
        }));
    }

    protected processGetEndorsementGroupCodeForConfigById(response: HttpResponseBase): Observable<EndorsementGroupCodeInfoForConfigDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EndorsementGroupCodeInfoForConfigDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addOrUpdateEndorsementGroupConfiguration(command: AddOrUpdateEndorsementGroupCodeCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Configurations/AddOrUpdateEndorsementGroupConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateEndorsementGroupConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateEndorsementGroupConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddOrUpdateEndorsementGroupConfiguration(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCertificateGroupCodeResults(): Observable<CodeTableConfigurationResultDto[]> {
        let url_ = this.baseUrl + "/api/Configurations/GetCertificateGroupCodeResults";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCertificateGroupCodeResults(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCertificateGroupCodeResults(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CodeTableConfigurationResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CodeTableConfigurationResultDto[]>;
        }));
    }

    protected processGetCertificateGroupCodeResults(response: HttpResponseBase): Observable<CodeTableConfigurationResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CodeTableConfigurationResultDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deactivateCertificateGroup(command: DeactivateCertificateGroupCodeCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Configurations/DeactivateCertificateGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivateCertificateGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivateCertificateGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeactivateCertificateGroup(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    reactivateCertificateGroup(command: ReactivateCertificateGroupCodeCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Configurations/ReactivateCertificateGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReactivateCertificateGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReactivateCertificateGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processReactivateCertificateGroup(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCertificateGroupCodeForConfigById(certificateGroupCodeId?: number | undefined): Observable<CertificateGroupCodeInfoForConfigDto> {
        let url_ = this.baseUrl + "/api/Configurations/GetCertificateGroupCodeForConfigById?";
        if (certificateGroupCodeId === null)
            throw new globalThis.Error("The parameter 'certificateGroupCodeId' cannot be null.");
        else if (certificateGroupCodeId !== undefined)
            url_ += "certificateGroupCodeId=" + encodeURIComponent("" + certificateGroupCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCertificateGroupCodeForConfigById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCertificateGroupCodeForConfigById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CertificateGroupCodeInfoForConfigDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CertificateGroupCodeInfoForConfigDto>;
        }));
    }

    protected processGetCertificateGroupCodeForConfigById(response: HttpResponseBase): Observable<CertificateGroupCodeInfoForConfigDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CertificateGroupCodeInfoForConfigDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addOrUpdateCertificateGroupConfiguration(command: AddOrUpdateCertificateGroupCodeCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Configurations/AddOrUpdateCertificateGroupConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateCertificateGroupConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateCertificateGroupConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddOrUpdateCertificateGroupConfiguration(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLeaFeatureSubscriptionResults(): Observable<LeaFeatureSubscriptionResultDto[]> {
        let url_ = this.baseUrl + "/api/Configurations/GetLeaFeatureSubscriptionResults";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaFeatureSubscriptionResults(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaFeatureSubscriptionResults(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaFeatureSubscriptionResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaFeatureSubscriptionResultDto[]>;
        }));
    }

    protected processGetLeaFeatureSubscriptionResults(response: HttpResponseBase): Observable<LeaFeatureSubscriptionResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LeaFeatureSubscriptionResultDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLeaFeatureSubscriptionForConfigByType(leaFeatureDescriptionType?: LeaFeatureSubscriptionType | undefined): Observable<LeaFeatureSubscriptionInfoForConfigDto> {
        let url_ = this.baseUrl + "/api/Configurations/GetLeaFeatureSubscriptionForConfigByType?";
        if (leaFeatureDescriptionType === null)
            throw new globalThis.Error("The parameter 'leaFeatureDescriptionType' cannot be null.");
        else if (leaFeatureDescriptionType !== undefined)
            url_ += "LeaFeatureDescriptionType=" + encodeURIComponent("" + leaFeatureDescriptionType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaFeatureSubscriptionForConfigByType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaFeatureSubscriptionForConfigByType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaFeatureSubscriptionInfoForConfigDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaFeatureSubscriptionInfoForConfigDto>;
        }));
    }

    protected processGetLeaFeatureSubscriptionForConfigByType(response: HttpResponseBase): Observable<LeaFeatureSubscriptionInfoForConfigDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LeaFeatureSubscriptionInfoForConfigDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addLeaFeatureSubscription(command: AddLeaFeatureSubscriptionCommand): Observable<number[]> {
        let url_ = this.baseUrl + "/api/Configurations/AddLeaFeatureSubscription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddLeaFeatureSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddLeaFeatureSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processAddLeaFeatureSubscription(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    removeLeaFeatureSubscription(command: RemoveLeaFeatureSubscriptionCommand): Observable<number[]> {
        let url_ = this.baseUrl + "/api/Configurations/RemoveLeaFeatureSubscription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveLeaFeatureSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveLeaFeatureSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processRemoveLeaFeatureSubscription(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addAllLeaFeatureSubscriptions(command: AddAllLeaFeatureSubscriptionsCommand): Observable<number[]> {
        let url_ = this.baseUrl + "/api/Configurations/AddAllLeaFeatureSubscriptions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddAllLeaFeatureSubscriptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddAllLeaFeatureSubscriptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processAddAllLeaFeatureSubscriptions(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    removeAllLeaFeatureSubscriptions(command: RemoveAllLeaFeatureSubscriptionsCommand): Observable<number[]> {
        let url_ = this.baseUrl + "/api/Configurations/RemoveAllLeaFeatureSubscriptions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveAllLeaFeatureSubscriptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveAllLeaFeatureSubscriptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processRemoveAllLeaFeatureSubscriptions(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CspReportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    report(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/csp-report";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processReport(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DisciplineClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getMatchedNasdtecEntries(model: GetMatchedNasdtecEntriesQuery): Observable<MatchedNasdtecEntryListDto> {
        let url_ = this.baseUrl + "/api/Discipline/GetMatchedNasdtecEntries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMatchedNasdtecEntries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMatchedNasdtecEntries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MatchedNasdtecEntryListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MatchedNasdtecEntryListDto>;
        }));
    }

    protected processGetMatchedNasdtecEntries(response: HttpResponseBase): Observable<MatchedNasdtecEntryListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MatchedNasdtecEntryListDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPersonDisciplines(personId?: number | undefined): Observable<PersonDisciplineDto[]> {
        let url_ = this.baseUrl + "/api/Discipline/GetPersonDisciplines?";
        if (personId === null)
            throw new globalThis.Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonDisciplines(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonDisciplines(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonDisciplineDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonDisciplineDto[]>;
        }));
    }

    protected processGetPersonDisciplines(response: HttpResponseBase): Observable<PersonDisciplineDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PersonDisciplineDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateMatchedNasdtecEntry(command: UpdateMatchedNasdtecEntryCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Discipline/UpdateMatchedNasdtecEntry";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMatchedNasdtecEntry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMatchedNasdtecEntry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdateMatchedNasdtecEntry(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addDiscipline(command: AddOrUpdatePersonDisciplineCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Discipline/AddDiscipline";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddDiscipline(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddDiscipline(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddDiscipline(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateDiscipline(command: AddOrUpdatePersonDisciplineCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Discipline/UpdateDiscipline";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDiscipline(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDiscipline(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdateDiscipline(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteDiscipline(command: DeletePersonDisciplineCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Discipline/DeleteDiscipline";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDiscipline(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDiscipline(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteDiscipline(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProblematicFingerprintCards(model: GetProblematicFingerprintCardsQuery): Observable<ProblematicFingerprintCardListDto> {
        let url_ = this.baseUrl + "/api/Discipline/GetProblematicFingerprintCards";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProblematicFingerprintCards(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProblematicFingerprintCards(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProblematicFingerprintCardListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProblematicFingerprintCardListDto>;
        }));
    }

    protected processGetProblematicFingerprintCards(response: HttpResponseBase): Observable<ProblematicFingerprintCardListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblematicFingerprintCardListDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateProblematicFingerprintCardRecord(command: UpdateProblematicFingerprintCardRecordCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Discipline/UpdateProblematicFingerprintCardRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProblematicFingerprintCardRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProblematicFingerprintCardRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdateProblematicFingerprintCardRecord(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportIUFingerprintCards(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Discipline/ExportIUFingerprintCards";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportIUFingerprintCards(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportIUFingerprintCards(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processExportIUFingerprintCards(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    processCaseIQCaseClosures(command: ProcessCaseIQCaseClosuresCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Discipline/ProcessCaseIQCaseClosures";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProcessCaseIQCaseClosures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProcessCaseIQCaseClosures(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processProcessCaseIQCaseClosures(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCaseIQAutomationReport(): Observable<CaseIQAutomationReportView[]> {
        let url_ = this.baseUrl + "/api/Discipline/GetCaseIQAutomationReport";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaseIQAutomationReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaseIQAutomationReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaseIQAutomationReportView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaseIQAutomationReportView[]>;
        }));
    }

    protected processGetCaseIQAutomationReport(response: HttpResponseBase): Observable<CaseIQAutomationReportView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseIQAutomationReportView[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    manuallyCompleteInvestigativeReview(command: ManuallyCompleteInvestigativeReviewCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Discipline/ManuallyCompleteInvestigativeReview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processManuallyCompleteInvestigativeReview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processManuallyCompleteInvestigativeReview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processManuallyCompleteInvestigativeReview(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EdPrepProgramsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getPersonPPIRecommendations(personId?: number | undefined): Observable<PersonPPIRecommendationDto[]> {
        let url_ = this.baseUrl + "/api/EdPrepPrograms/GetPersonPPIRecommendations?";
        if (personId === null)
            throw new globalThis.Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonPPIRecommendations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonPPIRecommendations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonPPIRecommendationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonPPIRecommendationDto[]>;
        }));
    }

    protected processGetPersonPPIRecommendations(response: HttpResponseBase): Observable<PersonPPIRecommendationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PersonPPIRecommendationDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getApprovedAreasEndorsementsDeficienciesByCertificateTypeId(certificateTypeCodeId?: number | undefined, preparationInstitutionId?: number | undefined): Observable<ApprovedAreasEndorsementsDeficienciesDto> {
        let url_ = this.baseUrl + "/api/EdPrepPrograms/GetApprovedAreasEndorsementsDeficienciesByCertificateTypeId?";
        if (certificateTypeCodeId === null)
            throw new globalThis.Error("The parameter 'certificateTypeCodeId' cannot be null.");
        else if (certificateTypeCodeId !== undefined)
            url_ += "certificateTypeCodeId=" + encodeURIComponent("" + certificateTypeCodeId) + "&";
        if (preparationInstitutionId === null)
            throw new globalThis.Error("The parameter 'preparationInstitutionId' cannot be null.");
        else if (preparationInstitutionId !== undefined)
            url_ += "preparationInstitutionId=" + encodeURIComponent("" + preparationInstitutionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApprovedAreasEndorsementsDeficienciesByCertificateTypeId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApprovedAreasEndorsementsDeficienciesByCertificateTypeId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApprovedAreasEndorsementsDeficienciesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApprovedAreasEndorsementsDeficienciesDto>;
        }));
    }

    protected processGetApprovedAreasEndorsementsDeficienciesByCertificateTypeId(response: HttpResponseBase): Observable<ApprovedAreasEndorsementsDeficienciesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApprovedAreasEndorsementsDeficienciesDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getOutOfStateApprovedAreasAndDeficienciesByCertificateTypeId(certificateTypeCodeId?: number | undefined): Observable<OutOfStateApprovedAreasAndDeficienciesDto> {
        let url_ = this.baseUrl + "/api/EdPrepPrograms/GetOutOfStateApprovedAreasAndDeficienciesByCertificateTypeId?";
        if (certificateTypeCodeId === null)
            throw new globalThis.Error("The parameter 'certificateTypeCodeId' cannot be null.");
        else if (certificateTypeCodeId !== undefined)
            url_ += "certificateTypeCodeId=" + encodeURIComponent("" + certificateTypeCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOutOfStateApprovedAreasAndDeficienciesByCertificateTypeId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOutOfStateApprovedAreasAndDeficienciesByCertificateTypeId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OutOfStateApprovedAreasAndDeficienciesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OutOfStateApprovedAreasAndDeficienciesDto>;
        }));
    }

    protected processGetOutOfStateApprovedAreasAndDeficienciesByCertificateTypeId(response: HttpResponseBase): Observable<OutOfStateApprovedAreasAndDeficienciesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OutOfStateApprovedAreasAndDeficienciesDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addPersonPPIRecommendation(command: AddOrUpdatePersonPPIRecommendationsCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/EdPrepPrograms/AddPersonPPIRecommendation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddPersonPPIRecommendation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPersonPPIRecommendation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddPersonPPIRecommendation(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updatePersonPPIRecommendation(command: AddOrUpdatePersonPPIRecommendationsCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/EdPrepPrograms/UpdatePersonPPIRecommendation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePersonPPIRecommendation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePersonPPIRecommendation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdatePersonPPIRecommendation(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deletePersonPreparationRecommendationProgram(command: DeletePersonPPIRecommendationCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/EdPrepPrograms/DeletePersonPreparationRecommendationProgram";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePersonPreparationRecommendationProgram(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePersonPreparationRecommendationProgram(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeletePersonPreparationRecommendationProgram(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EducatorPortalPreviewClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getServiceItemEvaluationForEducatorPreview(applicationServiceItemId?: number | undefined): Observable<EdPortalPreviewServiceItemEvaluationDto> {
        let url_ = this.baseUrl + "/api/EducatorPortalPreview/GetServiceItemEvaluationForEducatorPreview?";
        if (applicationServiceItemId === null)
            throw new globalThis.Error("The parameter 'applicationServiceItemId' cannot be null.");
        else if (applicationServiceItemId !== undefined)
            url_ += "applicationServiceItemId=" + encodeURIComponent("" + applicationServiceItemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceItemEvaluationForEducatorPreview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceItemEvaluationForEducatorPreview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EdPortalPreviewServiceItemEvaluationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EdPortalPreviewServiceItemEvaluationDto>;
        }));
    }

    protected processGetServiceItemEvaluationForEducatorPreview(response: HttpResponseBase): Observable<EdPortalPreviewServiceItemEvaluationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EdPortalPreviewServiceItemEvaluationDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EducatorsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    createPersons(command: CreatePersonsCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Educators/CreatePersons";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePersons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePersons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePersons(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkExistingEducator(searchQuery: CheckExistingEducatorQuery): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Educators/CheckExistingEducator";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckExistingEducator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckExistingEducator(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckExistingEducator(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEducatorManagementHeaderInfo(personId: number): Observable<EducatorHeaderDto> {
        let url_ = this.baseUrl + "/api/Educators/GetEducatorManagementHeaderInfo/{personId}";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorManagementHeaderInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorManagementHeaderInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EducatorHeaderDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EducatorHeaderDto>;
        }));
    }

    protected processGetEducatorManagementHeaderInfo(response: HttpResponseBase): Observable<EducatorHeaderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EducatorHeaderDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDemographics(personId: number): Observable<EducatorDemographicsDto> {
        let url_ = this.baseUrl + "/api/Educators/GetDemographics/{personId}";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDemographics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDemographics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EducatorDemographicsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EducatorDemographicsDto>;
        }));
    }

    protected processGetDemographics(response: HttpResponseBase): Observable<EducatorDemographicsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EducatorDemographicsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateDemographics(command: UpdateDemographicsCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Educators/UpdateDemographics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDemographics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDemographics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdateDemographics(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPersonsAddressInfo(personId: number): Observable<PersonAddressDto> {
        let url_ = this.baseUrl + "/api/Educators/GetPersonsAddressInfo/{personId}";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonsAddressInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonsAddressInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonAddressDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonAddressDto>;
        }));
    }

    protected processGetPersonsAddressInfo(response: HttpResponseBase): Observable<PersonAddressDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PersonAddressDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPersonsPhoneInfo(personId: number): Observable<PersonPhoneDto[]> {
        let url_ = this.baseUrl + "/api/Educators/GetPersonsPhoneInfo/{personId}";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonsPhoneInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonsPhoneInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonPhoneDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonPhoneDto[]>;
        }));
    }

    protected processGetPersonsPhoneInfo(response: HttpResponseBase): Observable<PersonPhoneDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PersonPhoneDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPersonsEmailInfo(personId: number): Observable<PersonEmailDto[]> {
        let url_ = this.baseUrl + "/api/Educators/GetPersonsEmailInfo/{personId}";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonsEmailInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonsEmailInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonEmailDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonEmailDto[]>;
        }));
    }

    protected processGetPersonsEmailInfo(response: HttpResponseBase): Observable<PersonEmailDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PersonEmailDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addPersonsAddress(command: AddOrUpdatePersonsAddressCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Educators/AddPersonsAddress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddPersonsAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPersonsAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddPersonsAddress(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updatePersonsAddress(command: AddOrUpdatePersonsAddressCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Educators/UpdatePersonsAddress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePersonsAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePersonsAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdatePersonsAddress(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addPersonsPhone(command: AddOrUpdatePersonsPhoneCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Educators/AddPersonsPhone";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddPersonsPhone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPersonsPhone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddPersonsPhone(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updatePersonsPhone(command: AddOrUpdatePersonsPhoneCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Educators/UpdatePersonsPhone";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePersonsPhone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePersonsPhone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdatePersonsPhone(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deletePersonsPhone(command: DeletePersonsPhoneCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Educators/DeletePersonsPhone";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePersonsPhone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePersonsPhone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeletePersonsPhone(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addPersonsEmail(command: AddOrUpdatePersonsEmailCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Educators/AddPersonsEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddPersonsEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPersonsEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddPersonsEmail(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updatePersonsEmail(command: AddOrUpdatePersonsEmailCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Educators/UpdatePersonsEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePersonsEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePersonsEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdatePersonsEmail(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deletePersonsEmail(command: DeletePersonsEmailCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Educators/DeletePersonsEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePersonsEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePersonsEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeletePersonsEmail(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEducatorTests(personId: number): Observable<EducatorTestsResultList> {
        let url_ = this.baseUrl + "/api/Educators/GetEducatorTests/{personId}";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorTests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorTests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EducatorTestsResultList>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EducatorTestsResultList>;
        }));
    }

    protected processGetEducatorTests(response: HttpResponseBase): Observable<EducatorTestsResultList> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EducatorTestsResultList;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addEducatorTest(command: AddUpdatePersonTestsCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Educators/AddEducatorTest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddEducatorTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddEducatorTest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddEducatorTest(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateEducatorTest(command: AddUpdatePersonTestsCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Educators/UpdateEducatorTest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEducatorTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEducatorTest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdateEducatorTest(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteEducatorTest(command: DeletePersonTestsCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Educators/DeleteEducatorTest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteEducatorTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEducatorTest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteEducatorTest(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEducatorDegrees(personId: number): Observable<EducatorDegreeResultList> {
        let url_ = this.baseUrl + "/api/Educators/GetEducatorDegrees/{personId}";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorDegrees(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorDegrees(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EducatorDegreeResultList>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EducatorDegreeResultList>;
        }));
    }

    protected processGetEducatorDegrees(response: HttpResponseBase): Observable<EducatorDegreeResultList> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EducatorDegreeResultList;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addEducatorDegrees(command: AddUpdatePersonDegreesCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Educators/AddEducatorDegrees";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddEducatorDegrees(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddEducatorDegrees(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddEducatorDegrees(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateEducatorDegrees(command: AddUpdatePersonDegreesCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Educators/UpdateEducatorDegrees";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEducatorDegrees(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEducatorDegrees(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateEducatorDegrees(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteEducatorDegree(command: DeletePersonDegreeCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Educators/DeleteEducatorDegree";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteEducatorDegree(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEducatorDegree(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteEducatorDegree(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEducatorApplications(personId: number): Observable<EducatorApplicationDto[]> {
        let url_ = this.baseUrl + "/api/Educators/GetEducatorApplications/{personId}";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorApplications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorApplications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EducatorApplicationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EducatorApplicationDto[]>;
        }));
    }

    protected processGetEducatorApplications(response: HttpResponseBase): Observable<EducatorApplicationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EducatorApplicationDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEducatorApplicationCount(personId: number): Observable<number> {
        let url_ = this.baseUrl + "/api/Educators/GetEducatorApplicationCount/{personId}";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorApplicationCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorApplicationCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetEducatorApplicationCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteEducatorApplication(command: DeleteEducatorApplicationCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Educators/DeleteEducatorApplication";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteEducatorApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEducatorApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteEducatorApplication(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addManualFingerprintCard(command: AddManualFingerprintCardCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Educators/AddManualFingerprintCard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddManualFingerprintCard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddManualFingerprintCard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddManualFingerprintCard(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEducatorFingerprintHistory(personId?: number | undefined, includeManual?: boolean | undefined, includeCER?: boolean | undefined): Observable<EducatorFingerprintHistoryDto[]> {
        let url_ = this.baseUrl + "/api/Educators/GetEducatorFingerprintHistory?";
        if (personId === null)
            throw new globalThis.Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        if (includeManual === null)
            throw new globalThis.Error("The parameter 'includeManual' cannot be null.");
        else if (includeManual !== undefined)
            url_ += "includeManual=" + encodeURIComponent("" + includeManual) + "&";
        if (includeCER === null)
            throw new globalThis.Error("The parameter 'includeCER' cannot be null.");
        else if (includeCER !== undefined)
            url_ += "includeCER=" + encodeURIComponent("" + includeCER) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorFingerprintHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorFingerprintHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EducatorFingerprintHistoryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EducatorFingerprintHistoryDto[]>;
        }));
    }

    protected processGetEducatorFingerprintHistory(response: HttpResponseBase): Observable<EducatorFingerprintHistoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EducatorFingerprintHistoryDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteManualFingerprintCard(command: DeleteManualFingerprintCardCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Educators/DeleteManualFingerprintCard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteManualFingerprintCard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteManualFingerprintCard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteManualFingerprintCard(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteDpsFeedFingerprintCard(command: DeleteDpsFeedFingerprintCardCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Educators/DeleteDpsFeedFingerprintCard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDpsFeedFingerprintCard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDpsFeedFingerprintCard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteDpsFeedFingerprintCard(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEducatorActiveFingerprintCard(personId?: number | undefined, fingerprintId?: number | null | undefined, cardType?: FingerprintCardType | undefined): Observable<PersonFingerprintCardViewInformationDto> {
        let url_ = this.baseUrl + "/api/Educators/GetEducatorActiveFingerprintCard?";
        if (personId === null)
            throw new globalThis.Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        if (fingerprintId !== undefined && fingerprintId !== null)
            url_ += "fingerprintId=" + encodeURIComponent("" + fingerprintId) + "&";
        if (cardType === null)
            throw new globalThis.Error("The parameter 'cardType' cannot be null.");
        else if (cardType !== undefined)
            url_ += "cardType=" + encodeURIComponent("" + cardType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorActiveFingerprintCard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorActiveFingerprintCard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonFingerprintCardViewInformationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonFingerprintCardViewInformationDto>;
        }));
    }

    protected processGetEducatorActiveFingerprintCard(response: HttpResponseBase): Observable<PersonFingerprintCardViewInformationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PersonFingerprintCardViewInformationDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteCER(command: DeleteConditionalEarlyReleaseCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Educators/DeleteCER";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCER(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCER(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteCER(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addCER(command: AddUpdateConditionalEarlyReleaseCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Educators/AddCER";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCER(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCER(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddCER(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateCER(command: AddUpdateConditionalEarlyReleaseCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Educators/UpdateCER";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCER(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCER(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateCER(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCerByPersonCerId(personCerId: number): Observable<ConditionalEarlyReleaseDto> {
        let url_ = this.baseUrl + "/api/Educators/GetCerByPersonCerId/{personCerId}";
        if (personCerId === undefined || personCerId === null)
            throw new globalThis.Error("The parameter 'personCerId' must be defined.");
        url_ = url_.replace("{personCerId}", encodeURIComponent("" + personCerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCerByPersonCerId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCerByPersonCerId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConditionalEarlyReleaseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConditionalEarlyReleaseDto>;
        }));
    }

    protected processGetCerByPersonCerId(response: HttpResponseBase): Observable<ConditionalEarlyReleaseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ConditionalEarlyReleaseDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEducatorCers(personId: number): Observable<ConditionalEarlyReleaseListItemDto[]> {
        let url_ = this.baseUrl + "/api/Educators/GetEducatorCers/{personId}";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorCers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorCers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConditionalEarlyReleaseListItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConditionalEarlyReleaseListItemDto[]>;
        }));
    }

    protected processGetEducatorCers(response: HttpResponseBase): Observable<ConditionalEarlyReleaseListItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ConditionalEarlyReleaseListItemDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEducatorNotes(personId: number): Observable<EducatorAuditItemsDto> {
        let url_ = this.baseUrl + "/api/Educators/GetEducatorNotes/{personId}";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorNotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EducatorAuditItemsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EducatorAuditItemsDto>;
        }));
    }

    protected processGetEducatorNotes(response: HttpResponseBase): Observable<EducatorAuditItemsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EducatorAuditItemsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addEducatorNote(command: AddOrUpdateEducatorNoteCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Educators/AddEducatorNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddEducatorNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddEducatorNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddEducatorNote(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateEducatorNote(command: AddOrUpdateEducatorNoteCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Educators/UpdateEducatorNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEducatorNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEducatorNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdateEducatorNote(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteEducatorNote(command: DeleteEducatorNoteCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Educators/DeleteEducatorNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteEducatorNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEducatorNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteEducatorNote(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addOrUpdateDocument(command: AddOrUpdateEducatorDocumentCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Educators/AddOrUpdateDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddOrUpdateDocument(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDocumentContentByPersonDocumentId(personDocumentId: number): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Educators/GetDocumentContentByPersonDocumentId/{personDocumentId}";
        if (personDocumentId === undefined || personDocumentId === null)
            throw new globalThis.Error("The parameter 'personDocumentId' must be defined.");
        url_ = url_.replace("{personDocumentId}", encodeURIComponent("" + personDocumentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentContentByPersonDocumentId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentContentByPersonDocumentId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGetDocumentContentByPersonDocumentId(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    repairRemoteLink(command: RepairRemoteDocumentLinkCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Educators/RepairRemoteLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRepairRemoteLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRepairRemoteLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processRepairRemoteLink(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEducatorDocuments(personId: number): Observable<EducatorDocumentDto[]> {
        let url_ = this.baseUrl + "/api/Educators/GetEducatorDocuments/{personId}";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EducatorDocumentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EducatorDocumentDto[]>;
        }));
    }

    protected processGetEducatorDocuments(response: HttpResponseBase): Observable<EducatorDocumentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EducatorDocumentDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEducatorCertificates(personId: number): Observable<EducatorCertificateDto[]> {
        let url_ = this.baseUrl + "/api/Educators/GetEducatorCertificates/{personId}";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorCertificates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorCertificates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EducatorCertificateDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EducatorCertificateDto[]>;
        }));
    }

    protected processGetEducatorCertificates(response: HttpResponseBase): Observable<EducatorCertificateDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EducatorCertificateDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEducatorApprovedAreas(personId: number): Observable<EducatorApprovedAreaDto[]> {
        let url_ = this.baseUrl + "/api/Educators/GetEducatorApprovedAreas/{personId}";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorApprovedAreas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorApprovedAreas(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EducatorApprovedAreaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EducatorApprovedAreaDto[]>;
        }));
    }

    protected processGetEducatorApprovedAreas(response: HttpResponseBase): Observable<EducatorApprovedAreaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EducatorApprovedAreaDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEducatorEndorsements(personId: number): Observable<EducatorEndorsementDto[]> {
        let url_ = this.baseUrl + "/api/Educators/GetEducatorEndorsements/{personId}";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorEndorsements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorEndorsements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EducatorEndorsementDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EducatorEndorsementDto[]>;
        }));
    }

    protected processGetEducatorEndorsements(response: HttpResponseBase): Observable<EducatorEndorsementDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EducatorEndorsementDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEducatorExistingCertAreaEndorsements(personId: number): Observable<ExistingCertAreaEndorsementsDto> {
        let url_ = this.baseUrl + "/api/Educators/GetEducatorExistingCertAreaEndorsements/{personId}";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorExistingCertAreaEndorsements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorExistingCertAreaEndorsements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExistingCertAreaEndorsementsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExistingCertAreaEndorsementsDto>;
        }));
    }

    protected processGetEducatorExistingCertAreaEndorsements(response: HttpResponseBase): Observable<ExistingCertAreaEndorsementsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExistingCertAreaEndorsementsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEducatorCurrentBalance(personId?: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/Educators/GetEducatorCurrentBalance?";
        if (personId === null)
            throw new globalThis.Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorCurrentBalance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorCurrentBalance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetEducatorCurrentBalance(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEducatorPaymentReversals(personId?: number | undefined): Observable<EducatorManagementPaymentReversalDto[]> {
        let url_ = this.baseUrl + "/api/Educators/GetEducatorPaymentReversals?";
        if (personId === null)
            throw new globalThis.Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorPaymentReversals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorPaymentReversals(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EducatorManagementPaymentReversalDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EducatorManagementPaymentReversalDto[]>;
        }));
    }

    protected processGetEducatorPaymentReversals(response: HttpResponseBase): Observable<EducatorManagementPaymentReversalDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EducatorManagementPaymentReversalDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEducatorLedger(personId?: number | undefined): Observable<EducatorLedgerDto[]> {
        let url_ = this.baseUrl + "/api/Educators/GetEducatorLedger?";
        if (personId === null)
            throw new globalThis.Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorLedger(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorLedger(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EducatorLedgerDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EducatorLedgerDto[]>;
        }));
    }

    protected processGetEducatorLedger(response: HttpResponseBase): Observable<EducatorLedgerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EducatorLedgerDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addManualPersonAlert(command: AddManualPersonAlertCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Educators/AddManualPersonAlert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddManualPersonAlert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddManualPersonAlert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddManualPersonAlert(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deletePersonAlert(command: DeletePersonAlertCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Educators/DeletePersonAlert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePersonAlert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePersonAlert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeletePersonAlert(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPendingReviewDocumentsListOptions(): Observable<PendingReviewDocumentsListOptionsDto> {
        let url_ = this.baseUrl + "/api/Educators/GetPendingReviewDocumentsListOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPendingReviewDocumentsListOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPendingReviewDocumentsListOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PendingReviewDocumentsListOptionsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PendingReviewDocumentsListOptionsDto>;
        }));
    }

    protected processGetPendingReviewDocumentsListOptions(response: HttpResponseBase): Observable<PendingReviewDocumentsListOptionsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PendingReviewDocumentsListOptionsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPendingReviewDocuments(documentCodeId?: number | undefined, year?: string | null | undefined): Observable<DocumentReviewDto[]> {
        let url_ = this.baseUrl + "/api/Educators/GetPendingReviewDocuments?";
        if (documentCodeId === null)
            throw new globalThis.Error("The parameter 'documentCodeId' cannot be null.");
        else if (documentCodeId !== undefined)
            url_ += "documentCodeId=" + encodeURIComponent("" + documentCodeId) + "&";
        if (year !== undefined && year !== null)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPendingReviewDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPendingReviewDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentReviewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentReviewDto[]>;
        }));
    }

    protected processGetPendingReviewDocuments(response: HttpResponseBase): Observable<DocumentReviewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentReviewDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDetailsForDocumentReview(personDocumentId?: number | undefined): Observable<DocumentReviewDetailsDto> {
        let url_ = this.baseUrl + "/api/Educators/GetDetailsForDocumentReview?";
        if (personDocumentId === null)
            throw new globalThis.Error("The parameter 'personDocumentId' cannot be null.");
        else if (personDocumentId !== undefined)
            url_ += "personDocumentId=" + encodeURIComponent("" + personDocumentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDetailsForDocumentReview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetailsForDocumentReview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentReviewDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentReviewDetailsDto>;
        }));
    }

    protected processGetDetailsForDocumentReview(response: HttpResponseBase): Observable<DocumentReviewDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentReviewDetailsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateEducatorDocumentFromReview(command: UpdateEducatorDocumentFromReviewCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Educators/UpdateEducatorDocumentFromReview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEducatorDocumentFromReview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEducatorDocumentFromReview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateEducatorDocumentFromReview(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPrintJobDocuments(): Observable<PrintQueueDocumentDto[]> {
        let url_ = this.baseUrl + "/api/Educators/GetPrintJobDocuments";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPrintJobDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPrintJobDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PrintQueueDocumentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PrintQueueDocumentDto[]>;
        }));
    }

    protected processGetPrintJobDocuments(response: HttpResponseBase): Observable<PrintQueueDocumentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PrintQueueDocumentDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPrintQueueQuickFilterCounts(): Observable<PrintQueueQuickFilterCountsDto> {
        let url_ = this.baseUrl + "/api/Educators/GetPrintQueueQuickFilterCounts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPrintQueueQuickFilterCounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPrintQueueQuickFilterCounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PrintQueueQuickFilterCountsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PrintQueueQuickFilterCountsDto>;
        }));
    }

    protected processGetPrintQueueQuickFilterCounts(response: HttpResponseBase): Observable<PrintQueueQuickFilterCountsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PrintQueueQuickFilterCountsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createPrintJob(command: CreatePrintJobCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Educators/CreatePrintJob";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePrintJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePrintJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processCreatePrintJob(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getApplicationDocuments(applicationId: number): Observable<ApplicationDocumentDto[]> {
        let url_ = this.baseUrl + "/api/Educators/GetApplicationDocuments/{applicationId}";
        if (applicationId === undefined || applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApplicationDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApplicationDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationDocumentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationDocumentDto[]>;
        }));
    }

    protected processGetApplicationDocuments(response: HttpResponseBase): Observable<ApplicationDocumentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationDocumentDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    finalizePrintJob(command: FinalizePrintJobCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Educators/FinalizePrintJob";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinalizePrintJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinalizePrintJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processFinalizePrintJob(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deletePrintJob(command: DeletePrintJobCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Educators/DeletePrintJob";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePrintJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePrintJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeletePrintJob(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    collatePrintJobDocuments(command: CollatePrintJobDocumentsCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Educators/CollatePrintJobDocuments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCollatePrintJobDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCollatePrintJobDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processCollatePrintJobDocuments(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAddressWindowDocument(command: GetAddressWindowDocumentCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Educators/GetAddressWindowDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAddressWindowDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAddressWindowDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGetAddressWindowDocument(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPrintJobs(model: GetPrintJobsQuery): Observable<PrintJobListDto> {
        let url_ = this.baseUrl + "/api/Educators/GetPrintJobs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPrintJobs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPrintJobs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PrintJobListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PrintJobListDto>;
        }));
    }

    protected processGetPrintJobs(response: HttpResponseBase): Observable<PrintJobListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PrintJobListDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLatestPrintJobForCurrentUser(): Observable<PrintJobDto> {
        let url_ = this.baseUrl + "/api/Educators/GetLatestPrintJobForCurrentUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLatestPrintJobForCurrentUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLatestPrintJobForCurrentUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PrintJobDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PrintJobDto>;
        }));
    }

    protected processGetLatestPrintJobForCurrentUser(response: HttpResponseBase): Observable<PrintJobDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PrintJobDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSetFiltersForPrintJobsGrid(columnNames: string[]): Observable<SetFilterResultDto[]> {
        let url_ = this.baseUrl + "/api/Educators/GetSetFiltersForPrintJobsGrid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(columnNames);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSetFiltersForPrintJobsGrid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSetFiltersForPrintJobsGrid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SetFilterResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SetFilterResultDto[]>;
        }));
    }

    protected processGetSetFiltersForPrintJobsGrid(response: HttpResponseBase): Observable<SetFilterResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SetFilterResultDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEducatorCertificateHistory(personId?: number | undefined): Observable<EducatorCertificateSnapshotGroupDto[]> {
        let url_ = this.baseUrl + "/api/Educators/GetEducatorCertificateHistory?";
        if (personId === null)
            throw new globalThis.Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorCertificateHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorCertificateHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EducatorCertificateSnapshotGroupDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EducatorCertificateSnapshotGroupDto[]>;
        }));
    }

    protected processGetEducatorCertificateHistory(response: HttpResponseBase): Observable<EducatorCertificateSnapshotGroupDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EducatorCertificateSnapshotGroupDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCertificateVerificationLetter(command: GetCertificateVerificationLetterCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Educators/GetCertificateVerificationLetter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCertificateVerificationLetter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCertificateVerificationLetter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGetCertificateVerificationLetter(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    generateCertificate(command: GenerateCertificateCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Educators/GenerateCertificate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateCertificate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateCertificate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGenerateCertificate(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updatePersonCertificate(command: UpdatePersonCertificateCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Educators/UpdatePersonCertificate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePersonCertificate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePersonCertificate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdatePersonCertificate(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEducatorEmploymentHistory(personId: number): Observable<StaffEmploymentHistoryDto> {
        let url_ = this.baseUrl + "/api/Educators/GetEducatorEmploymentHistory/{personId}";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorEmploymentHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorEmploymentHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StaffEmploymentHistoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StaffEmploymentHistoryDto>;
        }));
    }

    protected processGetEducatorEmploymentHistory(response: HttpResponseBase): Observable<StaffEmploymentHistoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StaffEmploymentHistoryDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEducatorProfessionalDevelopmentRecords(personId: number, applicationServiceItemId?: number | undefined, showVerifiedRecords?: boolean | undefined): Observable<EducatorProfessionalDevelopmentRecordDto[]> {
        let url_ = this.baseUrl + "/api/Educators/GetEducatorProfessionalDevelopmentRecords/{personId}?";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        if (applicationServiceItemId === null)
            throw new globalThis.Error("The parameter 'applicationServiceItemId' cannot be null.");
        else if (applicationServiceItemId !== undefined)
            url_ += "applicationServiceItemId=" + encodeURIComponent("" + applicationServiceItemId) + "&";
        if (showVerifiedRecords === null)
            throw new globalThis.Error("The parameter 'showVerifiedRecords' cannot be null.");
        else if (showVerifiedRecords !== undefined)
            url_ += "showVerifiedRecords=" + encodeURIComponent("" + showVerifiedRecords) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorProfessionalDevelopmentRecords(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorProfessionalDevelopmentRecords(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EducatorProfessionalDevelopmentRecordDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EducatorProfessionalDevelopmentRecordDto[]>;
        }));
    }

    protected processGetEducatorProfessionalDevelopmentRecords(response: HttpResponseBase): Observable<EducatorProfessionalDevelopmentRecordDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EducatorProfessionalDevelopmentRecordDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEducatorProfessionalDevelopmentSummary(applicationServiceItemId: number): Observable<EducatorProfessionalDevelopmentSummaryDto> {
        let url_ = this.baseUrl + "/api/Educators/GetEducatorProfessionalDevelopmentSummary/{applicationServiceItemId}";
        if (applicationServiceItemId === undefined || applicationServiceItemId === null)
            throw new globalThis.Error("The parameter 'applicationServiceItemId' must be defined.");
        url_ = url_.replace("{applicationServiceItemId}", encodeURIComponent("" + applicationServiceItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorProfessionalDevelopmentSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorProfessionalDevelopmentSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EducatorProfessionalDevelopmentSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EducatorProfessionalDevelopmentSummaryDto>;
        }));
    }

    protected processGetEducatorProfessionalDevelopmentSummary(response: HttpResponseBase): Observable<EducatorProfessionalDevelopmentSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EducatorProfessionalDevelopmentSummaryDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEducatorCases(personId: number): Observable<EducatorCaseDto[]> {
        let url_ = this.baseUrl + "/api/Educators/GetEducatorCases/{personId}";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorCases(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorCases(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EducatorCaseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EducatorCaseDto[]>;
        }));
    }

    protected processGetEducatorCases(response: HttpResponseBase): Observable<EducatorCaseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EducatorCaseDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAddressExistsStatus(personId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Educators/GetAddressExistsStatus/{personId}";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAddressExistsStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAddressExistsStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processGetAddressExistsStatus(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deletePersonCertificate(command: DeletePersonCertificateCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Educators/DeletePersonCertificate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePersonCertificate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePersonCertificate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeletePersonCertificate(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deletePersonApprovedArea(command: DeletePersonApprovedAreaCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Educators/DeletePersonApprovedArea";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePersonApprovedArea(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePersonApprovedArea(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeletePersonApprovedArea(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deletePersonEndorsement(command: DeletePersonEndorsementCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Educators/DeletePersonEndorsement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePersonEndorsement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePersonEndorsement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeletePersonEndorsement(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updatePersonApprovedArea(command: UpdatePersonApprovedAreaCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Educators/UpdatePersonApprovedArea";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePersonApprovedArea(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePersonApprovedArea(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdatePersonApprovedArea(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updatePersonEndorsement(command: UpdatePersonEndorsementCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Educators/UpdatePersonEndorsement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePersonEndorsement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePersonEndorsement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdatePersonEndorsement(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEducatorDuplicatesSearch(searchQuery: GetEducatorDuplicatesSearchQuery): Observable<DuplicateEducatorSearchDto[]> {
        let url_ = this.baseUrl + "/api/Educators/GetEducatorDuplicatesSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorDuplicatesSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorDuplicatesSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DuplicateEducatorSearchDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DuplicateEducatorSearchDto[]>;
        }));
    }

    protected processGetEducatorDuplicatesSearch(response: HttpResponseBase): Observable<DuplicateEducatorSearchDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DuplicateEducatorSearchDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    linkDuplicateEducator(command: LinkDuplicateEducatorCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Educators/LinkDuplicateEducator";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLinkDuplicateEducator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLinkDuplicateEducator(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processLinkDuplicateEducator(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    linkEducatorsFromPotentialMatch(command: LinkEducatorsFromPotentialMatchCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Educators/LinkEducatorsFromPotentialMatch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLinkEducatorsFromPotentialMatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLinkEducatorsFromPotentialMatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processLinkEducatorsFromPotentialMatch(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    removeDuplicateEducatorLink(command: RemoveDuplicateEducatorLinkCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Educators/RemoveDuplicateEducatorLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveDuplicateEducatorLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveDuplicateEducatorLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processRemoveDuplicateEducatorLink(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEducatorDuplicates(query: GetEducatorDuplicatesQuery): Observable<DuplicateEducatorDto[]> {
        let url_ = this.baseUrl + "/api/Educators/GetEducatorDuplicates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorDuplicates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorDuplicates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DuplicateEducatorDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DuplicateEducatorDto[]>;
        }));
    }

    protected processGetEducatorDuplicates(response: HttpResponseBase): Observable<DuplicateEducatorDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DuplicateEducatorDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEducatorPotentialMatches(query: GetEducatorPotentialMatchesQuery): Observable<PotentialEducatorMatchDto[]> {
        let url_ = this.baseUrl + "/api/Educators/GetEducatorPotentialMatches";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorPotentialMatches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorPotentialMatches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PotentialEducatorMatchDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PotentialEducatorMatchDto[]>;
        }));
    }

    protected processGetEducatorPotentialMatches(response: HttpResponseBase): Observable<PotentialEducatorMatchDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PotentialEducatorMatchDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEducatorEinFrom(query: GetEducatorEinFromPersonIdQuery): Observable<string> {
        let url_ = this.baseUrl + "/api/Educators/GetEducatorEinFrom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorEinFrom(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorEinFrom(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetEducatorEinFrom(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    associateTranscript(command: AssociateTranscriptCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Educators/AssociateTranscript";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssociateTranscript(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssociateTranscript(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAssociateTranscript(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    associateAbsoluteTranscripts(command: AssociateAbsoluteTranscriptCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Educators/AssociateAbsoluteTranscripts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssociateAbsoluteTranscripts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssociateAbsoluteTranscripts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processAssociateAbsoluteTranscripts(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEducatorAssociatedTranscripts(personId?: number | undefined): Observable<TranscriptMatchDto[]> {
        let url_ = this.baseUrl + "/api/Educators/GetEducatorAssociatedTranscripts?";
        if (personId === null)
            throw new globalThis.Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorAssociatedTranscripts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorAssociatedTranscripts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TranscriptMatchDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TranscriptMatchDto[]>;
        }));
    }

    protected processGetEducatorAssociatedTranscripts(response: HttpResponseBase): Observable<TranscriptMatchDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TranscriptMatchDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEducatorUnassociatedTranscripts(personId?: number | undefined): Observable<PotentialTranscriptMatchDto[]> {
        let url_ = this.baseUrl + "/api/Educators/GetEducatorUnassociatedTranscripts?";
        if (personId === null)
            throw new globalThis.Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorUnassociatedTranscripts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorUnassociatedTranscripts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PotentialTranscriptMatchDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PotentialTranscriptMatchDto[]>;
        }));
    }

    protected processGetEducatorUnassociatedTranscripts(response: HttpResponseBase): Observable<PotentialTranscriptMatchDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PotentialTranscriptMatchDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTranscriptDocument(personId: number, transcriptId: number): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Educators/GetTranscriptDocument/{personId}/{transcriptId}";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        if (transcriptId === undefined || transcriptId === null)
            throw new globalThis.Error("The parameter 'transcriptId' must be defined.");
        url_ = url_.replace("{transcriptId}", encodeURIComponent("" + transcriptId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTranscriptDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTranscriptDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGetTranscriptDocument(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deletePersonDocument(command: DeletePersonDocumentCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Educators/DeletePersonDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePersonDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePersonDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeletePersonDocument(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEducatorSpecialPrograms(personId: number): Observable<EducatorSpecialProgramResultList> {
        let url_ = this.baseUrl + "/api/Educators/GetEducatorSpecialPrograms/{personId}";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorSpecialPrograms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorSpecialPrograms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EducatorSpecialProgramResultList>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EducatorSpecialProgramResultList>;
        }));
    }

    protected processGetEducatorSpecialPrograms(response: HttpResponseBase): Observable<EducatorSpecialProgramResultList> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EducatorSpecialProgramResultList;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addEducatorSpecialProgram(command: AddUpdatePersonSpecialProgramCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Educators/AddEducatorSpecialProgram";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddEducatorSpecialProgram(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddEducatorSpecialProgram(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddEducatorSpecialProgram(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateEducatorSpecialPrograms(command: AddUpdatePersonSpecialProgramCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Educators/UpdateEducatorSpecialPrograms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEducatorSpecialPrograms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEducatorSpecialPrograms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateEducatorSpecialPrograms(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteEducatorSpecialProgram(command: DeletePersonSpecialProgramCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Educators/DeleteEducatorSpecialProgram";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteEducatorSpecialProgram(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEducatorSpecialProgram(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteEducatorSpecialProgram(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    resetPersonInformation(command: ResetPersonInformationCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Educators/ResetPersonInformation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPersonInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPersonInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processResetPersonInformation(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadPrintJobMailingLabels(startDate?: Date | undefined, includeFinalizedJobs?: boolean | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Educators/DownloadPrintJobMailingLabels?";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (includeFinalizedJobs === null)
            throw new globalThis.Error("The parameter 'includeFinalizedJobs' cannot be null.");
        else if (includeFinalizedJobs !== undefined)
            url_ += "includeFinalizedJobs=" + encodeURIComponent("" + includeFinalizedJobs) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadPrintJobMailingLabels(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadPrintJobMailingLabels(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDownloadPrintJobMailingLabels(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EppClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getEducatorHeaderInformation(personId: number): Observable<EppEducatorHeaderDto> {
        let url_ = this.baseUrl + "/api/Epp/GetEducatorHeaderInformation/{personId}";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorHeaderInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorHeaderInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EppEducatorHeaderDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EppEducatorHeaderDto>;
        }));
    }

    protected processGetEducatorHeaderInformation(response: HttpResponseBase): Observable<EppEducatorHeaderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EppEducatorHeaderDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEducatorGeneralInformation(personId: number): Observable<EducatorInformationDto> {
        let url_ = this.baseUrl + "/api/Epp/GetEducatorGeneralInformation/{personId}";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorGeneralInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorGeneralInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EducatorInformationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EducatorInformationDto>;
        }));
    }

    protected processGetEducatorGeneralInformation(response: HttpResponseBase): Observable<EducatorInformationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EducatorInformationDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEducatorGeneralFingerprintCard(personId: number): Observable<PersonFingerprintCardInformationDto> {
        let url_ = this.baseUrl + "/api/Epp/GetEducatorGeneralFingerprintCard/{personId}";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorGeneralFingerprintCard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorGeneralFingerprintCard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonFingerprintCardInformationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonFingerprintCardInformationDto>;
        }));
    }

    protected processGetEducatorGeneralFingerprintCard(response: HttpResponseBase): Observable<PersonFingerprintCardInformationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PersonFingerprintCardInformationDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEducatorCertificates(personId?: number | undefined): Observable<EppEducatorCertificateDto[]> {
        let url_ = this.baseUrl + "/api/Epp?";
        if (personId === null)
            throw new globalThis.Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorCertificates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorCertificates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EppEducatorCertificateDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EppEducatorCertificateDto[]>;
        }));
    }

    protected processGetEducatorCertificates(response: HttpResponseBase): Observable<EppEducatorCertificateDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EppEducatorCertificateDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEducatorApplications(personId: number): Observable<EppEducatorApplicationDto[]> {
        let url_ = this.baseUrl + "/api/Epp/GetEducatorApplications/{personId}";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorApplications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorApplications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EppEducatorApplicationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EppEducatorApplicationDto[]>;
        }));
    }

    protected processGetEducatorApplications(response: HttpResponseBase): Observable<EppEducatorApplicationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EppEducatorApplicationDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEducatorEducation(personId: number): Observable<EppEducatorEducationDto[]> {
        let url_ = this.baseUrl + "/api/Epp/GetEducatorEducation/{personId}";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorEducation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorEducation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EppEducatorEducationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EppEducatorEducationDto[]>;
        }));
    }

    protected processGetEducatorEducation(response: HttpResponseBase): Observable<EppEducatorEducationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EppEducatorEducationDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEducatorExams(personId: number): Observable<EducatorExamDto[]> {
        let url_ = this.baseUrl + "/api/Epp/GetEducatorExams/{personId}";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorExams(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorExams(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EducatorExamDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EducatorExamDto[]>;
        }));
    }

    protected processGetEducatorExams(response: HttpResponseBase): Observable<EducatorExamDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EducatorExamDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEducatorEmploymentHistory(personId: number): Observable<StaffEmploymentHistoryDto> {
        let url_ = this.baseUrl + "/api/Epp/GetEducatorEmploymentHistory/{personId}";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorEmploymentHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorEmploymentHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StaffEmploymentHistoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StaffEmploymentHistoryDto>;
        }));
    }

    protected processGetEducatorEmploymentHistory(response: HttpResponseBase): Observable<StaffEmploymentHistoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StaffEmploymentHistoryDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCohorts(model: GetCohortsQuery): Observable<EppCohortListDto> {
        let url_ = this.baseUrl + "/api/Epp/GetCohorts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCohorts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCohorts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EppCohortListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EppCohortListDto>;
        }));
    }

    protected processGetCohorts(response: HttpResponseBase): Observable<EppCohortListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EppCohortListDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCohortsSetFilterValues(query: GetCohortsSetFiltersQuery): Observable<SetFilterResultDto> {
        let url_ = this.baseUrl + "/api/Epp/GetCohortsSetFilterValues";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCohortsSetFilterValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCohortsSetFilterValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SetFilterResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SetFilterResultDto>;
        }));
    }

    protected processGetCohortsSetFilterValues(response: HttpResponseBase): Observable<SetFilterResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SetFilterResultDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addCohort(command: AddCohortCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Epp/AddCohort";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCohort(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCohort(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddCohort(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateCohort(command: UpdateCohortCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Epp/UpdateCohort";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCohort(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCohort(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdateCohort(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    removeCohort(command: RemoveCohortCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Epp/RemoveCohort";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveCohort(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveCohort(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processRemoveCohort(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCohortStudents(model: GetCohortStudentsQuery): Observable<EppCohortStudentListDto> {
        let url_ = this.baseUrl + "/api/Epp/GetCohortStudents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCohortStudents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCohortStudents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EppCohortStudentListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EppCohortStudentListDto>;
        }));
    }

    protected processGetCohortStudents(response: HttpResponseBase): Observable<EppCohortStudentListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EppCohortStudentListDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCohortStudentsSetFilterValues(query: GetCohortStudentsSetFiltersQuery): Observable<SetFilterResultDto> {
        let url_ = this.baseUrl + "/api/Epp/GetCohortStudentsSetFilterValues";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCohortStudentsSetFilterValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCohortStudentsSetFilterValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SetFilterResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SetFilterResultDto>;
        }));
    }

    protected processGetCohortStudentsSetFilterValues(response: HttpResponseBase): Observable<SetFilterResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SetFilterResultDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    removeStudentFromCohort(command: RemoveStudentFromCohortCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Epp/RemoveStudentFromCohort";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveStudentFromCohort(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveStudentFromCohort(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processRemoveStudentFromCohort(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCohortInformation(cohortId?: number | undefined): Observable<CohortInformationDto> {
        let url_ = this.baseUrl + "/api/Epp/GetCohortInformation?";
        if (cohortId === null)
            throw new globalThis.Error("The parameter 'cohortId' cannot be null.");
        else if (cohortId !== undefined)
            url_ += "cohortId=" + encodeURIComponent("" + cohortId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCohortInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCohortInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CohortInformationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CohortInformationDto>;
        }));
    }

    protected processGetCohortInformation(response: HttpResponseBase): Observable<CohortInformationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CohortInformationDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAvailableCohorts(query: GetAvailableInstitutionCohortsForStudentQuery): Observable<InstitutionCohortsForStudentDto> {
        let url_ = this.baseUrl + "/api/Epp/GetAvailableCohorts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailableCohorts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailableCohorts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InstitutionCohortsForStudentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InstitutionCohortsForStudentDto>;
        }));
    }

    protected processGetAvailableCohorts(response: HttpResponseBase): Observable<InstitutionCohortsForStudentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InstitutionCohortsForStudentDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addStudentToCohort(command: AddStudentToCohortCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Epp/AddStudentToCohort";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddStudentToCohort(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddStudentToCohort(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddStudentToCohort(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getStudentCohorts(personId?: number | undefined): Observable<StudentCohortDto[]> {
        let url_ = this.baseUrl + "/api/Epp/GetStudentCohorts?";
        if (personId === null)
            throw new globalThis.Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStudentCohorts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStudentCohorts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StudentCohortDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StudentCohortDto[]>;
        }));
    }

    protected processGetStudentCohorts(response: HttpResponseBase): Observable<StudentCohortDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StudentCohortDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProgramRecommendation(cohortStudentProgramId?: number | undefined): Observable<ProgramRecommendationDto> {
        let url_ = this.baseUrl + "/api/Epp/GetProgramRecommendation?";
        if (cohortStudentProgramId === null)
            throw new globalThis.Error("The parameter 'cohortStudentProgramId' cannot be null.");
        else if (cohortStudentProgramId !== undefined)
            url_ += "cohortStudentProgramId=" + encodeURIComponent("" + cohortStudentProgramId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProgramRecommendation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProgramRecommendation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProgramRecommendationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProgramRecommendationDto>;
        }));
    }

    protected processGetProgramRecommendation(response: HttpResponseBase): Observable<ProgramRecommendationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProgramRecommendationDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveCohortStudentProgram(command: SaveCohortStudentProgramCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Epp/SaveCohortStudentProgram";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveCohortStudentProgram(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveCohortStudentProgram(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processSaveCohortStudentProgram(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    revertManualWithdrawalFromCohortStudentProgram(command: RevertManualWithdrawalFromCohortStudentProgramCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Epp/RevertManualWithdrawalFromCohortStudentProgram";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRevertManualWithdrawalFromCohortStudentProgram(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRevertManualWithdrawalFromCohortStudentProgram(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processRevertManualWithdrawalFromCohortStudentProgram(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAvailableInstitutionProgramsForStudent(query: GetAvailableInstitutionProgramsForStudentQuery): Observable<SimpleCodeDescriptionDto[]> {
        let url_ = this.baseUrl + "/api/Epp/GetAvailableInstitutionProgramsForStudent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailableInstitutionProgramsForStudent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailableInstitutionProgramsForStudent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleCodeDescriptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleCodeDescriptionDto[]>;
        }));
    }

    protected processGetAvailableInstitutionProgramsForStudent(response: HttpResponseBase): Observable<SimpleCodeDescriptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimpleCodeDescriptionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProgramsForInstitution(): Observable<SimpleCodeDescriptionDto[]> {
        let url_ = this.baseUrl + "/api/Epp/GetProgramsForInstitution";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProgramsForInstitution(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProgramsForInstitution(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleCodeDescriptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleCodeDescriptionDto[]>;
        }));
    }

    protected processGetProgramsForInstitution(response: HttpResponseBase): Observable<SimpleCodeDescriptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimpleCodeDescriptionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCohortStudentPrograms(query: GetCohortStudentProgramsQuery): Observable<SimpleCodeDescriptionDto[]> {
        let url_ = this.baseUrl + "/api/Epp/GetCohortStudentPrograms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCohortStudentPrograms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCohortStudentPrograms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleCodeDescriptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleCodeDescriptionDto[]>;
        }));
    }

    protected processGetCohortStudentPrograms(response: HttpResponseBase): Observable<SimpleCodeDescriptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimpleCodeDescriptionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    authorizeCohortStudentProgram(command: AuthorizeCohortStudentProgramCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Epp/AuthorizeCohortStudentProgram";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthorizeCohortStudentProgram(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthorizeCohortStudentProgram(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAuthorizeCohortStudentProgram(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPotentialVoucherOptions(cohortStudentProgramId?: number | undefined): Observable<EppVoucherProgramOptionsDto> {
        let url_ = this.baseUrl + "/api/Epp/GetPotentialVoucherOptions?";
        if (cohortStudentProgramId === null)
            throw new globalThis.Error("The parameter 'cohortStudentProgramId' cannot be null.");
        else if (cohortStudentProgramId !== undefined)
            url_ += "cohortStudentProgramId=" + encodeURIComponent("" + cohortStudentProgramId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPotentialVoucherOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPotentialVoucherOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EppVoucherProgramOptionsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EppVoucherProgramOptionsDto>;
        }));
    }

    protected processGetPotentialVoucherOptions(response: HttpResponseBase): Observable<EppVoucherProgramOptionsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EppVoucherProgramOptionsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteCohortStudentProgram(command: DeleteCohortStudentProgramCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Epp/DeleteCohortStudentProgram";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCohortStudentProgram(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCohortStudentProgram(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteCohortStudentProgram(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadStudentUploadTemplate(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Epp/DownloadStudentUploadTemplate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadStudentUploadTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadStudentUploadTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDownloadStudentUploadTemplate(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadIRUploadTemplate(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Epp/DownloadIRUploadTemplate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadIRUploadTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadIRUploadTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDownloadIRUploadTemplate(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    validateStudentsFromFile(command: ValidateStudentsFromFileCommand): Observable<StudentSpreadsheetErrorsDto> {
        let url_ = this.baseUrl + "/api/Epp/ValidateStudentsFromFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateStudentsFromFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateStudentsFromFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StudentSpreadsheetErrorsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StudentSpreadsheetErrorsDto>;
        }));
    }

    protected processValidateStudentsFromFile(response: HttpResponseBase): Observable<StudentSpreadsheetErrorsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StudentSpreadsheetErrorsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    validateIRFile(command: ValidateIRFileCommand): Observable<IRSpreadsheetErrorsDto> {
        let url_ = this.baseUrl + "/api/Epp/ValidateIRFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateIRFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateIRFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IRSpreadsheetErrorsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IRSpreadsheetErrorsDto>;
        }));
    }

    protected processValidateIRFile(response: HttpResponseBase): Observable<IRSpreadsheetErrorsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IRSpreadsheetErrorsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportStudents(cohortId?: number | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Epp/ExportStudents?";
        if (cohortId === null)
            throw new globalThis.Error("The parameter 'cohortId' cannot be null.");
        else if (cohortId !== undefined)
            url_ += "cohortId=" + encodeURIComponent("" + cohortId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportStudents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportStudents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processExportStudents(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    completeIRUpload(command: CompleteIRUploadCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Epp/CompleteIRUpload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteIRUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteIRUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processCompleteIRUpload(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getExpectedIRUploadValues(): Observable<IRUploadExpectedValuesDto> {
        let url_ = this.baseUrl + "/api/Epp/GetExpectedIRUploadValues";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExpectedIRUploadValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExpectedIRUploadValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IRUploadExpectedValuesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IRUploadExpectedValuesDto>;
        }));
    }

    protected processGetExpectedIRUploadValues(response: HttpResponseBase): Observable<IRUploadExpectedValuesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IRUploadExpectedValuesDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadIRUploadExpectedValues(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Epp/DownloadIRUploadExpectedValues";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadIRUploadExpectedValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadIRUploadExpectedValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDownloadIRUploadExpectedValues(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    completeStudentUpload(command: CompleteStudentUploadCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Epp/CompleteStudentUpload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteStudentUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteStudentUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processCompleteStudentUpload(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportAllCandidates(cohortId?: number | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Epp/ExportAllCandidates?";
        if (cohortId === null)
            throw new globalThis.Error("The parameter 'cohortId' cannot be null.");
        else if (cohortId !== undefined)
            url_ += "cohortId=" + encodeURIComponent("" + cohortId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportAllCandidates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportAllCandidates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processExportAllCandidates(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    revertCohortStudentProgramAuthorization(command: RevertCohortStudentProgramAuthorizationCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Epp/RevertCohortStudentProgramAuthorization";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRevertCohortStudentProgramAuthorization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRevertCohortStudentProgramAuthorization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processRevertCohortStudentProgramAuthorization(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getVoucherAllocations(): Observable<VoucherAllocationResultDto[]> {
        let url_ = this.baseUrl + "/api/Epp/GetVoucherAllocations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVoucherAllocations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVoucherAllocations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoucherAllocationResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoucherAllocationResultDto[]>;
        }));
    }

    protected processGetVoucherAllocations(response: HttpResponseBase): Observable<VoucherAllocationResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VoucherAllocationResultDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getVoucherCreditsManagementDetails(voucherAllocationId?: number | undefined): Observable<VoucherCreditManagementDetailsDto> {
        let url_ = this.baseUrl + "/api/Epp/GetVoucherCreditsManagementDetails?";
        if (voucherAllocationId === null)
            throw new globalThis.Error("The parameter 'voucherAllocationId' cannot be null.");
        else if (voucherAllocationId !== undefined)
            url_ += "voucherAllocationId=" + encodeURIComponent("" + voucherAllocationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVoucherCreditsManagementDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVoucherCreditsManagementDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoucherCreditManagementDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoucherCreditManagementDetailsDto>;
        }));
    }

    protected processGetVoucherCreditsManagementDetails(response: HttpResponseBase): Observable<VoucherCreditManagementDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VoucherCreditManagementDetailsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createVoucherCredits(command: CreateVoucherCreditsCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Epp/CreateVoucherCredits";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateVoucherCredits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateVoucherCredits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processCreateVoucherCredits(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteVoucherCredits(command: DeleteVoucherCreditsCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Epp/DeleteVoucherCredits";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteVoucherCredits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteVoucherCredits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteVoucherCredits(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateVoucherCredits(command: UpdateVoucherCreditsCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Epp/UpdateVoucherCredits";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateVoucherCredits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateVoucherCredits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdateVoucherCredits(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEppVoucherPersons(lastName?: string | null | undefined, firstName?: string | null | undefined, eIN?: string | null | undefined, searchAllPersons?: boolean | undefined): Observable<PersonSearchResultDto[]> {
        let url_ = this.baseUrl + "/api/Epp/GetEppVoucherPersons?";
        if (lastName !== undefined && lastName !== null)
            url_ += "LastName=" + encodeURIComponent("" + lastName) + "&";
        if (firstName !== undefined && firstName !== null)
            url_ += "FirstName=" + encodeURIComponent("" + firstName) + "&";
        if (eIN !== undefined && eIN !== null)
            url_ += "EIN=" + encodeURIComponent("" + eIN) + "&";
        if (searchAllPersons === null)
            throw new globalThis.Error("The parameter 'searchAllPersons' cannot be null.");
        else if (searchAllPersons !== undefined)
            url_ += "SearchAllPersons=" + encodeURIComponent("" + searchAllPersons) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEppVoucherPersons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEppVoucherPersons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonSearchResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonSearchResultDto[]>;
        }));
    }

    protected processGetEppVoucherPersons(response: HttpResponseBase): Observable<PersonSearchResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PersonSearchResultDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getBulkEppVoucherPersons(commaSeparatedEins?: string | undefined, searchAllPersons?: boolean | undefined): Observable<BulkPersonSearchResultDto> {
        let url_ = this.baseUrl + "/api/Epp/GetBulkEppVoucherPersons?";
        if (commaSeparatedEins === null)
            throw new globalThis.Error("The parameter 'commaSeparatedEins' cannot be null.");
        else if (commaSeparatedEins !== undefined)
            url_ += "CommaSeparatedEins=" + encodeURIComponent("" + commaSeparatedEins) + "&";
        if (searchAllPersons === null)
            throw new globalThis.Error("The parameter 'searchAllPersons' cannot be null.");
        else if (searchAllPersons !== undefined)
            url_ += "SearchAllPersons=" + encodeURIComponent("" + searchAllPersons) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBulkEppVoucherPersons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBulkEppVoucherPersons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BulkPersonSearchResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BulkPersonSearchResultDto>;
        }));
    }

    protected processGetBulkEppVoucherPersons(response: HttpResponseBase): Observable<BulkPersonSearchResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkPersonSearchResultDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EvaluationsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAddCertificateEvalDetail(applicationServiceItemId?: number | undefined): Observable<AddCertificateEvalDetailDto> {
        let url_ = this.baseUrl + "/api/Evaluations/GetAddCertificateEvalDetail?";
        if (applicationServiceItemId === null)
            throw new globalThis.Error("The parameter 'applicationServiceItemId' cannot be null.");
        else if (applicationServiceItemId !== undefined)
            url_ += "ApplicationServiceItemId=" + encodeURIComponent("" + applicationServiceItemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAddCertificateEvalDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAddCertificateEvalDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddCertificateEvalDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddCertificateEvalDetailDto>;
        }));
    }

    protected processGetAddCertificateEvalDetail(response: HttpResponseBase): Observable<AddCertificateEvalDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AddCertificateEvalDetailDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAddApprovedAreaEvalDetail(applicationServiceItemId?: number | undefined): Observable<AddApprovedAreaEvalDetailDto> {
        let url_ = this.baseUrl + "/api/Evaluations/GetAddApprovedAreaEvalDetail?";
        if (applicationServiceItemId === null)
            throw new globalThis.Error("The parameter 'applicationServiceItemId' cannot be null.");
        else if (applicationServiceItemId !== undefined)
            url_ += "ApplicationServiceItemId=" + encodeURIComponent("" + applicationServiceItemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAddApprovedAreaEvalDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAddApprovedAreaEvalDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddApprovedAreaEvalDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddApprovedAreaEvalDetailDto>;
        }));
    }

    protected processGetAddApprovedAreaEvalDetail(response: HttpResponseBase): Observable<AddApprovedAreaEvalDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AddApprovedAreaEvalDetailDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getExtensionEvalDetail(applicationServiceItemId?: number | undefined): Observable<ExtensionEvalDetailDto> {
        let url_ = this.baseUrl + "/api/Evaluations/GetExtensionEvalDetail?";
        if (applicationServiceItemId === null)
            throw new globalThis.Error("The parameter 'applicationServiceItemId' cannot be null.");
        else if (applicationServiceItemId !== undefined)
            url_ += "ApplicationServiceItemId=" + encodeURIComponent("" + applicationServiceItemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExtensionEvalDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExtensionEvalDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExtensionEvalDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExtensionEvalDetailDto>;
        }));
    }

    protected processGetExtensionEvalDetail(response: HttpResponseBase): Observable<ExtensionEvalDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExtensionEvalDetailDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getNameChangeEvalDetail(applicationServiceItemId?: number | undefined): Observable<NameChangeEvalDetailDto> {
        let url_ = this.baseUrl + "/api/Evaluations/GetNameChangeEvalDetail?";
        if (applicationServiceItemId === null)
            throw new globalThis.Error("The parameter 'applicationServiceItemId' cannot be null.");
        else if (applicationServiceItemId !== undefined)
            url_ += "ApplicationServiceItemId=" + encodeURIComponent("" + applicationServiceItemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNameChangeEvalDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNameChangeEvalDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NameChangeEvalDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NameChangeEvalDetailDto>;
        }));
    }

    protected processGetNameChangeEvalDetail(response: HttpResponseBase): Observable<NameChangeEvalDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NameChangeEvalDetailDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAddEndorsementEvalDetail(applicationServiceItemId?: number | undefined): Observable<AddEndorsementEvalDetailDto> {
        let url_ = this.baseUrl + "/api/Evaluations/GetAddEndorsementEvalDetail?";
        if (applicationServiceItemId === null)
            throw new globalThis.Error("The parameter 'applicationServiceItemId' cannot be null.");
        else if (applicationServiceItemId !== undefined)
            url_ += "ApplicationServiceItemId=" + encodeURIComponent("" + applicationServiceItemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAddEndorsementEvalDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAddEndorsementEvalDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddEndorsementEvalDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddEndorsementEvalDetailDto>;
        }));
    }

    protected processGetAddEndorsementEvalDetail(response: HttpResponseBase): Observable<AddEndorsementEvalDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AddEndorsementEvalDetailDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEvaluationTypes(applicationServiceItemId?: number | undefined): Observable<EvaluationTypeDto[]> {
        let url_ = this.baseUrl + "/api/Evaluations/GetEvaluationTypes?";
        if (applicationServiceItemId === null)
            throw new globalThis.Error("The parameter 'applicationServiceItemId' cannot be null.");
        else if (applicationServiceItemId !== undefined)
            url_ += "applicationServiceItemId=" + encodeURIComponent("" + applicationServiceItemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEvaluationTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEvaluationTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EvaluationTypeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EvaluationTypeDto[]>;
        }));
    }

    protected processGetEvaluationTypes(response: HttpResponseBase): Observable<EvaluationTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EvaluationTypeDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAvailableVoucherCreditOptions(applicationServiceItemId?: number | undefined): Observable<AvailableVoucherCreditOptionsDto> {
        let url_ = this.baseUrl + "/api/Evaluations/GetAvailableVoucherCreditOptions?";
        if (applicationServiceItemId === null)
            throw new globalThis.Error("The parameter 'applicationServiceItemId' cannot be null.");
        else if (applicationServiceItemId !== undefined)
            url_ += "applicationServiceItemId=" + encodeURIComponent("" + applicationServiceItemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailableVoucherCreditOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailableVoucherCreditOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AvailableVoucherCreditOptionsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AvailableVoucherCreditOptionsDto>;
        }));
    }

    protected processGetAvailableVoucherCreditOptions(response: HttpResponseBase): Observable<AvailableVoucherCreditOptionsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AvailableVoucherCreditOptionsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    redeemRetroactiveVoucherCredit(command: RedeemRetroactiveVoucherCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Evaluations/RedeemRetroactiveVoucherCredit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRedeemRetroactiveVoucherCredit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRedeemRetroactiveVoucherCredit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processRedeemRetroactiveVoucherCredit(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRemoveDeficiencyEvalDetail(applicationServiceItemId?: number | undefined): Observable<RemoveDeficiencyEvalDetailDto> {
        let url_ = this.baseUrl + "/api/Evaluations/GetRemoveDeficiencyEvalDetail?";
        if (applicationServiceItemId === null)
            throw new globalThis.Error("The parameter 'applicationServiceItemId' cannot be null.");
        else if (applicationServiceItemId !== undefined)
            url_ += "ApplicationServiceItemId=" + encodeURIComponent("" + applicationServiceItemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRemoveDeficiencyEvalDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRemoveDeficiencyEvalDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RemoveDeficiencyEvalDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RemoveDeficiencyEvalDetailDto>;
        }));
    }

    protected processGetRemoveDeficiencyEvalDetail(response: HttpResponseBase): Observable<RemoveDeficiencyEvalDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RemoveDeficiencyEvalDetailDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addOrUpdateHoldOnServiceItem(command: AddOrUpdateHoldOnServiceItemCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Evaluations/AddOrUpdateHoldOnServiceItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateHoldOnServiceItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateHoldOnServiceItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddOrUpdateHoldOnServiceItem(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    removeHoldOnServiceItem(command: RemoveHoldOnServiceItemCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Evaluations/RemoveHoldOnServiceItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveHoldOnServiceItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveHoldOnServiceItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processRemoveHoldOnServiceItem(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getApplicationServiceItemForEvaluation(applicationServiceItemId?: number | undefined): Observable<EvaluationServiceItemDetailsDto> {
        let url_ = this.baseUrl + "/api/Evaluations/GetApplicationServiceItemForEvaluation?";
        if (applicationServiceItemId === null)
            throw new globalThis.Error("The parameter 'applicationServiceItemId' cannot be null.");
        else if (applicationServiceItemId !== undefined)
            url_ += "applicationServiceItemId=" + encodeURIComponent("" + applicationServiceItemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApplicationServiceItemForEvaluation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApplicationServiceItemForEvaluation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EvaluationServiceItemDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EvaluationServiceItemDetailsDto>;
        }));
    }

    protected processGetApplicationServiceItemForEvaluation(response: HttpResponseBase): Observable<EvaluationServiceItemDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EvaluationServiceItemDetailsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getApplicationServiceItemEvaluation(applicationServiceItemId?: number | undefined, evaluationId?: number | undefined): Observable<ServiceItemEvaluationDto> {
        let url_ = this.baseUrl + "/api/Evaluations/GetApplicationServiceItemEvaluation?";
        if (applicationServiceItemId === null)
            throw new globalThis.Error("The parameter 'applicationServiceItemId' cannot be null.");
        else if (applicationServiceItemId !== undefined)
            url_ += "applicationServiceItemId=" + encodeURIComponent("" + applicationServiceItemId) + "&";
        if (evaluationId === null)
            throw new globalThis.Error("The parameter 'evaluationId' cannot be null.");
        else if (evaluationId !== undefined)
            url_ += "evaluationId=" + encodeURIComponent("" + evaluationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApplicationServiceItemEvaluation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApplicationServiceItemEvaluation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceItemEvaluationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceItemEvaluationDto>;
        }));
    }

    protected processGetApplicationServiceItemEvaluation(response: HttpResponseBase): Observable<ServiceItemEvaluationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ServiceItemEvaluationDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveApplicationServiceItemEvaluation(command: SaveApplicationServiceItemEvaluationCommand): Observable<ServiceItemEvaluationDto> {
        let url_ = this.baseUrl + "/api/Evaluations/SaveApplicationServiceItemEvaluation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveApplicationServiceItemEvaluation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveApplicationServiceItemEvaluation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceItemEvaluationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceItemEvaluationDto>;
        }));
    }

    protected processSaveApplicationServiceItemEvaluation(response: HttpResponseBase): Observable<ServiceItemEvaluationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ServiceItemEvaluationDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    requestServiceItemCancellation(command: RequestServiceItemCancellationCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Evaluations/RequestServiceItemCancellation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestServiceItemCancellation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestServiceItemCancellation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processRequestServiceItemCancellation(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    approveServiceItemCancellation(command: ApproveServiceItemCancellationCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Evaluations/ApproveServiceItemCancellation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveServiceItemCancellation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveServiceItemCancellation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processApproveServiceItemCancellation(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    rejectServiceItemCancellation(command: RejectServiceItemCancellationCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Evaluations/RejectServiceItemCancellation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRejectServiceItemCancellation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRejectServiceItemCancellation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processRejectServiceItemCancellation(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEvaluationDocumentsForReview(applicationServiceItemId?: number | undefined, documentCodeId?: number | undefined): Observable<EvaluationDocumentReviewDto> {
        let url_ = this.baseUrl + "/api/Evaluations/GetEvaluationDocumentsForReview?";
        if (applicationServiceItemId === null)
            throw new globalThis.Error("The parameter 'applicationServiceItemId' cannot be null.");
        else if (applicationServiceItemId !== undefined)
            url_ += "applicationServiceItemId=" + encodeURIComponent("" + applicationServiceItemId) + "&";
        if (documentCodeId === null)
            throw new globalThis.Error("The parameter 'documentCodeId' cannot be null.");
        else if (documentCodeId !== undefined)
            url_ += "documentCodeId=" + encodeURIComponent("" + documentCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEvaluationDocumentsForReview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEvaluationDocumentsForReview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EvaluationDocumentReviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EvaluationDocumentReviewDto>;
        }));
    }

    protected processGetEvaluationDocumentsForReview(response: HttpResponseBase): Observable<EvaluationDocumentReviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EvaluationDocumentReviewDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateAIServiceItem(applicationServiceItemEvaluationId?: number | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Evaluations/UpdateAIServiceItem?";
        if (applicationServiceItemEvaluationId === null)
            throw new globalThis.Error("The parameter 'applicationServiceItemEvaluationId' cannot be null.");
        else if (applicationServiceItemEvaluationId !== undefined)
            url_ += "applicationServiceItemEvaluationId=" + encodeURIComponent("" + applicationServiceItemEvaluationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAIServiceItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAIServiceItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdateAIServiceItem(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateSIServiceItem(applicationServiceItemEvaluationId?: number | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Evaluations/UpdateSIServiceItem?";
        if (applicationServiceItemEvaluationId === null)
            throw new globalThis.Error("The parameter 'applicationServiceItemEvaluationId' cannot be null.");
        else if (applicationServiceItemEvaluationId !== undefined)
            url_ += "applicationServiceItemEvaluationId=" + encodeURIComponent("" + applicationServiceItemEvaluationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSIServiceItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSIServiceItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdateSIServiceItem(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateServiceItemToSubstantiveReview(command: UpdateServiceItemToSubstantiveReviewCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Evaluations/UpdateServiceItemToSubstantiveReview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateServiceItemToSubstantiveReview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateServiceItemToSubstantiveReview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdateServiceItemToSubstantiveReview(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateSubstantiveComplete(command: UpdateSubstantiveCompleteCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Evaluations/UpdateSubstantiveComplete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSubstantiveComplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSubstantiveComplete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdateSubstantiveComplete(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getServiceItemMaterialsReceived(applicationServiceItemId?: number | undefined): Observable<ServiceItemMaterialsReceivedDto[]> {
        let url_ = this.baseUrl + "/api/Evaluations/GetServiceItemMaterialsReceived?";
        if (applicationServiceItemId === null)
            throw new globalThis.Error("The parameter 'applicationServiceItemId' cannot be null.");
        else if (applicationServiceItemId !== undefined)
            url_ += "applicationServiceItemId=" + encodeURIComponent("" + applicationServiceItemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceItemMaterialsReceived(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceItemMaterialsReceived(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceItemMaterialsReceivedDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceItemMaterialsReceivedDto[]>;
        }));
    }

    protected processGetServiceItemMaterialsReceived(response: HttpResponseBase): Observable<ServiceItemMaterialsReceivedDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ServiceItemMaterialsReceivedDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    acknowledgeServiceItemMaterialsReceived(command: AcknowledgeServiceItemMaterialsReceivedCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Evaluations/AcknowledgeServiceItemMaterialsReceived";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcknowledgeServiceItemMaterialsReceived(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcknowledgeServiceItemMaterialsReceived(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAcknowledgeServiceItemMaterialsReceived(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateDenyServiceItem(command: UpdateDenyServiceItemCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Evaluations/UpdateDenyServiceItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDenyServiceItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDenyServiceItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdateDenyServiceItem(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addOrUpdateAppeal(command: AddOrUpdateAppealResponseCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Evaluations/AddOrUpdateAppeal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateAppeal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateAppeal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddOrUpdateAppeal(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateSIReturnServiceItem(command: UpdateSIReturnServiceItemCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Evaluations/UpdateSIReturnServiceItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSIReturnServiceItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSIReturnServiceItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdateSIReturnServiceItem(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    cancelAppeal(command: CancelAppealCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Evaluations/CancelAppeal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelAppeal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelAppeal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processCancelAppeal(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    beginAppeal(command: AddAppealCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Evaluations/BeginAppeal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBeginAppeal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBeginAppeal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processBeginAppeal(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEvaluationCompletionMessage(applicationServiceItemEvaluationId?: number | undefined): Observable<EvaluationCompletionMessageDto> {
        let url_ = this.baseUrl + "/api/Evaluations/GetEvaluationCompletionMessage?";
        if (applicationServiceItemEvaluationId === null)
            throw new globalThis.Error("The parameter 'applicationServiceItemEvaluationId' cannot be null.");
        else if (applicationServiceItemEvaluationId !== undefined)
            url_ += "applicationServiceItemEvaluationId=" + encodeURIComponent("" + applicationServiceItemEvaluationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEvaluationCompletionMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEvaluationCompletionMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EvaluationCompletionMessageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EvaluationCompletionMessageDto>;
        }));
    }

    protected processGetEvaluationCompletionMessage(response: HttpResponseBase): Observable<EvaluationCompletionMessageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EvaluationCompletionMessageDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateAddCertificateServiceItemAndDeleteEvaluations(command: UpdateAddCertificateServiceItemAndDeleteEvaluationsCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Evaluations/UpdateAddCertificateServiceItemAndDeleteEvaluations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAddCertificateServiceItemAndDeleteEvaluations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAddCertificateServiceItemAndDeleteEvaluations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdateAddCertificateServiceItemAndDeleteEvaluations(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateAddApprovedAreaServiceItemAndDeleteEvaluations(command: UpdateAddApprovedAreaServiceItemAndDeleteEvaluationsCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Evaluations/UpdateAddApprovedAreaServiceItemAndDeleteEvaluations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAddApprovedAreaServiceItemAndDeleteEvaluations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAddApprovedAreaServiceItemAndDeleteEvaluations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdateAddApprovedAreaServiceItemAndDeleteEvaluations(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateAddEndorsementServiceItemAndDeleteEvaluations(command: UpdateAddEndorsementServiceItemAndDeleteEvaluationsCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Evaluations/UpdateAddEndorsementServiceItemAndDeleteEvaluations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAddEndorsementServiceItemAndDeleteEvaluations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAddEndorsementServiceItemAndDeleteEvaluations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdateAddEndorsementServiceItemAndDeleteEvaluations(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateDeficiencyRemovalServiceItemAndDeleteEvaluations(command: UpdateDeficiencyRemovalServiceItemAndDeleteEvaluationsCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Evaluations/UpdateDeficiencyRemovalServiceItemAndDeleteEvaluations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDeficiencyRemovalServiceItemAndDeleteEvaluations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDeficiencyRemovalServiceItemAndDeleteEvaluations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdateDeficiencyRemovalServiceItemAndDeleteEvaluations(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRenewalEvalDetail(applicationServiceItemId?: number | undefined): Observable<RenewalEvalDetailDto> {
        let url_ = this.baseUrl + "/api/Evaluations/GetRenewalEvalDetail?";
        if (applicationServiceItemId === null)
            throw new globalThis.Error("The parameter 'applicationServiceItemId' cannot be null.");
        else if (applicationServiceItemId !== undefined)
            url_ += "ApplicationServiceItemId=" + encodeURIComponent("" + applicationServiceItemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRenewalEvalDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRenewalEvalDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RenewalEvalDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RenewalEvalDetailDto>;
        }));
    }

    protected processGetRenewalEvalDetail(response: HttpResponseBase): Observable<RenewalEvalDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RenewalEvalDetailDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateRenewalServiceItem(command: UpdateRenewalServiceItemCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Evaluations/UpdateRenewalServiceItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRenewalServiceItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRenewalServiceItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdateRenewalServiceItem(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateExtensionServiceItem(command: UpdateExtensionServiceItemCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Evaluations/UpdateExtensionServiceItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateExtensionServiceItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateExtensionServiceItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdateExtensionServiceItem(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateNameChangeServiceItem(command: UpdateNameChangeServiceItemCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Evaluations/UpdateNameChangeServiceItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateNameChangeServiceItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateNameChangeServiceItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdateNameChangeServiceItem(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSsnChangeEvalDetail(applicationServiceItemId?: number | undefined): Observable<SsnChangeEvalDetailDto> {
        let url_ = this.baseUrl + "/api/Evaluations/GetSsnChangeEvalDetail?";
        if (applicationServiceItemId === null)
            throw new globalThis.Error("The parameter 'applicationServiceItemId' cannot be null.");
        else if (applicationServiceItemId !== undefined)
            url_ += "ApplicationServiceItemId=" + encodeURIComponent("" + applicationServiceItemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSsnChangeEvalDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSsnChangeEvalDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SsnChangeEvalDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SsnChangeEvalDetailDto>;
        }));
    }

    protected processGetSsnChangeEvalDetail(response: HttpResponseBase): Observable<SsnChangeEvalDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SsnChangeEvalDetailDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateSsnChangeServiceItem(command: UpdateSsnChangeServiceItemCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Evaluations/UpdateSsnChangeServiceItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSsnChangeServiceItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSsnChangeServiceItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdateSsnChangeServiceItem(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    printCopyOfCertificateNow(command: PrintCopyOfCertificateNowCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Evaluations/PrintCopyOfCertificateNow";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrintCopyOfCertificateNow(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrintCopyOfCertificateNow(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processPrintCopyOfCertificateNow(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addCopyOfCertificateToPrintQueue(command: AddCopyOfCertificateToPrintQueueCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Evaluations/AddCopyOfCertificateToPrintQueue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCopyOfCertificateToPrintQueue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCopyOfCertificateToPrintQueue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddCopyOfCertificateToPrintQueue(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAddIRCertificateEvalDetail(applicationServiceItemId?: number | undefined): Observable<AddIRCertificateEvalDetailDto> {
        let url_ = this.baseUrl + "/api/Evaluations/GetAddIRCertificateEvalDetail?";
        if (applicationServiceItemId === null)
            throw new globalThis.Error("The parameter 'applicationServiceItemId' cannot be null.");
        else if (applicationServiceItemId !== undefined)
            url_ += "ApplicationServiceItemId=" + encodeURIComponent("" + applicationServiceItemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAddIRCertificateEvalDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAddIRCertificateEvalDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddIRCertificateEvalDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddIRCertificateEvalDetailDto>;
        }));
    }

    protected processGetAddIRCertificateEvalDetail(response: HttpResponseBase): Observable<AddIRCertificateEvalDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AddIRCertificateEvalDetailDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateServiceItemSendToIU(command: UpdateServiceItemSendToIUCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Evaluations/UpdateServiceItemSendToIU";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateServiceItemSendToIU(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateServiceItemSendToIU(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdateServiceItemSendToIU(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAddIREndorsementEvalDetail(applicationServiceItemId?: number | undefined): Observable<AddIREndorsementEvalDetailDto> {
        let url_ = this.baseUrl + "/api/Evaluations/GetAddIREndorsementEvalDetail?";
        if (applicationServiceItemId === null)
            throw new globalThis.Error("The parameter 'applicationServiceItemId' cannot be null.");
        else if (applicationServiceItemId !== undefined)
            url_ += "ApplicationServiceItemId=" + encodeURIComponent("" + applicationServiceItemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAddIREndorsementEvalDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAddIREndorsementEvalDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddIREndorsementEvalDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddIREndorsementEvalDetailDto>;
        }));
    }

    protected processGetAddIREndorsementEvalDetail(response: HttpResponseBase): Observable<AddIREndorsementEvalDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AddIREndorsementEvalDetailDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    previewDenialLetter(command: PreviewDenialLetterCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Evaluations/PreviewDenialLetter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPreviewDenialLetter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPreviewDenialLetter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processPreviewDenialLetter(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDenialReasonsForEval(query: GetEvalDenialReasonsQuery): Observable<EvalDenialReasonDto[]> {
        let url_ = this.baseUrl + "/api/Evaluations/GetDenialReasonsForEval";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDenialReasonsForEval(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDenialReasonsForEval(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EvalDenialReasonDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EvalDenialReasonDto[]>;
        }));
    }

    protected processGetDenialReasonsForEval(response: HttpResponseBase): Observable<EvalDenialReasonDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EvalDenialReasonDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addManualDenialReason(command: AddManualDenialReasonCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Evaluations/AddManualDenialReason";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddManualDenialReason(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddManualDenialReason(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddManualDenialReason(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    removeManualDenialReason(command: RemoveManualDenialReasonCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Evaluations/RemoveManualDenialReason";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveManualDenialReason(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveManualDenialReason(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processRemoveManualDenialReason(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateIRCertificateServiceItemAndDeleteEvaluations(command: UpdateIRCertificateServiceItemAndDeleteEvaluationsCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Evaluations/UpdateIRCertificateServiceItemAndDeleteEvaluations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateIRCertificateServiceItemAndDeleteEvaluations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateIRCertificateServiceItemAndDeleteEvaluations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdateIRCertificateServiceItemAndDeleteEvaluations(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateIREndorsementServiceItemAndDeleteEvaluations(command: UpdateIREndorsementServiceItemAndDeleteEvaluationsCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Evaluations/UpdateIREndorsementServiceItemAndDeleteEvaluations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateIREndorsementServiceItemAndDeleteEvaluations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateIREndorsementServiceItemAndDeleteEvaluations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdateIREndorsementServiceItemAndDeleteEvaluations(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    removeIncompleteReasonsFromEvaluation(command: RemoveIncompleteReasonsFromEvaluationCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Evaluations/RemoveIncompleteReasonsFromEvaluation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveIncompleteReasonsFromEvaluation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveIncompleteReasonsFromEvaluation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processRemoveIncompleteReasonsFromEvaluation(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCertificateTypeCodesByLevel(query: GetEvalFormCertificateTypeCodesForPersonQuery): Observable<EvalCertificateTypeCodeDto[]> {
        let url_ = this.baseUrl + "/api/Evaluations/GetCertificateTypeCodesByLevel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCertificateTypeCodesByLevel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCertificateTypeCodesByLevel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EvalCertificateTypeCodeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EvalCertificateTypeCodeDto[]>;
        }));
    }

    protected processGetCertificateTypeCodesByLevel(response: HttpResponseBase): Observable<EvalCertificateTypeCodeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EvalCertificateTypeCodeDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    assignEvaluationToSelf(command: AssignEvaluationToSelfCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Evaluations/AssignEvaluationToSelf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignEvaluationToSelf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignEvaluationToSelf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAssignEvaluationToSelf(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    forceServiceItemIssuance(command: ForceServiceItemIssuanceCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Evaluations/ForceServiceItemIssuance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processForceServiceItemIssuance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForceServiceItemIssuance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processForceServiceItemIssuance(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getServiceItemValidationDetails(applicationServiceItemId?: number | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/Evaluations/GetServiceItemValidationDetails?";
        if (applicationServiceItemId === null)
            throw new globalThis.Error("The parameter 'applicationServiceItemId' cannot be null.");
        else if (applicationServiceItemId !== undefined)
            url_ += "applicationServiceItemId=" + encodeURIComponent("" + applicationServiceItemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceItemValidationDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceItemValidationDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetServiceItemValidationDetails(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateCloseServiceItem(command: UpdateCloseServiceItemCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Evaluations/UpdateCloseServiceItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCloseServiceItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCloseServiceItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdateCloseServiceItem(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEvaluationIdForApplicationServiceItem(applicationServiceItemId?: number | undefined): Observable<number | null> {
        let url_ = this.baseUrl + "/api/Evaluations/GetEvaluationIdForApplicationServiceItem?";
        if (applicationServiceItemId === null)
            throw new globalThis.Error("The parameter 'applicationServiceItemId' cannot be null.");
        else if (applicationServiceItemId !== undefined)
            url_ += "ApplicationServiceItemId=" + encodeURIComponent("" + applicationServiceItemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEvaluationIdForApplicationServiceItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEvaluationIdForApplicationServiceItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number | null>;
        }));
    }

    protected processGetEvaluationIdForApplicationServiceItem(response: HttpResponseBase): Observable<number | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getReinstateCertificateEvalDetail(applicationServiceItemId?: number | undefined): Observable<ReinstateCertificateEvalDetailDto> {
        let url_ = this.baseUrl + "/api/Evaluations?";
        if (applicationServiceItemId === null)
            throw new globalThis.Error("The parameter 'applicationServiceItemId' cannot be null.");
        else if (applicationServiceItemId !== undefined)
            url_ += "ApplicationServiceItemId=" + encodeURIComponent("" + applicationServiceItemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReinstateCertificateEvalDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReinstateCertificateEvalDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReinstateCertificateEvalDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReinstateCertificateEvalDetailDto>;
        }));
    }

    protected processGetReinstateCertificateEvalDetail(response: HttpResponseBase): Observable<ReinstateCertificateEvalDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReinstateCertificateEvalDetailDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateReinstateCertificateServiceItem(command: UpdateReinstateCertificateServiceItemCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Evaluations/UpdateReinstateCertificateServiceItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateReinstateCertificateServiceItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateReinstateCertificateServiceItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdateReinstateCertificateServiceItem(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAddCertificateEvalCompletionDetails(applicationServiceItemId?: number | undefined): Observable<AddCertificateEvalCompletionDetailsDto> {
        let url_ = this.baseUrl + "/api/Evaluations/GetAddCertificateEvalCompletionDetails?";
        if (applicationServiceItemId === null)
            throw new globalThis.Error("The parameter 'applicationServiceItemId' cannot be null.");
        else if (applicationServiceItemId !== undefined)
            url_ += "applicationServiceItemId=" + encodeURIComponent("" + applicationServiceItemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAddCertificateEvalCompletionDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAddCertificateEvalCompletionDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddCertificateEvalCompletionDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddCertificateEvalCompletionDetailsDto>;
        }));
    }

    protected processGetAddCertificateEvalCompletionDetails(response: HttpResponseBase): Observable<AddCertificateEvalCompletionDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AddCertificateEvalCompletionDetailsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getScreenShareAvailabilityState(personId?: number | undefined): Observable<ScreenShareAvailabilityStateDto> {
        let url_ = this.baseUrl + "/api/Evaluations/GetScreenShareAvailabilityState?";
        if (personId === null)
            throw new globalThis.Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetScreenShareAvailabilityState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetScreenShareAvailabilityState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScreenShareAvailabilityStateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScreenShareAvailabilityStateDto>;
        }));
    }

    protected processGetScreenShareAvailabilityState(response: HttpResponseBase): Observable<ScreenShareAvailabilityStateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ScreenShareAvailabilityStateDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createEvaluationCommunication(command: CreateEvaluationCommunicationCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Evaluations/CreateEvaluationCommunication";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateEvaluationCommunication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEvaluationCommunication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processCreateEvaluationCommunication(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getApplicationServiceItemEvaluationTimeline(applicationServiceItemId?: number | undefined): Observable<ServiceItemEvaluationTimelineItemDto[]> {
        let url_ = this.baseUrl + "/api/Evaluations/GetApplicationServiceItemEvaluationTimeline?";
        if (applicationServiceItemId === null)
            throw new globalThis.Error("The parameter 'applicationServiceItemId' cannot be null.");
        else if (applicationServiceItemId !== undefined)
            url_ += "applicationServiceItemId=" + encodeURIComponent("" + applicationServiceItemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApplicationServiceItemEvaluationTimeline(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApplicationServiceItemEvaluationTimeline(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceItemEvaluationTimelineItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceItemEvaluationTimelineItemDto[]>;
        }));
    }

    protected processGetApplicationServiceItemEvaluationTimeline(response: HttpResponseBase): Observable<ServiceItemEvaluationTimelineItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ServiceItemEvaluationTimelineItemDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEvaluationCommunicationImageContent(evaluationCommunicationImageId: number): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Evaluations/GetEvaluationCommunicationImageContent/{evaluationCommunicationImageId}";
        if (evaluationCommunicationImageId === undefined || evaluationCommunicationImageId === null)
            throw new globalThis.Error("The parameter 'evaluationCommunicationImageId' must be defined.");
        url_ = url_.replace("{evaluationCommunicationImageId}", encodeURIComponent("" + evaluationCommunicationImageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEvaluationCommunicationImageContent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEvaluationCommunicationImageContent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGetEvaluationCommunicationImageContent(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FingerprintManagementClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getMismatchedDpsFingerprintFeedRecords(): Observable<MismatchedDpsFingerprintFeedRecordDto[]> {
        let url_ = this.baseUrl + "/api/FingerprintManagement/GetMismatchedDpsFingerprintFeedRecords";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMismatchedDpsFingerprintFeedRecords(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMismatchedDpsFingerprintFeedRecords(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MismatchedDpsFingerprintFeedRecordDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MismatchedDpsFingerprintFeedRecordDto[]>;
        }));
    }

    protected processGetMismatchedDpsFingerprintFeedRecords(response: HttpResponseBase): Observable<MismatchedDpsFingerprintFeedRecordDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MismatchedDpsFingerprintFeedRecordDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    disassociateMismatchedDpsFingerprintFeedRecord(command: DisassociateMismatchedDpsFingerprintFeedRecordCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/FingerprintManagement/DisassociateMismatchedDpsFingerprintFeedRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisassociateMismatchedDpsFingerprintFeedRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisassociateMismatchedDpsFingerprintFeedRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDisassociateMismatchedDpsFingerprintFeedRecord(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    validateDpsFingerprintFeedRecordAssociation(command: ValidateDpsFingerprintFeedRecordAssociationCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/FingerprintManagement/ValidateDpsFingerprintFeedRecordAssociation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateDpsFingerprintFeedRecordAssociation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateDpsFingerprintFeedRecordAssociation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processValidateDpsFingerprintFeedRecordAssociation(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class HelpClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getHelpObjects(): Observable<HelpObjectDto[]> {
        let url_ = this.baseUrl + "/api/Help/GetHelpObjects";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHelpObjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHelpObjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HelpObjectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HelpObjectDto[]>;
        }));
    }

    protected processGetHelpObjects(response: HttpResponseBase): Observable<HelpObjectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HelpObjectDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getHelpObjectsByPortal(portalType?: PortalType | undefined): Observable<HelpObjectDto[]> {
        let url_ = this.baseUrl + "/api/Help/GetHelpObjectsByPortal?";
        if (portalType === null)
            throw new globalThis.Error("The parameter 'portalType' cannot be null.");
        else if (portalType !== undefined)
            url_ += "portalType=" + encodeURIComponent("" + portalType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHelpObjectsByPortal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHelpObjectsByPortal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HelpObjectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HelpObjectDto[]>;
        }));
    }

    protected processGetHelpObjectsByPortal(response: HttpResponseBase): Observable<HelpObjectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HelpObjectDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addHelpObject(command: AddHelpObjectCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Help/AddHelpObject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddHelpObject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddHelpObject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddHelpObject(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteHelpObject(command: DeleteHelpObjectCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Help/DeleteHelpObject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteHelpObject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteHelpObject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteHelpObject(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class LabClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getUsers(): Observable<UserListItemDto[]> {
        let url_ = this.baseUrl + "/api/Lab/GetUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserListItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserListItemDto[]>;
        }));
    }

    protected processGetUsers(response: HttpResponseBase): Observable<UserListItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserListItemDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUserDetail(userId: number): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/Lab/GetUserDetail/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processGetUserDetail(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateUser(command: UpdateUserCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Lab/UpdateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdateUser(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDataDictionaryList(): Observable<DataDictionaryViewDto[]> {
        let url_ = this.baseUrl + "/api/Lab/GetDataDictionaryList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDataDictionaryList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDataDictionaryList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataDictionaryViewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataDictionaryViewDto[]>;
        }));
    }

    protected processGetDataDictionaryList(response: HttpResponseBase): Observable<DataDictionaryViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DataDictionaryViewDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadTestPdf(command: GenerateTestPdfCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Lab/DownloadTestPdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadTestPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadTestPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDownloadTestPdf(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createCase(command: CreateCaseCommand): Observable<CreateCaseDto> {
        let url_ = this.baseUrl + "/api/Lab/CreateCase";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateCaseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateCaseDto>;
        }));
    }

    protected processCreateCase(response: HttpResponseBase): Observable<CreateCaseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateCaseDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateCase(command: UpdateCaseCommand): Observable<UpdateCaseDto> {
        let url_ = this.baseUrl + "/api/Lab/UpdateCase";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateCaseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateCaseDto>;
        }));
    }

    protected processUpdateCase(response: HttpResponseBase): Observable<UpdateCaseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UpdateCaseDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCase(caseId?: string | undefined): Observable<CaseDto> {
        let url_ = this.baseUrl + "/api/Lab/GetCase?";
        if (caseId === null)
            throw new globalThis.Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaseDto>;
        }));
    }

    protected processGetCase(response: HttpResponseBase): Observable<CaseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getNASDTECInfo(firstRecord?: number | undefined, lastRecord?: number | undefined): Observable<NasdtecDto[]> {
        let url_ = this.baseUrl + "/api/Lab/GetNASDTECInfo?";
        if (firstRecord === null)
            throw new globalThis.Error("The parameter 'firstRecord' cannot be null.");
        else if (firstRecord !== undefined)
            url_ += "firstRecord=" + encodeURIComponent("" + firstRecord) + "&";
        if (lastRecord === null)
            throw new globalThis.Error("The parameter 'lastRecord' cannot be null.");
        else if (lastRecord !== undefined)
            url_ += "lastRecord=" + encodeURIComponent("" + lastRecord) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNASDTECInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNASDTECInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NasdtecDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NasdtecDto[]>;
        }));
    }

    protected processGetNASDTECInfo(response: HttpResponseBase): Observable<NasdtecDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NasdtecDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    verifyDocumentSignature(pendingApplicationDocumentId?: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Lab/VerifyDocumentSignature?";
        if (pendingApplicationDocumentId === null)
            throw new globalThis.Error("The parameter 'pendingApplicationDocumentId' cannot be null.");
        else if (pendingApplicationDocumentId !== undefined)
            url_ += "pendingApplicationDocumentId=" + encodeURIComponent("" + pendingApplicationDocumentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyDocumentSignature(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyDocumentSignature(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processVerifyDocumentSignature(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getExistingSftpFilesForType(sftpFileType?: SftpFileType | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/Lab/GetExistingSftpFilesForType?";
        if (sftpFileType === null)
            throw new globalThis.Error("The parameter 'sftpFileType' cannot be null.");
        else if (sftpFileType !== undefined)
            url_ += "sftpFileType=" + encodeURIComponent("" + sftpFileType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExistingSftpFilesForType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExistingSftpFilesForType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetExistingSftpFilesForType(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    uploadSftpTestFile(command: UploadSftpTestFileCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Lab/UploadSftpTestFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadSftpTestFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadSftpTestFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUploadSftpTestFile(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getActiveStaffAssignmentsForPerson(eIN?: string | null | undefined): Observable<SimpleSelectOptionDto[]> {
        let url_ = this.baseUrl + "/api/Lab/GetActiveStaffAssignmentsForPerson?";
        if (eIN !== undefined && eIN !== null)
            url_ += "EIN=" + encodeURIComponent("" + eIN) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveStaffAssignmentsForPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveStaffAssignmentsForPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleSelectOptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleSelectOptionDto[]>;
        }));
    }

    protected processGetActiveStaffAssignmentsForPerson(response: HttpResponseBase): Observable<SimpleSelectOptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimpleSelectOptionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCountStaffAssignmentsRelatedToACRuleDefinition(acRuleDefinitionId?: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/Lab/GetCountStaffAssignmentsRelatedToACRuleDefinition?";
        if (acRuleDefinitionId === null)
            throw new globalThis.Error("The parameter 'acRuleDefinitionId' cannot be null.");
        else if (acRuleDefinitionId !== undefined)
            url_ += "acRuleDefinitionId=" + encodeURIComponent("" + acRuleDefinitionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountStaffAssignmentsRelatedToACRuleDefinition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountStaffAssignmentsRelatedToACRuleDefinition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetCountStaffAssignmentsRelatedToACRuleDefinition(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getACRuleDefinitionsForLab(): Observable<SimpleSelectOptionDto[]> {
        let url_ = this.baseUrl + "/api/Lab/GetACRuleDefinitionsForLab";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetACRuleDefinitionsForLab(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetACRuleDefinitionsForLab(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleSelectOptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleSelectOptionDto[]>;
        }));
    }

    protected processGetACRuleDefinitionsForLab(response: HttpResponseBase): Observable<SimpleSelectOptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimpleSelectOptionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    evaluateACForStaffAssignment(staffAssignmentId?: number | undefined): Observable<EvaluateACForStaffAssignmentResultDto> {
        let url_ = this.baseUrl + "/api/Lab/EvaluateACForStaffAssignment?";
        if (staffAssignmentId === null)
            throw new globalThis.Error("The parameter 'staffAssignmentId' cannot be null.");
        else if (staffAssignmentId !== undefined)
            url_ += "staffAssignmentId=" + encodeURIComponent("" + staffAssignmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEvaluateACForStaffAssignment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEvaluateACForStaffAssignment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EvaluateACForStaffAssignmentResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EvaluateACForStaffAssignmentResultDto>;
        }));
    }

    protected processEvaluateACForStaffAssignment(response: HttpResponseBase): Observable<EvaluateACForStaffAssignmentResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EvaluateACForStaffAssignmentResultDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    testEvaluateACForACRuleDefinition(acRuleDefinitionId?: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/Lab/TestEvaluateACForACRuleDefinition?";
        if (acRuleDefinitionId === null)
            throw new globalThis.Error("The parameter 'acRuleDefinitionId' cannot be null.");
        else if (acRuleDefinitionId !== undefined)
            url_ += "acRuleDefinitionId=" + encodeURIComponent("" + acRuleDefinitionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTestEvaluateACForACRuleDefinition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestEvaluateACForACRuleDefinition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processTestEvaluateACForACRuleDefinition(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSentTestEmails(): Observable<TestEmailResultDto[]> {
        let url_ = this.baseUrl + "/api/Lab/GetSentTestEmails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSentTestEmails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSentTestEmails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TestEmailResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TestEmailResultDto[]>;
        }));
    }

    protected processGetSentTestEmails(response: HttpResponseBase): Observable<TestEmailResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TestEmailResultDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    clearTestEmailsCache(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Lab/ClearTestEmailsCache";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearTestEmailsCache(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearTestEmailsCache(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processClearTestEmailsCache(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class LeaBatchUploadClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getBatchUploads(leaCodeId?: number | null | undefined): Observable<LeaBatchUploadDto[]> {
        let url_ = this.baseUrl + "/api/LeaBatchUpload/GetBatchUploads?";
        if (leaCodeId !== undefined && leaCodeId !== null)
            url_ += "leaCodeId=" + encodeURIComponent("" + leaCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBatchUploads(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBatchUploads(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaBatchUploadDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaBatchUploadDto[]>;
        }));
    }

    protected processGetBatchUploads(response: HttpResponseBase): Observable<LeaBatchUploadDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LeaBatchUploadDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportLeaBatchUploadTemplateToExcel(query: ExportLeaBatchUploadTemplateToExcelQuery): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaBatchUpload/ExportLeaBatchUploadTemplateToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportLeaBatchUploadTemplateToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportLeaBatchUploadTemplateToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processExportLeaBatchUploadTemplateToExcel(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getBatchUploadReferences(leaCodeId?: number | null | undefined): Observable<BatchUploadReferenceDto[]> {
        let url_ = this.baseUrl + "/api/LeaBatchUpload/GetBatchUploadReferences?";
        if (leaCodeId !== undefined && leaCodeId !== null)
            url_ += "leaCodeId=" + encodeURIComponent("" + leaCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBatchUploadReferences(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBatchUploadReferences(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BatchUploadReferenceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BatchUploadReferenceDto[]>;
        }));
    }

    protected processGetBatchUploadReferences(response: HttpResponseBase): Observable<BatchUploadReferenceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BatchUploadReferenceDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportLeaBatchUploadReferencesToExcel(query: ExportLeaBatchUploadReferencesToExcelQuery): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaBatchUpload/ExportLeaBatchUploadReferencesToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportLeaBatchUploadReferencesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportLeaBatchUploadReferencesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processExportLeaBatchUploadReferencesToExcel(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportLeaCurrentDataToExcel(query: ExportLeaBatchUploadCurrentDataToExcelQuery): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaBatchUpload/ExportLeaCurrentDataToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportLeaCurrentDataToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportLeaCurrentDataToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processExportLeaCurrentDataToExcel(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    validatePerformanceEvaluationUpload(command: ValidatePerformanceEvaluationUploadCommand): Observable<BatchUploadSpreadsheetErrorsDto> {
        let url_ = this.baseUrl + "/api/LeaBatchUpload/ValidatePerformanceEvaluationUpload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidatePerformanceEvaluationUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidatePerformanceEvaluationUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BatchUploadSpreadsheetErrorsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BatchUploadSpreadsheetErrorsDto>;
        }));
    }

    protected processValidatePerformanceEvaluationUpload(response: HttpResponseBase): Observable<BatchUploadSpreadsheetErrorsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BatchUploadSpreadsheetErrorsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    submitPerformanceEvaluationUpload(command: SubmitPerformanceEvaluationUploadCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaBatchUpload/SubmitPerformanceEvaluationUpload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmitPerformanceEvaluationUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitPerformanceEvaluationUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processSubmitPerformanceEvaluationUpload(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class LeaContactsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getLeaMainContactInformation(leaCodeId?: number | undefined): Observable<MainContactInformationDto> {
        let url_ = this.baseUrl + "/api/LeaContacts/GetLeaMainContactInformation?";
        if (leaCodeId === null)
            throw new globalThis.Error("The parameter 'leaCodeId' cannot be null.");
        else if (leaCodeId !== undefined)
            url_ += "leaCodeId=" + encodeURIComponent("" + leaCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaMainContactInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaMainContactInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MainContactInformationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MainContactInformationDto>;
        }));
    }

    protected processGetLeaMainContactInformation(response: HttpResponseBase): Observable<MainContactInformationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MainContactInformationDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLeaAdministrativeContacts(leaCodeId?: number | undefined): Observable<LeaAdministrativeContactsDto> {
        let url_ = this.baseUrl + "/api/LeaContacts/GetLeaAdministrativeContacts?";
        if (leaCodeId === null)
            throw new globalThis.Error("The parameter 'leaCodeId' cannot be null.");
        else if (leaCodeId !== undefined)
            url_ += "leaCodeId=" + encodeURIComponent("" + leaCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaAdministrativeContacts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaAdministrativeContacts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaAdministrativeContactsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaAdministrativeContactsDto>;
        }));
    }

    protected processGetLeaAdministrativeContacts(response: HttpResponseBase): Observable<LeaAdministrativeContactsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LeaAdministrativeContactsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLeaLocationContactInformation(leaCodeId?: number | undefined): Observable<LeaLocationContactDto[]> {
        let url_ = this.baseUrl + "/api/LeaContacts/GetLeaLocationContactInformation?";
        if (leaCodeId === null)
            throw new globalThis.Error("The parameter 'leaCodeId' cannot be null.");
        else if (leaCodeId !== undefined)
            url_ += "leaCodeId=" + encodeURIComponent("" + leaCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaLocationContactInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaLocationContactInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaLocationContactDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaLocationContactDto[]>;
        }));
    }

    protected processGetLeaLocationContactInformation(response: HttpResponseBase): Observable<LeaLocationContactDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LeaLocationContactDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLeaInfoStaffSearchForRoles(searchQuery: GetLeaInfoStaffSearchForRolesQuery): Observable<LeaInfoStaffSearchResultList> {
        let url_ = this.baseUrl + "/api/LeaContacts/GetLeaInfoStaffSearchForRoles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaInfoStaffSearchForRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaInfoStaffSearchForRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaInfoStaffSearchResultList>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaInfoStaffSearchResultList>;
        }));
    }

    protected processGetLeaInfoStaffSearchForRoles(response: HttpResponseBase): Observable<LeaInfoStaffSearchResultList> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LeaInfoStaffSearchResultList;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLeaRolesForSelectOptions(): Observable<LeaRoleSelectOptionDto[]> {
        let url_ = this.baseUrl + "/api/LeaContacts/GetLeaRolesForSelectOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaRolesForSelectOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaRolesForSelectOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaRoleSelectOptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaRoleSelectOptionDto[]>;
        }));
    }

    protected processGetLeaRolesForSelectOptions(response: HttpResponseBase): Observable<LeaRoleSelectOptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LeaRoleSelectOptionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLeaSiteRolesForSelectOptions(): Observable<SimpleCodeDescriptionDto[]> {
        let url_ = this.baseUrl + "/api/LeaContacts/GetLeaSiteRolesForSelectOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaSiteRolesForSelectOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaSiteRolesForSelectOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleCodeDescriptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleCodeDescriptionDto[]>;
        }));
    }

    protected processGetLeaSiteRolesForSelectOptions(response: HttpResponseBase): Observable<SimpleCodeDescriptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimpleCodeDescriptionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLeaSitesForSelectOptions(leaCodeId?: number | undefined): Observable<SimpleCodeDescriptionDto[]> {
        let url_ = this.baseUrl + "/api/LeaContacts/GetLeaSitesForSelectOptions?";
        if (leaCodeId === null)
            throw new globalThis.Error("The parameter 'leaCodeId' cannot be null.");
        else if (leaCodeId !== undefined)
            url_ += "leaCodeId=" + encodeURIComponent("" + leaCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaSitesForSelectOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaSitesForSelectOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleCodeDescriptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleCodeDescriptionDto[]>;
        }));
    }

    protected processGetLeaSitesForSelectOptions(response: HttpResponseBase): Observable<SimpleCodeDescriptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimpleCodeDescriptionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addUpdateLeaRoleContact(command: AddUpdateLeaRoleContactCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaContacts/AddUpdateLeaRoleContact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddUpdateLeaRoleContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddUpdateLeaRoleContact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddUpdateLeaRoleContact(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addUpdateLeaSiteRoleContact(command: AddUpdateLeaSiteRoleContactCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaContacts/AddUpdateLeaSiteRoleContact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddUpdateLeaSiteRoleContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddUpdateLeaSiteRoleContact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddUpdateLeaSiteRoleContact(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    removeLeaRoleContact(command: RemoveLeaRoleContactCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaContacts/RemoveLeaRoleContact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveLeaRoleContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveLeaRoleContact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processRemoveLeaRoleContact(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    removeLeaSiteRoleContact(command: RemoveLeaSiteRoleContactCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaContacts/RemoveLeaSiteRoleContact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveLeaSiteRoleContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveLeaSiteRoleContact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processRemoveLeaSiteRoleContact(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    fillMissingLeaSiteContacts(command: FillMissingLeaSiteContactsCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaContacts/FillMissingLeaSiteContacts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFillMissingLeaSiteContacts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFillMissingLeaSiteContacts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processFillMissingLeaSiteContacts(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    verifyLeaRoleContact(command: VerifyLeaRoleContactCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaContacts/VerifyLeaRoleContact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyLeaRoleContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyLeaRoleContact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processVerifyLeaRoleContact(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    verifyLeaSiteRoleContact(command: VerifyLeaSiteRoleContactCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaContacts/VerifyLeaSiteRoleContact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyLeaSiteRoleContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyLeaSiteRoleContact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processVerifyLeaSiteRoleContact(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportLeaContactRoleInformationToExcel(leaCodeId?: number | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaContacts/ExportLeaContactRoleInformationToExcel?";
        if (leaCodeId === null)
            throw new globalThis.Error("The parameter 'leaCodeId' cannot be null.");
        else if (leaCodeId !== undefined)
            url_ += "leaCodeId=" + encodeURIComponent("" + leaCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportLeaContactRoleInformationToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportLeaContactRoleInformationToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processExportLeaContactRoleInformationToExcel(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportLeaSiteContactRoleInformationToExcel(model: ExportSiteContactRoleInformationToExcelQuery): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaContacts/ExportLeaSiteContactRoleInformationToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportLeaSiteContactRoleInformationToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportLeaSiteContactRoleInformationToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processExportLeaSiteContactRoleInformationToExcel(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportAllLeaContactRoleInformationToExcel(model: ExportAllContactRoleInformationToExcelQuery): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaContacts/ExportAllLeaContactRoleInformationToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportAllLeaContactRoleInformationToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportAllLeaContactRoleInformationToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processExportAllLeaContactRoleInformationToExcel(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    validateAdminContacts(leaCodeId?: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/LeaContacts/ValidateAdminContacts?";
        if (leaCodeId === null)
            throw new globalThis.Error("The parameter 'leaCodeId' cannot be null.");
        else if (leaCodeId !== undefined)
            url_ += "leaCodeId=" + encodeURIComponent("" + leaCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateAdminContacts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateAdminContacts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processValidateAdminContacts(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class LeaClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getEducatorHeaderInformation(personId: number): Observable<LeaEducatorHeaderDto> {
        let url_ = this.baseUrl + "/api/Lea/GetEducatorHeaderInformation/{personId}";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorHeaderInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorHeaderInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaEducatorHeaderDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaEducatorHeaderDto>;
        }));
    }

    protected processGetEducatorHeaderInformation(response: HttpResponseBase): Observable<LeaEducatorHeaderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LeaEducatorHeaderDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEducatorEmploymentInfo(personId: number): Observable<EducatorEmploymentInfoDto> {
        let url_ = this.baseUrl + "/api/Lea/GetEducatorEmploymentInfo/{personId}";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorEmploymentInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorEmploymentInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EducatorEmploymentInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EducatorEmploymentInfoDto>;
        }));
    }

    protected processGetEducatorEmploymentInfo(response: HttpResponseBase): Observable<EducatorEmploymentInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EducatorEmploymentInfoDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEducatorGeneralInformation(personId: number): Observable<LeaEducatorInformationDto> {
        let url_ = this.baseUrl + "/api/Lea/GetEducatorGeneralInformation/{personId}";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorGeneralInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorGeneralInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaEducatorInformationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaEducatorInformationDto>;
        }));
    }

    protected processGetEducatorGeneralInformation(response: HttpResponseBase): Observable<LeaEducatorInformationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LeaEducatorInformationDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEducatorExams(personId: number): Observable<EducatorExamDto2[]> {
        let url_ = this.baseUrl + "/api/Lea/GetEducatorExams/{personId}";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorExams(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorExams(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EducatorExamDto2[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EducatorExamDto2[]>;
        }));
    }

    protected processGetEducatorExams(response: HttpResponseBase): Observable<EducatorExamDto2[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EducatorExamDto2[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEducatorGeneralFingerprintCard(personId: number): Observable<PersonFingerprintCardInformationDto> {
        let url_ = this.baseUrl + "/api/Lea/GetEducatorGeneralFingerprintCard/{personId}";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorGeneralFingerprintCard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorGeneralFingerprintCard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonFingerprintCardInformationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonFingerprintCardInformationDto>;
        }));
    }

    protected processGetEducatorGeneralFingerprintCard(response: HttpResponseBase): Observable<PersonFingerprintCardInformationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PersonFingerprintCardInformationDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEducatorCertificates(personId?: number | undefined): Observable<LeaEducatorDetailCertificateDto[]> {
        let url_ = this.baseUrl + "/api/Lea?";
        if (personId === null)
            throw new globalThis.Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorCertificates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorCertificates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaEducatorDetailCertificateDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaEducatorDetailCertificateDto[]>;
        }));
    }

    protected processGetEducatorCertificates(response: HttpResponseBase): Observable<LeaEducatorDetailCertificateDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LeaEducatorDetailCertificateDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEducatorApplications(personId: number): Observable<LeaEducatorApplicationDto[]> {
        let url_ = this.baseUrl + "/api/Lea/GetEducatorApplications/{personId}";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorApplications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorApplications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaEducatorApplicationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaEducatorApplicationDto[]>;
        }));
    }

    protected processGetEducatorApplications(response: HttpResponseBase): Observable<LeaEducatorApplicationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LeaEducatorApplicationDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEducatorEducation(personId: number): Observable<LeaEducatorEducationDto[]> {
        let url_ = this.baseUrl + "/api/Lea/GetEducatorEducation/{personId}";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorEducation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorEducation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaEducatorEducationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaEducatorEducationDto[]>;
        }));
    }

    protected processGetEducatorEducation(response: HttpResponseBase): Observable<LeaEducatorEducationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LeaEducatorEducationDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLeaEducatorRosterSetFilterValues(query: GetEducatorRosterFilterValuesQuery): Observable<SetFilterResultDto> {
        let url_ = this.baseUrl + "/api/Lea/GetLeaEducatorRosterSetFilterValues";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaEducatorRosterSetFilterValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaEducatorRosterSetFilterValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SetFilterResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SetFilterResultDto>;
        }));
    }

    protected processGetLeaEducatorRosterSetFilterValues(response: HttpResponseBase): Observable<SetFilterResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SetFilterResultDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLeaEducatorRoster(model: GetLeaEducatorRosterQuery): Observable<LeaEducatorRosterListDto> {
        let url_ = this.baseUrl + "/api/Lea/GetLeaEducatorRoster";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaEducatorRoster(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaEducatorRoster(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaEducatorRosterListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaEducatorRosterListDto>;
        }));
    }

    protected processGetLeaEducatorRoster(response: HttpResponseBase): Observable<LeaEducatorRosterListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LeaEducatorRosterListDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLeaEducatorRosterQuickFilterCounts(leaEdOrgId?: string | null | undefined): Observable<LeaEducatorRosterQuickFilterCountsDto> {
        let url_ = this.baseUrl + "/api/Lea/GetLeaEducatorRosterQuickFilterCounts?";
        if (leaEdOrgId !== undefined && leaEdOrgId !== null)
            url_ += "leaEdOrgId=" + encodeURIComponent("" + leaEdOrgId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaEducatorRosterQuickFilterCounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaEducatorRosterQuickFilterCounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaEducatorRosterQuickFilterCountsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaEducatorRosterQuickFilterCountsDto>;
        }));
    }

    protected processGetLeaEducatorRosterQuickFilterCounts(response: HttpResponseBase): Observable<LeaEducatorRosterQuickFilterCountsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LeaEducatorRosterQuickFilterCountsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addEducatorToRoster(command: AddEducatorToRosterCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Lea/AddEducatorToRoster";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddEducatorToRoster(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddEducatorToRoster(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddEducatorToRoster(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    removeEducatorFromRoster(command: RemoveEducatorFromRosterCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Lea/RemoveEducatorFromRoster";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveEducatorFromRoster(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveEducatorFromRoster(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processRemoveEducatorFromRoster(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLeaSiteCodes(): Observable<LeaSiteCodeDto[]> {
        let url_ = this.baseUrl + "/api/Lea/GetLeaSiteCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaSiteCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaSiteCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaSiteCodeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaSiteCodeDto[]>;
        }));
    }

    protected processGetLeaSiteCodes(response: HttpResponseBase): Observable<LeaSiteCodeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LeaSiteCodeDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updatePersonCertificateProfessionalDevelopment(command: UpdatePersonCertificateProfessionalDevelopmentCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Lea/UpdatePersonCertificateProfessionalDevelopment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePersonCertificateProfessionalDevelopment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePersonCertificateProfessionalDevelopment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdatePersonCertificateProfessionalDevelopment(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUnprofessionalConductFormInfo(personId: number): Observable<UnprofessionalConductFormInfoDto> {
        let url_ = this.baseUrl + "/api/Lea/GetUnprofessionalConductFormInfo/{personId}";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnprofessionalConductFormInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnprofessionalConductFormInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UnprofessionalConductFormInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UnprofessionalConductFormInfoDto>;
        }));
    }

    protected processGetUnprofessionalConductFormInfo(response: HttpResponseBase): Observable<UnprofessionalConductFormInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnprofessionalConductFormInfoDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    submitUnprofessionalConductReport(command: SubmitUnprofessionalConductReportCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Lea/SubmitUnprofessionalConductReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmitUnprofessionalConductReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitUnprofessionalConductReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processSubmitUnprofessionalConductReport(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEducatorEmploymentHistory(personId: number): Observable<LeaEducatorEmploymentHistoryDto> {
        let url_ = this.baseUrl + "/api/Lea/GetEducatorEmploymentHistory/{personId}";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorEmploymentHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorEmploymentHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaEducatorEmploymentHistoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaEducatorEmploymentHistoryDto>;
        }));
    }

    protected processGetEducatorEmploymentHistory(response: HttpResponseBase): Observable<LeaEducatorEmploymentHistoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LeaEducatorEmploymentHistoryDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    rushServiceItem(command: OldLeaRushServiceItemCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Lea/RushServiceItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRushServiceItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRushServiceItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processRushServiceItem(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    removeRushFromServiceItem(command: RemoveRushFromServiceItemCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Lea/RemoveRushFromServiceItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveRushFromServiceItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveRushFromServiceItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processRemoveRushFromServiceItem(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getVoucherAllocations(leaEdOrgId?: string | null | undefined): Observable<VoucherAllocationResultDto[]> {
        let url_ = this.baseUrl + "/api/Lea/GetVoucherAllocations?";
        if (leaEdOrgId !== undefined && leaEdOrgId !== null)
            url_ += "LeaEdOrgId=" + encodeURIComponent("" + leaEdOrgId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVoucherAllocations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVoucherAllocations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoucherAllocationResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoucherAllocationResultDto[]>;
        }));
    }

    protected processGetVoucherAllocations(response: HttpResponseBase): Observable<VoucherAllocationResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VoucherAllocationResultDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getVoucherCreditsManagementDetails(voucherAllocationId?: number | undefined): Observable<VoucherCreditManagementDetailsDto> {
        let url_ = this.baseUrl + "/api/Lea/GetVoucherCreditsManagementDetails?";
        if (voucherAllocationId === null)
            throw new globalThis.Error("The parameter 'voucherAllocationId' cannot be null.");
        else if (voucherAllocationId !== undefined)
            url_ += "voucherAllocationId=" + encodeURIComponent("" + voucherAllocationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVoucherCreditsManagementDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVoucherCreditsManagementDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoucherCreditManagementDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoucherCreditManagementDetailsDto>;
        }));
    }

    protected processGetVoucherCreditsManagementDetails(response: HttpResponseBase): Observable<VoucherCreditManagementDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VoucherCreditManagementDetailsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createVoucherCredits(command: CreateVoucherCreditsCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Lea/CreateVoucherCredits";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateVoucherCredits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateVoucherCredits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processCreateVoucherCredits(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteVoucherCredits(command: DeleteVoucherCreditsCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Lea/DeleteVoucherCredits";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteVoucherCredits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteVoucherCredits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteVoucherCredits(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateVoucherCredits(command: UpdateVoucherCreditsCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Lea/UpdateVoucherCredits";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateVoucherCredits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateVoucherCredits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdateVoucherCredits(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getOldLeaVoucherPersons(leaEdOrgId?: string | null | undefined, lastName?: string | null | undefined, firstName?: string | null | undefined, eIN?: string | null | undefined): Observable<PersonSearchResultDto[]> {
        let url_ = this.baseUrl + "/api/Lea/GetOldLeaVoucherPersons?";
        if (leaEdOrgId !== undefined && leaEdOrgId !== null)
            url_ += "LeaEdOrgId=" + encodeURIComponent("" + leaEdOrgId) + "&";
        if (lastName !== undefined && lastName !== null)
            url_ += "LastName=" + encodeURIComponent("" + lastName) + "&";
        if (firstName !== undefined && firstName !== null)
            url_ += "FirstName=" + encodeURIComponent("" + firstName) + "&";
        if (eIN !== undefined && eIN !== null)
            url_ += "EIN=" + encodeURIComponent("" + eIN) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOldLeaVoucherPersons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOldLeaVoucherPersons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonSearchResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonSearchResultDto[]>;
        }));
    }

    protected processGetOldLeaVoucherPersons(response: HttpResponseBase): Observable<PersonSearchResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PersonSearchResultDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getBulkOldLeaVoucherPersons(leaEdOrgId?: string | null | undefined, commaSeparatedEins?: string | undefined): Observable<BulkPersonSearchResultDto> {
        let url_ = this.baseUrl + "/api/Lea/GetBulkOldLeaVoucherPersons?";
        if (leaEdOrgId !== undefined && leaEdOrgId !== null)
            url_ += "LeaEdOrgId=" + encodeURIComponent("" + leaEdOrgId) + "&";
        if (commaSeparatedEins === null)
            throw new globalThis.Error("The parameter 'commaSeparatedEins' cannot be null.");
        else if (commaSeparatedEins !== undefined)
            url_ += "CommaSeparatedEins=" + encodeURIComponent("" + commaSeparatedEins) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBulkOldLeaVoucherPersons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBulkOldLeaVoucherPersons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BulkPersonSearchResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BulkPersonSearchResultDto>;
        }));
    }

    protected processGetBulkOldLeaVoucherPersons(response: HttpResponseBase): Observable<BulkPersonSearchResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkPersonSearchResultDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class LeaHomeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getLeaToDoTasks(): Observable<LeaToDoTaskDto[]> {
        let url_ = this.baseUrl + "/api/LeaHome/GetLeaToDoTasks";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaToDoTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaToDoTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaToDoTaskDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaToDoTaskDto[]>;
        }));
    }

    protected processGetLeaToDoTasks(response: HttpResponseBase): Observable<LeaToDoTaskDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LeaToDoTaskDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDashboardReports(): Observable<LeaReportDto[]> {
        let url_ = this.baseUrl + "/api/LeaHome/GetDashboardReports";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDashboardReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDashboardReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaReportDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaReportDto[]>;
        }));
    }

    protected processGetDashboardReports(response: HttpResponseBase): Observable<LeaReportDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LeaReportDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getStaffStatuses(model: GetLeaStaffStatusQuery): Observable<LeaStaffStatusListDto> {
        let url_ = this.baseUrl + "/api/LeaHome/GetStaffStatuses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStaffStatuses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStaffStatuses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaStaffStatusListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaStaffStatusListDto>;
        }));
    }

    protected processGetStaffStatuses(response: HttpResponseBase): Observable<LeaStaffStatusListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LeaStaffStatusListDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getStaffStatusCounts(leaCodeId?: number | undefined): Observable<LeaStaffStatusCountsDto> {
        let url_ = this.baseUrl + "/api/LeaHome/GetStaffStatusCounts?";
        if (leaCodeId === null)
            throw new globalThis.Error("The parameter 'leaCodeId' cannot be null.");
        else if (leaCodeId !== undefined)
            url_ += "leaCodeId=" + encodeURIComponent("" + leaCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStaffStatusCounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStaffStatusCounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaStaffStatusCountsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaStaffStatusCountsDto>;
        }));
    }

    protected processGetStaffStatusCounts(response: HttpResponseBase): Observable<LeaStaffStatusCountsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LeaStaffStatusCountsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class LeaInformationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getCurrentUserLeaCodeId(): Observable<number | null> {
        let url_ = this.baseUrl + "/api/LeaInformation/GetCurrentUserLeaCodeId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentUserLeaCodeId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentUserLeaCodeId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number | null>;
        }));
    }

    protected processGetCurrentUserLeaCodeId(response: HttpResponseBase): Observable<number | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLeaAlerts(): Observable<LeaAlertListDto> {
        let url_ = this.baseUrl + "/api/LeaInformation/GetLeaAlerts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaAlerts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaAlerts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaAlertListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaAlertListDto>;
        }));
    }

    protected processGetLeaAlerts(response: HttpResponseBase): Observable<LeaAlertListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LeaAlertListDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class LeaPerformanceEvaluationsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAcademicYearOptions(leaCodeId?: number | null | undefined): Observable<AcademicYearOptionResultDto> {
        let url_ = this.baseUrl + "/api/LeaPerformanceEvaluations/GetAcademicYearOptions?";
        if (leaCodeId !== undefined && leaCodeId !== null)
            url_ += "leaCodeId=" + encodeURIComponent("" + leaCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAcademicYearOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAcademicYearOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AcademicYearOptionResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AcademicYearOptionResultDto>;
        }));
    }

    protected processGetAcademicYearOptions(response: HttpResponseBase): Observable<AcademicYearOptionResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AcademicYearOptionResultDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPerformanceEvaluations(model: GetPerformanceEvaluationsQuery): Observable<PerformanceEvaluationRecordDto[]> {
        let url_ = this.baseUrl + "/api/LeaPerformanceEvaluations/GetPerformanceEvaluations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPerformanceEvaluations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPerformanceEvaluations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PerformanceEvaluationRecordDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PerformanceEvaluationRecordDto[]>;
        }));
    }

    protected processGetPerformanceEvaluations(response: HttpResponseBase): Observable<PerformanceEvaluationRecordDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PerformanceEvaluationRecordDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadPerformanceEvaluations(model: DownloadPerformanceEvaluationsQuery): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaPerformanceEvaluations/DownloadPerformanceEvaluations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadPerformanceEvaluations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadPerformanceEvaluations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDownloadPerformanceEvaluations(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updatePerformanceEvaluationCounts(command: UpdatePerformanceEvaluationCountsCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaPerformanceEvaluations/UpdatePerformanceEvaluationCounts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePerformanceEvaluationCounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePerformanceEvaluationCounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdatePerformanceEvaluationCounts(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    verifyPerformanceEvaluations(command: VerifyPerformanceEvaluationsCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaPerformanceEvaluations/VerifyPerformanceEvaluations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyPerformanceEvaluations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyPerformanceEvaluations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processVerifyPerformanceEvaluations(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class LeaProfessionalDevelopmentClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getCurrentUserContactEmail(): Observable<string> {
        let url_ = this.baseUrl + "/api/LeaProfessionalDevelopment/GetCurrentUserContactEmail";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentUserContactEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentUserContactEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetCurrentUserContactEmail(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCurrentProfessionalDevelopmentNotificationSubscriptions(): Observable<ProfessionalDevelopmentNotificationSubscriptionDto[]> {
        let url_ = this.baseUrl + "/api/LeaProfessionalDevelopment/GetCurrentProfessionalDevelopmentNotificationSubscriptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentProfessionalDevelopmentNotificationSubscriptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentProfessionalDevelopmentNotificationSubscriptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfessionalDevelopmentNotificationSubscriptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfessionalDevelopmentNotificationSubscriptionDto[]>;
        }));
    }

    protected processGetCurrentProfessionalDevelopmentNotificationSubscriptions(response: HttpResponseBase): Observable<ProfessionalDevelopmentNotificationSubscriptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfessionalDevelopmentNotificationSubscriptionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLeaOnlineProfessionalDevelopmentUploadOptInState(leaCodeId?: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/LeaProfessionalDevelopment/GetLeaOnlineProfessionalDevelopmentUploadOptInState?";
        if (leaCodeId === null)
            throw new globalThis.Error("The parameter 'leaCodeId' cannot be null.");
        else if (leaCodeId !== undefined)
            url_ += "leaCodeId=" + encodeURIComponent("" + leaCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaOnlineProfessionalDevelopmentUploadOptInState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaOnlineProfessionalDevelopmentUploadOptInState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processGetLeaOnlineProfessionalDevelopmentUploadOptInState(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateProfessionalDevelopmentNotificationSubscription(command: UpdateProfessionalDevelopmentNotificationSubscriptionCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaProfessionalDevelopment/UpdateProfessionalDevelopmentNotificationSubscription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProfessionalDevelopmentNotificationSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProfessionalDevelopmentNotificationSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdateProfessionalDevelopmentNotificationSubscription(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProfessionalDevelopmentVerificationRequests(leaCodeId?: number | undefined, includeFinalizedRequests?: boolean | undefined): Observable<LeaProfessionalDevelopmentVerificationRequestDto[]> {
        let url_ = this.baseUrl + "/api/LeaProfessionalDevelopment/GetProfessionalDevelopmentVerificationRequests?";
        if (leaCodeId === null)
            throw new globalThis.Error("The parameter 'leaCodeId' cannot be null.");
        else if (leaCodeId !== undefined)
            url_ += "leaCodeId=" + encodeURIComponent("" + leaCodeId) + "&";
        if (includeFinalizedRequests === null)
            throw new globalThis.Error("The parameter 'includeFinalizedRequests' cannot be null.");
        else if (includeFinalizedRequests !== undefined)
            url_ += "includeFinalizedRequests=" + encodeURIComponent("" + includeFinalizedRequests) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfessionalDevelopmentVerificationRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfessionalDevelopmentVerificationRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaProfessionalDevelopmentVerificationRequestDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaProfessionalDevelopmentVerificationRequestDto[]>;
        }));
    }

    protected processGetProfessionalDevelopmentVerificationRequests(response: HttpResponseBase): Observable<LeaProfessionalDevelopmentVerificationRequestDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LeaProfessionalDevelopmentVerificationRequestDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProfessionalDevelopmentRecords(leaCodeId?: number | undefined): Observable<ProfessionalDevelopmentRecordResultDto[]> {
        let url_ = this.baseUrl + "/api/LeaProfessionalDevelopment/GetProfessionalDevelopmentRecords?";
        if (leaCodeId === null)
            throw new globalThis.Error("The parameter 'leaCodeId' cannot be null.");
        else if (leaCodeId !== undefined)
            url_ += "leaCodeId=" + encodeURIComponent("" + leaCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfessionalDevelopmentRecords(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfessionalDevelopmentRecords(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfessionalDevelopmentRecordResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfessionalDevelopmentRecordResultDto[]>;
        }));
    }

    protected processGetProfessionalDevelopmentRecords(response: HttpResponseBase): Observable<ProfessionalDevelopmentRecordResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfessionalDevelopmentRecordResultDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    verifyProfessionalDevelopmentVerificationRequest(command: VerifyProfessionalDevelopmentVerificationRequestCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaProfessionalDevelopment/VerifyProfessionalDevelopmentVerificationRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyProfessionalDevelopmentVerificationRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyProfessionalDevelopmentVerificationRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processVerifyProfessionalDevelopmentVerificationRequest(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    rejectProfessionalDevelopmentVerificationRequest(command: RejectProfessionalDevelopmentVerificationRequestCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaProfessionalDevelopment/RejectProfessionalDevelopmentVerificationRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRejectProfessionalDevelopmentVerificationRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRejectProfessionalDevelopmentVerificationRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processRejectProfessionalDevelopmentVerificationRequest(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    fulfillProfessionalDevelopmentRequest(command: FulfillProfessionalDevelopmentRequestCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaProfessionalDevelopment/FulfillProfessionalDevelopmentRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFulfillProfessionalDevelopmentRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFulfillProfessionalDevelopmentRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processFulfillProfessionalDevelopmentRequest(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    rejectProfessionalDevelopmentRequest(command: RejectProfessionalDevelopmentRequestCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaProfessionalDevelopment/RejectProfessionalDevelopmentRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRejectProfessionalDevelopmentRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRejectProfessionalDevelopmentRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processRejectProfessionalDevelopmentRequest(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPersonsProfessionalDevelopmentSearch(leaCodeId?: number | undefined, lastName?: string | null | undefined, firstName?: string | null | undefined, eIN?: string | null | undefined, leaSiteCodeId?: number | null | undefined): Observable<LeaPDPersonSearchResultDto[]> {
        let url_ = this.baseUrl + "/api/LeaProfessionalDevelopment/GetPersonsProfessionalDevelopmentSearch?";
        if (leaCodeId === null)
            throw new globalThis.Error("The parameter 'leaCodeId' cannot be null.");
        else if (leaCodeId !== undefined)
            url_ += "LeaCodeId=" + encodeURIComponent("" + leaCodeId) + "&";
        if (lastName !== undefined && lastName !== null)
            url_ += "LastName=" + encodeURIComponent("" + lastName) + "&";
        if (firstName !== undefined && firstName !== null)
            url_ += "FirstName=" + encodeURIComponent("" + firstName) + "&";
        if (eIN !== undefined && eIN !== null)
            url_ += "EIN=" + encodeURIComponent("" + eIN) + "&";
        if (leaSiteCodeId !== undefined && leaSiteCodeId !== null)
            url_ += "LeaSiteCodeId=" + encodeURIComponent("" + leaSiteCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonsProfessionalDevelopmentSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonsProfessionalDevelopmentSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaPDPersonSearchResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaPDPersonSearchResultDto[]>;
        }));
    }

    protected processGetPersonsProfessionalDevelopmentSearch(response: HttpResponseBase): Observable<LeaPDPersonSearchResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LeaPDPersonSearchResultDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTotalCountOfPendingProfessionalDevelopmentRequests(leaCodeId?: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/LeaProfessionalDevelopment/GetTotalCountOfPendingProfessionalDevelopmentRequests?";
        if (leaCodeId === null)
            throw new globalThis.Error("The parameter 'leaCodeId' cannot be null.");
        else if (leaCodeId !== undefined)
            url_ += "leaCodeId=" + encodeURIComponent("" + leaCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTotalCountOfPendingProfessionalDevelopmentRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTotalCountOfPendingProfessionalDevelopmentRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetTotalCountOfPendingProfessionalDevelopmentRequests(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getBulkPersonSearch(leaCodeId?: number | undefined, commaSeparatedEins?: string | undefined): Observable<LeaPDBulkPersonSearchResultDto> {
        let url_ = this.baseUrl + "/api/LeaProfessionalDevelopment/GetBulkPersonSearch?";
        if (leaCodeId === null)
            throw new globalThis.Error("The parameter 'leaCodeId' cannot be null.");
        else if (leaCodeId !== undefined)
            url_ += "LeaCodeId=" + encodeURIComponent("" + leaCodeId) + "&";
        if (commaSeparatedEins === null)
            throw new globalThis.Error("The parameter 'commaSeparatedEins' cannot be null.");
        else if (commaSeparatedEins !== undefined)
            url_ += "CommaSeparatedEins=" + encodeURIComponent("" + commaSeparatedEins) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBulkPersonSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBulkPersonSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaPDBulkPersonSearchResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaPDBulkPersonSearchResultDto>;
        }));
    }

    protected processGetBulkPersonSearch(response: HttpResponseBase): Observable<LeaPDBulkPersonSearchResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LeaPDBulkPersonSearchResultDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createProfessionalDevelopmentRecord(command: CreateProfessionalDevelopmentRecordCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaProfessionalDevelopment/CreateProfessionalDevelopmentRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateProfessionalDevelopmentRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProfessionalDevelopmentRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processCreateProfessionalDevelopmentRecord(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateProfessionalDevelopmentRecords(command: UpdateProfessionalDevelopmentRecordCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaProfessionalDevelopment/UpdateProfessionalDevelopmentRecords";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProfessionalDevelopmentRecords(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProfessionalDevelopmentRecords(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdateProfessionalDevelopmentRecords(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteProfessionalDevelopmentRecords(command: DeleteProfessionalDevelopmentRecordCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaProfessionalDevelopment/DeleteProfessionalDevelopmentRecords";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteProfessionalDevelopmentRecords(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProfessionalDevelopmentRecords(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteProfessionalDevelopmentRecords(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    verifyRemainingProfessionalDevelopmentHours(command: VerifyRemainingProfessionalDevelopmentHoursCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaProfessionalDevelopment/VerifyRemainingProfessionalDevelopmentHours";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyRemainingProfessionalDevelopmentHours(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyRemainingProfessionalDevelopmentHours(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processVerifyRemainingProfessionalDevelopmentHours(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class LeaReportsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getReports(): Observable<LeaReportDto[]> {
        let url_ = this.baseUrl + "/api/LeaReports/GetReports";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaReportDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaReportDto[]>;
        }));
    }

    protected processGetReports(response: HttpResponseBase): Observable<LeaReportDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LeaReportDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class LeaStaffClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAssignmentOptions(): Observable<AssignmentOptionsListDto> {
        let url_ = this.baseUrl + "/api/LeaStaff/GetAssignmentOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssignmentOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssignmentOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssignmentOptionsListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssignmentOptionsListDto>;
        }));
    }

    protected processGetAssignmentOptions(response: HttpResponseBase): Observable<AssignmentOptionsListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AssignmentOptionsListDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getStaffAssignmentDetailsForRemoval(staffAssignmentId?: number | undefined): Observable<RosterStaffAssignmentDto> {
        let url_ = this.baseUrl + "/api/LeaStaff/GetStaffAssignmentDetailsForRemoval?";
        if (staffAssignmentId === null)
            throw new globalThis.Error("The parameter 'staffAssignmentId' cannot be null.");
        else if (staffAssignmentId !== undefined)
            url_ += "staffAssignmentId=" + encodeURIComponent("" + staffAssignmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStaffAssignmentDetailsForRemoval(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStaffAssignmentDetailsForRemoval(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RosterStaffAssignmentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RosterStaffAssignmentDto>;
        }));
    }

    protected processGetStaffAssignmentDetailsForRemoval(response: HttpResponseBase): Observable<RosterStaffAssignmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RosterStaffAssignmentDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPositionDetailsForAssignment(staffPositionId?: number | undefined): Observable<PositionDetailsForAssignmentDto> {
        let url_ = this.baseUrl + "/api/LeaStaff/GetPositionDetailsForAssignment?";
        if (staffPositionId === null)
            throw new globalThis.Error("The parameter 'staffPositionId' cannot be null.");
        else if (staffPositionId !== undefined)
            url_ += "staffPositionId=" + encodeURIComponent("" + staffPositionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPositionDetailsForAssignment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPositionDetailsForAssignment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PositionDetailsForAssignmentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PositionDetailsForAssignmentDto>;
        }));
    }

    protected processGetPositionDetailsForAssignment(response: HttpResponseBase): Observable<PositionDetailsForAssignmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PositionDetailsForAssignmentDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSelectedStaffMemberDetailsForAssignment(personId?: number | undefined): Observable<StaffMemberInfoDto> {
        let url_ = this.baseUrl + "/api/LeaStaff/GetSelectedStaffMemberDetailsForAssignment?";
        if (personId === null)
            throw new globalThis.Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSelectedStaffMemberDetailsForAssignment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSelectedStaffMemberDetailsForAssignment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StaffMemberInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StaffMemberInfoDto>;
        }));
    }

    protected processGetSelectedStaffMemberDetailsForAssignment(response: HttpResponseBase): Observable<StaffMemberInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StaffMemberInfoDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getExistingStaffAssignmentForManagement(staffAssignmentId?: number | undefined): Observable<ExistingStaffAssignmentForManagementDto> {
        let url_ = this.baseUrl + "/api/LeaStaff/GetExistingStaffAssignmentForManagement?";
        if (staffAssignmentId === null)
            throw new globalThis.Error("The parameter 'staffAssignmentId' cannot be null.");
        else if (staffAssignmentId !== undefined)
            url_ += "staffAssignmentId=" + encodeURIComponent("" + staffAssignmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExistingStaffAssignmentForManagement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExistingStaffAssignmentForManagement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExistingStaffAssignmentForManagementDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExistingStaffAssignmentForManagementDto>;
        }));
    }

    protected processGetExistingStaffAssignmentForManagement(response: HttpResponseBase): Observable<ExistingStaffAssignmentForManagementDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExistingStaffAssignmentForManagementDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getStaffYoeForPerson(personId?: number | undefined): Observable<StaffPersonYoeDto> {
        let url_ = this.baseUrl + "/api/LeaStaff/GetStaffYoeForPerson?";
        if (personId === null)
            throw new globalThis.Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStaffYoeForPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStaffYoeForPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StaffPersonYoeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StaffPersonYoeDto>;
        }));
    }

    protected processGetStaffYoeForPerson(response: HttpResponseBase): Observable<StaffPersonYoeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StaffPersonYoeDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addUpdateStaffAssignment(command: AddUpdateStaffAssignmentCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/LeaStaff/AddUpdateStaffAssignment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddUpdateStaffAssignment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddUpdateStaffAssignment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddUpdateStaffAssignment(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    removeStaffAssignment(command: RemoveStaffAssignmentCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/LeaStaff/RemoveStaffAssignment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveStaffAssignment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveStaffAssignment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processRemoveStaffAssignment(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    verifyStaffAssignments(command: VerifyStaffAssignmentsCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/LeaStaff/VerifyStaffAssignments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyStaffAssignments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyStaffAssignments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processVerifyStaffAssignments(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getStaffHeaderInformation(personId: number): Observable<LeaStaffHeaderDto> {
        let url_ = this.baseUrl + "/api/LeaStaff/GetStaffHeaderInformation/{personId}";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStaffHeaderInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStaffHeaderInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaStaffHeaderDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaStaffHeaderDto>;
        }));
    }

    protected processGetStaffHeaderInformation(response: HttpResponseBase): Observable<LeaStaffHeaderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LeaStaffHeaderDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getStaffEmploymentInfo(personId: number): Observable<StaffEmploymentInfoDto> {
        let url_ = this.baseUrl + "/api/LeaStaff/GetStaffEmploymentInfo/{personId}";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStaffEmploymentInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStaffEmploymentInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StaffEmploymentInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StaffEmploymentInfoDto>;
        }));
    }

    protected processGetStaffEmploymentInfo(response: HttpResponseBase): Observable<StaffEmploymentInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StaffEmploymentInfoDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getStaffEmploymentHistory(personId: number): Observable<StaffEmploymentHistoryDto> {
        let url_ = this.baseUrl + "/api/LeaStaff/GetStaffEmploymentHistory/{personId}";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStaffEmploymentHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStaffEmploymentHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StaffEmploymentHistoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StaffEmploymentHistoryDto>;
        }));
    }

    protected processGetStaffEmploymentHistory(response: HttpResponseBase): Observable<StaffEmploymentHistoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StaffEmploymentHistoryDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getStaffGeneralInformation(personId: number): Observable<LeaStaffInformationDto> {
        let url_ = this.baseUrl + "/api/LeaStaff/GetStaffGeneralInformation/{personId}";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStaffGeneralInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStaffGeneralInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaStaffInformationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaStaffInformationDto>;
        }));
    }

    protected processGetStaffGeneralInformation(response: HttpResponseBase): Observable<LeaStaffInformationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LeaStaffInformationDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getStaffExams(personId: number): Observable<StaffExamDto[]> {
        let url_ = this.baseUrl + "/api/LeaStaff/GetStaffExams/{personId}";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStaffExams(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStaffExams(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StaffExamDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StaffExamDto[]>;
        }));
    }

    protected processGetStaffExams(response: HttpResponseBase): Observable<StaffExamDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StaffExamDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getStaffFingerprintCard(personId: number): Observable<PersonFingerprintCardInformationDto> {
        let url_ = this.baseUrl + "/api/LeaStaff/GetStaffFingerprintCard/{personId}";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStaffFingerprintCard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStaffFingerprintCard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonFingerprintCardInformationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonFingerprintCardInformationDto>;
        }));
    }

    protected processGetStaffFingerprintCard(response: HttpResponseBase): Observable<PersonFingerprintCardInformationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PersonFingerprintCardInformationDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getStaffCertificates(personId: number): Observable<LeaStaffDetailCertificateDto[]> {
        let url_ = this.baseUrl + "/api/LeaStaff/GetStaffCertificates/{personId}";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStaffCertificates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStaffCertificates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaStaffDetailCertificateDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaStaffDetailCertificateDto[]>;
        }));
    }

    protected processGetStaffCertificates(response: HttpResponseBase): Observable<LeaStaffDetailCertificateDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LeaStaffDetailCertificateDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getStaffApplications(personId: number): Observable<LeaStaffApplicationDto[]> {
        let url_ = this.baseUrl + "/api/LeaStaff/GetStaffApplications/{personId}";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStaffApplications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStaffApplications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaStaffApplicationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaStaffApplicationDto[]>;
        }));
    }

    protected processGetStaffApplications(response: HttpResponseBase): Observable<LeaStaffApplicationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LeaStaffApplicationDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getStaffEducation(personId: number): Observable<LeaStaffEducationDto[]> {
        let url_ = this.baseUrl + "/api/LeaStaff/GetStaffEducation/{personId}";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStaffEducation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStaffEducation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaStaffEducationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaStaffEducationDto[]>;
        }));
    }

    protected processGetStaffEducation(response: HttpResponseBase): Observable<LeaStaffEducationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LeaStaffEducationDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUnprofessionalConductFormInformation(personId: number): Observable<UnprofessionalConductFormInformationDto> {
        let url_ = this.baseUrl + "/api/LeaStaff/GetUnprofessionalConductFormInformation/{personId}";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnprofessionalConductFormInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnprofessionalConductFormInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UnprofessionalConductFormInformationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UnprofessionalConductFormInformationDto>;
        }));
    }

    protected processGetUnprofessionalConductFormInformation(response: HttpResponseBase): Observable<UnprofessionalConductFormInformationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnprofessionalConductFormInformationDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    submitUnprofessionalConductReport(command: SubmitUnprofessionalConductReportCommand2): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaStaff/SubmitUnprofessionalConductReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmitUnprofessionalConductReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitUnprofessionalConductReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processSubmitUnprofessionalConductReport(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLeaSiteCodeOptionsForLea(leaCodeId?: number | undefined): Observable<SimpleCodeDescriptionDto[]> {
        let url_ = this.baseUrl + "/api/LeaStaff/GetLeaSiteCodeOptionsForLea?";
        if (leaCodeId === null)
            throw new globalThis.Error("The parameter 'leaCodeId' cannot be null.");
        else if (leaCodeId !== undefined)
            url_ += "leaCodeId=" + encodeURIComponent("" + leaCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaSiteCodeOptionsForLea(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaSiteCodeOptionsForLea(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleCodeDescriptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleCodeDescriptionDto[]>;
        }));
    }

    protected processGetLeaSiteCodeOptionsForLea(response: HttpResponseBase): Observable<SimpleCodeDescriptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimpleCodeDescriptionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    rushServiceItem(command: LeaRushServiceItemCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaStaff/RushServiceItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRushServiceItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRushServiceItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processRushServiceItem(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    removeRushFromServiceItem(command: RemoveRushFromServiceItemCommand2): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaStaff/RemoveRushFromServiceItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveRushFromServiceItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveRushFromServiceItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processRemoveRushFromServiceItem(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    triggerManualACEvaluation(command: TriggerManualACEvaluationCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaStaff/TriggerManualACEvaluation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTriggerManualACEvaluation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTriggerManualACEvaluation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processTriggerManualACEvaluation(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProfessionalDevelopmentRequests(leaCodeId?: number | undefined, includeFinalizedRequests?: boolean | undefined): Observable<ProfessionalDevelopmentRequestResultDto[]> {
        let url_ = this.baseUrl + "/api/LeaStaff/GetProfessionalDevelopmentRequests?";
        if (leaCodeId === null)
            throw new globalThis.Error("The parameter 'leaCodeId' cannot be null.");
        else if (leaCodeId !== undefined)
            url_ += "leaCodeId=" + encodeURIComponent("" + leaCodeId) + "&";
        if (includeFinalizedRequests === null)
            throw new globalThis.Error("The parameter 'includeFinalizedRequests' cannot be null.");
        else if (includeFinalizedRequests !== undefined)
            url_ += "includeFinalizedRequests=" + encodeURIComponent("" + includeFinalizedRequests) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfessionalDevelopmentRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfessionalDevelopmentRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfessionalDevelopmentRequestResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfessionalDevelopmentRequestResultDto[]>;
        }));
    }

    protected processGetProfessionalDevelopmentRequests(response: HttpResponseBase): Observable<ProfessionalDevelopmentRequestResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfessionalDevelopmentRequestResultDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLeaStaffPositions(model: GetLeaStaffPositionsQuery): Observable<LeaStaffPositionsListDto> {
        let url_ = this.baseUrl + "/api/LeaStaff/GetLeaStaffPositions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaStaffPositions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaStaffPositions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaStaffPositionsListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaStaffPositionsListDto>;
        }));
    }

    protected processGetLeaStaffPositions(response: HttpResponseBase): Observable<LeaStaffPositionsListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LeaStaffPositionsListDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLeaStaffPositionsMetadata(leaCodeId?: number | null | undefined, shouldIncludeClosedPositions?: boolean | undefined): Observable<LeaStaffPositionsMetadataDto> {
        let url_ = this.baseUrl + "/api/LeaStaff/GetLeaStaffPositionsMetadata?";
        if (leaCodeId !== undefined && leaCodeId !== null)
            url_ += "leaCodeId=" + encodeURIComponent("" + leaCodeId) + "&";
        if (shouldIncludeClosedPositions === null)
            throw new globalThis.Error("The parameter 'shouldIncludeClosedPositions' cannot be null.");
        else if (shouldIncludeClosedPositions !== undefined)
            url_ += "shouldIncludeClosedPositions=" + encodeURIComponent("" + shouldIncludeClosedPositions) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaStaffPositionsMetadata(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaStaffPositionsMetadata(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaStaffPositionsMetadataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaStaffPositionsMetadataDto>;
        }));
    }

    protected processGetLeaStaffPositionsMetadata(response: HttpResponseBase): Observable<LeaStaffPositionsMetadataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LeaStaffPositionsMetadataDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAssignedPositionDetails(staffPositionId?: number | undefined): Observable<LeaStaffAssignmentPersonInformationDto> {
        let url_ = this.baseUrl + "/api/LeaStaff/GetAssignedPositionDetails?";
        if (staffPositionId === null)
            throw new globalThis.Error("The parameter 'staffPositionId' cannot be null.");
        else if (staffPositionId !== undefined)
            url_ += "staffPositionId=" + encodeURIComponent("" + staffPositionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssignedPositionDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssignedPositionDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaStaffAssignmentPersonInformationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaStaffAssignmentPersonInformationDto>;
        }));
    }

    protected processGetAssignedPositionDetails(response: HttpResponseBase): Observable<LeaStaffAssignmentPersonInformationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LeaStaffAssignmentPersonInformationDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getStaffPositionFormOptions(): Observable<StaffPositionFormOptionsDto> {
        let url_ = this.baseUrl + "/api/LeaStaff/GetStaffPositionFormOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStaffPositionFormOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStaffPositionFormOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StaffPositionFormOptionsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StaffPositionFormOptionsDto>;
        }));
    }

    protected processGetStaffPositionFormOptions(response: HttpResponseBase): Observable<StaffPositionFormOptionsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StaffPositionFormOptionsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPositionOptions(positionClassificationCodeId?: number | undefined): Observable<PositionOptionDto[]> {
        let url_ = this.baseUrl + "/api/LeaStaff/GetPositionOptions?";
        if (positionClassificationCodeId === null)
            throw new globalThis.Error("The parameter 'positionClassificationCodeId' cannot be null.");
        else if (positionClassificationCodeId !== undefined)
            url_ += "positionClassificationCodeId=" + encodeURIComponent("" + positionClassificationCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPositionOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPositionOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PositionOptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PositionOptionDto[]>;
        }));
    }

    protected processGetPositionOptions(response: HttpResponseBase): Observable<PositionOptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PositionOptionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPositionStatusCodeOptions(): Observable<SimpleSelectOptionDto[]> {
        let url_ = this.baseUrl + "/api/LeaStaff/GetPositionStatusCodeOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPositionStatusCodeOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPositionStatusCodeOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleSelectOptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleSelectOptionDto[]>;
        }));
    }

    protected processGetPositionStatusCodeOptions(response: HttpResponseBase): Observable<SimpleSelectOptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimpleSelectOptionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getContentAreaOptions(positionCodeId?: number | undefined): Observable<SimpleCodeDescriptionDto[]> {
        let url_ = this.baseUrl + "/api/LeaStaff/GetContentAreaOptions?";
        if (positionCodeId === null)
            throw new globalThis.Error("The parameter 'positionCodeId' cannot be null.");
        else if (positionCodeId !== undefined)
            url_ += "positionCodeId=" + encodeURIComponent("" + positionCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContentAreaOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContentAreaOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleCodeDescriptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleCodeDescriptionDto[]>;
        }));
    }

    protected processGetContentAreaOptions(response: HttpResponseBase): Observable<SimpleCodeDescriptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimpleCodeDescriptionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPositionContentAreaDetails(positionCodeId?: number | undefined, contentAreaCodeId?: number | undefined): Observable<PositionContentAreaDetailsDto> {
        let url_ = this.baseUrl + "/api/LeaStaff/GetPositionContentAreaDetails?";
        if (positionCodeId === null)
            throw new globalThis.Error("The parameter 'positionCodeId' cannot be null.");
        else if (positionCodeId !== undefined)
            url_ += "positionCodeId=" + encodeURIComponent("" + positionCodeId) + "&";
        if (contentAreaCodeId === null)
            throw new globalThis.Error("The parameter 'contentAreaCodeId' cannot be null.");
        else if (contentAreaCodeId !== undefined)
            url_ += "contentAreaCodeId=" + encodeURIComponent("" + contentAreaCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPositionContentAreaDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPositionContentAreaDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PositionContentAreaDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PositionContentAreaDetailsDto>;
        }));
    }

    protected processGetPositionContentAreaDetails(response: HttpResponseBase): Observable<PositionContentAreaDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PositionContentAreaDetailsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getGradeLevelsForPositionContentArea(positionCodeId?: number | undefined, contentAreaCodeId?: number | undefined): Observable<SimpleCodeDescriptionDto[]> {
        let url_ = this.baseUrl + "/api/LeaStaff/GetGradeLevelsForPositionContentArea?";
        if (positionCodeId === null)
            throw new globalThis.Error("The parameter 'positionCodeId' cannot be null.");
        else if (positionCodeId !== undefined)
            url_ += "positionCodeId=" + encodeURIComponent("" + positionCodeId) + "&";
        if (contentAreaCodeId === null)
            throw new globalThis.Error("The parameter 'contentAreaCodeId' cannot be null.");
        else if (contentAreaCodeId !== undefined)
            url_ += "contentAreaCodeId=" + encodeURIComponent("" + contentAreaCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGradeLevelsForPositionContentArea(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGradeLevelsForPositionContentArea(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleCodeDescriptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleCodeDescriptionDto[]>;
        }));
    }

    protected processGetGradeLevelsForPositionContentArea(response: HttpResponseBase): Observable<SimpleCodeDescriptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimpleCodeDescriptionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getExistingStaffPositionForManagement(staffPositionId?: number | undefined): Observable<ExistingStaffPositionForManagementDto> {
        let url_ = this.baseUrl + "/api/LeaStaff/GetExistingStaffPositionForManagement?";
        if (staffPositionId === null)
            throw new globalThis.Error("The parameter 'staffPositionId' cannot be null.");
        else if (staffPositionId !== undefined)
            url_ += "staffPositionId=" + encodeURIComponent("" + staffPositionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExistingStaffPositionForManagement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExistingStaffPositionForManagement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExistingStaffPositionForManagementDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExistingStaffPositionForManagementDto>;
        }));
    }

    protected processGetExistingStaffPositionForManagement(response: HttpResponseBase): Observable<ExistingStaffPositionForManagementDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExistingStaffPositionForManagementDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addUpdateStaffPosition(command: AddUpdateStaffPositionCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/LeaStaff/AddUpdateStaffPosition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddUpdateStaffPosition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddUpdateStaffPosition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddUpdateStaffPosition(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    closeStaffPosition(command: CloseStaffPositionCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/LeaStaff/CloseStaffPosition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCloseStaffPosition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCloseStaffPosition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCloseStaffPosition(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadStaffPositions(model: DownloadStaffPositionsQuery): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaStaff/DownloadStaffPositions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadStaffPositions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadStaffPositions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDownloadStaffPositions(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getReconciliationYearOptions(leaCodeId?: number | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/LeaStaff/GetReconciliationYearOptions?";
        if (leaCodeId === null)
            throw new globalThis.Error("The parameter 'leaCodeId' cannot be null.");
        else if (leaCodeId !== undefined)
            url_ += "leaCodeId=" + encodeURIComponent("" + leaCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReconciliationYearOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReconciliationYearOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetReconciliationYearOptions(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLeaStaffRosterReconciliation(model: GetLeaStaffRosterReconciliationQuery): Observable<LeaStaffRosterReconciliationMemberDto[]> {
        let url_ = this.baseUrl + "/api/LeaStaff/GetLeaStaffRosterReconciliation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaStaffRosterReconciliation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaStaffRosterReconciliation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaStaffRosterReconciliationMemberDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaStaffRosterReconciliationMemberDto[]>;
        }));
    }

    protected processGetLeaStaffRosterReconciliation(response: HttpResponseBase): Observable<LeaStaffRosterReconciliationMemberDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LeaStaffRosterReconciliationMemberDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addRemovalReasonToStaffAssignment(command: AddRemovalReasonToStaffAssignmentCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaStaff/AddRemovalReasonToStaffAssignment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddRemovalReasonToStaffAssignment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddRemovalReasonToStaffAssignment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddRemovalReasonToStaffAssignment(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    changeEndDateForAssignment(command: ChangeEndDateForStaffAssignmentCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaStaff/ChangeEndDateForAssignment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeEndDateForAssignment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeEndDateForAssignment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processChangeEndDateForAssignment(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLeaCredentialManagementRoster(model: GetLeaCredentialManagementRosterQuery): Observable<LeaCredentialManagementRosterListDto> {
        let url_ = this.baseUrl + "/api/LeaStaff/GetLeaCredentialManagementRoster";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaCredentialManagementRoster(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaCredentialManagementRoster(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaCredentialManagementRosterListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaCredentialManagementRosterListDto>;
        }));
    }

    protected processGetLeaCredentialManagementRoster(response: HttpResponseBase): Observable<LeaCredentialManagementRosterListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LeaCredentialManagementRosterListDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLeaCredentialManagementRosterCount(model: GetLeaCredentialManagementRosterCountQuery): Observable<number> {
        let url_ = this.baseUrl + "/api/LeaStaff/GetLeaCredentialManagementRosterCount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaCredentialManagementRosterCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaCredentialManagementRosterCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetLeaCredentialManagementRosterCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLeaStaffRoster(model: GetLeaStaffRosterQuery): Observable<LeaStaffRosterListDto> {
        let url_ = this.baseUrl + "/api/LeaStaff/GetLeaStaffRoster";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaStaffRoster(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaStaffRoster(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaStaffRosterListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaStaffRosterListDto>;
        }));
    }

    protected processGetLeaStaffRoster(response: HttpResponseBase): Observable<LeaStaffRosterListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LeaStaffRosterListDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getStaffRosterCertificates(personId: number): Observable<LeaStaffRosterCertificateDto[]> {
        let url_ = this.baseUrl + "/api/LeaStaff/GetStaffRosterCertificates/{personId}";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStaffRosterCertificates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStaffRosterCertificates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaStaffRosterCertificateDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaStaffRosterCertificateDto[]>;
        }));
    }

    protected processGetStaffRosterCertificates(response: HttpResponseBase): Observable<LeaStaffRosterCertificateDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LeaStaffRosterCertificateDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLeaStaffRosterFilterOptions(leaCodeId?: number | undefined, includeEmptyDistrictEmployments?: boolean | undefined, includeEmptySiteEmployments?: boolean | undefined, includeFilledDistrictEmployments?: boolean | undefined, includeFilledSiteEmployments?: boolean | undefined): Observable<LeaStaffRosterFilterOptionsDto> {
        let url_ = this.baseUrl + "/api/LeaStaff/GetLeaStaffRosterFilterOptions?";
        if (leaCodeId === null)
            throw new globalThis.Error("The parameter 'leaCodeId' cannot be null.");
        else if (leaCodeId !== undefined)
            url_ += "leaCodeId=" + encodeURIComponent("" + leaCodeId) + "&";
        if (includeEmptyDistrictEmployments === null)
            throw new globalThis.Error("The parameter 'includeEmptyDistrictEmployments' cannot be null.");
        else if (includeEmptyDistrictEmployments !== undefined)
            url_ += "includeEmptyDistrictEmployments=" + encodeURIComponent("" + includeEmptyDistrictEmployments) + "&";
        if (includeEmptySiteEmployments === null)
            throw new globalThis.Error("The parameter 'includeEmptySiteEmployments' cannot be null.");
        else if (includeEmptySiteEmployments !== undefined)
            url_ += "includeEmptySiteEmployments=" + encodeURIComponent("" + includeEmptySiteEmployments) + "&";
        if (includeFilledDistrictEmployments === null)
            throw new globalThis.Error("The parameter 'includeFilledDistrictEmployments' cannot be null.");
        else if (includeFilledDistrictEmployments !== undefined)
            url_ += "includeFilledDistrictEmployments=" + encodeURIComponent("" + includeFilledDistrictEmployments) + "&";
        if (includeFilledSiteEmployments === null)
            throw new globalThis.Error("The parameter 'includeFilledSiteEmployments' cannot be null.");
        else if (includeFilledSiteEmployments !== undefined)
            url_ += "includeFilledSiteEmployments=" + encodeURIComponent("" + includeFilledSiteEmployments) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaStaffRosterFilterOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaStaffRosterFilterOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaStaffRosterFilterOptionsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaStaffRosterFilterOptionsDto>;
        }));
    }

    protected processGetLeaStaffRosterFilterOptions(response: HttpResponseBase): Observable<LeaStaffRosterFilterOptionsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LeaStaffRosterFilterOptionsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLeaCredentialManagementRosterFilterOptions(leaCodeId?: number | undefined): Observable<LeaCredentialRosterFilterOptionsDto> {
        let url_ = this.baseUrl + "/api/LeaStaff/GetLeaCredentialManagementRosterFilterOptions?";
        if (leaCodeId === null)
            throw new globalThis.Error("The parameter 'leaCodeId' cannot be null.");
        else if (leaCodeId !== undefined)
            url_ += "leaCodeId=" + encodeURIComponent("" + leaCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaCredentialManagementRosterFilterOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaCredentialManagementRosterFilterOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaCredentialRosterFilterOptionsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaCredentialRosterFilterOptionsDto>;
        }));
    }

    protected processGetLeaCredentialManagementRosterFilterOptions(response: HttpResponseBase): Observable<LeaCredentialRosterFilterOptionsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LeaCredentialRosterFilterOptionsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRosterRemovalReasons(): Observable<RosterRemovalReasonDto[]> {
        let url_ = this.baseUrl + "/api/LeaStaff/GetRosterRemovalReasons";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRosterRemovalReasons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRosterRemovalReasons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RosterRemovalReasonDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RosterRemovalReasonDto[]>;
        }));
    }

    protected processGetRosterRemovalReasons(response: HttpResponseBase): Observable<RosterRemovalReasonDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RosterRemovalReasonDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEmploymentDetailsForRosterRemoval(leaStaffEmploymentId?: number | undefined, leaSiteStaffEmploymentId?: number | null | undefined): Observable<GetEmploymentDetailsForRosterRemovalDto> {
        let url_ = this.baseUrl + "/api/LeaStaff/GetEmploymentDetailsForRosterRemoval?";
        if (leaStaffEmploymentId === null)
            throw new globalThis.Error("The parameter 'leaStaffEmploymentId' cannot be null.");
        else if (leaStaffEmploymentId !== undefined)
            url_ += "leaStaffEmploymentId=" + encodeURIComponent("" + leaStaffEmploymentId) + "&";
        if (leaSiteStaffEmploymentId !== undefined && leaSiteStaffEmploymentId !== null)
            url_ += "leaSiteStaffEmploymentId=" + encodeURIComponent("" + leaSiteStaffEmploymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmploymentDetailsForRosterRemoval(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmploymentDetailsForRosterRemoval(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEmploymentDetailsForRosterRemovalDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEmploymentDetailsForRosterRemovalDto>;
        }));
    }

    protected processGetEmploymentDetailsForRosterRemoval(response: HttpResponseBase): Observable<GetEmploymentDetailsForRosterRemovalDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetEmploymentDetailsForRosterRemovalDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    removeFromRoster(command: RemoveFromRosterCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaStaff/RemoveFromRoster";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveFromRoster(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveFromRoster(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processRemoveFromRoster(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updatePersonCertificateProfessionalDevelopment(command: UpdatePersonCertificateProfessionalDevelopmentCommand2): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaStaff/UpdatePersonCertificateProfessionalDevelopment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePersonCertificateProfessionalDevelopment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePersonCertificateProfessionalDevelopment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdatePersonCertificateProfessionalDevelopment(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getStaffMemberForRosterManagement(personId?: number | undefined, staffPositionId?: number | null | undefined): Observable<StaffMemberInfoDto> {
        let url_ = this.baseUrl + "/api/LeaStaff/GetStaffMemberForRosterManagement?";
        if (personId === null)
            throw new globalThis.Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        if (staffPositionId !== undefined && staffPositionId !== null)
            url_ += "staffPositionId=" + encodeURIComponent("" + staffPositionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStaffMemberForRosterManagement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStaffMemberForRosterManagement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StaffMemberInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StaffMemberInfoDto>;
        }));
    }

    protected processGetStaffMemberForRosterManagement(response: HttpResponseBase): Observable<StaffMemberInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StaffMemberInfoDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLocationsForManagement(leaCodeId?: number | null | undefined): Observable<LocationOptionDto[]> {
        let url_ = this.baseUrl + "/api/LeaStaff/GetLocationsForManagement?";
        if (leaCodeId !== undefined && leaCodeId !== null)
            url_ += "leaCodeId=" + encodeURIComponent("" + leaCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationsForManagement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationsForManagement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationOptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationOptionDto[]>;
        }));
    }

    protected processGetLocationsForManagement(response: HttpResponseBase): Observable<LocationOptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LocationOptionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getExistingStaffEmploymentForManagement(leaStaffEmploymentId?: number | null | undefined, leaSiteStaffEmploymentId?: number | null | undefined): Observable<ExistingStaffEmploymentForManagementDto> {
        let url_ = this.baseUrl + "/api/LeaStaff/GetExistingStaffEmploymentForManagement?";
        if (leaStaffEmploymentId !== undefined && leaStaffEmploymentId !== null)
            url_ += "leaStaffEmploymentId=" + encodeURIComponent("" + leaStaffEmploymentId) + "&";
        if (leaSiteStaffEmploymentId !== undefined && leaSiteStaffEmploymentId !== null)
            url_ += "leaSiteStaffEmploymentId=" + encodeURIComponent("" + leaSiteStaffEmploymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExistingStaffEmploymentForManagement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExistingStaffEmploymentForManagement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExistingStaffEmploymentForManagementDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExistingStaffEmploymentForManagementDto>;
        }));
    }

    protected processGetExistingStaffEmploymentForManagement(response: HttpResponseBase): Observable<ExistingStaffEmploymentForManagementDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExistingStaffEmploymentForManagementDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addUpdateStaffEmployment(command: AddUpdateStaffEmploymentCommand): Observable<StaffEmploymentUpdateResultsDto> {
        let url_ = this.baseUrl + "/api/LeaStaff/AddUpdateStaffEmployment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddUpdateStaffEmployment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddUpdateStaffEmployment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StaffEmploymentUpdateResultsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StaffEmploymentUpdateResultsDto>;
        }));
    }

    protected processAddUpdateStaffEmployment(response: HttpResponseBase): Observable<StaffEmploymentUpdateResultsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StaffEmploymentUpdateResultsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getStaffPositionsForRosterAssignmentManagement(staffAssignmentId?: number | null | undefined, leaSiteCodeId?: number | null | undefined): Observable<SimpleSelectOptionDto[]> {
        let url_ = this.baseUrl + "/api/LeaStaff/GetStaffPositionsForRosterAssignmentManagement?";
        if (staffAssignmentId !== undefined && staffAssignmentId !== null)
            url_ += "staffAssignmentId=" + encodeURIComponent("" + staffAssignmentId) + "&";
        if (leaSiteCodeId !== undefined && leaSiteCodeId !== null)
            url_ += "leaSiteCodeId=" + encodeURIComponent("" + leaSiteCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStaffPositionsForRosterAssignmentManagement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStaffPositionsForRosterAssignmentManagement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleSelectOptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleSelectOptionDto[]>;
        }));
    }

    protected processGetStaffPositionsForRosterAssignmentManagement(response: HttpResponseBase): Observable<SimpleSelectOptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimpleSelectOptionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadStaffRoster(model: DownloadStaffRosterQuery): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaStaff/DownloadStaffRoster";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadStaffRoster(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadStaffRoster(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDownloadStaffRoster(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadLeaCredentialManagementRoster(model: DownloadLeaCredentialManagementRosterQuery): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaStaff/DownloadLeaCredentialManagementRoster";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadLeaCredentialManagementRoster(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadLeaCredentialManagementRoster(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDownloadLeaCredentialManagementRoster(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getHistoricalYearOptions(leaCodeId?: number | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/LeaStaff/GetHistoricalYearOptions?";
        if (leaCodeId === null)
            throw new globalThis.Error("The parameter 'leaCodeId' cannot be null.");
        else if (leaCodeId !== undefined)
            url_ += "leaCodeId=" + encodeURIComponent("" + leaCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistoricalYearOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistoricalYearOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetHistoricalYearOptions(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getHistoricalSnapshot(model: GetHistoricalSnapshotQuery): Observable<HistoricalSnapshotRecordDto[]> {
        let url_ = this.baseUrl + "/api/LeaStaff/GetHistoricalSnapshot";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistoricalSnapshot(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistoricalSnapshot(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HistoricalSnapshotRecordDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HistoricalSnapshotRecordDto[]>;
        }));
    }

    protected processGetHistoricalSnapshot(response: HttpResponseBase): Observable<HistoricalSnapshotRecordDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HistoricalSnapshotRecordDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadHistoricalSnapshot(model: DownloadHistoricalSnapshotQuery): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaStaff/DownloadHistoricalSnapshot";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadHistoricalSnapshot(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadHistoricalSnapshot(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDownloadHistoricalSnapshot(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class LeaSurveysClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getSurveyAssignments(leaCodeId?: number | null | undefined): Observable<LeaSurveyAssignmentDto[]> {
        let url_ = this.baseUrl + "/api/LeaSurveys/GetSurveyAssignments?";
        if (leaCodeId !== undefined && leaCodeId !== null)
            url_ += "leaCodeId=" + encodeURIComponent("" + leaCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSurveyAssignments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveyAssignments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaSurveyAssignmentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaSurveyAssignmentDto[]>;
        }));
    }

    protected processGetSurveyAssignments(response: HttpResponseBase): Observable<LeaSurveyAssignmentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LeaSurveyAssignmentDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSurveyIntendedContacts(surveyAssignmentId?: number | undefined, leaCodeId?: number | null | undefined): Observable<SurveyIntendedContactDto[]> {
        let url_ = this.baseUrl + "/api/LeaSurveys/GetSurveyIntendedContacts?";
        if (surveyAssignmentId === null)
            throw new globalThis.Error("The parameter 'surveyAssignmentId' cannot be null.");
        else if (surveyAssignmentId !== undefined)
            url_ += "surveyAssignmentId=" + encodeURIComponent("" + surveyAssignmentId) + "&";
        if (leaCodeId !== undefined && leaCodeId !== null)
            url_ += "leaCodeId=" + encodeURIComponent("" + leaCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSurveyIntendedContacts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveyIntendedContacts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveyIntendedContactDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveyIntendedContactDto[]>;
        }));
    }

    protected processGetSurveyIntendedContacts(response: HttpResponseBase): Observable<SurveyIntendedContactDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SurveyIntendedContactDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class LeaTitleIStatusClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getTitleIStatusOptions(): Observable<TitleIStatusOptionDto[]> {
        let url_ = this.baseUrl + "/api/LeaTitleIStatus/GetTitleIStatusOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTitleIStatusOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTitleIStatusOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TitleIStatusOptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TitleIStatusOptionDto[]>;
        }));
    }

    protected processGetTitleIStatusOptions(response: HttpResponseBase): Observable<TitleIStatusOptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TitleIStatusOptionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTitleIStatusManagementQuickFilterCounts(leaCodeId?: number | undefined): Observable<TitleIStatusManagementQuickFilterCountsDto> {
        let url_ = this.baseUrl + "/api/LeaTitleIStatus/GetTitleIStatusManagementQuickFilterCounts?";
        if (leaCodeId === null)
            throw new globalThis.Error("The parameter 'leaCodeId' cannot be null.");
        else if (leaCodeId !== undefined)
            url_ += "leaCodeId=" + encodeURIComponent("" + leaCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTitleIStatusManagementQuickFilterCounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTitleIStatusManagementQuickFilterCounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TitleIStatusManagementQuickFilterCountsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TitleIStatusManagementQuickFilterCountsDto>;
        }));
    }

    protected processGetTitleIStatusManagementQuickFilterCounts(response: HttpResponseBase): Observable<TitleIStatusManagementQuickFilterCountsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TitleIStatusManagementQuickFilterCountsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTitleIStatusManagement(model: GetTitleIStatusManagementQuery): Observable<TitleIStatusManagementListDto> {
        let url_ = this.baseUrl + "/api/LeaTitleIStatus/GetTitleIStatusManagement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTitleIStatusManagement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTitleIStatusManagement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TitleIStatusManagementListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TitleIStatusManagementListDto>;
        }));
    }

    protected processGetTitleIStatusManagement(response: HttpResponseBase): Observable<TitleIStatusManagementListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TitleIStatusManagementListDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setTitleIStatus(command: SetTitleIStatusCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaTitleIStatus/SetTitleIStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetTitleIStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetTitleIStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processSetTitleIStatus(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class LeaVouchersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getVoucherAllocations(leaCodeId?: number | undefined): Observable<VoucherAllocationResultDto[]> {
        let url_ = this.baseUrl + "/api/LeaVouchers/GetVoucherAllocations?";
        if (leaCodeId === null)
            throw new globalThis.Error("The parameter 'leaCodeId' cannot be null.");
        else if (leaCodeId !== undefined)
            url_ += "LeaCodeId=" + encodeURIComponent("" + leaCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVoucherAllocations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVoucherAllocations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoucherAllocationResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoucherAllocationResultDto[]>;
        }));
    }

    protected processGetVoucherAllocations(response: HttpResponseBase): Observable<VoucherAllocationResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VoucherAllocationResultDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getVoucherCreditsManagementDetails(voucherAllocationId?: number | undefined): Observable<VoucherCreditManagementDetailsDto> {
        let url_ = this.baseUrl + "/api/LeaVouchers/GetVoucherCreditsManagementDetails?";
        if (voucherAllocationId === null)
            throw new globalThis.Error("The parameter 'voucherAllocationId' cannot be null.");
        else if (voucherAllocationId !== undefined)
            url_ += "voucherAllocationId=" + encodeURIComponent("" + voucherAllocationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVoucherCreditsManagementDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVoucherCreditsManagementDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoucherCreditManagementDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoucherCreditManagementDetailsDto>;
        }));
    }

    protected processGetVoucherCreditsManagementDetails(response: HttpResponseBase): Observable<VoucherCreditManagementDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VoucherCreditManagementDetailsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createVoucherCredits(command: CreateVoucherCreditsCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaVouchers/CreateVoucherCredits";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateVoucherCredits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateVoucherCredits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processCreateVoucherCredits(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteVoucherCredits(command: DeleteVoucherCreditsCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaVouchers/DeleteVoucherCredits";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteVoucherCredits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteVoucherCredits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteVoucherCredits(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateVoucherCredits(command: UpdateVoucherCreditsCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaVouchers/UpdateVoucherCredits";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateVoucherCredits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateVoucherCredits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdateVoucherCredits(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLeaVoucherPersons(leaCodeId?: number | undefined, lastName?: string | null | undefined, firstName?: string | null | undefined, eIN?: string | null | undefined): Observable<PersonSearchResultDto[]> {
        let url_ = this.baseUrl + "/api/LeaVouchers/GetLeaVoucherPersons?";
        if (leaCodeId === null)
            throw new globalThis.Error("The parameter 'leaCodeId' cannot be null.");
        else if (leaCodeId !== undefined)
            url_ += "LeaCodeId=" + encodeURIComponent("" + leaCodeId) + "&";
        if (lastName !== undefined && lastName !== null)
            url_ += "LastName=" + encodeURIComponent("" + lastName) + "&";
        if (firstName !== undefined && firstName !== null)
            url_ += "FirstName=" + encodeURIComponent("" + firstName) + "&";
        if (eIN !== undefined && eIN !== null)
            url_ += "EIN=" + encodeURIComponent("" + eIN) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaVoucherPersons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaVoucherPersons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonSearchResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonSearchResultDto[]>;
        }));
    }

    protected processGetLeaVoucherPersons(response: HttpResponseBase): Observable<PersonSearchResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PersonSearchResultDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getBulkLeaVoucherPersons(leaCodeId?: number | undefined, commaSeparatedEins?: string | undefined): Observable<BulkPersonSearchResultDto> {
        let url_ = this.baseUrl + "/api/LeaVouchers/GetBulkLeaVoucherPersons?";
        if (leaCodeId === null)
            throw new globalThis.Error("The parameter 'leaCodeId' cannot be null.");
        else if (leaCodeId !== undefined)
            url_ += "LeaCodeId=" + encodeURIComponent("" + leaCodeId) + "&";
        if (commaSeparatedEins === null)
            throw new globalThis.Error("The parameter 'commaSeparatedEins' cannot be null.");
        else if (commaSeparatedEins !== undefined)
            url_ += "CommaSeparatedEins=" + encodeURIComponent("" + commaSeparatedEins) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBulkLeaVoucherPersons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBulkLeaVoucherPersons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BulkPersonSearchResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BulkPersonSearchResultDto>;
        }));
    }

    protected processGetBulkLeaVoucherPersons(response: HttpResponseBase): Observable<BulkPersonSearchResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkPersonSearchResultDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class LeaWorkforceBatchUploadClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getWorkforceReconciliation(leaCodeId?: number | undefined, batchUploadId?: number | undefined): Observable<WorkforceReconciliationDto> {
        let url_ = this.baseUrl + "/api/LeaWorkforceBatchUpload/GetWorkforceReconciliation?";
        if (leaCodeId === null)
            throw new globalThis.Error("The parameter 'leaCodeId' cannot be null.");
        else if (leaCodeId !== undefined)
            url_ += "LeaCodeId=" + encodeURIComponent("" + leaCodeId) + "&";
        if (batchUploadId === null)
            throw new globalThis.Error("The parameter 'batchUploadId' cannot be null.");
        else if (batchUploadId !== undefined)
            url_ += "BatchUploadId=" + encodeURIComponent("" + batchUploadId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkforceReconciliation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkforceReconciliation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkforceReconciliationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkforceReconciliationDto>;
        }));
    }

    protected processGetWorkforceReconciliation(response: HttpResponseBase): Observable<WorkforceReconciliationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkforceReconciliationDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    prepareWorkforceReconciliation(command: PrepareWorkforceReconciliationCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaWorkforceBatchUpload/PrepareWorkforceReconciliation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrepareWorkforceReconciliation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrepareWorkforceReconciliation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processPrepareWorkforceReconciliation(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveWorkforceReconciliation(command: SaveWorkforceReconciliationCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaWorkforceBatchUpload/SaveWorkforceReconciliation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveWorkforceReconciliation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveWorkforceReconciliation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processSaveWorkforceReconciliation(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    prepareWorkforcePreview(command: PrepareWorkforcePreviewCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaWorkforceBatchUpload/PrepareWorkforcePreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrepareWorkforcePreview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrepareWorkforcePreview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processPrepareWorkforcePreview(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    returnToWorkforceReconciliation(command: ReturnToWorkforceReconciliationCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaWorkforceBatchUpload/ReturnToWorkforceReconciliation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReturnToWorkforceReconciliation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReturnToWorkforceReconciliation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processReturnToWorkforceReconciliation(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getWorkforcePreview(leaCodeId?: number | undefined, batchUploadId?: number | undefined, pageNumber?: number | undefined, pageSize?: number | undefined, recordType?: BatchUploadRecordType | null | undefined, changeTypes?: BatchUploadChangeType[] | null | undefined): Observable<WorkforcePreviewDto> {
        let url_ = this.baseUrl + "/api/LeaWorkforceBatchUpload/GetWorkforcePreview?";
        if (leaCodeId === null)
            throw new globalThis.Error("The parameter 'leaCodeId' cannot be null.");
        else if (leaCodeId !== undefined)
            url_ += "LeaCodeId=" + encodeURIComponent("" + leaCodeId) + "&";
        if (batchUploadId === null)
            throw new globalThis.Error("The parameter 'batchUploadId' cannot be null.");
        else if (batchUploadId !== undefined)
            url_ += "BatchUploadId=" + encodeURIComponent("" + batchUploadId) + "&";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (recordType !== undefined && recordType !== null)
            url_ += "RecordType=" + encodeURIComponent("" + recordType) + "&";
        if (changeTypes !== undefined && changeTypes !== null)
            changeTypes && changeTypes.forEach(item => { url_ += "ChangeTypes=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkforcePreview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkforcePreview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkforcePreviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkforcePreviewDto>;
        }));
    }

    protected processGetWorkforcePreview(response: HttpResponseBase): Observable<WorkforcePreviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkforcePreviewDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchWorkforcePreview(leaCodeId?: number | undefined, batchUploadId?: number | undefined, searchTerm?: string | undefined, pageNumber?: number | undefined, pageSize?: number | undefined): Observable<WorkforcePreviewSearchDto> {
        let url_ = this.baseUrl + "/api/LeaWorkforceBatchUpload/SearchWorkforcePreview?";
        if (leaCodeId === null)
            throw new globalThis.Error("The parameter 'leaCodeId' cannot be null.");
        else if (leaCodeId !== undefined)
            url_ += "LeaCodeId=" + encodeURIComponent("" + leaCodeId) + "&";
        if (batchUploadId === null)
            throw new globalThis.Error("The parameter 'batchUploadId' cannot be null.");
        else if (batchUploadId !== undefined)
            url_ += "BatchUploadId=" + encodeURIComponent("" + batchUploadId) + "&";
        if (searchTerm === null)
            throw new globalThis.Error("The parameter 'searchTerm' cannot be null.");
        else if (searchTerm !== undefined)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchWorkforcePreview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchWorkforcePreview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkforcePreviewSearchDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkforcePreviewSearchDto>;
        }));
    }

    protected processSearchWorkforcePreview(response: HttpResponseBase): Observable<WorkforcePreviewSearchDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkforcePreviewSearchDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    submitWorkforceBatchUpload(command: SubmitWorkforceBatchUploadCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaWorkforceBatchUpload/SubmitWorkforceBatchUpload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmitWorkforceBatchUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitWorkforceBatchUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processSubmitWorkforceBatchUpload(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    resumeWorkforceFinalization(command: ResumeWorkforceFinalizationCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaWorkforceBatchUpload/ResumeWorkforceFinalization";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResumeWorkforceFinalization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResumeWorkforceFinalization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processResumeWorkforceFinalization(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadBlankWorkforceWorkbook(query: DownloadBlankWorkforceWorkbookQuery): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaWorkforceBatchUpload/DownloadBlankWorkforceWorkbook";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadBlankWorkforceWorkbook(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadBlankWorkforceWorkbook(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDownloadBlankWorkforceWorkbook(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadCurrentWorkforceWorkbook(query: DownloadCurrentWorkforceWorkbookQuery): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaWorkforceBatchUpload/DownloadCurrentWorkforceWorkbook";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadCurrentWorkforceWorkbook(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadCurrentWorkforceWorkbook(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDownloadCurrentWorkforceWorkbook(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getWorkforceBatchUploadEntry(leaCodeId?: number | undefined): Observable<WorkforceBatchUploadEntryDto> {
        let url_ = this.baseUrl + "/api/LeaWorkforceBatchUpload/GetWorkforceBatchUploadEntry?";
        if (leaCodeId === null)
            throw new globalThis.Error("The parameter 'leaCodeId' cannot be null.");
        else if (leaCodeId !== undefined)
            url_ += "LeaCodeId=" + encodeURIComponent("" + leaCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkforceBatchUploadEntry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkforceBatchUploadEntry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkforceBatchUploadEntryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkforceBatchUploadEntryDto>;
        }));
    }

    protected processGetWorkforceBatchUploadEntry(response: HttpResponseBase): Observable<WorkforceBatchUploadEntryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkforceBatchUploadEntryDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getWorkforceBatchUploadHistory(leaCodeId?: number | undefined, pageNumber?: number | undefined, pageSize?: number | undefined): Observable<WorkforceBatchUploadHistoryDto> {
        let url_ = this.baseUrl + "/api/LeaWorkforceBatchUpload/GetWorkforceBatchUploadHistory?";
        if (leaCodeId === null)
            throw new globalThis.Error("The parameter 'leaCodeId' cannot be null.");
        else if (leaCodeId !== undefined)
            url_ += "LeaCodeId=" + encodeURIComponent("" + leaCodeId) + "&";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkforceBatchUploadHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkforceBatchUploadHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkforceBatchUploadHistoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkforceBatchUploadHistoryDto>;
        }));
    }

    protected processGetWorkforceBatchUploadHistory(response: HttpResponseBase): Observable<WorkforceBatchUploadHistoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkforceBatchUploadHistoryDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    resetWorkforceBatchUpload(command: ResetWorkforceBatchUploadCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaWorkforceBatchUpload/ResetWorkforceBatchUpload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetWorkforceBatchUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetWorkforceBatchUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processResetWorkforceBatchUpload(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    persistWorkforceWorkbook(leaCodeId?: number | undefined, workbook?: FileParameter | null | undefined): Observable<PersistWorkforceWorkbookResultDto> {
        let url_ = this.baseUrl + "/api/LeaWorkforceBatchUpload/PersistWorkforceWorkbook";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (leaCodeId === null || leaCodeId === undefined)
            throw new globalThis.Error("The parameter 'leaCodeId' cannot be null.");
        else
            content_.append("leaCodeId", leaCodeId.toString());
        if (workbook !== null && workbook !== undefined)
            content_.append("workbook", workbook.data, workbook.fileName ? workbook.fileName : "workbook");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPersistWorkforceWorkbook(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPersistWorkforceWorkbook(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersistWorkforceWorkbookResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersistWorkforceWorkbookResultDto>;
        }));
    }

    protected processPersistWorkforceWorkbook(response: HttpResponseBase): Observable<PersistWorkforceWorkbookResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PersistWorkforceWorkbookResultDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    validatePersistedWorkforceWorkbook(command: ValidateWorkforceWorkbookCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaWorkforceBatchUpload/ValidatePersistedWorkforceWorkbook";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidatePersistedWorkforceWorkbook(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidatePersistedWorkforceWorkbook(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processValidatePersistedWorkforceWorkbook(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getWorkforceWorkbookValidationResult(leaCodeId?: number | undefined, batchUploadId?: number | undefined): Observable<WorkforceStoredWorkbookValidationDto> {
        let url_ = this.baseUrl + "/api/LeaWorkforceBatchUpload/GetWorkforceWorkbookValidationResult?";
        if (leaCodeId === null)
            throw new globalThis.Error("The parameter 'leaCodeId' cannot be null.");
        else if (leaCodeId !== undefined)
            url_ += "LeaCodeId=" + encodeURIComponent("" + leaCodeId) + "&";
        if (batchUploadId === null)
            throw new globalThis.Error("The parameter 'batchUploadId' cannot be null.");
        else if (batchUploadId !== undefined)
            url_ += "BatchUploadId=" + encodeURIComponent("" + batchUploadId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkforceWorkbookValidationResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkforceWorkbookValidationResult(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkforceStoredWorkbookValidationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkforceStoredWorkbookValidationDto>;
        }));
    }

    protected processGetWorkforceWorkbookValidationResult(response: HttpResponseBase): Observable<WorkforceStoredWorkbookValidationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkforceStoredWorkbookValidationDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    proceedToReconciliation(request: ContinueWorkforceWorkbookRequestDto): Observable<ProceedToWorkforceReconciliationResultDto> {
        let url_ = this.baseUrl + "/api/LeaWorkforceBatchUpload/ProceedToReconciliation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProceedToReconciliation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProceedToReconciliation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProceedToWorkforceReconciliationResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProceedToWorkforceReconciliationResultDto>;
        }));
    }

    protected processProceedToReconciliation(response: HttpResponseBase): Observable<ProceedToWorkforceReconciliationResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProceedToWorkforceReconciliationResultDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class LeaWorkforceManagementClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getLeavePreview(leaCodeId?: number | undefined, personId?: number | undefined, leaStaffEmploymentId?: number | undefined, leaveStatus?: StaffLeaveStatus | undefined): Observable<WorkforceLeavePreviewDto> {
        let url_ = this.baseUrl + "/api/LeaWorkforceManagement/GetLeavePreview?";
        if (leaCodeId === null)
            throw new globalThis.Error("The parameter 'leaCodeId' cannot be null.");
        else if (leaCodeId !== undefined)
            url_ += "LeaCodeId=" + encodeURIComponent("" + leaCodeId) + "&";
        if (personId === null)
            throw new globalThis.Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "PersonId=" + encodeURIComponent("" + personId) + "&";
        if (leaStaffEmploymentId === null)
            throw new globalThis.Error("The parameter 'leaStaffEmploymentId' cannot be null.");
        else if (leaStaffEmploymentId !== undefined)
            url_ += "LeaStaffEmploymentId=" + encodeURIComponent("" + leaStaffEmploymentId) + "&";
        if (leaveStatus === null)
            throw new globalThis.Error("The parameter 'leaveStatus' cannot be null.");
        else if (leaveStatus !== undefined)
            url_ += "LeaveStatus=" + encodeURIComponent("" + leaveStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeavePreview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeavePreview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkforceLeavePreviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkforceLeavePreviewDto>;
        }));
    }

    protected processGetLeavePreview(response: HttpResponseBase): Observable<WorkforceLeavePreviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkforceLeavePreviewDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    changeLeave(command: ChangeWorkforceLeaveCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaWorkforceManagement/ChangeLeave";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeLeave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeLeave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processChangeLeave(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkPersonIdentity(query: CheckWorkforcePersonIdentityQuery): Observable<WorkforceIdentityMatchesDto> {
        let url_ = this.baseUrl + "/api/LeaWorkforceManagement/CheckPersonIdentity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckPersonIdentity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckPersonIdentity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkforceIdentityMatchesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkforceIdentityMatchesDto>;
        }));
    }

    protected processCheckPersonIdentity(response: HttpResponseBase): Observable<WorkforceIdentityMatchesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkforceIdentityMatchesDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createPerson(command: CreateWorkforcePersonCommand): Observable<WorkforcePersonMatchDto> {
        let url_ = this.baseUrl + "/api/LeaWorkforceManagement/CreatePerson";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkforcePersonMatchDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkforcePersonMatchDto>;
        }));
    }

    protected processCreatePerson(response: HttpResponseBase): Observable<WorkforcePersonMatchDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkforcePersonMatchDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEmploymentOptions(leaCodeId?: number | undefined): Observable<WorkforceEmploymentOptionsDto> {
        let url_ = this.baseUrl + "/api/LeaWorkforceManagement/GetEmploymentOptions?";
        if (leaCodeId === null)
            throw new globalThis.Error("The parameter 'leaCodeId' cannot be null.");
        else if (leaCodeId !== undefined)
            url_ += "leaCodeId=" + encodeURIComponent("" + leaCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmploymentOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmploymentOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkforceEmploymentOptionsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkforceEmploymentOptionsDto>;
        }));
    }

    protected processGetEmploymentOptions(response: HttpResponseBase): Observable<WorkforceEmploymentOptionsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkforceEmploymentOptionsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAssignmentOptions(leaCodeId?: number | undefined, personId?: number | undefined): Observable<WorkforceEmploymentOptionsDto> {
        let url_ = this.baseUrl + "/api/LeaWorkforceManagement/GetAssignmentOptions?";
        if (leaCodeId === null)
            throw new globalThis.Error("The parameter 'leaCodeId' cannot be null.");
        else if (leaCodeId !== undefined)
            url_ += "leaCodeId=" + encodeURIComponent("" + leaCodeId) + "&";
        if (personId === null)
            throw new globalThis.Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssignmentOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssignmentOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkforceEmploymentOptionsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkforceEmploymentOptionsDto>;
        }));
    }

    protected processGetAssignmentOptions(response: HttpResponseBase): Observable<WorkforceEmploymentOptionsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkforceEmploymentOptionsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addStaff(command: AddWorkforceStaffCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaWorkforceManagement/AddStaff";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddStaff(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddStaff(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddStaff(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addAssignment(command: AddWorkforceAssignmentCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaWorkforceManagement/AddAssignment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddAssignment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddAssignment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddAssignment(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchPerson(query: SearchWorkforcePersonQuery): Observable<WorkforcePersonLookupDto> {
        let url_ = this.baseUrl + "/api/LeaWorkforceManagement/SearchPerson";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkforcePersonLookupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkforcePersonLookupDto>;
        }));
    }

    protected processSearchPerson(response: HttpResponseBase): Observable<WorkforcePersonLookupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkforcePersonLookupDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSystemLockState(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/LeaWorkforceManagement/GetSystemLockState";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSystemLockState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSystemLockState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processGetSystemLockState(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAccessState(leaCodeId?: number | undefined): Observable<WorkforceManagementAccessDto> {
        let url_ = this.baseUrl + "/api/LeaWorkforceManagement/GetAccessState?";
        if (leaCodeId === null)
            throw new globalThis.Error("The parameter 'leaCodeId' cannot be null.");
        else if (leaCodeId !== undefined)
            url_ += "leaCodeId=" + encodeURIComponent("" + leaCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccessState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccessState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkforceManagementAccessDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkforceManagementAccessDto>;
        }));
    }

    protected processGetAccessState(response: HttpResponseBase): Observable<WorkforceManagementAccessDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkforceManagementAccessDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getOverview(leaCodeId?: number | undefined): Observable<WorkforceOverviewDto> {
        let url_ = this.baseUrl + "/api/LeaWorkforceManagement/GetOverview?";
        if (leaCodeId === null)
            throw new globalThis.Error("The parameter 'leaCodeId' cannot be null.");
        else if (leaCodeId !== undefined)
            url_ += "leaCodeId=" + encodeURIComponent("" + leaCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOverview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkforceOverviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkforceOverviewDto>;
        }));
    }

    protected processGetOverview(response: HttpResponseBase): Observable<WorkforceOverviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkforceOverviewDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPeopleRoster(query: GetWorkforcePeopleRosterQuery): Observable<WorkforcePeopleRosterResponseDto> {
        let url_ = this.baseUrl + "/api/LeaWorkforceManagement/GetPeopleRoster";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPeopleRoster(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPeopleRoster(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkforcePeopleRosterResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkforcePeopleRosterResponseDto>;
        }));
    }

    protected processGetPeopleRoster(response: HttpResponseBase): Observable<WorkforcePeopleRosterResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkforcePeopleRosterResponseDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPositions(query: GetWorkforcePositionsQuery): Observable<WorkforcePositionsResponseDto> {
        let url_ = this.baseUrl + "/api/LeaWorkforceManagement/GetPositions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPositions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPositions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkforcePositionsResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkforcePositionsResponseDto>;
        }));
    }

    protected processGetPositions(response: HttpResponseBase): Observable<WorkforcePositionsResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkforcePositionsResponseDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportPeopleRoster(query: ExportWorkforcePeopleRosterQuery): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaWorkforceManagement/ExportPeopleRoster";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportPeopleRoster(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportPeopleRoster(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processExportPeopleRoster(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportPositions(query: ExportWorkforcePositionsQuery): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaWorkforceManagement/ExportPositions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportPositions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportPositions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processExportPositions(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPositionDetails(leaCodeId?: number | undefined, staffPositionId?: number | undefined): Observable<WorkforcePositionDetailsDto> {
        let url_ = this.baseUrl + "/api/LeaWorkforceManagement/GetPositionDetails?";
        if (leaCodeId === null)
            throw new globalThis.Error("The parameter 'leaCodeId' cannot be null.");
        else if (leaCodeId !== undefined)
            url_ += "leaCodeId=" + encodeURIComponent("" + leaCodeId) + "&";
        if (staffPositionId === null)
            throw new globalThis.Error("The parameter 'staffPositionId' cannot be null.");
        else if (staffPositionId !== undefined)
            url_ += "staffPositionId=" + encodeURIComponent("" + staffPositionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPositionDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPositionDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkforcePositionDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkforcePositionDetailsDto>;
        }));
    }

    protected processGetPositionDetails(response: HttpResponseBase): Observable<WorkforcePositionDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkforcePositionDetailsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPositionLifecycleOptions(leaCodeId?: number | undefined, staffPositionId?: number | undefined): Observable<WorkforcePositionLifecycleOptionsDto> {
        let url_ = this.baseUrl + "/api/LeaWorkforceManagement/GetPositionLifecycleOptions?";
        if (leaCodeId === null)
            throw new globalThis.Error("The parameter 'leaCodeId' cannot be null.");
        else if (leaCodeId !== undefined)
            url_ += "leaCodeId=" + encodeURIComponent("" + leaCodeId) + "&";
        if (staffPositionId === null)
            throw new globalThis.Error("The parameter 'staffPositionId' cannot be null.");
        else if (staffPositionId !== undefined)
            url_ += "staffPositionId=" + encodeURIComponent("" + staffPositionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPositionLifecycleOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPositionLifecycleOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkforcePositionLifecycleOptionsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkforcePositionLifecycleOptionsDto>;
        }));
    }

    protected processGetPositionLifecycleOptions(response: HttpResponseBase): Observable<WorkforcePositionLifecycleOptionsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkforcePositionLifecycleOptionsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    closePosition(command: CloseWorkforcePositionCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaWorkforceManagement/ClosePosition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClosePosition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClosePosition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processClosePosition(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    reopenPosition(command: ReopenWorkforcePositionCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaWorkforceManagement/ReopenPosition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReopenPosition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReopenPosition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processReopenPosition(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updatePosition(command: UpdateWorkforcePositionCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaWorkforceManagement/UpdatePosition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePosition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePosition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdatePosition(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPositionCreateOptions(leaCodeId?: number | undefined): Observable<WorkforcePositionCreateOptionsDto> {
        let url_ = this.baseUrl + "/api/LeaWorkforceManagement/GetPositionCreateOptions?";
        if (leaCodeId === null)
            throw new globalThis.Error("The parameter 'leaCodeId' cannot be null.");
        else if (leaCodeId !== undefined)
            url_ += "leaCodeId=" + encodeURIComponent("" + leaCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPositionCreateOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPositionCreateOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkforcePositionCreateOptionsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkforcePositionCreateOptionsDto>;
        }));
    }

    protected processGetPositionCreateOptions(response: HttpResponseBase): Observable<WorkforcePositionCreateOptionsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkforcePositionCreateOptionsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPositionGradeLevelOptions(leaCodeId?: number | undefined, positionCodeId?: number | undefined, contentAreaCodeId?: number | undefined): Observable<SimpleCodeDescriptionDto[]> {
        let url_ = this.baseUrl + "/api/LeaWorkforceManagement/GetPositionGradeLevelOptions?";
        if (leaCodeId === null)
            throw new globalThis.Error("The parameter 'leaCodeId' cannot be null.");
        else if (leaCodeId !== undefined)
            url_ += "leaCodeId=" + encodeURIComponent("" + leaCodeId) + "&";
        if (positionCodeId === null)
            throw new globalThis.Error("The parameter 'positionCodeId' cannot be null.");
        else if (positionCodeId !== undefined)
            url_ += "positionCodeId=" + encodeURIComponent("" + positionCodeId) + "&";
        if (contentAreaCodeId === null)
            throw new globalThis.Error("The parameter 'contentAreaCodeId' cannot be null.");
        else if (contentAreaCodeId !== undefined)
            url_ += "contentAreaCodeId=" + encodeURIComponent("" + contentAreaCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPositionGradeLevelOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPositionGradeLevelOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleCodeDescriptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleCodeDescriptionDto[]>;
        }));
    }

    protected processGetPositionGradeLevelOptions(response: HttpResponseBase): Observable<SimpleCodeDescriptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimpleCodeDescriptionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createPosition(command: CreateWorkforcePositionCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/LeaWorkforceManagement/CreatePosition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePosition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePosition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePosition(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getVacancyFillOptions(leaCodeId?: number | undefined, staffPositionId?: number | undefined): Observable<WorkforceVacancyFillOptionsDto> {
        let url_ = this.baseUrl + "/api/LeaWorkforceManagement/GetVacancyFillOptions?";
        if (leaCodeId === null)
            throw new globalThis.Error("The parameter 'leaCodeId' cannot be null.");
        else if (leaCodeId !== undefined)
            url_ += "leaCodeId=" + encodeURIComponent("" + leaCodeId) + "&";
        if (staffPositionId === null)
            throw new globalThis.Error("The parameter 'staffPositionId' cannot be null.");
        else if (staffPositionId !== undefined)
            url_ += "staffPositionId=" + encodeURIComponent("" + staffPositionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVacancyFillOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVacancyFillOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkforceVacancyFillOptionsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkforceVacancyFillOptionsDto>;
        }));
    }

    protected processGetVacancyFillOptions(response: HttpResponseBase): Observable<WorkforceVacancyFillOptionsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkforceVacancyFillOptionsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchVacancyCandidates(query: SearchWorkforceVacancyCandidatesQuery): Observable<WorkforceVacancyCandidatesDto> {
        let url_ = this.baseUrl + "/api/LeaWorkforceManagement/SearchVacancyCandidates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchVacancyCandidates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchVacancyCandidates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkforceVacancyCandidatesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkforceVacancyCandidatesDto>;
        }));
    }

    protected processSearchVacancyCandidates(response: HttpResponseBase): Observable<WorkforceVacancyCandidatesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkforceVacancyCandidatesDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getReviewSequence(query: GetWorkforceReviewSequenceQuery): Observable<WorkforceReviewSequenceDto> {
        let url_ = this.baseUrl + "/api/LeaWorkforceManagement/GetReviewSequence";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewSequence(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewSequence(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkforceReviewSequenceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkforceReviewSequenceDto>;
        }));
    }

    protected processGetReviewSequence(response: HttpResponseBase): Observable<WorkforceReviewSequenceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkforceReviewSequenceDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPersonSummary(leaCodeId?: number | undefined, personId?: number | undefined): Observable<WorkforcePersonSummaryDto> {
        let url_ = this.baseUrl + "/api/LeaWorkforceManagement/GetPersonSummary?";
        if (leaCodeId === null)
            throw new globalThis.Error("The parameter 'leaCodeId' cannot be null.");
        else if (leaCodeId !== undefined)
            url_ += "leaCodeId=" + encodeURIComponent("" + leaCodeId) + "&";
        if (personId === null)
            throw new globalThis.Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkforcePersonSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkforcePersonSummaryDto>;
        }));
    }

    protected processGetPersonSummary(response: HttpResponseBase): Observable<WorkforcePersonSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkforcePersonSummaryDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAssignmentDetails(leaCodeId?: number | undefined, personId?: number | undefined, staffAssignmentId?: number | undefined, schoolYear?: string | undefined): Observable<WorkforceAssignmentDetailsDto> {
        let url_ = this.baseUrl + "/api/LeaWorkforceManagement/GetAssignmentDetails?";
        if (leaCodeId === null)
            throw new globalThis.Error("The parameter 'leaCodeId' cannot be null.");
        else if (leaCodeId !== undefined)
            url_ += "leaCodeId=" + encodeURIComponent("" + leaCodeId) + "&";
        if (personId === null)
            throw new globalThis.Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        if (staffAssignmentId === null)
            throw new globalThis.Error("The parameter 'staffAssignmentId' cannot be null.");
        else if (staffAssignmentId !== undefined)
            url_ += "staffAssignmentId=" + encodeURIComponent("" + staffAssignmentId) + "&";
        if (schoolYear === null)
            throw new globalThis.Error("The parameter 'schoolYear' cannot be null.");
        else if (schoolYear !== undefined)
            url_ += "schoolYear=" + encodeURIComponent("" + schoolYear) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssignmentDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssignmentDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkforceAssignmentDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkforceAssignmentDetailsDto>;
        }));
    }

    protected processGetAssignmentDetails(response: HttpResponseBase): Observable<WorkforceAssignmentDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkforceAssignmentDetailsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    correctAssignmentDates(command: CorrectWorkforceAssignmentDatesCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaWorkforceManagement/CorrectAssignmentDates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCorrectAssignmentDates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCorrectAssignmentDates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processCorrectAssignmentDates(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveEmploymentDetails(command: SaveWorkforceEmploymentDetailsCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaWorkforceManagement/SaveEmploymentDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveEmploymentDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveEmploymentDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processSaveEmploymentDetails(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveAssignmentDetails(command: SaveWorkforceAssignmentDetailsCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaWorkforceManagement/SaveAssignmentDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveAssignmentDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveAssignmentDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processSaveAssignmentDetails(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAssignmentEndOptions(leaCodeId?: number | undefined, personId?: number | undefined, staffAssignmentId?: number | undefined, schoolYear?: string | undefined): Observable<WorkforceAssignmentEndOptionsDto> {
        let url_ = this.baseUrl + "/api/LeaWorkforceManagement/GetAssignmentEndOptions?";
        if (leaCodeId === null)
            throw new globalThis.Error("The parameter 'leaCodeId' cannot be null.");
        else if (leaCodeId !== undefined)
            url_ += "leaCodeId=" + encodeURIComponent("" + leaCodeId) + "&";
        if (personId === null)
            throw new globalThis.Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        if (staffAssignmentId === null)
            throw new globalThis.Error("The parameter 'staffAssignmentId' cannot be null.");
        else if (staffAssignmentId !== undefined)
            url_ += "staffAssignmentId=" + encodeURIComponent("" + staffAssignmentId) + "&";
        if (schoolYear === null)
            throw new globalThis.Error("The parameter 'schoolYear' cannot be null.");
        else if (schoolYear !== undefined)
            url_ += "schoolYear=" + encodeURIComponent("" + schoolYear) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssignmentEndOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssignmentEndOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkforceAssignmentEndOptionsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkforceAssignmentEndOptionsDto>;
        }));
    }

    protected processGetAssignmentEndOptions(response: HttpResponseBase): Observable<WorkforceAssignmentEndOptionsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkforceAssignmentEndOptionsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    endAssignment(command: EndWorkforceAssignmentCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaWorkforceManagement/EndAssignment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEndAssignment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEndAssignment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processEndAssignment(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDepartureScheduleOptions(leaCodeId?: number | undefined, personId?: number | undefined, staffAssignmentId?: number | undefined, schoolYear?: string | undefined, leaSiteStaffEmploymentId?: number | null | undefined): Observable<WorkforceDepartureScheduleOptionsDto> {
        let url_ = this.baseUrl + "/api/LeaWorkforceManagement/GetDepartureScheduleOptions?";
        if (leaCodeId === null)
            throw new globalThis.Error("The parameter 'leaCodeId' cannot be null.");
        else if (leaCodeId !== undefined)
            url_ += "leaCodeId=" + encodeURIComponent("" + leaCodeId) + "&";
        if (personId === null)
            throw new globalThis.Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        if (staffAssignmentId === null)
            throw new globalThis.Error("The parameter 'staffAssignmentId' cannot be null.");
        else if (staffAssignmentId !== undefined)
            url_ += "staffAssignmentId=" + encodeURIComponent("" + staffAssignmentId) + "&";
        if (schoolYear === null)
            throw new globalThis.Error("The parameter 'schoolYear' cannot be null.");
        else if (schoolYear !== undefined)
            url_ += "schoolYear=" + encodeURIComponent("" + schoolYear) + "&";
        if (leaSiteStaffEmploymentId !== undefined && leaSiteStaffEmploymentId !== null)
            url_ += "leaSiteStaffEmploymentId=" + encodeURIComponent("" + leaSiteStaffEmploymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDepartureScheduleOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDepartureScheduleOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkforceDepartureScheduleOptionsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkforceDepartureScheduleOptionsDto>;
        }));
    }

    protected processGetDepartureScheduleOptions(response: HttpResponseBase): Observable<WorkforceDepartureScheduleOptionsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkforceDepartureScheduleOptionsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    scheduleDeparture(command: ScheduleWorkforceDepartureCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaWorkforceManagement/ScheduleDeparture";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScheduleDeparture(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScheduleDeparture(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processScheduleDeparture(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    cancelScheduledDeparture(command: CancelWorkforceDepartureCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaWorkforceManagement/CancelScheduledDeparture";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelScheduledDeparture(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelScheduledDeparture(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processCancelScheduledDeparture(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEmploymentEndPreview(leaCodeId?: number | undefined, personId?: number | undefined, leaSiteStaffEmploymentId?: number | null | undefined, schoolYear?: string | undefined, leaStaffEmploymentId?: number | null | undefined): Observable<WorkforceEmploymentEndPreviewDto> {
        let url_ = this.baseUrl + "/api/LeaWorkforceManagement/GetEmploymentEndPreview?";
        if (leaCodeId === null)
            throw new globalThis.Error("The parameter 'leaCodeId' cannot be null.");
        else if (leaCodeId !== undefined)
            url_ += "leaCodeId=" + encodeURIComponent("" + leaCodeId) + "&";
        if (personId === null)
            throw new globalThis.Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        if (leaSiteStaffEmploymentId !== undefined && leaSiteStaffEmploymentId !== null)
            url_ += "leaSiteStaffEmploymentId=" + encodeURIComponent("" + leaSiteStaffEmploymentId) + "&";
        if (schoolYear === null)
            throw new globalThis.Error("The parameter 'schoolYear' cannot be null.");
        else if (schoolYear !== undefined)
            url_ += "schoolYear=" + encodeURIComponent("" + schoolYear) + "&";
        if (leaStaffEmploymentId !== undefined && leaStaffEmploymentId !== null)
            url_ += "leaStaffEmploymentId=" + encodeURIComponent("" + leaStaffEmploymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmploymentEndPreview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmploymentEndPreview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkforceEmploymentEndPreviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkforceEmploymentEndPreviewDto>;
        }));
    }

    protected processGetEmploymentEndPreview(response: HttpResponseBase): Observable<WorkforceEmploymentEndPreviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkforceEmploymentEndPreviewDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    endEmployment(command: EndWorkforceEmploymentCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaWorkforceManagement/EndEmployment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEndEmployment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEndEmployment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processEndEmployment(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEndedRecordEditOptions(leaCodeId?: number | undefined, personId?: number | undefined, schoolYear?: string | undefined, staffAssignmentId?: number | null | undefined, leaSiteStaffEmploymentId?: number | null | undefined, leaStaffEmploymentId?: number | null | undefined): Observable<WorkforceEndedEditOptionsDto> {
        let url_ = this.baseUrl + "/api/LeaWorkforceManagement/GetEndedRecordEditOptions?";
        if (leaCodeId === null)
            throw new globalThis.Error("The parameter 'leaCodeId' cannot be null.");
        else if (leaCodeId !== undefined)
            url_ += "leaCodeId=" + encodeURIComponent("" + leaCodeId) + "&";
        if (personId === null)
            throw new globalThis.Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        if (schoolYear === null)
            throw new globalThis.Error("The parameter 'schoolYear' cannot be null.");
        else if (schoolYear !== undefined)
            url_ += "schoolYear=" + encodeURIComponent("" + schoolYear) + "&";
        if (staffAssignmentId !== undefined && staffAssignmentId !== null)
            url_ += "staffAssignmentId=" + encodeURIComponent("" + staffAssignmentId) + "&";
        if (leaSiteStaffEmploymentId !== undefined && leaSiteStaffEmploymentId !== null)
            url_ += "leaSiteStaffEmploymentId=" + encodeURIComponent("" + leaSiteStaffEmploymentId) + "&";
        if (leaStaffEmploymentId !== undefined && leaStaffEmploymentId !== null)
            url_ += "leaStaffEmploymentId=" + encodeURIComponent("" + leaStaffEmploymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEndedRecordEditOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEndedRecordEditOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkforceEndedEditOptionsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkforceEndedEditOptionsDto>;
        }));
    }

    protected processGetEndedRecordEditOptions(response: HttpResponseBase): Observable<WorkforceEndedEditOptionsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkforceEndedEditOptionsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    validateEndedRecordEdit(query: GetWorkforceEndedRecordEditPreviewQuery): Observable<WorkforceEndedEditPreviewDto> {
        let url_ = this.baseUrl + "/api/LeaWorkforceManagement/ValidateEndedRecordEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateEndedRecordEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateEndedRecordEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkforceEndedEditPreviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkforceEndedEditPreviewDto>;
        }));
    }

    protected processValidateEndedRecordEdit(response: HttpResponseBase): Observable<WorkforceEndedEditPreviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkforceEndedEditPreviewDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    editEndedRecord(command: EditEndedWorkforceRecordCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaWorkforceManagement/EditEndedRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditEndedRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditEndedRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processEditEndedRecord(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getNonReturnPreview(leaCodeId?: number | undefined, personId?: number | undefined, schoolYear?: string | undefined, leaStaffEmploymentId?: number | null | undefined, leaSiteStaffEmploymentId?: number | null | undefined): Observable<WorkforceNonReturnPreviewDto> {
        let url_ = this.baseUrl + "/api/LeaWorkforceManagement/GetNonReturnPreview?";
        if (leaCodeId === null)
            throw new globalThis.Error("The parameter 'leaCodeId' cannot be null.");
        else if (leaCodeId !== undefined)
            url_ += "leaCodeId=" + encodeURIComponent("" + leaCodeId) + "&";
        if (personId === null)
            throw new globalThis.Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        if (schoolYear === null)
            throw new globalThis.Error("The parameter 'schoolYear' cannot be null.");
        else if (schoolYear !== undefined)
            url_ += "schoolYear=" + encodeURIComponent("" + schoolYear) + "&";
        if (leaStaffEmploymentId !== undefined && leaStaffEmploymentId !== null)
            url_ += "leaStaffEmploymentId=" + encodeURIComponent("" + leaStaffEmploymentId) + "&";
        if (leaSiteStaffEmploymentId !== undefined && leaSiteStaffEmploymentId !== null)
            url_ += "leaSiteStaffEmploymentId=" + encodeURIComponent("" + leaSiteStaffEmploymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNonReturnPreview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNonReturnPreview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkforceNonReturnPreviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkforceNonReturnPreviewDto>;
        }));
    }

    protected processGetNonReturnPreview(response: HttpResponseBase): Observable<WorkforceNonReturnPreviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkforceNonReturnPreviewDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    correctNonReturn(command: CorrectWorkforceNonReturnCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaWorkforceManagement/CorrectNonReturn";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCorrectNonReturn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCorrectNonReturn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processCorrectNonReturn(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getErroneousEntryPreview(leaCodeId?: number | undefined, personId?: number | undefined, schoolYear?: string | undefined, leaStaffEmploymentId?: number | null | undefined, leaSiteStaffEmploymentId?: number | null | undefined): Observable<WorkforceErroneousEntryPreviewDto> {
        let url_ = this.baseUrl + "/api/LeaWorkforceManagement/GetErroneousEntryPreview?";
        if (leaCodeId === null)
            throw new globalThis.Error("The parameter 'leaCodeId' cannot be null.");
        else if (leaCodeId !== undefined)
            url_ += "leaCodeId=" + encodeURIComponent("" + leaCodeId) + "&";
        if (personId === null)
            throw new globalThis.Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        if (schoolYear === null)
            throw new globalThis.Error("The parameter 'schoolYear' cannot be null.");
        else if (schoolYear !== undefined)
            url_ += "schoolYear=" + encodeURIComponent("" + schoolYear) + "&";
        if (leaStaffEmploymentId !== undefined && leaStaffEmploymentId !== null)
            url_ += "leaStaffEmploymentId=" + encodeURIComponent("" + leaStaffEmploymentId) + "&";
        if (leaSiteStaffEmploymentId !== undefined && leaSiteStaffEmploymentId !== null)
            url_ += "leaSiteStaffEmploymentId=" + encodeURIComponent("" + leaSiteStaffEmploymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetErroneousEntryPreview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetErroneousEntryPreview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkforceErroneousEntryPreviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkforceErroneousEntryPreviewDto>;
        }));
    }

    protected processGetErroneousEntryPreview(response: HttpResponseBase): Observable<WorkforceErroneousEntryPreviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkforceErroneousEntryPreviewDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getErroneousAssignmentPreview(leaCodeId?: number | undefined, personId?: number | undefined, schoolYear?: string | undefined, staffAssignmentId?: number | undefined): Observable<WorkforceErroneousEntryPreviewDto> {
        let url_ = this.baseUrl + "/api/LeaWorkforceManagement/GetErroneousAssignmentPreview?";
        if (leaCodeId === null)
            throw new globalThis.Error("The parameter 'leaCodeId' cannot be null.");
        else if (leaCodeId !== undefined)
            url_ += "leaCodeId=" + encodeURIComponent("" + leaCodeId) + "&";
        if (personId === null)
            throw new globalThis.Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        if (schoolYear === null)
            throw new globalThis.Error("The parameter 'schoolYear' cannot be null.");
        else if (schoolYear !== undefined)
            url_ += "schoolYear=" + encodeURIComponent("" + schoolYear) + "&";
        if (staffAssignmentId === null)
            throw new globalThis.Error("The parameter 'staffAssignmentId' cannot be null.");
        else if (staffAssignmentId !== undefined)
            url_ += "staffAssignmentId=" + encodeURIComponent("" + staffAssignmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetErroneousAssignmentPreview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetErroneousAssignmentPreview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkforceErroneousEntryPreviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkforceErroneousEntryPreviewDto>;
        }));
    }

    protected processGetErroneousAssignmentPreview(response: HttpResponseBase): Observable<WorkforceErroneousEntryPreviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkforceErroneousEntryPreviewDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteErroneousAssignment(command: DeleteErroneousWorkforceAssignmentCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaWorkforceManagement/DeleteErroneousAssignment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteErroneousAssignment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteErroneousAssignment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteErroneousAssignment(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteErroneousEntry(command: DeleteErroneousWorkforceEmploymentCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaWorkforceManagement/DeleteErroneousEntry";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteErroneousEntry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteErroneousEntry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteErroneousEntry(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTransferOptions(leaCodeId?: number | undefined, personId?: number | undefined, staffAssignmentId?: number | undefined, schoolYear?: string | undefined): Observable<WorkforceTransferOptionsDto> {
        let url_ = this.baseUrl + "/api/LeaWorkforceManagement/GetTransferOptions?";
        if (leaCodeId === null)
            throw new globalThis.Error("The parameter 'leaCodeId' cannot be null.");
        else if (leaCodeId !== undefined)
            url_ += "leaCodeId=" + encodeURIComponent("" + leaCodeId) + "&";
        if (personId === null)
            throw new globalThis.Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        if (staffAssignmentId === null)
            throw new globalThis.Error("The parameter 'staffAssignmentId' cannot be null.");
        else if (staffAssignmentId !== undefined)
            url_ += "staffAssignmentId=" + encodeURIComponent("" + staffAssignmentId) + "&";
        if (schoolYear === null)
            throw new globalThis.Error("The parameter 'schoolYear' cannot be null.");
        else if (schoolYear !== undefined)
            url_ += "schoolYear=" + encodeURIComponent("" + schoolYear) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransferOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransferOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkforceTransferOptionsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkforceTransferOptionsDto>;
        }));
    }

    protected processGetTransferOptions(response: HttpResponseBase): Observable<WorkforceTransferOptionsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkforceTransferOptionsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    transferAssignment(command: TransferWorkforceAssignmentCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaWorkforceManagement/TransferAssignment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransferAssignment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransferAssignment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processTransferAssignment(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveWorkEmail(command: SaveWorkforceWorkEmailCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaWorkforceManagement/SaveWorkEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveWorkEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveWorkEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processSaveWorkEmail(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveAnnualStaffDetails(command: SaveWorkforceAnnualStaffDetailsCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaWorkforceManagement/SaveAnnualStaffDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveAnnualStaffDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveAnnualStaffDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processSaveAnnualStaffDetails(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    verifyRosterRecord(command: VerifyWorkforceRosterRecordCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LeaWorkforceManagement/VerifyRosterRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyRosterRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyRosterRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processVerifyRosterRecord(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PageAlertsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getPageAlerts(includeInactive?: boolean | undefined): Observable<PageAlertManagementDto[]> {
        let url_ = this.baseUrl + "/api/PageAlerts/GetPageAlerts?";
        if (includeInactive === null)
            throw new globalThis.Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPageAlerts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPageAlerts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PageAlertManagementDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PageAlertManagementDto[]>;
        }));
    }

    protected processGetPageAlerts(response: HttpResponseBase): Observable<PageAlertManagementDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PageAlertManagementDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getApplicablePageAlerts(page?: string | undefined, role?: string | undefined): Observable<PageAlertDto[]> {
        let url_ = this.baseUrl + "/api/PageAlerts/GetApplicablePageAlerts?";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (role === null)
            throw new globalThis.Error("The parameter 'role' cannot be null.");
        else if (role !== undefined)
            url_ += "role=" + encodeURIComponent("" + role) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApplicablePageAlerts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApplicablePageAlerts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PageAlertDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PageAlertDto[]>;
        }));
    }

    protected processGetApplicablePageAlerts(response: HttpResponseBase): Observable<PageAlertDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PageAlertDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addPageAlert(command: AddPageAlertCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/PageAlerts/AddPageAlert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddPageAlert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPageAlert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddPageAlert(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updatePageAlert(command: UpdatePageAlertCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/PageAlerts/UpdatePageAlert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePageAlert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePageAlert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdatePageAlert(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deactivatePageAlert(command: DeactivatePageAlertCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/PageAlerts/DeactivatePageAlert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivatePageAlert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivatePageAlert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeactivatePageAlert(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PaymentsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getReceiptForPaymentReversal(query: GetReceiptForPaymentReversalQuery): Observable<ReceiptForPaymentReversalDto> {
        let url_ = this.baseUrl + "/api/Payments/GetReceiptForPaymentReversal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReceiptForPaymentReversal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReceiptForPaymentReversal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReceiptForPaymentReversalDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReceiptForPaymentReversalDto>;
        }));
    }

    protected processGetReceiptForPaymentReversal(response: HttpResponseBase): Observable<ReceiptForPaymentReversalDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReceiptForPaymentReversalDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addPaymentReversal(command: AddPaymentReversalCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Payments/AddPaymentReversal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddPaymentReversal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPaymentReversal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddPaymentReversal(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendToCollections(command: UpdatePaymentReversalInCollectionsCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Payments/SendToCollections";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendToCollections(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendToCollections(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSendToCollections(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    abandonPaymentReversals(command: AddAbandonedPaymentReversalsCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Payments/AbandonPaymentReversals";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbandonPaymentReversals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbandonPaymentReversals(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAbandonPaymentReversals(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addReturnedCheckLetterDocument(command: AddReturnedCheckLetterDocumentCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Payments/AddReturnedCheckLetterDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddReturnedCheckLetterDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddReturnedCheckLetterDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddReturnedCheckLetterDocument(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    savePaymentRedepositPaymentInformation(command: SaveRedepositPaymentInformationCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Payments/SavePaymentRedepositPaymentInformation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSavePaymentRedepositPaymentInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSavePaymentRedepositPaymentInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processSavePaymentRedepositPaymentInformation(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEducatorPaymentReversalsForRedeposit(personId?: number | undefined): Observable<PaymentReversalForRedepositDto[]> {
        let url_ = this.baseUrl + "/api/Payments/GetEducatorPaymentReversalsForRedeposit?";
        if (personId === null)
            throw new globalThis.Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorPaymentReversalsForRedeposit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorPaymentReversalsForRedeposit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaymentReversalForRedepositDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaymentReversalForRedepositDto[]>;
        }));
    }

    protected processGetEducatorPaymentReversalsForRedeposit(response: HttpResponseBase): Observable<PaymentReversalForRedepositDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PaymentReversalForRedepositDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCurrentPaymentReversals(model: GetCurrentPaymentReversalsQuery): Observable<PaymentReversalListDto> {
        let url_ = this.baseUrl + "/api/Payments/GetCurrentPaymentReversals";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentPaymentReversals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentPaymentReversals(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaymentReversalListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaymentReversalListDto>;
        }));
    }

    protected processGetCurrentPaymentReversals(response: HttpResponseBase): Observable<PaymentReversalListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PaymentReversalListDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPaymentReversalQuickFilterCounts(): Observable<PaymentReversalQuickFilterCountsDto> {
        let url_ = this.baseUrl + "/api/Payments/GetPaymentReversalQuickFilterCounts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentReversalQuickFilterCounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentReversalQuickFilterCounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaymentReversalQuickFilterCountsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaymentReversalQuickFilterCountsDto>;
        }));
    }

    protected processGetPaymentReversalQuickFilterCounts(response: HttpResponseBase): Observable<PaymentReversalQuickFilterCountsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PaymentReversalQuickFilterCountsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPaymentsCollectedReportOperators(): Observable<PaymentsCollectedReportOperatorsDto[]> {
        let url_ = this.baseUrl + "/api/Payments/GetPaymentsCollectedReportOperators";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentsCollectedReportOperators(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentsCollectedReportOperators(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaymentsCollectedReportOperatorsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaymentsCollectedReportOperatorsDto[]>;
        }));
    }

    protected processGetPaymentsCollectedReportOperators(response: HttpResponseBase): Observable<PaymentsCollectedReportOperatorsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PaymentsCollectedReportOperatorsDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPaymentsCollectedReport(query: GetPaymentsCollectedReportQuery): Observable<PaymentCollectedByLocationDto[]> {
        let url_ = this.baseUrl + "/api/Payments/GetPaymentsCollectedReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentsCollectedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentsCollectedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaymentCollectedByLocationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaymentCollectedByLocationDto[]>;
        }));
    }

    protected processGetPaymentsCollectedReport(response: HttpResponseBase): Observable<PaymentCollectedByLocationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PaymentCollectedByLocationDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    processRefund(command: UpdateServiceItemRefundCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Payments/ProcessRefund";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProcessRefund(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProcessRefund(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processProcessRefund(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRefundsToProcess(query: GetRefundsToProcess): Observable<RefundItemDto[]> {
        let url_ = this.baseUrl + "/api/Payments/GetRefundsToProcess";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRefundsToProcess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRefundsToProcess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RefundItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RefundItemDto[]>;
        }));
    }

    protected processGetRefundsToProcess(response: HttpResponseBase): Observable<RefundItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RefundItemDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setToWaitingOnW9(command: UpdatePaymentLineItemCreditToWaitingOnW9Command): Observable<number> {
        let url_ = this.baseUrl + "/api/Payments/SetToWaitingOnW9";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetToWaitingOnW9(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetToWaitingOnW9(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSetToWaitingOnW9(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPendingApplicationPayments(): Observable<PendingApplicationPaymentDto[]> {
        let url_ = this.baseUrl + "/api/Payments/GetPendingApplicationPayments";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPendingApplicationPayments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPendingApplicationPayments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PendingApplicationPaymentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PendingApplicationPaymentDto[]>;
        }));
    }

    protected processGetPendingApplicationPayments(response: HttpResponseBase): Observable<PendingApplicationPaymentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PendingApplicationPaymentDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    manuallyCompletePendingApplicationPayments(command: ManuallyCompletePendingApplicationPaymentsCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Payments/ManuallyCompletePendingApplicationPayments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processManuallyCompletePendingApplicationPayments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processManuallyCompletePendingApplicationPayments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processManuallyCompletePendingApplicationPayments(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ProfessionalDevelopmentClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getProfessionalDevelopmentVerificationRequests(includeFinalizedRequests?: boolean | undefined): Observable<ProfessionalDevelopmentVerificationRequestDto[]> {
        let url_ = this.baseUrl + "/api/ProfessionalDevelopment/GetProfessionalDevelopmentVerificationRequests?";
        if (includeFinalizedRequests === null)
            throw new globalThis.Error("The parameter 'includeFinalizedRequests' cannot be null.");
        else if (includeFinalizedRequests !== undefined)
            url_ += "includeFinalizedRequests=" + encodeURIComponent("" + includeFinalizedRequests) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfessionalDevelopmentVerificationRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfessionalDevelopmentVerificationRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfessionalDevelopmentVerificationRequestDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfessionalDevelopmentVerificationRequestDto[]>;
        }));
    }

    protected processGetProfessionalDevelopmentVerificationRequests(response: HttpResponseBase): Observable<ProfessionalDevelopmentVerificationRequestDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfessionalDevelopmentVerificationRequestDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    assignProfessionalDevelopmentVerificationRequests(command: AssignProfessionalDevelopmentVerificationRequestsCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/ProfessionalDevelopment/AssignProfessionalDevelopmentVerificationRequests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignProfessionalDevelopmentVerificationRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignProfessionalDevelopmentVerificationRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAssignProfessionalDevelopmentVerificationRequests(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    verifyProfessionalDevelopmentVerificationRequest(command: VerifyProfessionalDevelopmentVerificationRequestCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/ProfessionalDevelopment/VerifyProfessionalDevelopmentVerificationRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyProfessionalDevelopmentVerificationRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyProfessionalDevelopmentVerificationRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processVerifyProfessionalDevelopmentVerificationRequest(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    rejectProfessionalDevelopmentVerificationRequest(command: RejectProfessionalDevelopmentVerificationRequestCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/ProfessionalDevelopment/RejectProfessionalDevelopmentVerificationRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRejectProfessionalDevelopmentVerificationRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRejectProfessionalDevelopmentVerificationRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processRejectProfessionalDevelopmentVerificationRequest(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProfessionalDevelopmentRequests(leaCodeId?: number | undefined, includeFinalizedRequests?: boolean | undefined): Observable<ProfessionalDevelopmentRequestResultDto[]> {
        let url_ = this.baseUrl + "/api/ProfessionalDevelopment/GetProfessionalDevelopmentRequests?";
        if (leaCodeId === null)
            throw new globalThis.Error("The parameter 'leaCodeId' cannot be null.");
        else if (leaCodeId !== undefined)
            url_ += "leaCodeId=" + encodeURIComponent("" + leaCodeId) + "&";
        if (includeFinalizedRequests === null)
            throw new globalThis.Error("The parameter 'includeFinalizedRequests' cannot be null.");
        else if (includeFinalizedRequests !== undefined)
            url_ += "includeFinalizedRequests=" + encodeURIComponent("" + includeFinalizedRequests) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfessionalDevelopmentRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfessionalDevelopmentRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfessionalDevelopmentRequestResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfessionalDevelopmentRequestResultDto[]>;
        }));
    }

    protected processGetProfessionalDevelopmentRequests(response: HttpResponseBase): Observable<ProfessionalDevelopmentRequestResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfessionalDevelopmentRequestResultDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createProfessionalDevelopmentRequest(command: CreateProfessionalDevelopmentRequestCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/ProfessionalDevelopment/CreateProfessionalDevelopmentRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateProfessionalDevelopmentRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProfessionalDevelopmentRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processCreateProfessionalDevelopmentRequest(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class SearchClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    search(searchQuery: GetEducatorSearchQuery): Observable<EducatorSearchResultList> {
        let url_ = this.baseUrl + "/api/Search/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EducatorSearchResultList>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EducatorSearchResultList>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<EducatorSearchResultList> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EducatorSearchResultList;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPersonsFromSimpleSearch(lastName?: string | null | undefined, firstName?: string | null | undefined, eIN?: string | null | undefined, leaSiteCodeId?: number | null | undefined, leaCodeId?: number | null | undefined): Observable<PersonSearchResultDto[]> {
        let url_ = this.baseUrl + "/api/Search/GetPersonsFromSimpleSearch?";
        if (lastName !== undefined && lastName !== null)
            url_ += "LastName=" + encodeURIComponent("" + lastName) + "&";
        if (firstName !== undefined && firstName !== null)
            url_ += "FirstName=" + encodeURIComponent("" + firstName) + "&";
        if (eIN !== undefined && eIN !== null)
            url_ += "EIN=" + encodeURIComponent("" + eIN) + "&";
        if (leaSiteCodeId !== undefined && leaSiteCodeId !== null)
            url_ += "LeaSiteCodeId=" + encodeURIComponent("" + leaSiteCodeId) + "&";
        if (leaCodeId !== undefined && leaCodeId !== null)
            url_ += "LeaCodeId=" + encodeURIComponent("" + leaCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonsFromSimpleSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonsFromSimpleSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonSearchResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonSearchResultDto[]>;
        }));
    }

    protected processGetPersonsFromSimpleSearch(response: HttpResponseBase): Observable<PersonSearchResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PersonSearchResultDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ServicesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getEvaluators(): Observable<EvaluatorDto[]> {
        let url_ = this.baseUrl + "/api/Services/GetEvaluators";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEvaluators(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEvaluators(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EvaluatorDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EvaluatorDto[]>;
        }));
    }

    protected processGetEvaluators(response: HttpResponseBase): Observable<EvaluatorDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EvaluatorDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUnassignedServices(model: GetUnassignedServicesQuery): Observable<UnassignedServiceListDto> {
        let url_ = this.baseUrl + "/api/Services/GetUnassignedServices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnassignedServices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnassignedServices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UnassignedServiceListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UnassignedServiceListDto>;
        }));
    }

    protected processGetUnassignedServices(response: HttpResponseBase): Observable<UnassignedServiceListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnassignedServiceListDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    assignEvaluatorToServices(command: AssignEvaluatorCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Services/AssignEvaluatorToServices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignEvaluatorToServices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignEvaluatorToServices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAssignEvaluatorToServices(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    selfAssignEvaluatorToServices(command: AssignEvaluatorCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Services/SelfAssignEvaluatorToServices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSelfAssignEvaluatorToServices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSelfAssignEvaluatorToServices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processSelfAssignEvaluatorToServices(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    transferServicesToEvaluator(command: AssignEvaluatorCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Services/TransferServicesToEvaluator";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransferServicesToEvaluator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransferServicesToEvaluator(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processTransferServicesToEvaluator(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    unassignEvaluator(command: UnassignEvaluatorCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Services/UnassignEvaluator";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnassignEvaluator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnassignEvaluator(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUnassignEvaluator(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    unassignSelfAsEvaluator(command: UnassignEvaluatorCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Services/UnassignSelfAsEvaluator";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnassignSelfAsEvaluator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnassignSelfAsEvaluator(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUnassignSelfAsEvaluator(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateCurrentUserAsEvaluator(command: UpdateCurrentUserAsEvaluatorCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Services/UpdateCurrentUserAsEvaluator";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCurrentUserAsEvaluator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCurrentUserAsEvaluator(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdateCurrentUserAsEvaluator(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSetFiltersForUnassignedServicesGrid(): Observable<SetFilterResultDto[]> {
        let url_ = this.baseUrl + "/api/Services/GetSetFiltersForUnassignedServicesGrid";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSetFiltersForUnassignedServicesGrid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSetFiltersForUnassignedServicesGrid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SetFilterResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SetFilterResultDto[]>;
        }));
    }

    protected processGetSetFiltersForUnassignedServicesGrid(response: HttpResponseBase): Observable<SetFilterResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SetFilterResultDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMyServices(model: GetMyServicesQuery): Observable<AssignedServiceListDto> {
        let url_ = this.baseUrl + "/api/Services/GetMyServices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyServices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyServices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssignedServiceListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssignedServiceListDto>;
        }));
    }

    protected processGetMyServices(response: HttpResponseBase): Observable<AssignedServiceListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AssignedServiceListDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSetFiltersForMyServicesGrid(): Observable<SetFilterResultDto[]> {
        let url_ = this.baseUrl + "/api/Services/GetSetFiltersForMyServicesGrid";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSetFiltersForMyServicesGrid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSetFiltersForMyServicesGrid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SetFilterResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SetFilterResultDto[]>;
        }));
    }

    protected processGetSetFiltersForMyServicesGrid(response: HttpResponseBase): Observable<SetFilterResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SetFilterResultDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAdminServiceItems(model: GetAdminServiceItemsQuery): Observable<AdminQueueDto> {
        let url_ = this.baseUrl + "/api/Services/GetAdminServiceItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdminServiceItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdminServiceItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdminQueueDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdminQueueDto>;
        }));
    }

    protected processGetAdminServiceItems(response: HttpResponseBase): Observable<AdminQueueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AdminQueueDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportMyServicesToExcel(model: ExportMyServicesToExcelQuery): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Services/ExportMyServicesToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportMyServicesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportMyServicesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processExportMyServicesToExcel(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSetFiltersForAdminServiceItemsGrid(): Observable<SetFilterResultDto[]> {
        let url_ = this.baseUrl + "/api/Services/GetSetFiltersForAdminServiceItemsGrid";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSetFiltersForAdminServiceItemsGrid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSetFiltersForAdminServiceItemsGrid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SetFilterResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SetFilterResultDto[]>;
        }));
    }

    protected processGetSetFiltersForAdminServiceItemsGrid(response: HttpResponseBase): Observable<SetFilterResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SetFilterResultDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    removeRushFromServiceItem(command: RemoveRushFromServiceItemCommand2): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Services/RemoveRushFromServiceItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveRushFromServiceItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveRushFromServiceItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processRemoveRushFromServiceItem(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class SurveyMonkeyClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    oAuthCallback(code?: string | undefined, state?: string | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/SurveyMonkey/oauth/callback?";
        if (code === null)
            throw new globalThis.Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (state === null)
            throw new globalThis.Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "state=" + encodeURIComponent("" + state) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOAuthCallback(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOAuthCallback(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processOAuthCallback(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    completedResponse(webhookEvent: SurveyMonkeyWebhookEvent): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/SurveyMonkey/webhook/completed-response";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(webhookEvent);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompletedResponse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompletedResponse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processCompletedResponse(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updatedResponse(webhookEvent: SurveyMonkeyWebhookEvent): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/SurveyMonkey/webhook/updated-response";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(webhookEvent);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatedResponse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatedResponse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdatedResponse(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface RolePermissionsDto {
    roleId: number;
    permissionId: number;
}

export interface RoleDto {
    roleId: number;
    adeConnectRoleName: string;
    description?: string | undefined;
}

export interface PermissionGroupDto {
    permissionGroupId: number;
    name: string;
    description?: string | undefined;
    permissions: PermissionDto[];
}

export interface PermissionDto {
    permissionId: number;
    name: string;
    displayName: string;
    description?: string | undefined;
    permissionGroupId: number;
    isSelected: boolean;
}

export interface CreateRolePermissionsCommand {
    roleId: number;
    permissionIds: number[];
}

export interface PotentialDuplicatePersonMatchPairDto {
    potentialDuplicatePersonMatchId: number;
    primaryMatch: PotentialDuplicatePersonMatchDto;
    secondaryMatch: PotentialDuplicatePersonMatchDto;
}

export interface PotentialDuplicatePersonMatchDto {
    personId: number;
    ein: string;
    lastName: string;
    firstName: string;
    middleName?: string | undefined;
    lastFourSsn: string;
    dateOfBirth?: Date | undefined;
    hasDiscipline: boolean;
    isPrimary: boolean;
}

export interface LinkedEducatorMatchPairDto {
    primaryMatch: LinkedEducatorMatchDto;
    secondaryMatch: LinkedEducatorMatchDto;
}

export interface LinkedEducatorMatchDto {
    personId: number;
    ein: string;
    lastName: string;
    firstName: string;
    middleName?: string | undefined;
    lastFourSsn: string;
    dateOfBirth?: Date | undefined;
    hasDiscipline: boolean;
}

export interface RejectPotentialDuplicatePersonMatchCommand {
    potentialDuplicatePersonMatchId: number;
}

export interface CheckMergeConflictsCommand {
    primaryPersonId: number;
    duplicatePersonId: number;
}

export interface MergeDuplicateEducatorsCommand {
    primaryPersonId: number;
    duplicatePersonId: number;
}

export interface QualificationPathConfigListItemDto {
    qualificationPathId: number;
    pathName: string;
    pathType: string;
    modifiedBy?: string | undefined;
    modifiedDate?: Date | undefined;
    questionAppGroups: AppQuestionGroup[];
}

export enum AppQuestionGroup {
    DegreeInfo = 0,
    TestInfo = 1,
    ReciprocalCertificateInfo = 2,
    PreK12TeachingExperienceInfo = 3,
    LeadershipProfessionalExperienceInfo = 4,
    CTEExperienceInfo = 5,
    CourseworkInfo = 6,
}

export interface QualificationPathConfigDto {
    qualificationPathId: number;
    description: string;
    pathType: QualificationPathType;
    appQuestionGroups: AppQuestionGroup[];
    questions: QualificationPathQuestionConfigDto[];
    requiredDocuments: QualificationPathRequiredDocumentConfigDto[];
}

export enum QualificationPathType {
    Administrative = 0,
    Substantive = 1,
}

export interface QualificationPathQuestionConfigDto {
    qualificationPathQuestionId?: number | undefined;
    text: string;
}

export interface QualificationPathRequiredDocumentConfigDto {
    qualificationPathRequiredDocumentId?: number | undefined;
    explanation?: string | undefined;
    documentCodeId?: number | undefined;
}

export interface DeleteQualificationPathCommand {
    qualificationPathId: number;
}

export interface AddOrUpdateQualificationPathCommand {
    qualificationPathId?: number | undefined;
    description?: string | undefined;
    pathType?: QualificationPathType | undefined;
    appQuestionGroups: AppQuestionGroup[];
    questions: QualificationPathQuestionConfigDto[];
    requiredDocuments: QualificationPathRequiredDocumentConfigDto[];
}

export interface QualificationPathCodeTablesDto {
    documentCodes: SimpleCodeDescriptionDto[];
}

export interface SimpleSelectOptionDto {
    id: number;
    description: string;
}

export interface SimpleCodeDescriptionDto extends SimpleSelectOptionDto {
    code: string;
}

export interface EvalCodeTablesDto {
    serviceCodes: SimpleCodeDescriptionDto[];
    certificateTypeCodes: SimpleCodeDescriptionDto[];
    endorsementCodes: SimpleCodeDescriptionDto[];
    denialDefinitions: SimpleCodeDescriptionDto[];
    adminPaths: SimpleCodeDescriptionDto[];
    substantivePaths: SimpleCodeDescriptionDto[];
    addCertificateCode: number;
    addEndorsementCode: number;
    extensionCode: number;
    addIRCertificateCode: number;
    addIREndorsementCode: number;
}

export interface GetEvalCodeTablesQuery {
    evaluationId?: number | undefined;
    includeInactive: boolean;
}

export interface EvaluationListItemDto {
    evaluationId: number;
    description: string;
    effectiveStartDate: Date;
    effectiveEndDate?: Date | undefined;
    serviceTypeCodeIds: number[];
    serviceTypeCodeDescriptions: string;
    certificateTypeCodes?: string | undefined;
    endorsementCodes?: string | undefined;
    effectiveStatus: EvaluationEffectiveStatus;
}

export enum EvaluationEffectiveStatus {
    IsInEffect = 0,
    NotYetInEffect = 1,
    NoLongerInEffect = 2,
}

export interface EvaluationDto {
    evaluationId: number;
    description: string;
    effectiveStartDate: Date;
    effectiveEndDate?: Date | undefined;
    serviceCodeIds: number[];
    certificateTypeCodeIds: number[];
    endorsementCodeIds: number[];
    adminPathIds: number[];
    substantivePathIds: number[];
    requirements: RequirementDto[];
}

export interface RequirementDto {
    requirementId?: number | undefined;
    parentRequirementId?: number | undefined;
    requirementType: RequirementType;
    title?: string | undefined;
    internalDescription?: string | undefined;
    explanation?: string | undefined;
    helperText?: string | undefined;
    allowableDeficiencyCodeId?: number | undefined;
    order: number;
    isShared: boolean;
    canBeShared: boolean;
    isComplete: boolean;
    wellKnownRequirement: WellKnownRequirement;
    denialDefinitionStatuteId?: number | undefined;
    reissuanceReminder?: string | undefined;
    requirementIncompleteReasons: RequirementIncompleteReasonDto[];
    subRequirementGroupType?: SubRequirementGroupType | undefined;
    subRequirements: RequirementDto[];
}

export enum RequirementType {
    Administrative = 0,
    Substantive = 1,
}

export enum WellKnownRequirement {
    None = 0,
    ValidFingerprint = 1,
    ValidCerFingerprint = 2,
    PrimaryKnowledgeTest = 3,
    SubjectKnowledgeTest = 4,
    AZConstitutionDeficiency = 5,
    USConstitutionDeficiency = 6,
}

export interface RequirementIncompleteReasonDto {
    requirementIncompleteReasonId?: number | undefined;
    requirementId: number;
    description: string;
    sortOrder: number;
}

export enum SubRequirementGroupType {
    Alternative = 0,
    Composite = 1,
}

export interface GetEvalDenialStatutesQuery {
    evaluationDenialDefinitionId: number;
}

export interface CreateOrUpdateEvaluationCommand {
    evaluationId?: number | undefined;
    description: string;
    serviceCodeIds: number[];
    certificateTypeCodeIds: number[];
    endorsementCodeIds: number[];
    requirements: RequirementDto[];
    adminQualificationPathIds: number[];
    substantiveQualificationPathIds: number[];
    effectiveStartDate: Date;
    effectiveEndDate?: Date | undefined;
}

export interface DeleteEvaluationCommand {
    evaluationId: number;
}

export interface CurrentSystemLockStateDto {
    isLocked: boolean;
    lockMessage?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedDate?: Date | undefined;
    defaultLockMessage: string;
    systemCanBeLocked: boolean;
    systemCanBeUnlocked: boolean;
}

export interface LockSystemCommand {
    lockMessage?: string | undefined;
}

export interface CurrentOperationalYearStateDto {
    currentOperationalYear: string;
    nextOperationalYear: string;
    systemIsLocked: boolean;
    isBetweenYears: boolean;
    endYearRecentlyInitiated: boolean;
    beginYearRecentlyInitiated: boolean;
    yearEndInitiatedBy?: string | undefined;
    yearEndInitiatedDate?: Date | undefined;
    edOrgSyncedDate?: Date | undefined;
    yearTransitionProcessState: YearTransitionProcessState;
}

export enum YearTransitionProcessState {
    OperationalYearActive = 0,
    YearEndProcessing = 1,
    YearEndCompleted = 2,
    BeginYearProcessing = 3,
}

export interface YearBeginProgressStatsDto {
    statGroups: YearTransitionProgressStatGroupDto[];
    total: number;
}

export interface YearTransitionProgressStatGroupDto {
    description: string;
    count: number;
}

export interface YearEndProgressStatsDto {
    statGroups: YearTransitionProgressStatGroupDto[];
    total: number;
}

export interface LeaEdOrgChangeResultListDto {
    leaChanges: LeaEdOrgChangeResultDto[];
    leaSiteChanges: LeaSiteEdOrgChangeResultDto[];
}

export interface LeaEdOrgChangeResultDto {
    leaDescription: string;
    leaType: string;
    changeDetected: string;
    isActive: boolean;
    createdDate: Date;
    modifiedDate?: Date | undefined;
}

export interface LeaSiteEdOrgChangeResultDto extends LeaEdOrgChangeResultDto {
    leaSiteDescription: string;
}

export interface ReevaluateACForPositionContentAreaCommand {
    positionContentAreaId: number;
}

export interface StaffAssignmentACResearchDto {
    staffAssignmentId: number;
    personId: number;
    fiscalYear: string;
    positionLocalIdentifier: string;
    positionDescription: string;
    contentAreaDescription: string;
    gradeLevels?: string | undefined;
    isAppropriatelyCertified?: boolean | undefined;
    positionContentAreaId: number;
    applicableRuleDefinitions: ApplicableACRuleDefinitionDto[];
    snapshotEvaluationDate?: Date | undefined;
    snapshotEvaluationReason?: string | undefined;
    snapshotInputData?: ACEvaluationInputData | undefined;
    ruleEvaluations: ACEvaluationSnapshotRuleData[];
    ruleEvaluationTrees: ACRuleEvaluationTreeDto[];
    competencyExplanations: ACCompetencyExplanation[];
}

export interface ApplicableACRuleDefinitionDto {
    acRuleDefinitionId: number;
    ruleName: string;
    dslExpression: string;
    gradeLevels?: string | undefined;
}

export interface ACEvaluationInputData {
    legacyPayload?: ACEvaluationLegacyPayload | undefined;
    certificates: ACEvaluationInputDataCertificate[];
    endorsements: ACEvaluationInputDataEndorsement[];
    approvedAreas: ACEvaluationInputDataApprovedAreas[];
}

export interface ACEvaluationLegacyPayload {
    sourcePositionId: number;
    appropriatelyCertifiedId: number;
    appropriatelyCertifiedValue: string;
}

export interface ACEvaluationInputDataCertificate {
    personCertificateId: number;
    code?: string | undefined;
    certificateType: string;
    certificateStatus: string;
    issueDate: Date;
    expireDate: Date;
    originalExpireDate: Date;
}

export interface ACEvaluationInputDataEndorsement {
    personEndorsementId: number;
    code?: string | undefined;
    endorsementType: string;
    endorsementLevel: string;
    startDate: Date;
    expireDate?: Date | undefined;
    lapsedDate?: Date | undefined;
}

export interface ACEvaluationInputDataApprovedAreas {
    personApprovedAreaId: number;
    code?: string | undefined;
    approvedAreaType: string;
    startDate: Date;
    lapsedDate?: Date | undefined;
}

export interface ACEvaluationSnapshotRuleData {
    acRuleDefinitionId: number;
    ruleName: string;
    dslExpression: string;
    rulePassed: boolean;
    inputData?: ACEvaluationInputData | undefined;
    competencyData?: ACEvaluationCompetencyData | undefined;
    evaluationTrace: string[];
}

export interface ACEvaluationCompetencyData {
    ruleName: string;
    competencies: ACEvaluationCompetencyResult[];
    results: ACEvaluationCompetencyFinal;
}

export interface ACEvaluationCompetencyResult {
    competencyCode: string;
    evaluationPassed: boolean;
    type: string;
    evidence: CompetencyResultEvidence[];
}

export interface CompetencyResultEvidence {
    credentialId: number;
}

export interface ACEvaluationCompetencyFinal {
    evaluationPassed: boolean;
    path: CompetencyPath;
}

export interface CompetencyPath {
    dslExpression: string;
    satisfiedBy: string[];
}

export interface ACRuleEvaluationTreeDto {
    acRuleDefinitionId: number;
    ruleName: string;
    dslExpression: string;
    passed: boolean;
    rootNode: ACRuleEvaluationTreeNode;
}

export interface ACRuleEvaluationTreeNode {
    operator: string;
    competencyCode?: string | undefined;
    passed: boolean;
    children: ACRuleEvaluationTreeNode[];
}

export interface ACCompetencyExplanation {
    competencyCode: string;
    description?: string | undefined;
    dslExpression: string;
    tokens: ACCompetencyTokenExplanation[];
}

export interface ACCompetencyTokenExplanation {
    token: string;
    label: string;
}

export interface StaffAssignmentSearchResultDto {
    staffAssignmentId: number;
    fiscalYear: string;
    positionLocalIdentifier: string;
    positionDescription: string;
    contentAreaDescription: string;
    gradeLevels?: string | undefined;
    isAppropriatelyCertified?: boolean | undefined;
}

export interface StaffAssignmentPositionContentAreaSearchResultDto {
    fiscalYear: string;
    totalMatchingCount: number;
    assignments: StaffAssignmentSearchResultDto[];
}

export interface WorkforceLegacyVerificationBackfillResultDto {
    schoolYear: string;
    isDryRun: boolean;
    backgroundJobId?: string | undefined;
    candidateCount: number;
    createdCount: number;
    fallbackReviewerCount: number;
    skippedExistingVerificationCount: number;
    skippedNoCoveredAssignmentsCount: number;
    skippedNotAllAssignmentsVerifiedCount: number;
    skippedNotReadyCount: number;
    leas: WorkforceLegacyVerificationBackfillLeaSummaryDto[];
    notReadyRecords: WorkforceLegacyVerificationBackfillNotReadyRecordDto[];
}

export interface WorkforceLegacyVerificationBackfillLeaSummaryDto {
    leaCodeId: number;
    leaName: string;
    createdCount: number;
    notReadyCount: number;
}

export interface WorkforceLegacyVerificationBackfillNotReadyRecordDto {
    personId: number;
    personName: string;
    ein?: string | undefined;
    leaCodeId: number;
    leaName: string;
    blockingReasons: string[];
}

export interface BackfillLegacyWorkforceVerificationsCommand {
    dryRun: boolean;
}

export interface LeaReportDto {
    reportId: number;
    title: string;
    description?: string | undefined;
    embedUrl: string;
    placement: string[];
    isEnabled: boolean;
    createdBy?: string | undefined;
    createdDate: Date;
    modifiedBy?: string | undefined;
    modifiedDate?: Date | undefined;
}

export interface AddOrUpdateReportCommand {
    reportId?: number | undefined;
    title: string;
    description?: string | undefined;
    embedUrl: string;
    placement: string[];
    isEnabled: boolean;
}

export interface ToggleReportStateCommand {
    reportId: number;
    isEnabled: boolean;
}

export interface VoucherReportDto {
    unallocatedFunds: number;
    rows: VoucherReportRowDto[];
}

export interface VoucherReportRowDto {
    distributionCycleName: string;
    status: string;
    issuedDate: Date;
    redeemedDate?: Date | undefined;
    expiresDate: Date;
    serviceType: string;
    credential?: string | undefined;
    voucherValue: number;
}

export interface SurveyInstanceResultDto {
    surveyInstanceId: number;
    name: string;
    schoolYear: string;
    scopeType: string;
    intendedContactRoles: string[];
    isRequiredDefault: boolean;
    showInYearBegin: boolean;
    openDate: Date;
    dueDate: Date;
    isActive: boolean;
    createdDate: Date;
    createdBy: string;
    completionSummary: CompletionSummaryDto;
}

export interface CompletionSummaryDto {
    totalAssignmentsCount: number;
    completedAssignmentsCount: number;
}

export interface SurveyManagementOptionsListDto {
    scopeTypes: ScopeTypeSelectOptionDto[];
    leaCodeOptions: LeaCodeSurveyAssignmentOptionDto[];
    leaSiteCodeOptions: LeaSiteCodeSurveyAssignmentOptionDto[];
    leaRoleOptions: SimpleSelectOptionDto[];
    leaSiteRoleOptions: SimpleSelectOptionDto[];
    existingSurveyOptions: ExistingSurveyOptionDto[];
}

export interface ScopeTypeSelectOptionDto extends SimpleSelectOptionDto {
    surveyScopeFocus?: SurveyScopeFocus | undefined;
}

export enum SurveyScopeFocus {
    Districts = 0,
    Sites = 1,
}

export interface SelectableOptionDto extends SimpleCodeDescriptionDto {
    selected: boolean;
    isActive: boolean;
}

export interface LeaCodeSurveyAssignmentOptionDto extends SelectableOptionDto {
    surveyAssignmentId?: number | undefined;
    leaType?: LeaType | undefined;
}

export enum LeaType {
    Public = 0,
    Charter = 1,
}

export interface LeaSiteCodeSurveyAssignmentOptionDto extends SelectableOptionDto {
    surveyAssignmentId?: number | undefined;
    leaSiteType?: LeaSiteType | undefined;
}

export enum LeaSiteType {
    Public = 0,
    Charter = 1,
}

export interface ExistingSurveyOptionDto {
    externalSurveyId?: string | undefined;
    name?: string | undefined;
    baseSurveyUrl?: string | undefined;
}

export interface AddOrUpdateSurveyInstanceCommand {
    surveyInstanceId?: number | undefined;
    name?: string | undefined;
    description?: string | undefined;
    schoolYear?: string | undefined;
    externalSurveyId?: string | undefined;
    baseSurveyUrl?: string | undefined;
    scopeType?: ScopeType | undefined;
    intendedLeaContactRoleIds: number[];
    intendedLeaSiteContactRoleIds: number[];
    surveyAssignments: SurveyAssignmentContext[];
    isRequiredDefault?: boolean | undefined;
    showInYearBegin?: boolean | undefined;
    openDate?: Date | undefined;
    dueDate?: Date | undefined;
}

export enum ScopeType {
    AllDistricts = 0,
    PublicDistricts = 1,
    CharterDistricts = 2,
    AllSites = 3,
    PublicSites = 4,
    CharterSites = 5,
    Custom = 6,
}

export interface SurveyAssignmentContext {
    surveyAssignmentId?: number | undefined;
    leaCodeId?: number | undefined;
    leaSiteCodeId?: number | undefined;
}

export interface CloseSurveyInstanceCommand {
    surveyInstanceId: number;
}

export interface AuditInfoDto {
    createdBy?: string | undefined;
    createdDate: Date;
    modifiedBy?: string | undefined;
    modifiedDate?: Date | undefined;
}

export interface SurveyInstanceForManagementDto extends AuditInfoDto {
    surveyInstanceId?: number | undefined;
    name?: string | undefined;
    description?: string | undefined;
    schoolYear?: string | undefined;
    externalSurveyId?: string | undefined;
    baseSurveyUrl?: string | undefined;
    scopeType?: ScopeType | undefined;
    surveyScopeFocus?: SurveyScopeFocus | undefined;
    intendedLeaContactRoleIds: number[];
    intendedLeaSiteContactRoleIds: number[];
    surveyAssignments: SurveyAssignmentContext[];
    isRequiredDefault: boolean;
    showInYearBegin: boolean;
    openDate?: Date | undefined;
    dueDate?: Date | undefined;
    isActive: boolean;
}

export interface SurveyReminderResult {
    successfulRemindersSentCount: number;
    failures: SurveyReminderFailure[];
}

export interface SurveyReminderFailure {
    locationDescription: string;
    reason: string;
}

export interface SendSurveyAssignmentReminderCommand {
    surveyInstanceId: number;
    targetAssignmentStatuses: SurveyAssignmentStatus[];
}

export enum SurveyAssignmentStatus {
    NotStarted = 0,
    InProgress = 1,
    Completed = 2,
    Closed = 3,
}

export interface VoucherProgramDetailsDto extends AuditInfoDto {
    voucherProgramId: number;
    name: string;
    description?: string | undefined;
    startDate: Date;
    endDate: Date;
    programEndedEarly?: boolean | undefined;
    programEndedEarlyReasons?: string | undefined;
    totalAvailableFunds: number;
    totalAllocatedFunds: number;
    effectiveAllocatedFunds: number;
    redeemedAmount: number;
    unallocatedFunds: number;
    status: VoucherProgramStatus;
    statusString: string;
    voucherDistributionCycles: VoucherDistributionCycleResultDto[];
}

export enum VoucherProgramStatus {
    NotStarted = 0,
    Active = 1,
    Ended = 2,
}

export interface VoucherDistributionCycleResultDto extends AuditInfoDto {
    voucherDistributionCycleId: number;
    name: string;
    description?: string | undefined;
    distributionType: VoucherDistributionType;
    distributionTypeString: string;
    distributedBy: VoucherDistributorType;
    distributedByString: string;
    status: VoucherDistributionCycleStatus;
    statusString: string;
    startDate: Date;
    endDate: Date;
    fundingLimit: number;
    allocatedAmount: number;
    currentAssignedAmount: number;
    unallocatedAmount: number;
    redeemedAmount: number;
}

export enum VoucherDistributionType {
    Individualized = 0,
    FirstComeFirstServe = 1,
}

export enum VoucherDistributorType {
    ArizonaDepartmentOfEducation = 1,
    LeaEpp = 2,
}

export enum VoucherDistributionCycleStatus {
    NotStarted = 0,
    Active = 1,
    Ended = 2,
}

export interface AddOrUpdateVoucherProgramCommand {
    voucherProgramId?: number | undefined;
    name?: string | undefined;
    description?: string | undefined;
    totalAvailableFunds?: number | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
}

export interface DeleteVoucherProgramCommand {
    voucherProgramId: number;
}

export interface EndVoucherProgramCommand {
    voucherProgramId: number;
    programEndedEarlyReasons?: string | undefined;
}

export interface VoucherDistributionCycleManagementDetailsDto extends VoucherDistributionCycleResultDto {
    voucherProgramId: number;
    voucherProgramName: string;
    voucherProgramStartDate: Date;
    voucherProgramEndDate: Date;
    hasEnded: boolean;
    eligibilityRules: VoucherEligibilityRuleDto[];
    allocations: VoucherAllocationDto[];
}

export interface VoucherEligibilityRuleDto extends AuditInfoDto {
    voucherEligibilityRuleId: number;
    serviceCodeId: number;
    serviceCodeDescription: string;
    certificateTypeCodeId?: number | undefined;
    certificateTypeDescription?: string | undefined;
    certificateGroupDescription?: string | undefined;
    endorsementCodeId?: number | undefined;
    endorsementDescription?: string | undefined;
    approvedAreaCodeId?: number | undefined;
    approvedAreaDescription?: string | undefined;
    credentialDescription: string;
    credentialType: string;
}

export interface VoucherAllocationDto extends AuditInfoDto {
    voucherAllocationId: number;
    leaCodeId?: number | undefined;
    leaDescription?: string | undefined;
    professionalPreparationInstitutionId?: number | undefined;
    eppDescription?: string | undefined;
    entityName: string;
    entityType: string;
    allocatedAmount: number;
    currentAssignedAmount: number;
    unallocatedAmount: number;
    redeemedAmount: number;
    hasActiveCredits: boolean;
}

export interface VoucherDistributionCycleInfoForConfigDto extends VoucherDistributionCycleResultDto {
    voucherProgramId: number;
}

export interface AgGridResponseOfVoucherEligibleServiceItemDto {
    data: VoucherEligibleServiceItemDto[];
    totalCount: number;
}

export interface VoucherEligibleServiceItemDto {
    serviceItemId: number;
    applicationId: number;
    educatorName?: string | undefined;
    educatorEmail?: string | undefined;
    educatorEin?: string | undefined;
    credentialName?: string | undefined;
    qualifyingEventDate: Date;
    paidServiceAmount: number;
    status?: string | undefined;
}

export interface AgGridQueryModelBase {
    filterModels: { [key: string]: AgGridFilterModel; };
    sortModels: AgGridSortModel[];
    pagination?: AgGridPaginationModel | undefined;
}

export interface AgGridQueryModelOfAgGridResponseOfVoucherEligibleServiceItemDto extends AgGridQueryModelBase {
}

export interface GetVoucherEligibleServiceItemsQuery extends AgGridQueryModelOfAgGridResponseOfVoucherEligibleServiceItemDto {
    voucherDistributionCycleId: number;
}

export interface AgGridFilterModel {
    filter?: string | undefined;
    dateFrom?: string | undefined;
    dateTo?: string | undefined;
    filterType?: string | undefined;
    operator?: string | undefined;
    type?: string | undefined;
    values: string[];
    filterModels: AgGridFilterModel[];
}

export interface AgGridSortModel {
    colId?: string | undefined;
    sort?: string | undefined;
    sortIndex?: number | undefined;
}

export interface AgGridPaginationModel {
    startRow: number;
    endRow: number;
}

export interface AgGridQueryModelOfByteOf extends AgGridQueryModelBase {
}

export interface ExportVoucherEligibleServiceItemsToExcelQuery extends AgGridQueryModelOfByteOf {
    voucherDistributionCycleId: number;
}

export interface AddOrUpdateVoucherDistributionCycleCommand {
    voucherProgramId: number;
    voucherDistributionCycleId?: number | undefined;
    name: string;
    description?: string | undefined;
    distributionType: VoucherDistributionType;
    distributedBy: VoucherDistributorType;
    startDate: Date;
    endDate: Date;
    fundingLimit: number;
}

export interface RedeemRetroactiveVoucherCommand {
    voucherDistributionCycleId: number;
    voucherAllocationId: number;
    serviceItemIds: number[];
    refundReason: string;
    includeOpenStatusServiceItems: boolean;
}

export interface DeleteDistributionCycleCommand {
    voucherDistributionCycleId: number;
}

export interface EligibilityRuleOptionsDto {
    certificates: CertificateOptionDto[];
    endorsements: EndorsementOptionDto[];
    certificateGroups: CertificateGroupOptionDto[];
    serviceCodes: ServiceCodeOptionDto[];
}

export interface CertificateOptionDto {
    certificateTypeCodeId: number;
    description: string;
    certificateGroupCodeId: number;
    certificateGroupDescription: string;
}

export interface EndorsementOptionDto {
    endorsementCodeId: number;
    description: string;
}

export interface CertificateGroupOptionDto {
    certificateGroupCodeId: number;
    description: string;
}

export interface ServiceCodeOptionDto {
    serviceCodeId: number;
    code: string;
    description: string;
}

export interface AddVoucherEligibilityRulesCommand {
    voucherDistributionCycleId: number;
    serviceCodeId: number;
    certificateTypeCodeIds: number[];
    endorsementCodeIds: number[];
}

export interface DeleteVoucherEligibilityRuleCommand {
    voucherEligibilityRuleId: number;
}

export interface AllocationOptionsDto {
    epps: AllocationEntityOptionDto[];
    leas: AllocationEntityOptionDto[];
}

export interface AllocationEntityOptionDto {
    id: number;
    description: string;
}

export interface BulkAllocateVouchersCommand {
    voucherDistributionCycleId: number;
    allocatedAmount: number;
    leaCodeIds: number[];
    professionalPreparationInstitutionIds: number[];
    entitiesGettingAllocationsCount: number;
}

export interface UpdateVoucherAllocationsCommand {
    voucherAllocationIds: number[];
    voucherDistributionCycleId: number;
    allocatedAmount: number;
}

export interface DeleteVoucherAllocationsCommand {
    voucherAllocationIds: number[];
}

export interface VoucherCreditManagementDetailsDto {
    voucherAllocation: VoucherAllocationResultDto;
    voucherCredits: VoucherCreditDto[];
    serviceCodes: VoucherCreditServiceCodeOptionDto[];
    distributionCycleStartDate: Date;
    distributionCycleEndDate: Date;
}

export interface VoucherAllocationResultDto {
    voucherAllocationId: number;
    voucherDistributionCycleId: number;
    programName: string;
    allocatedAmount: number;
    creditsIssuedAmount: number;
    redeemedAmount: number;
    hasActiveCredits: boolean;
    unassignedAmount: number;
    distributionCycle: VoucherDistributionCycleResultDto;
}

export interface VoucherCreditDto {
    voucherCreditAssignmentId: number;
    voucherAllocationId: number;
    personId: number;
    personName: string;
    ein: string;
    serviceCodeDescription: string;
    amount: number;
    expirationDate: Date;
    isExpired: boolean;
    isRedeemed: boolean;
    status: string;
}

export interface VoucherCreditServiceCodeOptionDto extends SimpleCodeDescriptionDto {
    fee: number;
}

export interface PersonSearchResultDto {
    personId: number;
    lastName: string;
    firstName: string;
    ein: string;
    leaSites?: string | undefined;
}

export interface BulkPersonSearchResultDto {
    einsWithNoMatch: string[];
    matches: PersonSearchResultDto[];
}

export interface CreateVoucherCreditsCommand {
    voucherAllocationId: number;
    personIds: number[];
    serviceCodeId: number;
    expiredDate: Date;
}

export interface UpdateVoucherCreditsCommand {
    voucherCreditAssignmentIds: number[];
    serviceCodeId?: number | undefined;
    expiredDate?: Date | undefined;
    shouldUpdateExpiredDate: boolean;
}

export interface DeleteVoucherCreditsCommand {
    voucherCreditAssignmentIds: number[];
}

export interface ReclaimUnassignedFundsCommand {
    voucherAllocationIds: number[];
}

export interface LogApplicationEventCommand {
    level: LogLevel;
    payload: Payload;
    commandQueryName?: string | undefined;
}

export enum LogLevel {
    Trace = 0,
    Debug = 1,
    Information = 2,
    Warning = 3,
    Error = 4,
    Critical = 5,
    None = 6,
}

export interface AddOrUpdateEducatorApplicationCommand {
    applicationId?: number | undefined;
    personId: number;
    applicationOptionCodeIds: number[];
}

export interface AddOrUpdateCertificateApplicationServiceItemCommand {
    applicationServiceItemId?: number | undefined;
    applicationId: number;
    personId?: number | undefined;
    certificateTypeCodeId?: number | undefined;
    requiredAreaType?: RequiredAreaType | undefined;
    certificateLevelCodeId?: number | undefined;
    leaCodeId?: number | undefined;
    professionalPreparationInstitutionId?: number | undefined;
    approvedAreaCodeId?: number | undefined;
    restrictedApprovedAreaCodeId?: number | undefined;
    visaExpireDate?: Date | undefined;
}

export enum RequiredAreaType {
    PrimaryApprovedArea = 0,
    RestrictedApprovedArea = 1,
}

export interface AddOrUpdateNameChangeServiceItemCommand {
    applicationServiceItemId?: number | undefined;
    applicationId: number;
    currentFirstName: string;
    currentMiddleName?: string | undefined;
    currentLastName: string;
    newFirstName: string;
    newMiddleName?: string | undefined;
    newLastName: string;
}

export interface ApplicationServiceItemDto {
    applicationServiceItemId?: number | undefined;
    applicationId: number;
    serviceCode?: string | undefined;
}

export interface CertificateServiceItemDto extends ApplicationServiceItemDto {
    certificateTypeCodeId: number;
    personId?: number | undefined;
    certificateTypeCodeDescription?: string | undefined;
    requiredAreaType?: RequiredAreaType | undefined;
    certificateLevelCodeId?: number | undefined;
    leaCodeId?: number | undefined;
    leaCodeDescription?: string | undefined;
    professionalPreparationInstitutionId?: number | undefined;
    professionalPreparationInstitutionDescription?: string | undefined;
    approvedAreaCodeId?: number | undefined;
    approvedAreaCodeDescription?: string | undefined;
    restrictedApprovedAreaCodeId?: number | undefined;
    restrictedApprovedAreaCodeDescription?: string | undefined;
    visaExpireDate?: Date | undefined;
}

export interface NameChangeServiceDetailDto extends ApplicationServiceItemDto {
    newFirstName?: string | undefined;
    newMiddleName?: string | undefined;
    newLastName?: string | undefined;
    currentFirstName: string;
    currentMiddleName?: string | undefined;
    currentLastName: string;
    detailDataExists: boolean;
}

export interface SsnChangeServiceDetailDto {
    applicationId: number;
    applicationServiceItemId?: number | undefined;
    currentSsn: string;
    newSsn?: string | undefined;
    detailDataExists: boolean;
}

export interface EducatorApplicationByIdDto {
    applicationId: number;
    createdDate: Date;
    createdBy?: string | undefined;
    modifiedDate?: Date | undefined;
    modifiedBy?: string | undefined;
    status?: string | undefined;
    typeDescription?: string | undefined;
    options?: ApplicationOption[] | undefined;
    deliveryMethodDescription?: string | undefined;
    requiresBackgroundCheck: boolean;
    backgroundCheckResponse?: BackgroundCheckResponse | undefined;
    applicationTypeCodeId?: number | undefined;
    locationCodeId?: number | undefined;
    deliveryCodeId?: number | undefined;
}

export interface ApplicationOption {
    applicationOptionCodeId: number;
    code: string;
    description: string;
    groupCode: string;
}

export enum BackgroundCheckResponse {
    YesToAtLeastOneQuestion = 0,
    NoToAllQuestions = 1,
    DidNotAnswerAllQuestions = 2,
}

export interface DeleteApplicationServiceItemCommand {
    applicationServiceItemId: number;
}

export interface ReturnedIncompleteReasonCodeQueryDto {
    returnedIncompleteReasonCodeId: number;
    detail: string;
    code: string;
    description: string;
    returnedIncompleteReasonCodeParameters: ReturnedIncompleteReasonCodeParameterDto[];
}

export interface ReturnedIncompleteReasonCodeParameterDto {
    returnedIncompleteReasonCodeParameterId: number;
    name: string;
    displayName: string;
    type?: ReturnedIncompleteReasonCodeParameterType | undefined;
}

export enum ReturnedIncompleteReasonCodeParameterType {
    Date = 0,
    Text = 1,
    Currency = 2,
}

export interface AddRILetterDocumentCommand {
    personId: number;
    applicationId: number;
    applicationDate: Date;
    reasonCodes: ReturnedIncompleteReasonDto[];
    isSave: boolean;
}

export interface ReturnedIncompleteReasonDto {
    returnedIncompleteReasonCodeId: number;
    description?: string | undefined;
    returnedIncompleteReasonCodeParameters: ReturnedIncompleteReasonParameter[];
}

export interface ReturnedIncompleteReasonParameter {
    returnedIncompleteReasonCodeParameterId: number;
    stringValue?: string | undefined;
    dateValue?: Date | undefined;
    displayName?: string | undefined;
    type?: ReturnedIncompleteReasonCodeParameterType | undefined;
}

export interface ApplicationDetailsOptionsDto {
    backgroundCheckResponses: BackgroundCheckResponseDto[];
    locationCodes: LocationCodeDto[];
    applicationTypeCodes: ApplicationTypeCodeDto[];
    deliveryCodes: DeliveryCodeDto[];
    phoenixLocationCodeId: number;
}

export interface BackgroundCheckResponseDto {
    enumValue: number;
    description: string;
}

export interface LocationCodeDto {
    locationCodeId: number;
    code: string;
    description: string;
}

export interface ApplicationTypeCodeDto {
    applicationTypeCodeId: number;
    description: string;
}

export interface DeliveryCodeDto {
    deliveryCodeId: number;
    description: string;
    isActive: boolean;
}

export interface SaveApplicationDetailsCommand {
    applicationId: number;
    backgroundReasonRequired: boolean;
    backgroundCheckResponse?: BackgroundCheckResponse | undefined;
    applicationTypeCodeId?: number | undefined;
    locationCodeId?: number | undefined;
    deliveryCodeId?: number | undefined;
}

export interface ServiceFeeWaiverCodesDto {
    serviceFeeWaiverCodeId: number;
    code: string;
    description: string;
}

export interface ServiceFeeSummaryDto {
    currentEducatorBalance: number;
    serviceFeeSummaryDetailItems: ServiceFeeSummaryDetailDto[];
    voucherCreditApplied: number;
    appliedVoucherCreditIds: number[];
}

export interface ServiceFeeSummaryDetailDto {
    lineItemId: string;
    personId: number;
    serviceCode: string;
    serviceCodeDescription: string;
    serviceFee: number;
    computedServiceFee: number;
    serviceFeeWaiverCodeId?: number | undefined;
    appliedVoucherCreditId?: number | undefined;
    serviceItems: ServiceFeeServiceItemDto[];
    lineItemDescription: string;
}

export interface ServiceFeeServiceItemDto {
    applicationServiceItemId?: number | undefined;
    itemDescription?: string | undefined;
    itemSubDescription?: string | undefined;
}

export interface SaveApplicationPaymentInformationCommand {
    applicationId: number;
    personId: number;
    paymentTypeCodeId: number;
    referenceNumber?: string | undefined;
    amountCollected: number;
    amountOwed: number;
    appliedCredit: number;
    appliedVoucherCredit: number;
    appliedVoucherCreditIds: number[];
    paymentLineItems: PaymentLineItemContext[];
}

export interface PaymentLineItemContext {
    amount: number;
    serviceCode: string;
    serviceFeeWaiverCodeId?: number | undefined;
    lineItemDescription: string;
    applicationServiceItemIds: number[];
}

export interface ApplicationReviewDetailsDto {
    amountPaid: number;
    applicationStatus: string;
    applicationTypeCodeId?: number | undefined;
    applicationId: number;
    backgroundCheckResponse?: BackgroundCheckResponse | undefined;
    createdDate: Date;
    daysAge: number;
    deliveryCodeId: number;
    locationCodeId: number;
    paymentDate?: Date | undefined;
    paymentTypeCodeId?: number | undefined;
    receiptNumber?: number | undefined;
    referenceNumber?: string | undefined;
    requiresBackgroundCheck: boolean;
    servicesRemaining: number;
    totalServices: number;
    percentageOfServicesComplete: number;
}

export interface ApplicationStatusDto {
    status: string;
}

export interface ApplicationReviewEvaluationDto {
    applicationServiceItemId: number;
    serviceCodeDescription: string;
    serviceCode: string;
    itemDescription?: string | undefined;
    itemSubDescription?: string | undefined;
    amountPaid?: number | undefined;
    status: string;
    assignee: string;
    waiverOption?: string | undefined;
    isOnHold: boolean;
    holdingAge: number;
    isIssued: boolean;
    serviceItemCancellationRequestId?: number | undefined;
    hasBeenReviewed: boolean;
    isRootRenewal: boolean;
}

export interface UpdateApplicationFromReviewCommand {
    applicationId: number;
    backgroundReasonRequired: boolean;
    backgroundCheckResponse?: BackgroundCheckResponse | undefined;
    applicationTypeCodeId?: number | undefined;
    locationCodeId?: number | undefined;
    deliveryCodeId?: number | undefined;
    paymentTypeCodeId?: number | undefined;
    referenceNumber?: string | undefined;
}

export interface AddApprovedAreaDetailDto {
    approvedAreaCodeOptions: ApprovedAreaCodeOptionForAddDto[];
    approvedAreasOnApplication: AddApprovedAreaDetailForAddDto[];
}

export interface ApprovedAreaCodeOptionForAddDto {
    approvedAreaCodeId: number;
    description: string;
}

export interface AddApprovedAreaDetailForAddDto {
    applicationServiceItemId: number;
    approvedAreaCodeId: number;
    description: string;
}

export interface AddApprovedAreaApplicationServiceItemCommand {
    applicationId: number;
    approvedAreaCodeId: number;
}

export interface AddEndorsementDetailDto {
    endorsementCodeOptions: EndorsementCodeOptionForAddDto[];
    endorsementsOnApplication: AddEndorsementDetailForAddDto[];
}

export interface EndorsementCodeOptionForAddDto {
    endorsementCodeId: number;
    description: string;
    endorsementGroupCode?: string | undefined;
    requiresLanguageCode: boolean;
    eligibleForVoucherCredit: boolean;
}

export interface AddEndorsementDetailForAddDto {
    applicationServiceItemId: number;
    endorsementCodeId: number;
    description: string;
    endorsementLevelDescription: string;
}

export interface AddEndorsementApplicationServiceItemCommand {
    personId: number;
    applicationId: number;
    endorsementCodeId: number;
    endorsementLevelCodeId: number;
    languageCodeId?: number | undefined;
}

export interface ValidateApplicationCommand {
    applicationId: number;
    personId: number;
}

export interface ExtendableCertificatesServiceDetailDto {
    personCertificateId: number;
    isExtended: boolean;
    description: string;
    expireDate: Date;
    isInternational: boolean;
    visaExpireDate?: Date | undefined;
    isChecked: boolean;
}

export interface AddOrUpdateCertificateExtensionServiceItemCommand {
    applicationId: number;
    personCertificateIds: number[];
    visaExpireDate?: Date | undefined;
}

export interface EducatorCertificateForRenewalDto {
    personCertificateId: number;
    description: string;
    status: string;
    expireDate: Date;
    isChecked: boolean;
    isInternational: boolean;
    pdRequirementState: ProfessionalDevelopmentRequirementState;
    eligibleForVoucherCredit: boolean;
}

export enum ProfessionalDevelopmentRequirementState {
    NotRequired = 0,
    NotRequiredYet = 1,
    NotMet = 2,
    Met = 3,
}

export interface RenewableCertificateDto {
    personCertificateId: number;
    description: string;
    expireDate: Date;
    status: string;
    isChecked: boolean;
    canBeAligned: boolean;
    isInternational: boolean;
    pdRequirementState: ProfessionalDevelopmentRequirementState;
    renewalSelectionType: RenewalSelectionType;
    eligibleForVoucherCredit: boolean;
}

export enum RenewalSelectionType {
    NotEligible = 0,
    StandardRenewal = 1,
    TenTwoRenewal = 2,
}

export interface AddOrUpdateRenewalApplicationServiceItemCommand {
    applicationId: number;
    personCertificateIds: number[];
    visaExpireDate?: Date | undefined;
}

export interface EducatorCertificateForCopyDto {
    personCertificateId: number;
    description: string;
    expireDate: Date;
    status: string;
}

export interface AddOrUpdateCopyOfCertificateApplicationServiceItemCommand {
    applicationId: number;
}

export interface RemoveDeficiencyDetailDto {
    allowableDeficiencyCodeOptions: AllowableDeficienciesForRemovalDto[];
    deficienciesToRemoveOnApplication: RemoveDeficiencyDetailForAddDto[];
}

export interface AllowableDeficienciesForRemovalDto {
    allowableDeficiencyCodeId: number;
    description: string;
}

export interface RemoveDeficiencyDetailForAddDto {
    applicationServiceItemId: number;
    allowableDeficiencyCodeId: number;
    description: string;
    subDescriptions: string[];
}

export interface AddRemoveDeficiencyApplicationServiceItemCommand {
    applicationId: number;
    allowableDeficiencyCodeId: number;
}

export interface AddOrUpdateSsnChangeServiceItemCommand {
    applicationServiceItemId?: number | undefined;
    applicationId: number;
    personId: number;
    newSsn: string;
}

export interface EducatorCertificateRecommendationDto {
    personPPIRecommendedCertificateId: number;
    programDescription: string;
    certificateDescription: string;
    approvedAreaDescription?: string | undefined;
    irIssueDate?: Date | undefined;
    specialProgramType: string;
    isChecked: boolean;
    eligibleForVoucherCredit: boolean;
}

export interface AddOrUpdateIRCertificateApplicationServiceItemCommand {
    applicationId: number;
    personPPIRecommendedCertificateIds: number[];
}

export interface EducatorEndorsementRecommendationDto {
    personPPIRecommendedCertificateEndorsementCodeId: number;
    programDescription: string;
    endorsementDescription: string;
    irIssueDate?: Date | undefined;
    specialProgramType: string;
    isChecked: boolean;
    eligibleForVoucherCredit: boolean;
}

export interface AddOrUpdateIREndorsementApplicationServiceItemCommand {
    applicationId: number;
    personPPIRecommendedCertificateEndorsementCodeIds: number[];
}

export interface ServiceItemEvalStateDto {
    hasFinalizedStatus: boolean;
    hasLegacyFinalizedStatus: boolean;
    isRenewal: boolean;
    alignedRenewalApplicationServiceItemId?: number | undefined;
}

export interface EducatorCertificateForReinstatementDto {
    personCertificateId: number;
    description: string;
    status: string;
    isChecked: boolean;
    expireDate: Date;
}

export interface AddOrUpdateReinstatementApplicationServiceItemsCommand {
    applicationId: number;
    personCertificateIds: number[];
}

export interface RushServiceItemCommand {
    applicationServiceItemId: number;
    personId: number;
    bestContactEmailAddress?: string | undefined;
}

export interface ManuallyWithdrawFromCohortStudentProgramCommand {
    personId: number;
    serviceCode: string;
    certificateTypeCodeId?: number | undefined;
    endorsementCodeId?: number | undefined;
}

export interface ExchangeIdpTokenCommand {
    idpIdentityToken: string;
}

export interface CreateNonProdUserTokenCommand {
    testEmail: string;
    edOrgRoleSelections: EdOrgRoleSelectionDto[];
}

export interface EdOrgRoleSelectionDto {
    edOrgId: number;
    roleIds: number[];
}

export interface ChangeEducationOrganizationCommand {
    edOrgId: number;
}

export interface EdOrgDto {
    edOrgId: number;
    edOrgName: string;
}

export interface GetEdOrgsQuery {
    edOrgNameSearch: string;
}

export interface AvailableEdOrgDto {
    edOrgId: number;
    edOrgName: string;
}

export interface UserPolicyEvalDto {
    canViewLab: boolean;
    canUpdateLab: boolean;
    canUseLabTestingTools: boolean;
    canViewDataDictionary: boolean;
    canMapRolePermissions: boolean;
    canViewRolePermissions: boolean;
    canCreatePersons: boolean;
    canUpdatePersons: boolean;
    canViewPersons: boolean;
    canDeletePersons: boolean;
    canModifySSNPersons: boolean;
    canReviewDocuments: boolean;
    canViewEducation: boolean;
    canCreateEducation: boolean;
    canUpdateEducation: boolean;
    canDeleteEducation: boolean;
    canViewPassedTests: boolean;
    canViewTests: boolean;
    canCreateManualTests: boolean;
    canUpdateManualTests: boolean;
    canDeleteManualTests: boolean;
    canModifyTestFeedRecords: boolean;
    canReceiveApplications: boolean;
    canViewApplications: boolean;
    canUpdateApplications: boolean;
    canDeleteApplications: boolean;
    canManageAdminQueue: boolean;
    canAssignServiceItemToOthers: boolean;
    canViewManualFingerprintCards: boolean;
    canCreateManualFingerprintCards: boolean;
    canDeleteManualFingerprintCards: boolean;
    canViewDPSFeedFingerprintCards: boolean;
    canDeleteDPSFeedFingerprintCards: boolean;
    canManageDpsFingerprintMismatches: boolean;
    canViewCER: boolean;
    canCreateCER: boolean;
    canUpdateCER: boolean;
    canDeleteCER: boolean;
    canViewNotes: boolean;
    canCreateNotes: boolean;
    canUpdateNotes: boolean;
    canDeleteNotes: boolean;
    canSelfAssignServiceItems: boolean;
    canUpdateBackgroundCheckAfterPayment: boolean;
    canViewCertificates: boolean;
    canDeleteCertificates: boolean;
    canUpdateCertificates: boolean;
    canUpdateCertificateStatuses: boolean;
    canUpdateCertificateDates: boolean;
    canUpdateCertificateLeaAndPpi: boolean;
    canViewPayments: boolean;
    canEnterPaymentReversal: boolean;
    canViewCollectedPaymentsReport: boolean;
    canEnterPaymentRedeposit: boolean;
    canAddEvaluations: boolean;
    canEditEvaluations: boolean;
    canConfigureDenials: boolean;
    canAddCustomIncompleteReasons: boolean;
    canApproveCancellations: boolean;
    canUploadDocuments: boolean;
    canViewPaymentReversalReport: boolean;
    canSendPaymentReversalToCollections: boolean;
    canInitiateHold: boolean;
    canProcessRefunds: boolean;
    canCreatePrintJobs: boolean;
    canViewNasdtecEntries: boolean;
    canUpdateNasdtecEntries: boolean;
    canViewDiscipline: boolean;
    canAddDiscipline: boolean;
    canUpdateDiscipline: boolean;
    canDeleteDiscipline: boolean;
    canViewDisciplineNotes: boolean;
    canManuallyCompleteInvestigativeReview: boolean;
    canViewInvestigativeAlerts: boolean;
    canViewCaseIQ: boolean;
    canManuallyProcessCaseIQCaseClosures: boolean;
    canPerformFinalSIReview: boolean;
    canProcessAppeals: boolean;
    canManageHangfire: boolean;
    canLoginAsTestUser: boolean;
    deleteBackgroundIssuesFingerprint: boolean;
    addBackgroundIssuesNASDTEC: boolean;
    deleteBackgroundIssuesNASDTEC: boolean;
    addBackgroundIssuesUnderInvestigation: boolean;
    deleteBackgroundIssuesUnderInvestigation: boolean;
    addBackgroundIssuesSbeAction: boolean;
    deleteBackgroundIssuesSbeAction: boolean;
    deleteBackgroundIssuesQuestions: boolean;
    deleteBackgroundIssuesLegacy: boolean;
    addCashierCheckOnly: boolean;
    deleteCashierCheckOnly: boolean;
    addW9: boolean;
    deleteW9: boolean;
    addHoldDoNotIssue: boolean;
    deleteHoldDoNotIssue: boolean;
    addSeeDirector: boolean;
    deleteSeeDirector: boolean;
    addBackgroundIssueIUComment: boolean;
    deleteBackgroundIssuesIUComment: boolean;
    deleteBackgroundIssuesTurnDown: boolean;
    canViewLea: boolean;
    canViewEpp: boolean;
    canViewCertPersons: boolean;
    canViewLeaPersons: boolean;
    canViewEppPersons: boolean;
    canSearchEducators: boolean;
    addManualToLeaRoster: boolean;
    removeManualToLeaRoster: boolean;
    canViewCohort: boolean;
    canAddCohort: boolean;
    canUpdateCohort: boolean;
    canDeleteCohort: boolean;
    canAddStudentsToCohort: boolean;
    canTransferStudentsToCohort: boolean;
    canRemoveStudentFromCohort: boolean;
    canAuthorizeRecommendation: boolean;
    canDeleteRecommendation: boolean;
    canSubmitUnprofessionalConductReport: boolean;
    canAddManualDenialReasons: boolean;
    canVerifyProfessionalDevelopment: boolean;
    canViewLeaContacts: boolean;
    canEditLeaContacts: boolean;
    canDeleteLeaContacts: boolean;
    canViewLeaSiteContacts: boolean;
    canEditLeaSiteContacts: boolean;
    canDeleteLeaSiteContacts: boolean;
    canUseLeaContactTestingTools: boolean;
    canInvalidateLeaContacts: boolean;
    canManageHelpObjects: boolean;
    canManagePageAlerts: boolean;
    canAddAlerts: boolean;
    canDeleteAlerts: boolean;
    canPrintVerificationLetter: boolean;
    canGenerateCertificates: boolean;
    canViewPersonDemographics: boolean;
    canViewPersonFullSsn: boolean;
    canViewPersonContact: boolean;
    hasCountyRole: boolean;
    canApprovePendingPayments: boolean;
    canCloseServiceItems: boolean;
    canLinkEducators: boolean;
    canMergeEducators: boolean;
    canViewTranscripts: boolean;
    canAssociateTranscripts: boolean;
    canViewLeaContactsInCert: boolean;
    canManageLeaStaffRoster: boolean;
    canDeleteDocuments: boolean;
    canViewAdminConfigurations: boolean;
    canManageCredentialConfigurations: boolean;
    canManageLeaConfigurations: boolean;
    canManuallyRecalculateAC: boolean;
    canManageEppConfigurations: boolean;
    deleteBackgroundIssuesAgencyRestricted: boolean;
    deleteBackgroundIssuesDrivingRestricted: boolean;
    canAddBackgroundIssuesSBENoAction: boolean;
    canDeleteBackgroundIssuesSBENoAction: boolean;
    canManageMismatchedFingerprintReport: boolean;
    canUpdateTitleIStatus: boolean;
    canManageLeaStaffPositions: boolean;
    canManageLeaUploads: boolean;
    canManageEvaluations: boolean;
    canViewSpecialPrograms: boolean;
    canCreateSpecialPrograms: boolean;
    canUpdateSpecialPrograms: boolean;
    canDeleteSpecialPrograms: boolean;
    canAddRushToServiceItems: boolean;
    canRemoveRushFromServiceItems: boolean;
    canViewLeaSurveys: boolean;
    canManageSurveys: boolean;
    canManageLeaYearTransition: boolean;
    canLockLeaSystem: boolean;
    canViewPerformanceEvaluations: boolean;
    canEditPerformanceEvaluations: boolean;
    canManageReports: boolean;
    canManageVoucherPrograms: boolean;
    canManageRetroactiveVouchers: boolean;
    canViewAdminReports: boolean;
    canViewVoucherReports: boolean;
    canManageLeaVoucherCredits: boolean;
    canManageEppVoucherCredits: boolean;
    canAssignProfessionalDevelopmentRequests: boolean;
    canVerifyCertProfessionalDevelopment: boolean;
    canResetPersonInformation: boolean;
    canInitiateEducatorScreenShare: boolean;
    canLeaCreatePersons: boolean;
    canViewLeaWorkforceInformation: boolean;
    canViewLeaCredentialManagementRoster: boolean;
    canCompleteLeaSurveys: boolean;
    canRedeemRetroactiveVoucherCreditsDuringEvaluation: boolean;
    canEditEndedAssignmentsAndEmployments: boolean;
}

export interface UserLogoutCommand {
    userId?: number | undefined;
}

export interface DataStateValidationResponseDto {
    isValid: boolean;
    validationFailureReason?: string | undefined;
    validationFailureMessages?: string[] | undefined;
}

export interface ValidateStateRulesQuery {
    dataStateRuleTypes: string[];
    routeParameters: { [key: string]: any; };
}

export interface TokenRefreshResult {
    token: string;
    wasRefreshed: boolean;
}

export interface MainContactInformationDto {
    leaDescription: string;
    physicalAddress?: LeaContactAddressDto | undefined;
    mailingAddress?: LeaContactAddressDto | undefined;
    phoneNumber?: string | undefined;
    webSite?: string | undefined;
}

export interface LeaContactAddressDto {
    line1?: string | undefined;
    line2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
}

export interface CertAdminContactInfoDto {
    personId: number;
    leaRoleContactInformationId: number;
    leaCodeId: number;
    ctds?: string | undefined;
    edOrgId?: string | undefined;
    contactLocation?: string | undefined;
    type?: string | undefined;
    titlePosition?: string | undefined;
    fullName?: string | undefined;
    phoneNumber?: string | undefined;
    extension?: string | undefined;
    emailAddress?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedDate?: Date | undefined;
    isInvalid: boolean;
    invalidatedBy?: string | undefined;
    invalidatedDate?: Date | undefined;
    isRequiredContact: boolean;
}

export interface CertSiteContactInfoDto {
    leaSiteRoleContactInformationId: number;
    leaSiteCodeId: number;
    leaCodeId: number;
    personId: number;
    location?: string | undefined;
    ctds?: string | undefined;
    edOrgId?: string | undefined;
    type?: string | undefined;
    titlePosition?: string | undefined;
    fullName?: string | undefined;
    phoneNumber?: string | undefined;
    extension?: string | undefined;
    emailAddress?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedDate?: Date | undefined;
    isInvalid: boolean;
    invalidatedBy?: string | undefined;
    invalidatedDate?: Date | undefined;
    isRequiredContact: boolean;
    leaSiteMainContactInformation?: MainContactInformationDto | undefined;
}

export interface InvalidateLeaSiteRoleContactsCommand {
    leaSiteRoleContactInformationIds: number[];
}

export interface InvalidateLeaRoleContactsCommand {
    leaRoleContactInformationIds: number[];
}

export interface ExportLeaContactRoleInformationToExcelQuery extends AgGridQueryModelOfByteOf {
    leaCodeId: number;
}

export interface ExportLeaSiteContactRoleInformationToExcelQuery extends AgGridQueryModelOfByteOf {
    leaCodeId?: number | undefined;
}

export interface CombinedContactsAgGridQueryModelOfByteOf {
    adminContactsAgGridQueryModel: AgGridQueryModelOfByteOf;
    siteContactsAgGridQueryModel: AgGridQueryModelOfByteOf;
}

export interface ExportAllLeaContactRoleInformationToExcelQuery extends CombinedContactsAgGridQueryModelOfByteOf {
    leaCodeId: number;
}

export interface PersonGenderCodeDto {
    genderCodeId: number;
    description: string;
    isDisabled: boolean;
}

export interface PersonEthnicityCodeDto {
    ethnicityCodeId: number;
    description: string;
    isDisabled: boolean;
}

export interface ProfessionalPreparationInstitutionDto {
    professionalPreparationInstitutionId: number;
    type: ProfessionalPreparationInstitutionType;
    edOrgId?: number | undefined;
    description: string;
}

export enum ProfessionalPreparationInstitutionType {
    IHE = 0,
    Organization = 1,
    LEA = 2,
}

export interface CertificateTypeCodeDto {
    certificateTypeCodeId: number;
    code: string;
    description: string;
    requiredAreaType?: RequiredAreaType | undefined;
    certificateGroupCodeId: number;
    certificateLevelCodeId: number;
}

export interface AccreditedInstitutionCodeDto {
    accreditedInstitutionCodeId: number;
    code: string;
    description: string;
    stateCodeId?: number | undefined;
}

export interface PersonRaceCodeDto {
    raceCodeId: number;
    code: string;
    description: string;
    isDisabled: boolean;
}

export interface GenderEthnicityRaceCodesDto {
    genderCodes: GenderCodeDto[];
    ethnicityCodes: EthnicityCodeDto[];
    raceCodes: RaceCodeDto[];
}

export interface GenderCodeDto {
    genderCodeId: number;
    description: string;
}

export interface EthnicityCodeDto {
    ethnicityCodeId: number;
    description: string;
}

export interface RaceCodeDto {
    raceCodeId: number;
    description: string;
}

export interface StateDto {
    stateCodeId: number;
    stateCode: string;
    description: string;
}

export interface PhoneCodeDto {
    phoneCodeId: number;
    code: string;
    description: string;
    isDisabled: boolean;
}

export interface EmailCodeDto {
    emailCodeId: number;
    code: string;
    description: string;
    isDisabled: boolean;
}

export interface TestCodeDto {
    testCodeId: number;
    testCode: string;
    description: string;
    isActive: boolean;
}

export interface DegreeCodeDto {
    degreeCodeId: number;
    isHigherEd: boolean;
    isHighSchoolDiplomaGed: boolean;
    levelRanking: number;
    description: string;
}

export interface DegreeTypeCodeDto {
    degreeTypeCodeId: number;
    degreeCodeId?: number | undefined;
    description: string;
}

export interface MajorCodeDto {
    majorCodeId: number;
    description: string;
}

export interface ApplicationOptionGroupCodeDto {
    applicationOptionGroupCodeId: number;
    code: string;
    description: string;
    applicationOptions: ApplicationOptionCodeDto[];
}

export interface ApplicationOptionCodeDto {
    applicationOptionCodeId: number;
    code: string;
    description: string;
    isSelected: boolean;
}

export interface LeaCodeDto {
    leaCodeId: number;
    code: string;
    description: string;
    edOrgId: string;
    displayName: string;
}

export interface CertificateLevelCodeDto {
    certificateLevelCodeId: number;
    code: string;
    description: string;
}

export interface FingerprintCardStatusCodeDto {
    fingerprintCardStatusCodeId: number;
    code: string;
    dpsDescription?: string | undefined;
    description: string;
    isActive: boolean;
}

export interface OutOfStateCertificateTypeCodeDto {
    certificateTypeCodeId: number;
    requiredAreaType?: RequiredAreaType | undefined;
    certificateTypeCodeDescription: string;
    effectiveDate: Date;
    endDate: Date;
    canBeMetByPersonPrepProgram: boolean;
}

export interface ContactTypeCodeDto {
    contactTypeCodeId: number;
    code: string;
    description: string;
}

export interface PersonCertificateTypeCodeDto extends CertificateTypeCodeDto {
    eligibleForVoucherCredit: boolean;
}

export interface DocumentCodeDto {
    documentCodeId?: number | undefined;
    description?: string | undefined;
    code?: string | undefined;
    canBeDeleted: boolean;
}

export interface PaymentTypeCodeDto {
    paymentTypeCodeId: number;
    code: string;
    description: string;
}

export interface LocationCodeDto2 {
    locationCodeId: number;
    code: string;
    description: string;
}

export interface AlertCodeDto {
    alertCodeId: number;
    code: string;
    description: string;
    canManuallyRemoveAlert: boolean;
    canManuallyAddAlert: boolean;
    hasDetails: boolean;
}

export interface LanguageCodeDto {
    languageCodeId: number;
    code: string;
    description: string;
}

export interface InStateActionTypeCodeDto {
    inStateActionTypeCodeId: number;
    code: string;
    description: string;
}

export interface OutOfStateActionTypeCodeDto {
    outOfStateActionTypeCodeId: number;
    code: string;
    description: string;
}

export interface EndorsementCodeDto {
    endorsementCodeId: number;
    code: string;
    description: string;
    requiresLanguageCode: boolean;
}

export interface AllowableDeficiencyDto {
    allowableDeficiencyCodeId: number;
    code: string;
    description: string;
    canBeMetByPersonPreparationProgram: boolean;
}

export interface EndorsementGroupCodeDto {
    endorsementGroupCodeId: number;
    code: string;
    description: string;
}

export interface SpecialProgramCodeDto {
    specialProgramCodeId: number;
    code: string;
    description: string;
    category: string;
    hasDetails: boolean;
}

export interface CertificationClientConfig {
    environment?: string | undefined;
    idleTimeoutInSeconds: number;
    azureAppConfig: AzureAppConfig;
}

export interface CertificationClientConfigDto extends CertificationClientConfig {
    testModeAllowed: boolean;
    fiscalYearDescription: string;
}

export interface AzureAppConfig {
    issuer: string;
    authority: string;
    metadataUrl: string;
    clientId: string;
    redirectUri: string;
    postLogoutRedirectUri: string;
}

export interface RazorToStringQuery {
    viewName: string;
    typeName: string;
    viewDataEntries: { [key: string]: any; };
    data: string;
}

export interface ReportErrorCommand {
    site: string;
    errorId: string;
    traceId: string;
}

export interface FeatureManagement {
    caseIQ: boolean;
    sharePointUpload: boolean;
    edPortalPayments: boolean;
    educatorNotifications: boolean;
    dpsFileCleanup: boolean;
    testFileCleanup: boolean;
    informationObscurity: boolean;
    achPayment: boolean;
    edPortalTour: boolean;
    deleteCertificates: boolean;
    substantivelyComplete: boolean;
    transcriptImport: boolean;
    einConflictResolution: boolean;
    certificationContacts: boolean;
    leaRoster: boolean;
    leaInformation: boolean;
    stakeholderIdGeneration: boolean;
    lea1Portal: boolean;
    lea2Portal: boolean;
    credentialConfiguration: boolean;
    lea2BatchUpload: boolean;
    lea2DpsBackgroundAlerts: boolean;
    lea2InitialFYLegacyPositionBatchUpload: boolean;
    lea2WorkforceBatchUpload: boolean;
    lea2WorkforceManagement: boolean;
    legacyLea2Workforce: boolean;
    mismatchedFingerprintReport: boolean;
    immediatePrint: boolean;
    eppManagement: boolean;
    evaluationQualificationPathTool: boolean;
    leaRush: boolean;
    workforceInformation: boolean;
    acEvaluation: boolean;
    bulkACReevaluation: boolean;
    surveys: boolean;
    emails: boolean;
    leaYearTransition: boolean;
    reports: boolean;
    vouchers: boolean;
    retroactiveVouchers: boolean;
    vouchersFirstComeFirstServeDistribution: boolean;
    complexProfessionalDevelopment: boolean;
    evaluationCommunication: boolean;
    screenShare: boolean;
}

export interface CodeTableConfigurationResultDto {
    id: number;
    code: string;
    description: string;
    isActive: boolean;
    createdDate: Date;
    hasBeenUsed: boolean;
}

export interface CodeTableInfoForConfigDto extends AuditInfoDto {
    code: string;
    description: string;
    isActive: boolean;
    sortOrder: number;
    hasBeenUsed: boolean;
}

export interface CertificateTypeCodeInfoForConfigDto extends CodeTableInfoForConfigDto {
    certificateTypeCodeId: number;
    requiredAreaType?: RequiredAreaType | undefined;
    certificateGroupCodeId: number;
    certificateLevelCodeId: number;
    certificateGradeRangeCodeId?: number | undefined;
    duration: number;
    legacyCode?: string | undefined;
    canBeMetByPersonPrepProgram: boolean;
    isTeaching: boolean;
    isOtherTeaching: boolean;
    isOtherProfessional: boolean;
    isAdmin: boolean;
    isPsychologyCounselorSocialWorker: boolean;
    isETC: boolean;
    nativeLanguageGroup?: string | undefined;
    isExtendable: boolean;
    isRenewable: boolean;
    numberOfExtensionsAllowed?: number | undefined;
    numberOfIssuancesAllowedInPeriod?: number | undefined;
    numberOfLifetimeIssuances?: number | undefined;
    expiryMethod: ExpiryMethod;
    publicDescription?: string | undefined;
    canBeAligned: boolean;
    extensionDuration?: number | undefined;
    extensionMethod?: ExtensionMethod | undefined;
    acceptsProfessionalDevelopment: boolean;
    statute?: string | undefined;
}

export enum ExpiryMethod {
    Unknown = 0,
    OnIssuance = 1,
    OnFiscalYear = 2,
    OnVisaExpiration = 3,
    OnDOB = 4,
}

export enum ExtensionMethod {
    OnExtensionDuration = 0,
    OnVisaExpiration = 1,
}

export interface AddOrUpdateCertificateConfigurationCommand {
    certificateTypeCodeId?: number | undefined;
    description?: string | undefined;
    isActive?: boolean | undefined;
    requiredAreaType?: RequiredAreaType | undefined;
    certificateGroupCodeId?: number | undefined;
    certificateLevelCodeId?: number | undefined;
    certificateGradeRangeCodeId?: number | undefined;
    duration?: number | undefined;
    legacyCode?: string | undefined;
    canBeMetByPersonPrepProgram?: boolean | undefined;
    isTeaching?: boolean | undefined;
    isOtherTeaching?: boolean | undefined;
    isOtherProfessional?: boolean | undefined;
    isAdmin?: boolean | undefined;
    isPsychologyCounselorSocialWorker?: boolean | undefined;
    isETC?: boolean | undefined;
    nativeLanguageGroup?: string | undefined;
    isExtendable?: boolean | undefined;
    isRenewable?: boolean | undefined;
    numberOfExtensionsAllowed?: number | undefined;
    numberOfIssuancesAllowedInPeriod?: number | undefined;
    numberOfLifetimeIssuances?: number | undefined;
    expiryMethod?: ExpiryMethod | undefined;
    publicDescription?: string | undefined;
    canBeAligned?: boolean | undefined;
    extensionDuration?: number | undefined;
    extensionMethod?: ExtensionMethod | undefined;
    acceptsProfessionalDevelopment?: boolean | undefined;
    statute?: string | undefined;
}

export interface DeactivateCodeTableCommandBase {
    id: number;
}

export interface DeactivateCertificateCommand extends DeactivateCodeTableCommandBase {
}

export interface GeneralCertificateTypeCodeDetailsDto {
    certificateTypeCodeId: number;
    description?: string | undefined;
    modifiedBy: string;
    modifiedDate: Date;
    requiredAreaType?: RequiredAreaType | undefined;
}

export interface EntityConfigurationRelationshipDto {
    id: number;
    description: string;
    hasRelationship: boolean;
    isActive: boolean;
}

export interface AddNonPrimaryOnlyFlagCommand {
    certificateTypeCodeId: number;
    approvedAreaCodeId: number;
}

export interface RemoveNonPrimaryOnlyFlagCommand {
    certificateTypeCodeId: number;
    approvedAreaCodeId: number;
}

export interface AddCertificateTypeApprovedAreaRelationshipCommand {
    certificateTypeCodeId: number;
    approvedAreaCodeId: number;
}

export interface RemoveCertificateTypeApprovedAreaRelationshipCommand {
    certificateTypeCodeId: number;
    approvedAreaCodeId: number;
}

export interface AddAllCertificateTypeApprovedAreaRelationshipsCommand {
    certificateTypeCodeId: number;
}

export interface RemoveAllCertificateTypeApprovedAreaRelationshipsCommand {
    certificateTypeCodeId: number;
}

export interface AddCertificateTypeEndorsementRelationshipCommand {
    certificateTypeCodeId: number;
    endorsementCodeId: number;
}

export interface AddAllCertificateTypeEndorsementRelationshipsCommand {
    certificateTypeCodeId: number;
}

export interface RemoveAllCertificateTypeEndorsementRelationshipsCommand {
    certificateTypeCodeId: number;
}

export interface RemoveCertificateTypeEndorsementRelationshipCommand {
    certificateTypeCodeId: number;
    endorsementCodeId: number;
}

export interface AllowableDeficiencyCertificateConfigurationDto {
    allowableDeficiencyCertificateConfigurationId: number;
    deficiencyDescription: string;
    areaDescription: string;
    durationInYears?: number | undefined;
}

export interface ExistingAllowableDeficiencyCertificateConfigurationDto {
    allowableDeficiencyCertificateConfigurationId: number;
    allowableDeficiencyCodeId: number;
    certificateTypeCodeId: number;
    approvedAreaCodeId?: number | undefined;
    durationInYears: number;
    explanationVerbiage: string;
    certificateVerbiage?: string | undefined;
}

export interface DefaultValuesForAllowableDeficiencyCertificateConfigurationDto {
    explanationVerbiage?: string | undefined;
    certificateVerbiage?: string | undefined;
}

export interface DeleteAllowableDeficiencyCertificateConfigurationCommand {
    allowableDeficiencyCertificateConfigurationId: number;
}

export interface AddOrUpdateAllowableDeficiencyCertificateConfigurationCommand {
    allowableDeficiencyCertificateConfigurationId?: number | undefined;
    certificateTypeCodeId: number;
    allowableDeficiencyCodeId?: number | undefined;
    approvedAreaCodeId?: number | undefined;
    durationInYears?: number | undefined;
    explanationVerbiage: string;
    certificateVerbiage?: string | undefined;
}

export interface ReactivateCodeTableCommandBase {
    id: number;
}

export interface ReactivateCertificateTypeCodeCommand extends ReactivateCodeTableCommandBase {
}

export interface DeactivateAreaCommand extends DeactivateCodeTableCommandBase {
}

export interface ReactivateApprovedAreaCodeCommand extends ReactivateCodeTableCommandBase {
}

export interface ApprovedAreaCodeInfoForConfigDto extends CodeTableInfoForConfigDto {
    approvedAreaCodeId: number;
    canMaintain: boolean;
    areaType?: AreaType | undefined;
    areaSubType?: AreaSubType | undefined;
    legacyCode?: string | undefined;
    relatedCertificateCodeIds: number[];
}

export enum AreaType {
    Adult = 0,
    Arts = 1,
    CTE = 2,
    EC = 3,
    Elem = 4,
    JROTC = 5,
    MG = 6,
    NA = 7,
    Sec = 8,
    Sped = 9,
}

export enum AreaSubType {
    FgnLang = 0,
    NatLang = 1,
}

export interface AddOrUpdateAreaConfigurationCommand {
    areaCodeId?: number | undefined;
    legacyCode?: string | undefined;
    canMaintain?: boolean | undefined;
    areaType?: AreaType | undefined;
    areaSubType?: AreaSubType | undefined;
    description?: string | undefined;
    relatedCertificateCodeIds?: number[] | undefined;
}

export interface CertificateAreaRelationshipRowDto {
    certificateTypeCodeId: number;
    description: string;
    isActive: boolean;
    hasRelationship: boolean;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
}

export interface UpdateCertificateAreaRelationshipDatesCommand {
    certificateTypeCodeIds: number[];
    approvedAreaCodeIds: number[];
    startDate: Date;
    endDate?: Date | undefined;
}

export interface RemoveCertificateAreaRelationshipsCommand {
    approvedAreaCodeId: number;
    certificateTypeCodeIds: number[];
}

export interface AddCertificateAreaRelationshipsCommand {
    approvedAreaCodeId: number;
    certificateTypeCodeIds: number[];
    startDate: Date;
    endDate?: Date | undefined;
}

export interface AreaRelationshipRowDto {
    approvedAreaCodeId: number;
    description: string;
    isActive: boolean;
    hasRelationship: boolean;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
}

export interface AddCertificateAreaRelationshipsByCertificateCommand {
    certificateTypeCodeId: number;
    approvedAreaCodeIds: number[];
    startDate: Date;
    endDate?: Date | undefined;
}

export interface RemoveCertificateAreaRelationshipsByCertificateCommand {
    certificateTypeCodeId: number;
    approvedAreaCodeIds: number[];
}

export interface DeactivateAllowableDeficiencyCommand extends DeactivateCodeTableCommandBase {
}

export interface ReactivateAllowableDeficiencyCommand extends ReactivateCodeTableCommandBase {
}

export interface AllowableDeficiencyCodeInfoForConfigDto extends CodeTableInfoForConfigDto {
    allowableDeficiencyCodeId: number;
    canBeMetByPersonPrepProgram: boolean;
    expiryBehavior: AllowableDeficiencyExpiryBehavior;
    defaultDurationInYears: number;
    defaultVerbiage?: string | undefined;
    certificateVerbiage?: string | undefined;
    legacyCode?: string | undefined;
}

export enum AllowableDeficiencyExpiryBehavior {
    SuspendedNonDisciplinary = 0,
    Lapses = 1,
}

export interface AddOrUpdateAllowableDeficiencyConfigurationCommand {
    allowableDeficiencyCodeId?: number | undefined;
    code?: string | undefined;
    description?: string | undefined;
    canBeMetByPersonPrepProgram?: boolean | undefined;
    expiryBehavior: AllowableDeficiencyExpiryBehavior;
    defaultDurationInYears?: number | undefined;
    defaultVerbiage?: string | undefined;
    certificateVerbiage?: string | undefined;
    isActive?: boolean | undefined;
    legacyCode?: string | undefined;
}

export interface DeactivateEndorsementCodeCommand extends DeactivateCodeTableCommandBase {
}

export interface ReactivateEndorsementCodeCommand extends ReactivateCodeTableCommandBase {
}

export interface EndorsementCodeInfoForConfigDto extends CodeTableInfoForConfigDto {
    endorsementCodeId: number;
    legacyCode?: string | undefined;
    canMaintain: boolean;
    endorsementGroupCodeId?: number | undefined;
    requiresLanguageCode: boolean;
    relatedCertificateCodeIds: number[];
    endorsementLevelCodes: EndorsementCodeEndorsementLevelContext[];
}

export interface EndorsementCodeEndorsementLevelContext {
    endorsementLevelCodeId: number;
    code?: string | undefined;
    publicDescription?: string | undefined;
}

export interface AddOrUpdateEndorsementCodeCommand {
    endorsementCodeId?: number | undefined;
    code?: string | undefined;
    description?: string | undefined;
    legacyCode?: string | undefined;
    canMaintain: boolean;
    endorsementGroupCodeId?: number | undefined;
    endorsementLevelCodes: EndorsementCodeEndorsementLevelContext[];
    hasBeenUsed?: boolean | undefined;
    isActive: boolean;
    relatedCertificateCodeIds: number[];
}

export interface DeactivatePublicCertificateGroupCodeCommand extends DeactivateCodeTableCommandBase {
}

export interface ReactivatePublicCertificateGroupCodeCommand extends ReactivateCodeTableCommandBase {
}

export interface PublicCertificateGroupCodeInfoForConfigDto extends CodeTableInfoForConfigDto {
    publicCertificateGroupCodeId: number;
    relatedCertificateCodeIds: number[];
}

export interface AddOrUpdatePublicCertificateGroupCodeCommand {
    publicCertificateGroupCodeId?: number | undefined;
    code?: string | undefined;
    description?: string | undefined;
    isActive?: boolean | undefined;
    relatedCertificateCodeIds: number[];
}

export interface DeactivatePublicEndorsementGroupCommand extends DeactivateCodeTableCommandBase {
}

export interface ReactivatePublicEndorsementGroupCodeCommand extends ReactivateCodeTableCommandBase {
}

export interface PublicEndorsementGroupCodeInfoForConfigDto extends CodeTableInfoForConfigDto {
    publicEndorsementGroupCodeId: number;
    relatedEndorsementCodeIds: number[];
}

export interface AddOrUpdatePublicEndorsementGroupCodeCommand {
    publicEndorsementGroupCodeId?: number | undefined;
    description?: string | undefined;
    relatedEndorsementCodeIds: number[];
}

export interface PositionClassificationCodeInfoForConfigDto extends CodeTableInfoForConfigDto {
    positionClassificationCodeId: number;
}

export interface AddOrUpdatePositionClassificationCodeCommand {
    positionClassificationCodeId?: number | undefined;
    code?: string | undefined;
    description?: string | undefined;
    hasBeenUsed: boolean;
}

export interface DeactivatePositionClassificationCodeCommand extends DeactivateCodeTableCommandBase {
}

export interface ReactivatePositionClassificationCodeCommand extends ReactivateCodeTableCommandBase {
}

export interface ContentAreaCodeInfoForConfigDto extends CodeTableInfoForConfigDto {
    contentAreaCodeId: number;
}

export interface AddOrUpdateContentAreaCodeCommand {
    contentAreaCodeId?: number | undefined;
    code?: string | undefined;
    description?: string | undefined;
}

export interface DeactivateContentAreaCodeCommand extends DeactivateCodeTableCommandBase {
}

export interface ReactivateContentAreaCodeCommand extends ReactivateCodeTableCommandBase {
}

export interface RosterRemovalReasonResultDto extends CodeTableConfigurationResultDto {
    title: string;
    isLeaReason: boolean;
    isAssignmentReason: boolean;
}

export interface RosterRemovalReasonInfoForConfigDto extends CodeTableInfoForConfigDto {
    rosterRemovalReasonId: number;
    title: string;
    isLeaReason: boolean;
    isAssignmentReason: boolean;
}

export interface AddOrUpdateRosterRemovalReasonCommand {
    rosterRemovalReasonId?: number | undefined;
    title?: string | undefined;
    description?: string | undefined;
    isLeaReason: boolean;
    isAssignmentReason: boolean;
}

export interface DeactivateRosterRemovalReasonCommand extends DeactivateCodeTableCommandBase {
}

export interface ReactivateRosterRemovalReasonCommand extends ReactivateCodeTableCommandBase {
}

export interface PositionContentAreaConfigurationResultDto {
    id: number;
    classificationDescription: string;
    positionDescription: string;
    contentAreaDescription: string;
    requiresExitReason: boolean;
    isActive: boolean;
    hasBeenUsed: boolean;
    createdDate: Date;
}

export interface PositionContentAreaInfoForConfigDto extends AuditInfoDto {
    positionContentAreaId: number;
    positionClassificationCodeId: number;
    positionCodeId: number;
    contentAreaCodeId: number;
    requiresExitReason: boolean;
    isActive: boolean;
    hasBeenUsed: boolean;
    gradeLevelCodeIds: number[];
}

export interface PositionContentAreaConfigOptionsDto {
    positionClassificationCodes: AdvancedCodeDescriptionDto[];
    positionCodes: PositionCodeOptionDto[];
    contentAreaCodes: AdvancedCodeDescriptionDto[];
    gradeLevelCodes: SimpleCodeDescriptionDto[];
}

export interface AdvancedCodeDescriptionDto extends SimpleCodeDescriptionDto {
    isActive: boolean;
}

export interface PositionCodeOptionDto extends AdvancedCodeDescriptionDto {
    positionClassificationCodeId: number;
}

export interface AddOrUpdatePositionContentAreaCommand {
    positionContentAreaId?: number | undefined;
    positionCodeId?: number | undefined;
    contentAreaCodeId?: number | undefined;
    positionClassificationCodeId?: number | undefined;
    requiresExitReason: boolean;
    hasBeenUsed: boolean;
    gradeLevelCodeIds: number[];
}

export interface DeactivatePositionContentAreaCommand {
    positionContentAreaId: number;
}

export interface ReactivatePositionContentAreaCommand {
    positionContentAreaId: number;
}

export interface PositionCodeResultDto extends CodeTableConfigurationResultDto {
    positionClassificationCodeId: number;
    positionClassificationCode?: PositionClassificationCode | undefined;
    isSpecialEd: boolean;
}

export interface Entity {
    createdBy?: string | undefined;
    createdDate: Date;
    modifiedBy?: string | undefined;
    modifiedDate?: Date | undefined;
    domainEvents: INotification[];
}

export interface CodeTableBase extends Entity {
    code: string;
    description: string;
    isActive: boolean;
    sortOrder: number;
}

export interface PositionClassificationCode extends CodeTableBase {
    positionClassificationCodeId: number;
}

/** Marker interface to represent a notification */
export interface INotification {
}

export interface PositionCodeInfoForConfigDto extends CodeTableInfoForConfigDto {
    positionCodeId: number;
    positionClassificationCodeId: number;
    isSpecialEd: boolean;
}

export interface AddOrUpdatePositionCodeCommand {
    positionCodeId?: number | undefined;
    positionClassificationCodeId: number;
    code?: string | undefined;
    description?: string | undefined;
    hasBeenUsed: boolean;
    isSpecialEd: boolean;
}

export interface DeactivatePositionCodeCommand extends DeactivateCodeTableCommandBase {
}

export interface ReactivatePositionCodeCommand extends ReactivateCodeTableCommandBase {
}

export interface TitleIStatusCodeInfoForConfigDto extends CodeTableInfoForConfigDto {
    titleIStatusCodeId: number;
}

export interface AddOrUpdateTitleIStatusCodeCommand {
    titleIStatusCodeId?: number | undefined;
    code?: string | undefined;
    description?: string | undefined;
    hasBeenUsed: boolean;
}

export interface DeactivateTitleIStatusCodeCommand extends DeactivateCodeTableCommandBase {
}

export interface ReactivateTitleIStatusCodeCommand extends ReactivateCodeTableCommandBase {
}

export interface ModeOfInstructionCodeInfoForConfigDto extends CodeTableInfoForConfigDto {
    modeOfInstructionCodeId: number;
}

export interface AddOrUpdateModeOfInstructionCodeCommand {
    modeOfInstructionCodeId?: number | undefined;
    code?: string | undefined;
    description?: string | undefined;
    hasBeenUsed: boolean;
}

export interface DeactivateModeOfInstructionCodeCommand extends DeactivateCodeTableCommandBase {
}

export interface ReactivateModeOfInstructionCodeCommand extends ReactivateCodeTableCommandBase {
}

export interface PositionStatusCodeInfoForConfigDto extends CodeTableInfoForConfigDto {
    positionStatusCodeId: number;
}

export interface AddOrUpdatePositionStatusCodeCommand {
    positionStatusCodeId?: number | undefined;
    code?: string | undefined;
    description?: string | undefined;
    hasBeenUsed: boolean;
}

export interface DeactivatePositionStatusCodeCommand extends DeactivateCodeTableCommandBase {
}

export interface ReactivatePositionStatusCodeCommand extends ReactivateCodeTableCommandBase {
}

export interface AssignmentStatusCodeInfoForConfigDto extends CodeTableInfoForConfigDto {
    assignmentStatusCodeId: number;
    isOnLeave?: boolean | undefined;
}

export interface AddOrUpdateAssignmentStatusCodeCommand {
    assignmentStatusCodeId?: number | undefined;
    code?: string | undefined;
    description?: string | undefined;
    isOnLeave?: boolean | undefined;
    hasBeenUsed: boolean;
}

export interface DeactivateAssignmentStatusCodeCommand extends DeactivateCodeTableCommandBase {
}

export interface ReactivateAssignmentStatusCodeCommand extends ReactivateCodeTableCommandBase {
}

export interface StatuteResultDto {
    id: number;
    statuteDescription: string;
    statuteType: string;
    createdDate: Date;
    hasBeenUsed: boolean;
}

export interface StatuteInfoForConfigDto extends AuditInfoDto {
    statuteId: number;
    description: string;
    statuteType: StatuteType;
    supportedCertificateTypeCodeIds: number[];
    supportedEndorsementCodeIds: number[];
}

export enum StatuteType {
    AddCertificate = 0,
    AddEndorsement = 1,
    AddArea = 2,
    RenewCertificate = 3,
}

export interface AddOrUpdateStatuteCommand {
    statuteId?: number | undefined;
    statuteType: StatuteType;
    description: string;
    supportedCertificateTypeCodeIds: number[];
    supportedEndorsementCodeIds: number[];
}

export interface StatuteDenialReasonResultDto {
    statuteDenialReasonId: number;
    statuteId: number;
    statuteReferenceCode: string;
    statuteReferenceDescription: string;
}

export interface AddOrUpdateStatuteDenialReasonCommand {
    statuteDenialReasonId?: number | undefined;
    statuteId: number;
    statuteReferenceCode?: string | undefined;
    statuteReferenceDescription?: string | undefined;
}

export interface DeleteStatuteDenialReasonCommand {
    statuteDenialReasonId: number;
}

export interface PreparationProgramResultDto extends CodeTableConfigurationResultDto {
    institutionDescription: string;
}

export interface PreparationProgramInfoForConfigDto extends CodeTableInfoForConfigDto {
    preparationProgramId?: number | undefined;
    professionalPreparationInstitutionId?: number | undefined;
    programPathCodeIds: number[];
    titleIIId?: string | undefined;
    titleIIType?: string | undefined;
    effectiveDate: Date;
    endDate?: Date | undefined;
}

export interface AddOrUpdatePreparationProgramCommand {
    preparationProgramId?: number | undefined;
    professionalPreparationInstitutionId?: number | undefined;
    programPathCodeIds: number[];
    titleIIId?: string | undefined;
    titleIIType?: string | undefined;
    effectiveDate: Date;
    endDate?: Date | undefined;
    description?: string | undefined;
    hasBeenUsed: boolean;
    code?: string | undefined;
}

export interface DeactivatePreparationProgramCommand extends DeactivateCodeTableCommandBase {
}

export interface ReactivatePreparationProgramCommand extends ReactivateCodeTableCommandBase {
}

export interface PreparationProgramCertificateResultDto {
    preparationProgramId: number;
    preparationProgramCertificateTypeCodeId: number;
    certificateTypeCodeId: number;
    certificateDescription: string;
    relatedAreasCount: number;
    relatedEndorsementsCount: number;
    relatedDeficienciesCount: number;
}

export interface DeletePreparationProgramCertificateCommand {
    preparationProgramCertificateTypeCodeId: number;
}

export interface PreparationProgramCertificateOptions {
    approvedAreaOptions: SimpleCodeDescriptionDto[];
    endorsementOptions: SimpleCodeDescriptionDto[];
    allowableDeficiencyOptions: SimpleCodeDescriptionDto[];
}

export interface PreparationProgramCertificateInfoForConfigDto {
    preparationProgramCertificateTypeCodeId: number;
    certificateTypeCodeId: number;
    preparationProgramId: number;
}

export interface AddOrUpdatePreparationProgramCertificateCommand {
    preparationProgramCertificateTypeCodeId?: number | undefined;
    preparationProgramId: number;
    certificateTypeCodeId: number;
}

export interface AddPreparationProgramCertificateAreaRelationshipCommand {
    preparationProgramCertificateTypeCodeId: number;
    approvedAreaCodeId: number;
}

export interface AddPreparationProgramCertificateEndorsementRelationshipCommand {
    preparationProgramCertificateTypeCodeId: number;
    endorsementCodeId: number;
}

export interface AddPreparationProgramCertificateDeficiencyRelationshipCommand {
    preparationProgramCertificateTypeCodeId: number;
    allowableDeficiencyCodeId: number;
}

export interface RemovePreparationProgramCertificateAreaRelationshipCommand {
    preparationProgramCertificateTypeCodeId: number;
    approvedAreaCodeId: number;
}

export interface RemovePreparationProgramCertificateEndorsementRelationshipCommand {
    preparationProgramCertificateTypeCodeId: number;
    endorsementCodeId: number;
}

export interface RemovePreparationProgramCertificateDeficiencyRelationshipCommand {
    preparationProgramCertificateTypeCodeId: number;
    allowableDeficiencyCodeId: number;
}

export interface ProfessionalPreparationInstitutionResultDto extends CodeTableConfigurationResultDto {
    edOrgId?: string | undefined;
    type: string;
}

export interface ProfessionalPreparationInstitutionInfoForConfigDto extends CodeTableInfoForConfigDto {
    professionalPreparationInstitutionId: number;
    type: ProfessionalPreparationInstitutionType;
    edOrgId?: string | undefined;
    isOutOfState: boolean;
    allowsATA: boolean;
}

export interface AddOrUpdateProfessionalPreparationInstitutionCommand {
    professionalPreparationInstitutionId?: number | undefined;
    description?: string | undefined;
    edOrgId?: string | undefined;
    edOrgIdAsInt?: number | undefined;
    type?: ProfessionalPreparationInstitutionType | undefined;
    isOutOfState?: boolean | undefined;
    allowsATA?: boolean | undefined;
    code?: string | undefined;
    hasBeenUsed?: boolean | undefined;
}

export interface DeactivateProfessionalPreparationInstitutionCommand extends DeactivateCodeTableCommandBase {
}

export interface ReactivateProfessionalPreparationInstitutionCommand extends ReactivateCodeTableCommandBase {
}

export interface DeactivateEndorsementGroupCodeCommand extends DeactivateCodeTableCommandBase {
}

export interface ReactivateEndorsementGroupCodeCommand extends ReactivateCodeTableCommandBase {
}

export interface EndorsementGroupCodeInfoForConfigDto extends CodeTableInfoForConfigDto {
    endorsementGroupCodeId: number;
}

export interface AddOrUpdateEndorsementGroupCodeCommand {
    endorsementGroupCodeId?: number | undefined;
    code?: string | undefined;
    description?: string | undefined;
}

export interface DeactivateCertificateGroupCodeCommand extends DeactivateCodeTableCommandBase {
}

export interface ReactivateCertificateGroupCodeCommand extends ReactivateCodeTableCommandBase {
}

export interface CertificateGroupCodeInfoForConfigDto extends CodeTableInfoForConfigDto {
    certificateGroupCodeId: number;
}

export interface AddOrUpdateCertificateGroupCodeCommand {
    certificateGroupCodeId?: number | undefined;
    code?: string | undefined;
    description?: string | undefined;
}

export interface LeaFeatureSubscriptionResultDto {
    leaFeatureDescriptionType: LeaFeatureSubscriptionType;
    leaFeatureDescriptionTypeDescription: string;
    currentSubscriptionCount: number;
}

export enum LeaFeatureSubscriptionType {
    EducatorPortalProfessionalDevelopmentSubmission = 0,
}

export interface LeaFeatureSubscriptionInfoForConfigDto {
    leaFeatureDescriptionType: LeaFeatureSubscriptionType;
    leaFeatureDescriptionTypeDescription: string;
    leaCodeIdsWithSubscription: number[];
}

export interface AddLeaFeatureSubscriptionCommand {
    leaCodeId: number;
    leaFeatureDescriptionType: LeaFeatureSubscriptionType;
}

export interface RemoveLeaFeatureSubscriptionCommand {
    leaCodeId: number;
    leaFeatureDescriptionType: LeaFeatureSubscriptionType;
}

export interface AddAllLeaFeatureSubscriptionsCommand {
    leaFeatureDescriptionType: LeaFeatureSubscriptionType;
}

export interface RemoveAllLeaFeatureSubscriptionsCommand {
    leaFeatureDescriptionType: LeaFeatureSubscriptionType;
}

export interface MatchedNasdtecEntryListDto {
    matchedNasdtecResults: MatchedNasdtecEntryViewDto[];
    totalResults: number;
}

export interface MatchedNasdtecEntryViewDto {
    nasdtecEntryId: number;
    matchDate: Date;
    state?: string | undefined;
    strategy: MatchingStrategy;
    nasdtecId?: string | undefined;
    ein: string;
    nasdtecUrl: string;
    lastName?: string | undefined;
    firstName?: string | undefined;
    personId?: number | undefined;
    dateOfBirth: Date;
    lea?: string | undefined;
    fingerprintCardStatus?: string | undefined;
    openApplicationsCount: number;
    certificateCount: number;
    iuProcessingStatus: NasdtecIUProcessingStatus;
    isInOOSDiscipline: boolean;
}

export enum MatchingStrategy {
    SSN = 0,
    LastFirstDOB = 1,
    LastDOB = 2,
}

export enum NasdtecIUProcessingStatus {
    Unknown = 0,
    New = 1,
    ReportRequested = 2,
    PendingReview = 3,
    OpenAndAssignCase = 4,
    Close = 5,
    Mismatch = 6,
    Duplicate = 7,
    Legacy = 8,
}

export interface AgGridQueryModelOfMatchedNasdtecEntryListDto extends AgGridQueryModelBase {
}

export interface GetMatchedNasdtecEntriesQuery extends AgGridQueryModelOfMatchedNasdtecEntryListDto {
}

export interface PersonDisciplineDto {
    personDisciplineId: number;
    personId: number;
    nasdtecEntryId?: number | undefined;
    jurisdictionState?: string | undefined;
    jurisdictionStateId: number;
    disciplineType: string;
    disciplineTypeId: number;
    inStateActionType?: string | undefined;
    inStateActionTypeCodeId?: number | undefined;
    outOfStateActionType?: string | undefined;
    outOfStateActionTypeCodeId?: number | undefined;
    note?: string | undefined;
    disciplineDate?: Date | undefined;
    disciplineEndDate?: Date | undefined;
    hasConditions: boolean;
    areConditionsMet?: boolean | undefined;
    isInState: boolean;
    modifiedBy?: string | undefined;
    modifiedDate?: Date | undefined;
    isManual: boolean;
    isNasdtec: boolean;
}

export interface UpdateMatchedNasdtecEntryCommand {
    nasdtecEntryId: number;
    iuProcessingStatus: NasdtecIUProcessingStatus;
}

export interface AddOrUpdatePersonDisciplineCommand {
    personDisciplineId: number;
    personId: number;
    nasdtecEntryId?: number | undefined;
    disciplineType: DisciplineType;
    jurisdictionStateCodeId: number;
    disciplineDate: Date;
    inStateActionTypeCodeId?: number | undefined;
    outOfStateActionTypeCodeId?: number | undefined;
    hasConditions: boolean;
    areConditionsMet?: boolean | undefined;
    note?: string | undefined;
    disciplineEndDate?: Date | undefined;
}

export enum DisciplineType {
    Nasdtec = 0,
    Manual = 1,
    Legacy = 2,
    CaseIq = 3,
}

export interface DeletePersonDisciplineCommand {
    personDisciplineId: number;
}

export interface ProblematicFingerprintCardListDto {
    problematicFingerprintCardResults: ProblematicFingerprintCardDto[];
    totalResults: number;
}

export interface ProblematicFingerprintCardBaseDto {
    dpsFingerprintFeedRecordId: number;
    isCurrentlyEmployed: boolean;
    personId?: number | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    ein?: string | undefined;
    sex?: string | undefined;
    fullDateOfBirth?: Date | undefined;
    cardNumber?: string | undefined;
    dpsApplicationNumber?: string | undefined;
    fingerprintCardStatus: string;
    isCurrentlyCertified: boolean;
    hasOpenApplication: boolean;
}

export interface ProblematicFingerprintCardDto extends ProblematicFingerprintCardBaseDto {
    dateOfBirth?: Date | undefined;
    iuProcessingStatus: FingerprintIUProcessingStatus;
}

export enum FingerprintIUProcessingStatus {
    Unknown = 0,
    New = 1,
    ReportRequested = 2,
    PendingReview = 3,
    OpenAndAssignCase = 4,
    Close = 5,
    Mismatch = 6,
    Duplicate = 7,
}

export interface AgGridQueryModelOfProblematicFingerprintCardListDto extends AgGridQueryModelBase {
}

export interface GetProblematicFingerprintCardsQuery extends AgGridQueryModelOfProblematicFingerprintCardListDto {
}

export interface UpdateProblematicFingerprintCardRecordCommand {
    dpsFingerprintFeedRecordId: number;
    iuProcessingStatus: FingerprintIUProcessingStatus;
}

export interface ProcessCaseIQCaseClosuresCommand {
    caseIds: string[];
}

export interface CaseIQAutomationReportView {
    personId: number;
    ein?: string | undefined;
    caseId: string;
    caseType?: string | undefined;
    disposition?: string | undefined;
    subDisposition?: string | undefined;
    caseClosed: boolean;
    caseClosureProcessed: boolean;
    automationSuccessful?: string | undefined;
    hasActiveCert?: string | undefined;
    alertsAdded?: number | undefined;
    underInvestigationRemoved?: number | undefined;
    disciplineAdded?: number | undefined;
    issuedOrDeniedServices?: number | undefined;
    caseReplicationModifiedDate?: Date | undefined;
    caseReplicationCreatedBy?: string | undefined;
}

export interface ManuallyCompleteInvestigativeReviewCommand {
    applicationServiceItemId: number;
    iuResponse?: IUResponse | undefined;
}

export enum IUResponse {
    IUOkay = 0,
    SBEApproved = 1,
    SBEDenied = 2,
    AdministrativelyIncomplete = 3,
    SubstantivelyIncomplete = 4,
    WithdrawnApplicant = 5,
}

export interface PersonPPIRecommendationDto {
    personPPIRecommendationId: number;
    isOutOfCountry: boolean;
    outOfStateLocation?: string | undefined;
    stateCodeId?: number | undefined;
    stateDescription?: string | undefined;
    professionalPreparationInstitutionId?: number | undefined;
    ppiDescription?: string | undefined;
    accreditedInstitutionCodeId?: number | undefined;
    accreditedInstitutionCodeDescription?: string | undefined;
    completionDate: Date;
    irIssueDate?: Date | undefined;
    createdBy?: string | undefined;
    createdDate: Date;
    modifiedBy?: string | undefined;
    modifiedDate?: Date | undefined;
    specialProgramType?: SpecialProgramType | undefined;
    specialProgramTypeDescription?: string | undefined;
    isExpired: boolean;
    hasSatisfactoryProgress?: boolean | undefined;
    programPathCodeId?: number | undefined;
    programPathDescription?: string | undefined;
    recommendationStatus: RecommendationStatus;
    degreeInformation?: RecommendedDegreeDto | undefined;
    recommendedAllowableDeficiencies?: RecommendedAllowableDeficienciesDto[] | undefined;
    personPPIRecommendationCertificates: PersonPPIRecommendationCertificatesDto[];
}

export enum SpecialProgramType {
    None = 0,
    ATA = 1,
}

export enum RecommendationStatus {
    Valid = 0,
    Expired = 1,
    Used = 2,
}

export interface RecommendedDegreeDto {
    awardingDegreeLevel?: string | undefined;
    awardingDegreeType?: string | undefined;
    awardingDegreeMajorOrCertificate?: string | undefined;
    awardingDegreeAwardDate?: Date | undefined;
    verifiedDegreeInstitution?: string | undefined;
    verifiedDegreeLevel?: string | undefined;
    verifiedDegreeType?: string | undefined;
    verifiedDegreeMajorOrCertificate?: string | undefined;
    verifiedDegreeAwardDate?: Date | undefined;
}

export interface RecommendedAllowableDeficienciesDto {
    allowableDeficiencyCodeId: number;
    courseNumber?: string | undefined;
    deficiencyDescription?: string | undefined;
    certificateTypeDescription?: string | undefined;
}

export interface PersonPPIRecommendationCertificatesDto {
    personPPIRecommendationCertificateId: number;
    personPPIRecommendationId: number;
    certificateTypeCodeId: number;
    requiredAreaType?: RequiredAreaType | undefined;
    certificateTypeDescription: string;
    areaCodeId?: number | undefined;
    areaCodeDescription?: string | undefined;
    personPPIRecommendationCertificateEndorsements?: PersonPPIRecommendationCertificateEndorsementDto[] | undefined;
    personPPIRecommendationCertificateAllowableMetDeficiencies?: PersonPPIRecommendationCertificateMetAllowableDeficiencyDto[] | undefined;
    isEditable: boolean;
}

export interface PersonPPIRecommendationCertificateEndorsementDto {
    endorsementCodeId: number;
    endorsementDescription: string;
    languageCodeId?: number | undefined;
    languageCodeDescription?: string | undefined;
    requiresLanguageCode: boolean;
}

export interface PersonPPIRecommendationCertificateMetAllowableDeficiencyDto {
    personPreparationProgramAllowableMetDeficiencyId: number;
    personPPIRecommendedCertificateId: number;
    allowableDeficiencyCodeId: number;
    description: string;
}

export interface ApprovedAreasEndorsementsDeficienciesDto {
    approvedEndorsementCodes: PreparationEndorsementCodeDto[];
    approvedAreaCodes: PreparationApprovedAreaCodeDto[];
    approvedAllowableDeficiencies: PreparationAllowableDeficiencyDto[];
}

export interface PreparationEndorsementCodeDto {
    endorsementCodeId: number;
    endorsementCode: string;
    endorsementDescription: string;
    requiresLanguageCode: boolean;
}

export interface PreparationApprovedAreaCodeDto {
    approvedAreaCodeId: number;
    areaCode: string;
    areaDescription: string;
}

export interface PreparationAllowableDeficiencyDto {
    allowableDeficiencyCodeId: number;
    allowableDeficiencyCode: string;
    allowableDeficiencyDescription: string;
}

export interface OutOfStateApprovedAreasAndDeficienciesDto {
    approvedAreaCodes: PreparationApprovedAreaCodeDto[];
    allowableDeficiencyCodes: PreparationAllowableDeficiencyDto[];
}

export interface AddOrUpdatePersonPPIRecommendationsCommand {
    personPPIRecommendationId?: number | undefined;
    personId: number;
    professionalPreparationInstitutionId?: number | undefined;
    accreditedInstitutionCodeId?: number | undefined;
    stateCodeId?: number | undefined;
    isOutOfCountry?: boolean | undefined;
    outOfStateLocation?: string | undefined;
    completionDate?: Date | undefined;
    irIssueDate?: Date | undefined;
    specialProgramType: SpecialProgramType;
    programPathCodeId?: number | undefined;
    personPPIRecommendationCertificates: IncomingPPPRecommendationCertificateDto[];
}

export interface IncomingPPPRecommendationCertificateDto {
    personPPIRecommendationCertificateId?: number | undefined;
    personPPIRecommendationId?: number | undefined;
    certificateTypeCodeId?: number | undefined;
    areaCodeId?: number | undefined;
    requiredAreaType?: RequiredAreaType | undefined;
    allowableDeficiencyCodeIds: number[];
    endorsementRecommendations: PersonPPIRecommendationCertificateEndorsementDto[];
}

export interface DeletePersonPPIRecommendationCommand {
    personPreparationProgramId: number;
}

export interface EdPortalPreviewServiceItemEvaluationDto {
    applicationServiceItemEvaluationId?: number | undefined;
    applicationServiceItemId: number;
    serviceItemItemDescription: string;
    applicationId: number;
    evaluationId: number;
    evaluationDescription: string;
    serviceCodeDescription: string;
    applicationCreatedDate: Date;
    modifiedDate: Date;
    isStatusBeyondAdministrative: boolean;
    serviceStatus: ServiceStatus;
    serviceStatusDescription: string;
    daysInCurrentStatus: number;
    isStatusFinalized: boolean;
    explanation?: string | undefined;
    helperText?: string | undefined;
    evaluationCompletedPercent?: number | undefined;
    multipleEvaluationsExist: boolean;
    clientServiceItemEvaluationRequirements: EdPortalPreviewServiceItemEvalRequirementDto[];
}

export enum ServiceStatus {
    Building = 0,
    Received = 1,
    AdministrativeReview = 2,
    AdministrativeIncomplete = 3,
    SubstantiveReview = 4,
    SubstantiveIncomplete = 5,
    FinalSIReview = 6,
    InvestigativeReviewPending = 7,
    InvestigativeReview = 8,
    Qualified = 9,
    SIReturned = 10,
    Appealed = 11,
    Issued = 12,
    AdministrativelyWithdrawn = 13,
    Denied = 14,
    Holding = 15,
    ReturnedIncomplete = 16,
    Cancelled = 17,
    Closed = 18,
}

export interface EdPortalPreviewServiceItemEvalRequirementDto {
    applicationServiceItemEvaluationRequirementId?: number | undefined;
    requirementId: number;
    title?: string | undefined;
    requirementType: RequirementType;
    order: number;
    clientSubRequirements: EdPortalPreviewServiceItemEvaluationSubRequirementDto[];
    clientSubRequirementGroups: EdPortalPreviewServiceItemEvaluationSubRequirementGroupDto[];
    hasAllowableDeficiency: boolean;
    isSatisfied: boolean;
    requirementIncompleteReasonId?: number | undefined;
    requirementIncompleteReasonDescription?: string | undefined;
    modifiedDate: Date;
    evaluationDetails?: string | undefined;
    helperText?: string | undefined;
    explanation?: string | undefined;
    customIncompleteReason?: string | undefined;
}

export interface EdPortalPreviewServiceItemEvaluationSubRequirementDto {
    applicationServiceItemEvaluationSubRequirementId?: number | undefined;
    subRequirementId: number;
    title?: string | undefined;
    order: number;
    parentRequirementId?: number | undefined;
    parentSubRequirementGroupId?: number | undefined;
    isSatisfied: boolean;
    hasAllowableDeficiency: boolean;
    subRequirementIncompleteReasonId?: number | undefined;
    subRequirementIncompleteReasonDescription?: string | undefined;
    evaluationDetails?: string | undefined;
    modifiedDate: Date;
    helperText?: string | undefined;
    explanation?: string | undefined;
    customIncompleteReason?: string | undefined;
}

export interface EdPortalPreviewServiceItemEvaluationSubRequirementGroupDto {
    subRequirementGroupId: number;
    description?: string | undefined;
    order: number;
    subRequirementGroupType: SubRequirementGroupType;
    parentRequirementId?: number | undefined;
    parentSubRequirementGroupId?: number | undefined;
    selectedSubRequirementId?: number | undefined;
    isSatisfied: boolean;
    clientSubRequirements: EdPortalPreviewServiceItemEvaluationSubRequirementDto[];
    clientSubRequirementGroups: EdPortalPreviewServiceItemEvaluationSubRequirementGroupDto[];
}

export interface CreatePersonsCommand {
    ssn: string;
    dateOfBirth?: Date | undefined;
    firstName: string;
    middleName?: string | undefined;
    lastName: string;
    generateSSN: boolean;
    genderCodeId?: number | undefined;
    ethnicityCodeId?: number | undefined;
    raceCodeIds: number[];
}

export interface CheckExistingEducatorQuery {
    lastName?: string | undefined;
    dateOfBirth?: Date | undefined;
}

export interface EducatorHeaderDto {
    personId: number;
    lastName: string;
    firstName: string;
    middleInitial?: string | undefined;
    ein?: string | undefined;
    adeLoginId?: string | undefined;
    lastLoginDate?: string | undefined;
    validityStatus?: string | undefined;
    potentialMismatchedFingerprintAssociation?: PotentialMismatchedDpsFingerprintAssociationDto | undefined;
    pendingIVPCardExists: boolean;
    hasUnacknowledgedFingerprintReceived: boolean;
    lastADELoginDisplay?: string | undefined;
    alerts: PersonAlertDto[];
    specialPrograms: EducatorSpecialProgramResultDto[];
    overallPdState: ProfessionalDevelopmentRequirementState;
    currentEmploymentInfo?: HeaderEmploymentInfo | undefined;
    duplicateEducators: DuplicateEducatorHeaderDto[];
    isPrimaryDuplicateEducator: boolean;
    mergedEins: string[];
    educatorStakeholderId?: string | undefined;
    adeConnectAccount?: string | undefined;
}

export interface PotentialMismatchedDpsFingerprintAssociationDto {
    ssnMismatch: boolean;
    dobMismatch: boolean;
    firstNameMismatch: boolean;
    lastNameMismatch: boolean;
    middleInitialMismatch: boolean;
}

export interface PersonAlertDto {
    personAlertId: number;
    display: string;
    canManuallyRemoveAlert: boolean;
    canManuallyAddAlert: boolean;
    code: string;
    hasDetails: boolean;
}

export interface EducatorSpecialProgramResultDto {
    personSpecialProgramId: number;
    personId: number;
    specialProgramCodeId?: number | undefined;
    specialProgramCodeDescription?: string | undefined;
    specialProgramDescription?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    createdDate: Date;
    createdBy?: string | undefined;
    modifiedDate?: Date | undefined;
    modifiedBy?: string | undefined;
}

export interface HeaderEmploymentInfo {
    lea: string;
    school?: string | undefined;
}

export interface DuplicateEducatorHeaderDto {
    personId: number;
    isPrimary: boolean;
}

export interface EducatorDemographicsDto {
    personId: number;
    firstName: string;
    middleName?: string | undefined;
    lastName: string;
    ssn: string;
    dateOfBirth?: Date | undefined;
    genderCodeId?: number | undefined;
    ethnicityCodeId?: number | undefined;
    raceCodesIds: number[];
    alternateNames: string[];
    isMissingDemographicData: boolean;
    modifiedBy?: string | undefined;
    modifiedDate?: Date | undefined;
}

export interface UpdateDemographicsCommand {
    personId: number;
    firstName: string;
    middleName?: string | undefined;
    lastName: string;
    dateOfBirth?: Date | undefined;
    genderCodeId?: number | undefined;
    ethnicityCodeId?: number | undefined;
    raceCodesIds: number[];
    ssn: string;
}

export interface PersonAddressDto {
    personAddressId: number;
    line1: string;
    line2?: string | undefined;
    city?: string | undefined;
    stateCode?: string | undefined;
    stateCodeId?: number | undefined;
    cityStateProvince?: string | undefined;
    zipCode: string;
    zipPlusFourCode?: string | undefined;
    isOutOfCountry: boolean;
    country?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedDate?: Date | undefined;
}

export interface PersonPhoneDto {
    personPhoneNumberId: number;
    phoneCodeId: number;
    description: string;
    phoneNumber: string;
    isMobile: boolean;
    isActive: boolean;
}

export interface PersonEmailDto {
    personEmailId: number;
    emailCodeId: number;
    description: string;
    email: string;
}

export interface AddOrUpdatePersonsAddressCommand {
    personAddressId?: number | undefined;
    personId: number;
    line1: string;
    line2?: string | undefined;
    outOfCountry?: boolean | undefined;
    city?: string | undefined;
    stateCodeId?: number | undefined;
    cityStateProvince?: string | undefined;
    country?: string | undefined;
    zipCode: string;
    zipPlusFourOption?: string | undefined;
}

export interface AddOrUpdatePersonsPhoneCommand {
    personPhoneNumberId?: number | undefined;
    personId: number;
    phoneCodeId?: number | undefined;
    number?: string | undefined;
    isMobile?: boolean | undefined;
}

export interface DeletePersonsPhoneCommand {
    personPhoneNumberId: number;
}

export interface AddOrUpdatePersonsEmailCommand {
    personEmailId?: number | undefined;
    personId: number;
    emailCodeId?: number | undefined;
    email?: string | undefined;
}

export interface DeletePersonsEmailCommand {
    personEmailId: number;
}

export interface EducatorTestsResultList {
    educatorTestsResults?: EducatorTestsResultDto[] | undefined;
}

export interface EducatorTestsResultDto {
    personTestId: number;
    testCode?: string | undefined;
    testCodeId?: number | undefined;
    testDescription?: string | undefined;
    testDate: Date;
    totalScaledScore?: number | undefined;
    status: TestStatus;
    stateCode?: string | undefined;
    stateDescription?: string | undefined;
    stateCodeId: number;
    isTestFeedRecord: boolean;
    modifiedDate?: Date | undefined;
    modifiedBy?: string | undefined;
    isNew: boolean;
}

export enum TestStatus {
    Passed = 0,
    Failed = 1,
    Taken = 2,
    Incomplete = 3,
}

export interface AddUpdatePersonTestsCommand {
    personTestId?: number | undefined;
    personId: number;
    stateCodeId?: number | undefined;
    testDate?: Date | undefined;
    testCodeId?: number | undefined;
    testCodeDescription?: string | undefined;
    scaledScore?: number | undefined;
    status?: TestStatus | undefined;
}

export interface DeletePersonTestsCommand {
    personTestId?: number | undefined;
}

export interface EducatorDegreeResultList {
    educatorDegreeResults?: EducatorDegreeResultDto[] | undefined;
}

export interface EducatorDegreeResultDto {
    personDegreeId: number;
    personId: number;
    degreeCodeId?: number | undefined;
    degreeDescription?: string | undefined;
    degreeTypeCodeId?: number | undefined;
    degreeTypeDescription?: string | undefined;
    majorCodeId?: number | undefined;
    majorDescription?: string | undefined;
    institutionCodeId?: number | undefined;
    institutionDescription?: string | undefined;
    stateCodeId?: number | undefined;
    stateCode?: string | undefined;
    isOutOfCountry: boolean;
    isHigherEd: boolean;
    awardDate: Date;
    createdDate: Date;
    createdBy?: string | undefined;
    modifiedDate?: Date | undefined;
    modifiedBy?: string | undefined;
}

export interface AddUpdatePersonDegreesCommand {
    personDegreeId?: number | undefined;
    personId: number;
    degreeCodeId?: number | undefined;
    degreeTypeCodeId?: number | undefined;
    majorCodeId?: number | undefined;
    institutionCodeId?: number | undefined;
    stateCodeId?: number | undefined;
    isOutOfCountry?: boolean | undefined;
    isHigherEd: boolean;
    awardDate?: Date | undefined;
}

export interface DeletePersonDegreeCommand {
    personDegreeId: number;
}

export interface EducatorApplicationDto {
    applicationId: number;
    personId: number;
    applicationStatus?: string | undefined;
    deliveryMethodDescription?: string | undefined;
    numberCompletedAppServiceItems: number;
    servicesRemaining: number;
    totalServices: number;
    canBeDeleted: boolean;
    createdDate: Date;
    createdBy?: string | undefined;
    modifiedDate?: Date | undefined;
    modifiedBy?: string | undefined;
    legacyReceiptNumber?: string | undefined;
    services?: ApplicationService[] | undefined;
}

export interface ApplicationService {
    applicationServiceItemId: number;
    serviceCodeDescription: string;
    serviceCode: string;
    itemDescription?: string | undefined;
    itemSubDescription?: string | undefined;
    status: string;
    statusEnum: ServiceStatus;
    hasActiveCancellationRequest: boolean;
    iuResponse?: string | undefined;
    isOnHold: boolean;
    holdingAge: number;
    isIssued: boolean;
    serviceItemCancellationRequestId?: number | undefined;
    isAlignmentRenewal: boolean;
    isRootRenewal: boolean;
}

export interface DeleteEducatorApplicationCommand {
    applicationId: number;
}

export interface AddManualFingerprintCardCommand {
    personId: number;
    arn?: string | undefined;
    appNum?: string | undefined;
    fingerprintCardStatusCodeId: number;
}

export interface EducatorFingerprintHistoryDto {
    fingerprintId: number;
    createDate?: Date | undefined;
    fingerprintCardStatusCodeId?: number | undefined;
    fingerprintCardStatusCodeDescription?: string | undefined;
    cardType?: FingerprintCardType | undefined;
    cardTypeDescription?: string | undefined;
    dateApplied?: Date | undefined;
    dateReceived?: Date | undefined;
    dateCompleted?: Date | undefined;
    expiredDate?: Date | undefined;
    modifiedBy?: string | undefined;
    modifiedDate?: Date | undefined;
}

export enum FingerprintCardType {
    DPS = 0,
    Manual = 1,
    CER = 2,
}

export interface DeleteManualFingerprintCardCommand {
    manualFingerprintId: number;
}

export interface DeleteDpsFeedFingerprintCardCommand {
    dpsFingerprintFeedRecordId: number;
}

export interface PersonFingerprintCardViewInformationDto {
    activeFingerprintCard?: FingerprintCardViewDto | undefined;
    potentialMismatchedFingerprintAssociation?: PotentialMismatchedDpsFingerprintAssociationDto | undefined;
}

export interface FingerprintCardViewDto {
    dpsFingerprintFeedRecordId?: number | undefined;
    personId?: number | undefined;
    governmentId?: string | undefined;
    lastName?: string | undefined;
    firstName?: string | undefined;
    middleInitial?: string | undefined;
    birthDate?: Date | undefined;
    sex?: string | undefined;
    arn?: string | undefined;
    appNum?: string | undefined;
    cardStatus?: string | undefined;
    validityStatus?: string | undefined;
    cardType?: string | undefined;
    atDateApplied?: Date | undefined;
    atDateCompleted?: Date | undefined;
    atDateReceived?: Date | undefined;
    expiredDate?: Date | undefined;
    orIssueDate?: Date | undefined;
    modifiedBy?: string | undefined;
    modifiedDate?: Date | undefined;
    isManual: boolean;
    ssn?: string | undefined;
    ethnicity?: string | undefined;
}

export interface DeleteConditionalEarlyReleaseCommand {
    personCerId: number;
}

export interface AddUpdateConditionalEarlyReleaseCommand {
    personCerId?: number | undefined;
    personId: number;
    leaCodeId: number;
    applicationNumber?: string | undefined;
    applicationDate: Date;
    certificateTypeCodeId: number;
}

export interface ConditionalEarlyReleaseDto {
    personCerId: number;
    personId: number;
    leaCodeId: number;
    leaCodeDescription: string;
    applicationNumber: string;
    applicationDate: Date;
    certificateTypeCodeId: number;
    certificateTypeCodeDescription: string;
    modifiedBy?: string | undefined;
    modifiedDate?: Date | undefined;
}

export interface ConditionalEarlyReleaseListItemDto {
    personCerId: number;
    leaCodeDescription?: string | undefined;
    certificateTypeCodeDescription?: string | undefined;
    applicationNumber?: string | undefined;
    applicationDate: Date;
    modifiedDate?: Date | undefined;
    modifiedBy?: string | undefined;
}

export interface EducatorAuditItemsDto {
    educatorNotes: EducatorNoteDto[];
    educatorAlerts: EducatorAlertDto[];
    educatorSystemEvents: EducatorSystemEventDto[];
}

export interface EducatorNoteDto {
    personNoteId: number;
    personId: number;
    content: string;
    contactTypeCodeId?: number | undefined;
    contactTypeCode?: string | undefined;
    sortDate: Date;
    createdBy: string;
    itemType: string;
}

export interface EducatorAlertDto {
    personAlertId: number;
    description: string;
    sortDate: Date;
    isActive: boolean;
    modifiedBy?: string | undefined;
    isAdd: boolean;
    itemType: string;
}

export interface EducatorSystemEventDto {
    personSystemEventId: number;
    eventDescription: string;
    sortDate: Date;
    itemType: string;
    createdBy: string;
}

export interface AddOrUpdateEducatorNoteCommand {
    personNoteId?: number | undefined;
    personId: number;
    content: string;
    contactTypeCodeId?: number | undefined;
    dateAndTime?: Date | undefined;
}

export interface DeleteEducatorNoteCommand {
    personNoteId: number;
}

export interface AddOrUpdateEducatorDocumentCommand {
    personDocumentId: number;
    personId: number;
    applicationId?: number | undefined;
    documentCodeIds: number[];
    documentDescription: string;
    content?: string | undefined;
    reviewStatus: ReviewStatus;
}

export enum ReviewStatus {
    Reviewed = 0,
    PendingReview = 1,
    Rejected = 2,
}

export interface RepairRemoteDocumentLinkCommand {
    personDocumentId: number;
}

export interface EducatorDocumentDto {
    personDocumentId: number;
    personId: number;
    documentCodes: DocumentCodeDto[];
    description?: string | undefined;
    fileName?: string | undefined;
    isUploadedToRemoteStorage: boolean;
    createdDate: Date;
    createdBy?: string | undefined;
    modifiedDate?: Date | undefined;
    modifiedBy?: string | undefined;
    reviewStatus: ReviewStatus;
    reviewStatusDescription?: string | undefined;
    isNew: boolean;
    canBeDeleted: boolean;
}

export interface EducatorCertificateDto {
    personCertificateId: number;
    personId: number;
    description: string;
    status: string;
    certificateStatusCodeId: number;
    statusCode: string;
    issueDate: Date;
    expireDate: Date;
    originalExpireDate: Date;
    hasCertificateDetails: boolean;
    restrictedApprovedAreaDescription?: string | undefined;
    leaCodeId?: number | undefined;
    leaDescription?: string | undefined;
    showLeaInput: boolean;
    professionalPreparationInstitutionId?: number | undefined;
    ppiDescription?: string | undefined;
    showPpiInput: boolean;
    allowableDeficiencies: PersonCertificateAllowableDeficiencyDisplayDto[];
    pdRequirementState: ProfessionalDevelopmentRequirementState;
    isRelatedToAnIR: boolean;
}

export interface PersonCertificateAllowableDeficiencyDisplayDto {
    description: string;
    startDate: Date;
    endDate: Date;
    hasExpired: boolean;
}

export interface EducatorApprovedAreaDto {
    personAreaId: number;
    areaName: string;
    dateAdded: Date;
    lapseDate?: Date | undefined;
    appliesTo: string[];
    isRelatedToAnIR: boolean;
}

export interface EducatorEndorsementDto {
    personEndorsementId: number;
    endorsementCodeDescription: string;
    endorsementLevelDescription: string;
    startDate: Date;
    lapseDate?: Date | undefined;
    expireDate?: Date | undefined;
    isRelatedToAnIR: boolean;
}

export interface ExistingCertAreaEndorsementsDto {
    certificates?: ExistingCertificateDto[] | undefined;
    areas?: ExistingAreaDto[] | undefined;
    endorsements?: ExistingEndorsementDto[] | undefined;
}

export interface ExistingCertificateDto {
    type: string;
    status: string;
    statusCode: string;
    issueDate: Date;
    expireDate: Date;
    hasCertificateDetails: boolean;
    restrictedApprovedAreaDescription?: string | undefined;
    leaDescription?: string | undefined;
    ppiDescription?: string | undefined;
    allowableDeficiencies: PersonCertificateAllowableDeficiencyDisplayDto[];
}

export interface ExistingAreaDto {
    name: string;
    startDate: Date;
}

export interface ExistingEndorsementDto {
    name: string;
    level: string;
    startDate?: Date | undefined;
    expireDate?: Date | undefined;
}

export interface EducatorManagementPaymentReversalDto {
    paymentReversalId: number;
    paymentId: number;
    receiptNumber: number;
    amount: number;
    reversalTypeDescription: string;
    reversalDate: Date;
    isInCollections: boolean;
}

export interface EducatorLedgerDto {
    personId: number;
    receiptNumber?: number | undefined;
    description?: string | undefined;
    transactionAmount: number;
    transactionDate: Date;
}

export interface AddManualPersonAlertCommand {
    personId: number;
    alertCodeId?: number | undefined;
    additionalInformation?: string | undefined;
}

export interface DeletePersonAlertCommand {
    personId: number;
    personAlertId: number;
}

export interface PendingReviewDocumentsListOptionsDto {
    years: string[];
    documentTypes: DocumentCodeDto[];
}

export interface DocumentReviewDto {
    personDocumentId: number;
    fileName: string;
    documentCodes: DocumentCodeDto[];
    receivedDate: Date;
}

export interface DocumentReviewDetailsDto {
    personDocumentId: number;
    educatorName: string;
    ein?: string | undefined;
    dateOfBirth: Date;
    alternateNames: string[];
    ssn?: string | undefined;
    documentReceivedDate: Date;
    fileName: string;
    reviewStatus?: ReviewStatus | undefined;
    reviewStatusDescription?: string | undefined;
    addresses: PersonAddressForReviewDto[];
    documentCodeIds: number[];
    reviewComments?: string | undefined;
    pendingRenameDetail: PendingDocumentRenameDetailDto;
}

export interface PersonAddressForReviewDto {
    line1: string;
    line2?: string | undefined;
    city?: string | undefined;
    stateCode?: string | undefined;
    cityStateProvince?: string | undefined;
    zipCode: string;
    zipPlusFourCode?: string | undefined;
    isActive: boolean;
}

export interface PendingDocumentRenameDetailDto {
    newFileName?: string | undefined;
    isInRenameQueue: boolean;
}

export interface UpdateEducatorDocumentFromReviewCommand {
    personDocumentId: number;
    fileName: string;
    documentCodeIds: number[];
    reviewStatus: ReviewStatus;
    reviewComments?: string | undefined;
}

export interface PrintQueueDocumentDto {
    personId: number;
    personDocumentId: number;
    ein?: string | undefined;
    educatorName?: string | undefined;
    documentName?: string | undefined;
    documentType?: string | undefined;
    createDate: string;
    assignedUserId?: number | undefined;
    assignedUserName?: string | undefined;
}

export interface PrintQueueQuickFilterCountsDto {
    myDocumentsCount: number;
    unassignedDocumentsCount: number;
    certificatesCount: number;
    plainPaperDocumentsCount: number;
}

export interface CreatePrintJobCommand {
    personDocumentIds: number[];
}

export interface ApplicationDocumentDto {
    personDocumentId: number;
    personId: number;
    documentCodes: DocumentCodeDto[];
    description?: string | undefined;
    fileName?: string | undefined;
    isUploadedToRemoteStorage: boolean;
    createdDate: Date;
    createdBy?: string | undefined;
    modifiedDate?: Date | undefined;
    modifiedBy?: string | undefined;
    isNew: boolean;
    reviewStatus: ReviewStatus;
    canBeDeleted: boolean;
}

export interface FinalizePrintJobCommand {
    printJobId: number;
}

export interface DeletePrintJobCommand {
    printJobId: number;
}

export interface CollatePrintJobDocumentsCommand {
    printJobId: number;
}

export interface GetAddressWindowDocumentCommand {
    personId: number;
}

export interface PrintJobListDto {
    printJobs: PrintJobDto[];
    totalPrintJobs: number;
}

export interface PrintJobDto {
    printJobId: number;
    printJobType: string;
    createDate: Date;
    createdBy: string;
    documentCount: number;
    finalizedDate?: Date | undefined;
    finalizedBy: string;
    isFinalized: boolean;
}

export interface AgGridQueryModelOfPrintJobListDto extends AgGridQueryModelBase {
}

export interface GetPrintJobsQuery extends AgGridQueryModelOfPrintJobListDto {
}

export interface SetFilterResultDto {
    columnName: string;
    columnValues: string[];
}

export interface EducatorCertificateSnapshotGroupDto {
    certificateGroupCodeId: number;
    certificateGroupDescription: string;
    certificateGroupSortOrder: number;
    personCertificateIds: number[];
    certificates: EducatorCertificateSnapshotDto[];
}

export interface EducatorCertificateSnapshotDto {
    personCertificateId: number;
    certificateSortOrder: number;
    certificateDescription: string;
    status: string;
    issueDate: Date;
    expireDate: Date;
    restrictedApprovedArea?: string | undefined;
    leaName?: string | undefined;
    professionalPreparationInstitutionName?: string | undefined;
    changeEvent: string;
    deficiencyDescriptions: string[];
    isExpanded: boolean;
    modifiedDate?: Date | undefined;
}

export interface GetCertificateVerificationLetterCommand {
    personId: number;
}

export interface GenerateCertificateCommand {
    personId: number;
}

export interface UpdatePersonCertificateCommand {
    personCertificateId: number;
    certificateStatusCodeId?: number | undefined;
    issueDate?: Date | undefined;
    expireDate?: Date | undefined;
    originalExpireDate?: Date | undefined;
    leaCodeId?: number | undefined;
    professionalPreparationInstitutionId?: number | undefined;
}

export interface StaffEmploymentHistoryDto {
    latestYearsOfExperienceFiscalYear?: string | undefined;
    currentFiscalYearYoeExists: boolean;
    hasActiveTeachingStaffAssignment: boolean;
    yearsOfExperience: StaffYoeDto[];
    staffEmployments: StaffEmploymentHistoryItemDto[];
}

export interface StaffYoeDto {
    positionClassificationCode: string;
    yearsOfExperience: number;
}

export interface StaffEmploymentHistoryItemDto {
    academicYear: string;
    leaDescription: string;
    assignments: StaffEmploymentHistoryAssignmentDto[];
}

export interface StaffEmploymentHistoryAssignmentDto {
    staffAssignmentId: number;
    staffPositionId: number;
    locationDescription: string;
    title: string;
    positionDescription: string;
    contentAreaDescription: string;
    assignmentStatusDescription: string;
    appropriatelyCertified?: boolean | undefined;
    acEvaluationDate?: Date | undefined;
}

export interface EducatorProfessionalDevelopmentRecordDto {
    professionalDevelopmentRecordId?: number | undefined;
    professionalDevelopmentRequestId?: number | undefined;
    professionalDevelopmentVerificationRequestId?: number | undefined;
    description?: string | undefined;
    hours?: number | undefined;
    completionDate?: Date | undefined;
    requestDate?: Date | undefined;
    source?: string | undefined;
    status?: string | undefined;
    professionalDevelopmentTypeCodeDescription?: string | undefined;
    leaName?: string | undefined;
    edOrgId?: string | undefined;
}

export interface EducatorProfessionalDevelopmentSummaryDto {
    totalHoursEarned: number;
    hoursRequired?: number | undefined;
}

export interface EducatorCaseDto {
    caseId: string;
    caseStatus?: string | undefined;
    caseType?: string | undefined;
    disposition?: string | undefined;
    subDisposition?: string | undefined;
    caseClosureProcessed: boolean;
    caseUri: string;
}

export interface DeletePersonCertificateCommand {
    personCertificateId: number;
}

export interface DeletePersonApprovedAreaCommand {
    personAreaId: number;
}

export interface DeletePersonEndorsementCommand {
    personEndorsementId: number;
}

export interface UpdatePersonApprovedAreaCommand {
    personAreaId: number;
    dateAdded?: Date | undefined;
    lapseDate?: Date | undefined;
}

export interface UpdatePersonEndorsementCommand {
    personEndorsementId: number;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    lapseDate?: Date | undefined;
}

export interface DuplicateEducatorSearchDto {
    personId: number;
    lastName: string;
    firstName: string;
    middleInitial?: string | undefined;
    lastFourSSN: string;
    ein: string;
    dateOfBirth: Date;
    isLinked: boolean;
}

export interface GetEducatorDuplicatesSearchQuery {
    einSearchTerm: string;
}

export interface LinkDuplicateEducatorCommand {
    currentEducatorPersonId: number;
    educatorPersonIdToLink: number;
}

export interface LinkEducatorsFromPotentialMatchCommand {
    potentialDuplicatePersonMatchId: number;
    currentEducatorPersonId: number;
    educatorPersonIdToLink: number;
}

export interface RemoveDuplicateEducatorLinkCommand {
    currentEducatorPersonId: number;
    educatorPersonIdToUnlink: number;
}

export interface DuplicateEducatorDto {
    personId: number;
    lastName: string;
    firstName: string;
    middleInitial?: string | undefined;
    lastFourSSN: string;
    ein: string;
    dateOfBirth: Date;
    isPrimaryEducator: boolean;
}

export interface GetEducatorDuplicatesQuery {
    personId: number;
}

export interface PotentialEducatorMatchDto {
    potentialDuplicatePersonMatchId: number;
    personId: number;
    lastName: string;
    firstName: string;
    middleInitial?: string | undefined;
    lastFourSsn: string;
    ein: string;
    dateOfBirth: Date;
}

export interface GetEducatorPotentialMatchesQuery {
    personId: number;
}

export interface GetEducatorEinFromPersonIdQuery {
    personId: number;
}

export interface AssociateTranscriptCommand {
    personId: number;
    transcriptId: number;
}

export interface AssociateAbsoluteTranscriptCommand {
    personId: number;
}

export interface TranscriptMatchDto {
    transcriptMatchId: number;
    personId: number;
    unifiedTranscriptIndexId: number;
    studentFirstName: string;
    studentMiddleName?: string | undefined;
    studentLastName: string;
    dateOfBirth?: Date | undefined;
    lastFourSsn?: string | undefined;
    schoolName?: string | undefined;
    yearsAttended?: string | undefined;
    transcriptPersonDocumentId?: number | undefined;
}

export interface PotentialTranscriptMatchDto {
    potentialTranscriptMatchId: number;
    personId: number;
    unifiedTranscriptIndexId: number;
    studentFirstName: string;
    studentMiddleName?: string | undefined;
    studentLastName: string;
    dateOfBirth?: Date | undefined;
    lastFourSsn?: string | undefined;
    schoolName?: string | undefined;
    documentIdNumber?: string | undefined;
    yearsAttended?: string | undefined;
    confidenceScore: number;
    dateSent?: Date | undefined;
}

export interface DeletePersonDocumentCommand {
    personDocumentId: number;
    deletionReason: string;
}

export interface EducatorSpecialProgramResultList {
    educatorSpecialProgramResults?: EducatorSpecialProgramResultDto[] | undefined;
}

export interface AddUpdatePersonSpecialProgramCommand {
    personSpecialProgramId?: number | undefined;
    personId: number;
    specialProgramCodeId?: number | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
}

export interface DeletePersonSpecialProgramCommand {
    personSpecialProgramId: number;
}

export interface ResetPersonInformationCommand {
    personId: number;
}

export interface EppEducatorHeaderDto {
    personId: number;
    lastName: string;
    firstName: string;
    middleInitial?: string | undefined;
    ein?: string | undefined;
    educatorStakeholderId?: string | undefined;
    fingerprintCardValidityStatus?: string | undefined;
    potentialMismatchedFingerprintAssociation?: PotentialMismatchedDpsFingerprintAssociationDto | undefined;
    personAlerts: EppPersonAlertDto[];
    personSpecialPrograms: EppEducatorSpecialProgramResultDto[];
    duplicateEducators: EppDuplicateEducatorHeaderDto[];
    isPrimaryDuplicateEducator: boolean;
}

export interface EppPersonAlertDto {
    personAlertId: number;
    display: string;
    code: string;
    tooltipText?: string | undefined;
}

export interface EppEducatorSpecialProgramResultDto {
    personSpecialProgramId: number;
    personId: number;
    specialProgramCodeId?: number | undefined;
    specialProgramCodeDescription?: string | undefined;
    specialProgramDescription?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    createdDate: Date;
    createdBy?: string | undefined;
    modifiedDate?: Date | undefined;
    modifiedBy?: string | undefined;
}

export interface EppDuplicateEducatorHeaderDto {
    personId: number;
    isPrimary: boolean;
}

export interface EducatorInformationDto {
    gender: string;
    ethnicity: string;
    races: string[];
    hasDisciplinaryHistory: boolean;
}

export interface PersonFingerprintCardInformationDto {
    personFingerprintCard?: PersonFingerprintCardDto | undefined;
    potentialMismatchedFingerprintAssociation?: PotentialMismatchedDpsFingerprintAssociationDto | undefined;
}

export interface PersonFingerprintCardDto {
    cardStatus?: string | undefined;
    applicationNumber?: string | undefined;
    cardNumber?: string | undefined;
    dateExpired?: Date | undefined;
    dateApplied?: Date | undefined;
}

export interface EppEducatorCertificateDto {
    personCertificateId: number;
    personId: number;
    description: string;
    certificateTypeCodeId: number;
    status: string;
    statusCode: string;
    shouldDisplayValidityDates: boolean;
    issueDate: Date;
    expireDate: Date;
    lapsedDate?: Date | undefined;
    hasCertificateDetails: boolean;
    restrictedApprovedAreaDescription?: string | undefined;
    leaDescription?: string | undefined;
    ppiDescription?: string | undefined;
    allowableDeficiencies: EppPersonCertificateAllowableDeficiencyDisplayDto[];
    approvedAreaDescriptions: string[];
    endorsementDescriptions: string[];
}

export interface EppPersonCertificateAllowableDeficiencyDisplayDto {
    description: string;
    startDate: Date;
    endDate: Date;
}

export interface EppEducatorApplicationDto {
    createdDate: Date;
    serviceItems: EppEducatorServiceItemDto[];
}

export interface EppEducatorServiceItemDto {
    applicationId: number;
    serviceCodeDescription: string;
    description?: string | undefined;
    subDescription?: string | undefined;
    currentStatus: string;
}

export interface EppEducatorEducationDto {
    degreeDescription: string;
    degreeTypeDescription?: string | undefined;
    majorDescription?: string | undefined;
    institutionDescription?: string | undefined;
    stateCodeId?: number | undefined;
    stateCode?: string | undefined;
    isOutOfCountry: boolean;
    awardDate: Date;
}

export interface EducatorExamDto {
    testDate: Date;
    state: string;
    code: string;
    description: string;
    status: TestStatus;
}

export interface EppCohortListDto {
    totalCohortEntries: number;
    cohortEntries: EppCohortDto[];
}

export interface EppCohortDto {
    cohortId: number;
    institution: string;
    fiscalYear: number;
    description: string;
    numberOfStudents: number;
}

export interface AgGridQueryModelOfEppCohortListDto extends AgGridQueryModelBase {
}

export interface GetCohortsQuery extends AgGridQueryModelOfEppCohortListDto {
}

export interface GetCohortsSetFiltersQuery {
    propertyName: string;
}

export interface AddCohortCommand {
    description: string;
    fiscalYear: string;
}

export interface UpdateCohortCommand {
    cohortId: number;
    description: string;
    fiscalYear: string;
}

export interface RemoveCohortCommand {
    cohortId: number;
}

export interface EppCohortStudentListDto {
    totalStudentEntries: number;
    studentEntries: EppCohortStudentDto[];
}

export interface EppCohortStudentDto {
    uniqueId: string;
    cohortId: number;
    personId: number;
    cohortStudentId: number;
    ein: string;
    firstName: string;
    lastName: string;
    middleName?: string | undefined;
    ivpCardNumber: string;
    ivpCardStatus: string;
    dateOfBirth: Date;
    hasDisciplinaryHistory: boolean;
    program: string;
    verified: boolean;
    hasAuthorizedProgram: boolean;
}

export interface AgGridQueryModelOfEppCohortStudentListDto extends AgGridQueryModelBase {
}

export interface CohortStudentsAgGridQueryModel extends AgGridQueryModelOfEppCohortStudentListDto {
    cohortId: number;
}

export interface GetCohortStudentsQuery extends CohortStudentsAgGridQueryModel {
}

export interface GetCohortStudentsSetFiltersQuery {
    propertyName: string;
}

export interface RemoveStudentFromCohortCommand {
    cohortId: number;
    cohortStudentId: number;
}

export interface CohortInformationDto {
    cohortId: number;
    description: string;
}

export interface InstitutionCohortsForStudentDto {
    availableCohorts: CohortDescriptionDto[];
}

export interface CohortDescriptionDto {
    cohortId: number;
    fiscalYear: number;
    description: string;
}

export interface GetAvailableInstitutionCohortsForStudentQuery {
    personId: number;
}

export interface AddStudentToCohortCommand {
    personId: number;
    cohortId: number;
    preparationProgramId?: number | undefined;
}

export interface StudentCohortDto {
    cohortId: number;
    cohortDescription: string;
    fiscalYear: number;
    cohortStudentId: number;
    professionalPreparationInstitutionId: number;
    hasAuthorizedProgram: boolean;
    isAdoeUser: boolean;
    institutionName: string;
    cohortDisplay: string;
}

export interface ProgramRecommendationDto {
    programCompletionDate?: Date | undefined;
    selectedSpecialProgramType?: SpecialProgramType | undefined;
    isAuthorized: boolean;
    certificates: RecommendationCertificateOptionDto[];
    endorsements: RecommendationEndorsementOptionDto[];
    allowableDeficiencies: RecommendationAllowableDeficiencyOptionDto[];
    degreeOptionsDto: DegreeOptionsDto;
    allowsATA: boolean;
    educatorName: string;
    isClassroomBased: boolean;
    hasSatisfactoryProgress?: boolean | undefined;
    programPathCodes: SimpleCodeDescriptionDto[];
    selectedProgramPathCodeId?: number | undefined;
    manualWithdrawnDate?: Date | undefined;
    manuallyWithdrawnBy?: string | undefined;
}

export interface RecommendationCertificateOptionDto {
    certificateTypeCodeId: number;
    certificateDescription: string;
    selected: boolean;
    selectedApprovedAreaId?: number | undefined;
    approvedAreas: SimpleCodeDescriptionDto[];
}

export interface RecommendationEndorsementOptionDto {
    endorsementCodeId: number;
    endorsementDescription: string;
    requiresLanguageCode: boolean;
    selected: boolean;
    selectedLanguageCodeId?: number | undefined;
    languageCodes: SimpleCodeDescriptionDto[];
}

export interface RecommendationAllowableDeficiencyOptionDto {
    allowableDeficiencyCodeId: number;
    allowableDeficiencyDescription: string;
    selected: boolean;
    courseNumber?: string | undefined;
    certificateTypeCodeId?: number | undefined;
    isCourseNumberRequired: boolean;
}

export interface DegreeOptionsDto {
    degreeLevelOptions: SimpleCodeDescriptionDto[];
    degreeTypeOptions: SimpleCodeDescriptionDto[];
    selectedAwardingDegreeLevelId?: number | undefined;
    selectedAwardingDegreeTypeId?: number | undefined;
    awardingDegreeMajorOrCertificate?: string | undefined;
    awardingDegreeAwardDate?: Date | undefined;
    verifiedDegreeInstitution?: string | undefined;
    selectedVerifiedDegreeLevelId?: number | undefined;
    selectedVerifiedDegreeTypeId?: number | undefined;
    verifiedDegreeMajorOrCertificate?: string | undefined;
    verifiedDegreeAwardDate?: Date | undefined;
}

export interface SaveCohortStudentProgramCommand {
    cohortStudentProgramId?: number | undefined;
    cohortStudentId?: number | undefined;
    preparationProgramId?: number | undefined;
    completionDate?: Date | undefined;
    specialProgramType?: SpecialProgramType | undefined;
    certificateItems: RecommendationCertificateItemDto[];
    endorsementItems: RecommendationEndorsementItemDto[];
    allowableDeficiencyItems: RecommendationAllowableDeficiencyItemDto[];
    awardingDegreeLevelId?: number | undefined;
    awardingDegreeTypeId?: number | undefined;
    awardingMajorCertificateDescription?: string | undefined;
    awardingDegreeAwardDate?: Date | undefined;
    verifiedDegreeInstitution?: string | undefined;
    verifiedDegreeLevelId?: number | undefined;
    verifiedDegreeTypeId?: number | undefined;
    verifiedMajorCertificateDescription?: string | undefined;
    verifiedDegreeAwardDate?: Date | undefined;
    hasSatisfactoryProgress?: boolean | undefined;
    programPathCodeId?: number | undefined;
}

export interface RecommendationCertificateItemDto {
    certificateTypeCodeId: number;
    requiredApprovedAreaCodeId?: number | undefined;
}

export interface RecommendationEndorsementItemDto {
    endorsementCodeId: number;
    languageCodeId?: number | undefined;
}

export interface RecommendationAllowableDeficiencyItemDto {
    allowableDeficiencyId: number;
    courseNumber?: string | undefined;
    certificateTypeCodeId?: number | undefined;
}

export interface RevertManualWithdrawalFromCohortStudentProgramCommand {
    cohortStudentProgramId: number;
}

export interface GetAvailableInstitutionProgramsForStudentQuery {
    cohortStudentId?: number | undefined;
}

export interface GetCohortStudentProgramsQuery {
    cohortStudentId: number;
}

export interface AuthorizeCohortStudentProgramCommand {
    cohortStudentProgramId?: number | undefined;
    cohortStudentId?: number | undefined;
    preparationProgramId?: number | undefined;
    completionDate?: Date | undefined;
    specialProgramType?: SpecialProgramType | undefined;
    certificateItems: RecommendationCertificateItemDto[];
    endorsementItems: RecommendationEndorsementItemDto[];
    allowableDeficiencyItems: RecommendationAllowableDeficiencyItemDto[];
    awardingDegreeLevelId?: number | undefined;
    awardingDegreeTypeId?: number | undefined;
    awardingMajorCertificateDescription?: string | undefined;
    awardingDegreeAwardDate?: Date | undefined;
    verifiedDegreeInstitution?: string | undefined;
    verifiedDegreeLevelId?: number | undefined;
    verifiedDegreeTypeId?: number | undefined;
    verifiedMajorCertificateDescription?: string | undefined;
    verifiedDegreeAwardDate?: Date | undefined;
    hasSatisfactoryProgress?: boolean | undefined;
    programPathCodeId?: number | undefined;
    voucherCreditSelections: VoucherCreditSelectionDto[];
}

export interface VoucherCreditSelectionDto {
    voucherAllocationId: number;
    serviceCodeId: number;
}

export interface EppVoucherProgramOptionsDto {
    programs: EppVoucherProgramOptionDto[];
}

export interface EppVoucherProgramOptionDto {
    voucherAllocationId: number;
    programName: string;
    serviceCodeOptions: EppVoucherServiceCodeOptionDto[];
}

export interface EppVoucherServiceCodeOptionDto {
    serviceCodeId: number;
    optionKey: string;
    description: string;
}

export interface DeleteCohortStudentProgramCommand {
    cohortStudentProgramId: number;
}

export interface SpreadsheetErrorsDto {
    worksheetErrors: WorksheetErrorDto[];
    structuralErrors: string[];
}

export interface StudentSpreadsheetErrorsDto extends SpreadsheetErrorsDto {
    lookupKey?: string | undefined;
}

export interface WorksheetErrorDto {
    sheetName: string;
    rowErrors: RowErrorDto[];
    rowWarnings: RowWarningDto[];
}

export interface RowErrorDto {
    rowNumber: string;
    columnErrors: ColumnErrorDto[];
}

export interface ColumnErrorDto {
    propertyName: string;
    errorMessage: string;
    location: CellLocation;
}

export interface CellLocation {
    sheetName: string;
    row: string;
    column?: string | undefined;
}

export interface RowWarningDto {
    rowNumber: string;
    warningMessage: string;
    location?: CellLocation | undefined;
}

export interface ValidateStudentsFromFileCommand {
    content: string;
    cohortId: number;
}

export interface IRSpreadsheetErrorsDto extends SpreadsheetErrorsDto {
    lookupKey?: string | undefined;
    autoAuthorizationCount?: number | undefined;
    manualAuthorizationCount?: number | undefined;
    cohortStudentProgramsToOverwriteCount?: number | undefined;
}

export interface ValidateIRFileCommand {
    cohortId: number;
    file: string;
}

export interface CompleteIRUploadCommand {
    lookupKey: string;
}

export interface IRUploadExpectedValuesDto {
    programCodes: SimpleCodeDescriptionDto[];
    degrees: IRUploadDegreeDto[];
    certificateTypes: IRUploadCertificateTypeDto[];
    approvedAreas: IRUploadApprovedAreaDto[];
    endorsements: IRUploadEndorsementDto[];
    requirements: IRUploadRequirementDto[];
    languages: IRUploadLanguageDto[];
    programPathCodes: SimpleCodeDescriptionDto[];
}

export interface IRUploadDegreeDto {
    degreeLevelDescription: string;
    degreeTypeDescription: string;
}

export interface IRUploadCertificateTypeDto {
    programDescription: string;
    programCode: string;
    certificateDescription: string;
}

export interface IRUploadApprovedAreaDto {
    programDescription: string;
    programCode: string;
    certificateDescription: string;
    approvedAreaDescription: string;
}

export interface IRUploadEndorsementDto {
    programDescription: string;
    programCode: string;
    certificateDescription: string;
    endorsementDescription: string;
    requiresLanguage?: string | undefined;
}

export interface IRUploadRequirementDto {
    programDescription: string;
    programCode: string;
    certificateDescription: string;
    requirementDescription: string;
}

export interface IRUploadLanguageDto {
    languageDescription: string;
}

export interface CompleteStudentUploadCommand {
    lookupKey: string;
}

export interface RevertCohortStudentProgramAuthorizationCommand {
    cohortStudentProgramId: number;
}

export interface BaseEvalDetailDto {
    applicationServiceItemId: number;
    serviceCodeDescription: string;
    status?: string | undefined;
    iuResponse?: string | undefined;
    isOnHold: boolean;
    holdingAge: number;
    assignedUserName?: string | undefined;
}

export interface AddCertificateEvalDetailDto extends BaseEvalDetailDto {
    applicationId: number;
    certificateTypeCode?: string | undefined;
    certificateLevelCode?: string | undefined;
    leaCode?: string | undefined;
    professionalPreparationInstitution?: string | undefined;
    approvedAreaCode?: string | undefined;
    restrictedApprovedAreaCode?: string | undefined;
    certificationPathDescription?: string | undefined;
    reciprocalStateCodeId?: string | undefined;
    currentStateDetails: AddCertStateDetail;
}

export interface AddCertStateDetail {
    certificateLevelCodeId: number;
    certificateTypeCodeId: number;
    approvedAreaCodeId?: number | undefined;
    restrictedApprovedAreaCodeId?: number | undefined;
    professionalPreparationInstitutionId?: number | undefined;
    leaCodeId?: number | undefined;
    visaExpireDate?: Date | undefined;
    certificationPath?: CertificationPath | undefined;
    reciprocalStateCodeId?: number | undefined;
}

export enum CertificationPath {
    Reciprocity = 0,
    Other = 1,
}

export interface AddApprovedAreaEvalDetailDto extends BaseEvalDetailDto {
    applicationId: number;
    approvedAreaCodeId: number;
    approvedAreaCode: string;
}

export interface ExtensionEvalDetailDto extends BaseEvalDetailDto {
    certificateTypeCodeDescription: string;
    currentStateDetails: ExtensionStateDetail;
}

export interface ExtensionStateDetail {
    applicationId: number;
    personId: number;
    personCertificateId: number;
    visaExpireDate?: Date | undefined;
}

export interface NameChangeEvalDetailDto extends BaseEvalDetailDto {
    currentStateDetails: NameChangeStateDetail;
    nameChangeDetailExists: boolean;
}

export interface NameChangeStateDetail {
    currentFirstName: string;
    currentMiddleName?: string | undefined;
    currentLastName: string;
    newFirstName?: string | undefined;
    newMiddleName?: string | undefined;
    newLastName?: string | undefined;
}

export interface AddEndorsementEvalDetailDto extends BaseEvalDetailDto {
    endorsementCode?: string | undefined;
    endorsementLevelCode?: string | undefined;
    languageCode?: string | undefined;
    currentStateDetails: AddEndorsementStateDetail;
}

export interface AddEndorsementStateDetail {
    personId: number;
    applicationId: number;
    endorsementCodeId: number;
    endorsementLevelCodeId: number;
    languageCodeId?: number | undefined;
}

export interface EvaluationTypeDto {
    evaluationId: number;
    description?: string | undefined;
}

export interface AvailableVoucherCreditOptionsDto {
    educatorName: string;
    ein?: string | undefined;
    serviceDescription: string;
    credentialDescription?: string | undefined;
    paidAmount: number;
    options: VoucherCreditOptionDto[];
}

export interface VoucherCreditOptionDto {
    voucherDistributionCycleId: number;
    voucherAllocationId: number;
    voucherDistributionCycleName: string;
    unallocatedAmount: number;
}

export interface RemoveDeficiencyEvalDetailDto extends BaseEvalDetailDto {
    allowableDeficiencyCode?: string | undefined;
    currentStateDetails: RemoveDeficiencyStateDetail;
}

export interface RemoveDeficiencyStateDetail {
    allowableDeficiencyCodeId: number;
    applicationId: number;
    personId: number;
}

export interface AddOrUpdateHoldOnServiceItemCommand {
    applicationServiceItemId: number;
    holdEndDate?: Date | undefined;
}

export interface RemoveHoldOnServiceItemCommand {
    applicationServiceItemId: number;
    holdEndDate?: Date | undefined;
}

export interface EvaluationServiceItemDetailsDto {
    applicationServiceItemId: number;
    applicationId: number;
    personId: number;
    serviceCode: string;
    currentStatus: string;
    isOnHold: boolean;
    isLinked: boolean;
    existingEvaluationId?: number | undefined;
    appealResponseCode?: SimpleCodeDescriptionDto | undefined;
    appealResponseNotes?: string | undefined;
    cancellationRequest?: CancellationRequestDto | undefined;
    isAssignedToEvaluator: boolean;
    hasRetroactiveVoucherRedemption: boolean;
    linkedApplicationServiceItems: LinkedApplicationServiceItemDto[];
    serviceItemDetailsExist: boolean;
    holdEndDate?: Date | undefined;
    isRootRenewal: boolean;
    isRushed: boolean;
    rushRequestedBy?: string | undefined;
}

export interface CancellationRequestDto {
    serviceItemCancellationRequestId?: number | undefined;
    reason?: string | undefined;
    requestedBy?: string | undefined;
    requestedDate?: Date | undefined;
    approvedBy?: string | undefined;
    approvedDate?: Date | undefined;
    rejectedBy?: string | undefined;
    rejectedDate?: Date | undefined;
    hasBeenReviewed: boolean;
}

export interface LinkedApplicationServiceItemDto {
    applicationServiceItemId: number;
    serviceCodeDescription: string;
    itemDescription?: string | undefined;
}

export interface ServiceItemEvaluationDto {
    applicationServiceItemEvaluationId?: number | undefined;
    applicationServiceItemId: number;
    evaluationId: number;
    serviceCodeId: number;
    modifiedDate: Date;
    createdBy: string;
    modifiedBy: string;
    serviceStatus: ServiceStatus;
    isStatusBeyondAdministrative: boolean;
    isEvaluationComplete: boolean;
    allowPrintImmediately: boolean;
    clientServiceItemEvaluationRequirements: ServiceItemEvaluationRequirementDto[];
}

export interface ServiceItemEvaluationRequirementDto {
    applicationServiceItemEvaluationRequirementId?: number | undefined;
    requirementId: number;
    title?: string | undefined;
    requirementType: RequirementType;
    order: number;
    clientSubRequirements: ServiceItemEvaluationSubRequirementDto[];
    clientSubRequirementGroups: ServiceItemEvaluationSubRequirementGroupDto[];
    hasAllowableDeficiency: boolean;
    isSatisfied: boolean;
    requirementIncompleteReasonId?: number | undefined;
    requirementIncompleteReasonDescription?: string | undefined;
    evaluationDetails?: string | undefined;
    modifiedDate: Date;
    mode: Mode;
    requirementIncompleteReasons: CertRequirementIncompleteReasonDto[];
    wellKnownRequirement: WellKnownRequirement;
    customIncompleteReason?: string | undefined;
}

export interface ServiceItemEvaluationSubRequirementDto {
    applicationServiceItemEvaluationSubRequirementId?: number | undefined;
    subRequirementId: number;
    title?: string | undefined;
    order: number;
    parentRequirementId?: number | undefined;
    parentSubRequirementGroupId?: number | undefined;
    isSatisfied: boolean;
    hasAllowableDeficiency: boolean;
    subRequirementIncompleteReasonId?: number | undefined;
    subRequirementIncompleteReasonDescription?: string | undefined;
    evaluationDetails?: string | undefined;
    modifiedDate: Date;
    mode: Mode;
    subRequirementIncompleteReasons: CertSubRequirementIncompleteReasonDto[];
    wellKnownRequirement: WellKnownRequirement;
    customIncompleteReason?: string | undefined;
}

export enum Mode {
    ReadOnly = 0,
    Edit = 1,
}

export interface BaseSubRequirementIncompleteReasonDto {
    subRequirementIncompleteReasonId: number;
    description?: string | undefined;
    isActive: boolean;
    sortOrder: number;
}

export interface CertSubRequirementIncompleteReasonDto extends BaseSubRequirementIncompleteReasonDto {
    subRequirementId: number;
}

export interface ServiceItemEvaluationSubRequirementGroupDto {
    subRequirementGroupId: number;
    description?: string | undefined;
    order: number;
    subRequirementGroupType: SubRequirementGroupType;
    parentRequirementId?: number | undefined;
    parentSubRequirementGroupId?: number | undefined;
    selectedSubRequirementId?: number | undefined;
    isSatisfied: boolean;
    clientSubRequirements: ServiceItemEvaluationSubRequirementDto[];
    clientSubRequirementGroups: ServiceItemEvaluationSubRequirementGroupDto[];
}

export interface BaseRequirementIncompleteReasonDto {
    requirementIncompleteReasonId: number;
    description?: string | undefined;
    isActive: boolean;
    sortOrder: number;
}

export interface CertRequirementIncompleteReasonDto extends BaseRequirementIncompleteReasonDto {
    requirementId: number;
}

export interface SaveApplicationServiceItemEvaluationCommand {
    serviceItemEvaluationDto: ServiceItemEvaluationDto;
}

export interface RequestServiceItemCancellationCommand {
    applicationServiceItemId: number;
    cancellationRequestReason: string;
}

export interface ApproveServiceItemCancellationCommand {
    serviceItemCancellationRequestId: number;
}

export interface RejectServiceItemCancellationCommand {
    serviceItemCancellationRequestId: number;
}

export interface EvaluationDocumentReviewDto {
    applicationDocuments: DocumentReviewDto[];
    otherEducatorDocuments: DocumentReviewDto[];
}

export interface UpdateServiceItemToSubstantiveReviewCommand {
    applicationServiceItemEvaluationId: number;
}

export interface UpdateSubstantiveCompleteCommand {
    applicationServiceItemEvaluationId: number;
    addCertificateCompletionContext?: AddCertificateCompletionContext | undefined;
    printImmediately: boolean;
}

export interface AddCertificateCompletionContext {
    reciprocalStateCodeId?: number | undefined;
    certificationPath?: CertificationPath | undefined;
}

export interface ServiceItemMaterialsReceivedDto {
    serviceItemMaterialsReceivedId: number;
    isAcknowledged: boolean;
    materialType: MaterialType;
}

export enum MaterialType {
    Document = 0,
    Fingerprint = 1,
    Test = 2,
    PDHoursAwarded = 3,
    PDVerified = 4,
    Transcript = 5,
}

export interface AcknowledgeServiceItemMaterialsReceivedCommand {
    serviceItemMaterialsReceivedIds: number[];
}

export interface UpdateDenyServiceItemCommand {
    applicationServiceItemEvaluationId: number;
}

export interface AddOrUpdateAppealResponseCommand {
    applicationServiceItemId: number;
    appealResponseCodeId?: number | undefined;
    newAppealResultReason?: string | undefined;
    newAppealResultDescription?: string | undefined;
    actionNeeded: AppealResultActionNeeded;
    appealResponseNotes?: string | undefined;
}

export enum AppealResultActionNeeded {
    DenialUpheld = 0,
    DenialReversed = 1,
}

export interface UpdateSIReturnServiceItemCommand {
    applicationServiceItemEvaluationId: number;
}

export interface CancelAppealCommand {
    applicationServiceItemId: number;
}

export interface AddAppealCommand {
    applicationServiceItemId: number;
}

export interface EvaluationCompletionMessageDto {
    serviceCode?: string | undefined;
    message: string;
    messageDetails: EvaluationCompletionMessageDetailDto[];
}

export interface EvaluationCompletionMessageDetailDto {
    label: string;
    details: string[];
}

export interface UpdateAddCertificateServiceItemAndDeleteEvaluationsCommand {
    applicationId: number;
    personId?: number | undefined;
    applicationServiceItemId: number;
    certificateTypeCodeId?: number | undefined;
    requiredAreaType?: RequiredAreaType | undefined;
    certificateLevelCodeId?: number | undefined;
    leaCodeId?: number | undefined;
    professionalPreparationInstitutionId?: number | undefined;
    approvedAreaCodeId?: number | undefined;
    restrictedApprovedAreaCodeId?: number | undefined;
    visaExpireDate?: Date | undefined;
    reciprocalStateCodeId?: number | undefined;
    certificationPath?: CertificationPath | undefined;
}

export interface UpdateAddApprovedAreaServiceItemAndDeleteEvaluationsCommand {
    applicationId: number;
    applicationServiceItemId: number;
    approvedAreaCodeId: number;
}

export interface UpdateAddEndorsementServiceItemAndDeleteEvaluationsCommand {
    applicationServiceItemId: number;
    personId: number;
    applicationId: number;
    endorsementCodeId: number;
    endorsementLevelCodeId: number;
    languageCodeId?: number | undefined;
}

export interface UpdateDeficiencyRemovalServiceItemAndDeleteEvaluationsCommand {
    personId: number;
    applicationServiceItemId: number;
    applicationId: number;
    allowableDeficiencyCodeId: number;
}

export interface RenewalEvalDetailDto extends BaseEvalDetailDto {
    certificateTypeCodeDescription: string;
    currentStateDetails?: RenewalStateDetail | undefined;
}

export interface RenewalStateDetail {
    applicationId: number;
    personId: number;
    personCertificateId: number;
    visaExpirationDate?: Date | undefined;
}

export interface UpdateRenewalServiceItemCommand {
    personId: number;
    applicationServiceItemId: number;
    applicationId: number;
    personCertificateId: number;
    visaExpireDate?: Date | undefined;
}

export interface UpdateExtensionServiceItemCommand {
    applicationServiceItemId: number;
    applicationId: number;
    personCertificateId: number;
    visaExpireDate?: Date | undefined;
}

export interface UpdateNameChangeServiceItemCommand {
    applicationServiceItemId: number;
    currentFirstName: string;
    currentMiddleName?: string | undefined;
    currentLastName: string;
    newFirstName?: string | undefined;
    newMiddleName?: string | undefined;
    newLastName?: string | undefined;
}

export interface SsnChangeEvalDetailDto extends BaseEvalDetailDto {
    currentStateDetails: SsnChangeStateDetail;
    ssnChangeDetailExists: boolean;
}

export interface SsnChangeStateDetail {
    personId: number;
    currentSsn: string;
    newSsn?: string | undefined;
}

export interface UpdateSsnChangeServiceItemCommand {
    applicationServiceItemId: number;
    personId: number;
    newSsn: string;
}

export interface PrintCopyOfCertificateNowCommand {
    personId: number;
    applicationServiceItemId: number;
}

export interface AddCopyOfCertificateToPrintQueueCommand {
    personId: number;
    applicationServiceItemId: number;
}

export interface AddIRCertificateEvalDetailDto extends BaseEvalDetailDto {
    certificateTypeCode?: string | undefined;
    professionalPreparationInstitution?: string | undefined;
    approvedAreaCode?: string | undefined;
}

export interface UpdateServiceItemSendToIUCommand {
    applicationServiceItemId: number;
}

export interface AddIREndorsementEvalDetailDto extends BaseEvalDetailDto {
    endorsementCode?: string | undefined;
    endorsementLevelCode?: string | undefined;
    languageCode?: string | undefined;
    professionalPreparationInstitution?: string | undefined;
}

export interface PreviewDenialLetterCommand {
    applicationServiceItemEvaluationId: number;
}

export interface EvalDenialReasonDto {
    manualDenialReasonId?: number | undefined;
    denialReason: string;
    isCustomReason: boolean;
}

export interface GetEvalDenialReasonsQuery {
    applicationServiceItemEvaluationId: number;
}

export interface AddManualDenialReasonCommand {
    serviceItemEvalId: number;
    denialReasonMarkdown: string;
}

export interface RemoveManualDenialReasonCommand {
    manualDenialReasonId: number;
}

export interface UpdateIRCertificateServiceItemAndDeleteEvaluationsCommand {
    applicationServiceItemId: number;
    personPPIRecommendedCertificateId: number;
}

export interface UpdateIREndorsementServiceItemAndDeleteEvaluationsCommand {
    applicationServiceItemId: number;
    personPPIRecommendedCertificateEndorsementCodeId: number;
}

export interface RemoveIncompleteReasonsFromEvaluationCommand {
    serviceItemEvaluationDto: ServiceItemEvaluationDto;
    requirementType: RequirementType;
}

export interface EvalCertificateTypeCodeDto extends CertificateTypeCodeDto {
    eligibleForVoucherCredit: boolean;
}

export interface GetEvalFormCertificateTypeCodesForPersonQuery {
    certificateLevelCodeId: number;
    personId: number;
    applicationServiceItemId: number;
}

export interface AssignEvaluationToSelfCommand {
    applicationServiceItemId: number;
}

export interface ForceServiceItemIssuanceCommand {
    applicationServiceItemId: number;
}

export interface UpdateCloseServiceItemCommand {
    applicationServiceItemId: number;
}

export interface ReinstateCertificateEvalDetailDto extends BaseEvalDetailDto {
    certificateTypeCodeDescription: string;
    currentStateDetails?: ReinstateCertificateStateDetail | undefined;
    statusUponReinstatementDescription?: string | undefined;
}

export interface ReinstateCertificateStateDetail {
    applicationId: number;
    personId: number;
    personCertificateId: number;
    certificateStatusCodeId?: number | undefined;
}

export interface UpdateReinstateCertificateServiceItemCommand {
    personId: number;
    applicationServiceItemId: number;
    applicationId: number;
    personCertificateId: number;
    certificateStatusCodeId?: number | undefined;
}

export interface AddCertificateEvalCompletionDetailsDto {
    reciprocalStateCodeId?: number | undefined;
    certificationPath?: CertificationPath | undefined;
}

export interface ScreenShareAvailabilityStateDto {
    hasEducatorUserAccount: boolean;
    isConnectedToScreenShareHub: boolean;
    targetADEConnectUserAccount?: string | undefined;
}

export interface CreateEvaluationCommunicationCommand {
    applicationServiceItemEvaluationId: number;
    subject: string;
    message: string;
    images: string[];
}

export interface ServiceItemEvaluationTimelineItemDto {
    eventType: EvaluationTimelineEventType;
    requiresEducatorAction: boolean;
    subject: string;
    message: string;
    timestamp: Date;
    personDocumentId?: number | undefined;
    evaluationCommunicationImageIds: number[];
}

export enum EvaluationTimelineEventType {
    StatusChange = 0,
    HoldBegin = 1,
    HoldEnded = 2,
    MaterialReceived = 3,
    EvaluationCommunication = 4,
    CertificatePrinted = 5,
    DecisionComplete = 6,
    ProfessionalDevelopmentRecorded = 7,
}

export interface MismatchedDpsFingerprintFeedRecordDto {
    dpsFingerprintFeedRecordId: number;
    isActiveFingerprintCard: boolean;
    receivedDate?: Date | undefined;
    personId: number;
    ein: string;
    personSSN?: string | undefined;
    personFirstName: string;
    personMiddleInitial?: string | undefined;
    personLastName: string;
    personBirthDate?: Date | undefined;
    governmentId?: string | undefined;
    cardFirstName?: string | undefined;
    cardMiddleInitial?: string | undefined;
    cardLastName?: string | undefined;
    cardBirthDate?: Date | undefined;
    cardStatus?: string | undefined;
    hasActionableCertificate: boolean;
    isCurrentlyEmployed: boolean;
    mismatchReasons: string[];
}

export interface DisassociateMismatchedDpsFingerprintFeedRecordCommand {
    dpsFingerprintFeedRecordId: number;
}

export interface ValidateDpsFingerprintFeedRecordAssociationCommand {
    dpsFingerprintFeedRecordId: number;
}

export interface HelpObjectDto {
    helpObjectId: number;
    portalType: PortalType;
    portalTypeDescription: string;
    title: string;
    description: string;
    content?: string | undefined;
    contentType: ContentType;
    contentTypeDescription: string;
    externalUri?: string | undefined;
}

export enum PortalType {
    Cert = 0,
    LEA = 1,
    LEA2 = 2,
    EPP = 3,
}

export enum ContentType {
    PDF = 0,
    Link = 1,
}

export interface AddHelpObjectCommand {
    portalType?: PortalType | undefined;
    title?: string | undefined;
    description?: string | undefined;
    content?: string | undefined;
    contentType?: ContentType | undefined;
    externalUri?: string | undefined;
}

export interface DeleteHelpObjectCommand {
    helpObjectId: number;
}

export interface UserListItemDto {
    userId: number;
    email?: string | undefined;
    name?: string | undefined;
}

export interface UserDto {
    userId: number;
    adeConnectUserAccount?: string | undefined;
}

export interface UpdateUserCommand {
    userId: number;
    adeConnectUserAccount?: string | undefined;
}

export interface DataDictionaryViewDto {
    schemaName?: string | undefined;
    tableName?: string | undefined;
    columnName?: string | undefined;
    columnId?: number | undefined;
    extendedProperty?: string | undefined;
    isTable: boolean;
    isPrimaryKey: boolean;
    isForeignKey: boolean;
    columnDataType?: string | undefined;
    columnLength?: string | undefined;
    isNullable?: boolean | undefined;
    tableCreateDate: Date;
    tableModifyDate: Date;
}

export interface GenerateTestPdfCommand {
    content: string;
    isLandscape: boolean;
}

export interface CreateCaseDto {
    caseId?: string | undefined;
}

export interface CreateCaseCommand {
    educatorName: string;
}

export interface UpdateCaseDto {
    caseId: string;
}

export interface UpdateCaseCommand {
    caseId: string;
    educatorName: string;
}

export interface CaseDto {
    id: string;
    caseStatus?: string | undefined;
    educatorName?: string | undefined;
}

export interface NasdtecDto {
    lastName: string;
    firstName: string;
    middleName: string;
    suffixName: string;
    certificationId: string;
    birthDate: string;
    jurisdiction: string;
    transactionDate: string;
    clearinghouseId: string;
    clearinghouseUrl: string;
}

export enum SftpFileType {
    Transcript = 0,
    Fingerprint = 1,
    Test = 2,
}

export interface UploadSftpTestFileCommand {
    sftpFileType: SftpFileType;
    content?: string | undefined;
    fileName?: string | undefined;
}

export interface EvaluateACForStaffAssignmentResultDto {
    staffAssignmentId: number;
    isAppropriatelyCertified: boolean;
    rulesEvaluated: number;
    rulesPassed: number;
    ruleResults: RuleEvaluationSummaryDto[];
    savedEvaluation?: SavedACEvaluationDto | undefined;
    allSnapshots: SavedACEvaluationSnapshotDto[];
}

export interface RuleEvaluationSummaryDto {
    acRuleDefinitionId: number;
    ruleName?: string | undefined;
    passed: boolean;
    competencies: CompetencySummaryDto[];
}

export interface CompetencySummaryDto {
    competencyCode?: string | undefined;
    description?: string | undefined;
    satisfied: boolean;
    matchedCredentials: string[];
}

export interface SavedACEvaluationDto {
    acEvaluationId: number;
    isAppropriatelyCertified: boolean;
    evaluationReason?: string | undefined;
    createdBy?: string | undefined;
    createdDate: Date;
    modifiedBy?: string | undefined;
    modifiedDate?: Date | undefined;
}

export interface SavedACEvaluationSnapshotDto {
    acEvaluationSnapshotId: number;
    evaluationDate: Date;
    isAppropriatelyCertified: boolean;
    evaluationReason?: string | undefined;
    inputDataJson?: string | undefined;
    evaluationDataJson?: string | undefined;
    createdBy?: string | undefined;
    createdDate: Date;
}

export interface TestEmailResultDto {
    sentAt: Date;
    subject: string;
    toRecipients: string[];
    ccRecipients: string[];
    bccRecipients: string[];
    body: string;
    isHtml: boolean;
}

export interface LeaBatchUploadDto {
    batchUploadSummaryId: number;
    leaCodeId: number;
    leaSiteCodeId?: number | undefined;
    batchType: BatchUploadBatchTypes;
    fiscalYear: string;
    filename: string;
    recordCount: number;
    processingStatus: BatchUploadProcessingStatuses;
    createdDate: Date;
    completedDate?: Date | undefined;
    comment?: string | undefined;
    uploadedBy?: string | undefined;
}

export enum BatchUploadBatchTypes {
    FullRoster = 0,
    PartialRoster = 1,
    StaffPositions = 2,
    PerformanceEvaluation = 3,
}

export enum BatchUploadProcessingStatuses {
    Processing = 0,
    Success = 1,
    Error = 2,
}

export interface ExportLeaBatchUploadTemplateToExcelQuery {
    batchType: BatchUploadBatchTypes;
    leaCodeId?: number | undefined;
}

export interface BatchUploadReferenceDto {
    title: string;
    batchType: BatchUploadBatchTypes;
    items: any[];
}

export interface ExportLeaBatchUploadReferencesToExcelQuery {
    batchType: BatchUploadBatchTypes;
    leaCodeId?: number | undefined;
}

export interface ExportLeaBatchUploadCurrentDataToExcelQuery {
    leaCodeId?: number | undefined;
    batchType: BatchUploadBatchTypes;
}

export interface BatchUploadSpreadsheetErrorsDto {
    structuralErrors: string[];
    rowErrors: RowErrorDto[];
    rowWarnings: RowWarningDto[];
    spreadsheetModelLookupKey?: string | undefined;
}

export interface ValidatePerformanceEvaluationUploadCommand {
    leaCodeId?: number | undefined;
    fileContent: string;
}

export interface SubmitPerformanceEvaluationUploadCommand {
    leaCodeId?: number | undefined;
    fileName: string;
    spreadsheetModelLookupKey: string;
}

export interface LeaAdministrativeContactsDto {
    requiredContacts: LeaAdministrativeContactDto[];
    optionalContacts: LeaAdministrativeContactDto[];
}

export interface LeaAdministrativeContactDto {
    leaRoleContactInformationId?: number | undefined;
    leaCodeId: number;
    personId?: number | undefined;
    leaRoleId: number;
    leaRoleDescription: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    extension?: string | undefined;
    emailAddress?: string | undefined;
    isInvalid: boolean;
    isRequiredContact: boolean;
    modifiedBy?: string | undefined;
    modifiedDate?: Date | undefined;
}

export interface LeaLocationContactDto {
    leaSiteRoleContactInformationId?: number | undefined;
    leaSiteRoleId: number;
    leaSiteCodeId: number;
    personId?: number | undefined;
    location?: string | undefined;
    type?: string | undefined;
    titlePosition?: string | undefined;
    fullName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    extension?: string | undefined;
    emailAddress?: string | undefined;
    isRequiredContact: boolean;
    leaSiteMainContactInformation?: MainContactInformationDto | undefined;
    modifiedBy?: string | undefined;
    modifiedDate?: Date | undefined;
    isInvalid: boolean;
    isCurrentUsersLocation: boolean;
}

export interface PaginationDto {
    pageNumber: number;
    pageSize: number;
}

export interface LeaInfoStaffSearchResultList extends PaginationDto {
    searchResults?: LeaInfoStaffSearchResultDto[] | undefined;
}

export interface LeaInfoStaffSearchResultDto {
    personId: number;
    firstName: string;
    lastName: string;
    ein: string;
    educatorStakeholderId?: string | undefined;
}

export interface GetLeaInfoStaffSearchForRolesQuery {
    lastName?: string | undefined;
    firstName?: string | undefined;
    ein?: string | undefined;
    educatorStakeholderId?: string | undefined;
    pageNumber: number;
    pageSize: number;
}

export interface LeaRoleSelectOptionDto {
    leaRoleId: number;
    description: string;
    isRequiredContact: boolean;
}

export interface AddUpdateLeaRoleContactCommand {
    leaCodeId: number;
    leaRoleContactInformationId?: number | undefined;
    leaRoleId?: number | undefined;
    personId?: number | undefined;
    phoneNumber?: string | undefined;
    extension?: string | undefined;
    emailAddress?: string | undefined;
}

export interface AddUpdateLeaSiteRoleContactCommand {
    leaCodeId: number;
    leaSiteRoleContactInformationId?: number | undefined;
    leaSiteRoleId?: number | undefined;
    leaSiteCodeId?: number | undefined;
    personId?: number | undefined;
    phoneNumber?: string | undefined;
    extension?: string | undefined;
    emailAddress?: string | undefined;
}

export interface RemoveLeaRoleContactCommand {
    leaCodeId: number;
    leaRoleContactInformationId: number;
}

export interface RemoveLeaSiteRoleContactCommand {
    leaCodeId: number;
    leaSiteRoleContactInformationId: number;
}

export interface FillMissingLeaSiteContactsCommand {
    leaCodeId: number;
}

export interface VerifyLeaRoleContactCommand {
    leaRoleContactInformationId: number;
}

export interface VerifyLeaSiteRoleContactCommand {
    leaSiteRoleContactInformationId: number;
}

export interface ExportSiteContactRoleInformationToExcelQuery extends AgGridQueryModelOfByteOf {
    leaCodeId: number;
}

export interface ExportAllContactRoleInformationToExcelQuery extends CombinedContactsAgGridQueryModelOfByteOf {
    leaCodeId: number;
}

export interface LeaEducatorHeaderDto {
    personId: number;
    lastName: string;
    firstName: string;
    middleInitial?: string | undefined;
    ein?: string | undefined;
    fingerprintCardValidityStatus?: string | undefined;
    potentialMismatchedFingerprintAssociation?: PotentialMismatchedDpsFingerprintAssociationDto | undefined;
    personAlerts: LeaPersonAlertDto[];
    personSpecialPrograms: LeaEducatorSpecialProgramResultDto[];
    edOrgName?: string | undefined;
    overallPdState: ProfessionalDevelopmentRequirementState;
    isEmployedAtUsersEdOrg: boolean;
    currentEmploymentInfo?: LeaHeaderEmploymentInfo | undefined;
    duplicateEducators: LeaDuplicateEducatorHeaderDto[];
    isPrimaryDuplicateEducator: boolean;
    mergedEins: string[];
    educatorStakeholderId?: string | undefined;
}

export interface LeaPersonAlertDto {
    personAlertId: number;
    display: string;
    code: string;
    tooltipText?: string | undefined;
}

export interface LeaEducatorSpecialProgramResultDto {
    personSpecialProgramId: number;
    personId: number;
    specialProgramCodeId?: number | undefined;
    specialProgramCodeDescription?: string | undefined;
    specialProgramDescription?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    createdDate: Date;
    createdBy?: string | undefined;
    modifiedDate?: Date | undefined;
    modifiedBy?: string | undefined;
}

export interface LeaHeaderEmploymentInfo {
    lea: string;
    school?: string | undefined;
}

export interface LeaDuplicateEducatorHeaderDto {
    personId: number;
    isPrimary: boolean;
}

export interface EducatorEmploymentInfoDto {
    firstName: string;
    lastName: string;
    edOrgName: string;
    isEmployedAtUsersEdOrg: boolean;
    existsInTiaSystem: boolean;
    existsInManualRosterSystem: boolean;
    needsPdVerified: boolean;
}

export interface LeaEducatorInformationDto {
    gender: string;
    ethnicity: string;
    races: string[];
    isUnderInvestigation: boolean;
    hasDisciplinaryHistory: boolean;
}

export interface EducatorExamDto2 {
    testDate: Date;
    state: string;
    code: string;
    description: string;
    status: TestStatus;
}

export interface LeaEducatorDetailCertificateDto {
    personCertificateId: number;
    personId: number;
    description: string;
    certificateTypeCodeId: number;
    status: string;
    statusCode: string;
    shouldDisplayValidityDates: boolean;
    issueDate: Date;
    expireDate: Date;
    lapsedDate?: Date | undefined;
    hasCertificateDetails: boolean;
    restrictedApprovedAreaDescription?: string | undefined;
    leaDescription?: string | undefined;
    ppiDescription?: string | undefined;
    pdRequirementState: ProfessionalDevelopmentRequirementState;
    allowableDeficiencies: LeaPersonCertificateAllowableDeficiencyDisplayDto[];
    approvedAreaDescriptions: string[];
    endorsements: EndorsementContextDto[];
}

export interface LeaPersonCertificateAllowableDeficiencyDisplayDto {
    description: string;
    startDate: Date;
    endDate: Date;
}

export interface EndorsementContextDto {
    description: string;
    expireDate?: Date | undefined;
}

export interface LeaEducatorApplicationDto {
    createdDate: Date;
    serviceItems: LeaEducatorServiceItemDto[];
}

export interface LeaEducatorServiceItemDto {
    applicationId: number;
    applicationServiceItemId: number;
    serviceCodeDescription: string;
    description?: string | undefined;
    subDescription?: string | undefined;
    currentStatus: string;
    isFinalizedStatus: boolean;
    evaluationPriority: EvaluationPriority;
    rushRequestedBy?: string | undefined;
}

export enum EvaluationPriority {
    None = 0,
    Rushed = 1,
}

export interface LeaEducatorEducationDto {
    degreeDescription: string;
    degreeTypeDescription?: string | undefined;
    majorDescription?: string | undefined;
    institutionDescription?: string | undefined;
    stateCodeId?: number | undefined;
    stateCode?: string | undefined;
    isOutOfCountry: boolean;
    awardDate: Date;
}

export interface GetEducatorRosterFilterValuesQuery {
    propertyName: string;
    edOrgId?: string | undefined;
}

export interface LeaEducatorRosterListDto {
    totalRosterEntries: number;
    rosterEntries: LeaEducatorRosterDto[];
}

export interface LeaEducatorRosterDto {
    personId: number;
    lastName: string;
    firstName: string;
    middleInitial?: string | undefined;
    ein: string;
    ivpStatus: string;
    hasDisciplinaryHistory: boolean;
    needsProfessionalDevelopment: boolean;
    hasDeficiencies: boolean;
    hasRenewableCertificates: boolean;
    leaDescription: string;
    schoolDescription?: string | undefined;
    educatorCertificates: LeaEducatorRosterCertificateDto[];
    isManualEducatorEmployment: boolean;
    schoolEdOrgId: string;
    leaEdOrgId: string;
    uniqueId: string;
    isUnderInvestigation: boolean;
}

export interface LeaEducatorRosterCertificateDto {
    personCertificateId: number;
    certificateDescription: string;
    isRenewable: boolean;
    validityRange: string;
    monthsToExpiry: number;
    status: string;
    professionalDevelopmentRequirementState: ProfessionalDevelopmentRequirementState;
    allowableDeficiencies?: string | undefined;
    renewalAppStatus: string;
}

export interface AgGridQueryModelOfLeaEducatorRosterListDto extends AgGridQueryModelBase {
}

export interface GetLeaEducatorRosterQuery extends AgGridQueryModelOfLeaEducatorRosterListDto {
    leaEdOrgId?: string | undefined;
}

export interface LeaEducatorRosterQuickFilterCountsDto {
    invalidIVPFingerprintCount: number;
    expiredIVPFingerprintCount: number;
    needsProfessionalDevelopmentCount: number;
    renewableCertificatesCount: number;
    hasDeficienciesCount: number;
    isUnderInvestigationCount: number;
}

export interface AddEducatorToRosterCommand {
    personId: number;
    leaSiteCodeId?: number | undefined;
}

export interface RemoveEducatorFromRosterCommand {
    personId: number;
}

export interface LeaSiteCodeDto {
    leaSiteCodeId: number;
    description: string;
}

export interface UpdatePersonCertificateProfessionalDevelopmentCommand {
    personIds: number[];
}

export interface UnprofessionalConductFormInfoDto {
    reportingLeaId: number;
    reportingLeaEdOrgId: string;
    reportingLeaDescription: string;
    reporterEmailAddress?: string | undefined;
    reportedPersonId: number;
    reportedEducatorName: string;
    reportedEIN?: string | undefined;
    currentEducatorEmploymentSchoolName?: string | undefined;
}

export interface SubmitUnprofessionalConductReportCommand {
    reportingLeaId: number;
    reportingLeaEdOrgId: string;
    reportingLeaDescription: string;
    reporterName: string;
    reporterPhoneNumber: string;
    reporterTitle: string;
    reporterEmailAddress: string;
    contactPerson?: string | undefined;
    contactPhone?: string | undefined;
    contactTitle?: string | undefined;
    contactEmail?: string | undefined;
    reportedPersonId: number;
    reportedEducatorName: string;
    reportedEIN?: string | undefined;
    currentEducatorEmploymentSchoolName?: string | undefined;
    violationDate?: Date | undefined;
    violationLocation: string;
    violationDetails: string;
    violationComments?: string | undefined;
    hasReportedToLawEnforcement?: ReportedToLawEnforcementResponse | undefined;
    agencyReportedTo?: string | undefined;
    policeReportNumber?: string | undefined;
}

export enum ReportedToLawEnforcementResponse {
    Yes = 0,
    No = 1,
    NotApplicable = 2,
}

export interface LeaEducatorEmploymentHistoryDto {
    items: LeaEducatorEmploymentHistoryItemDto[];
}

export interface LeaEducatorEmploymentHistoryItemDto {
    fiscalYear: string;
    lea: string;
    school?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    employmentIsFromMergedEin: boolean;
    period: string;
    positions: LeaEducatorPositionDto[];
}

export interface LeaEducatorPositionDto {
    positionDescription?: string | undefined;
    contentAreaDescription?: string | undefined;
    periodsTaught: number;
    gradesTaught?: string | undefined;
}

export interface OldLeaRushServiceItemCommand extends RushServiceItemCommand {
}

export interface RemoveRushFromServiceItemCommand {
    applicationServiceItemId: number;
}

export interface LeaToDoTaskDto {
    typeDescription: string;
    longDescription: string;
    relativeUrlForResolution: string;
}

export interface LeaStaffStatusListDto {
    staffStatuses: LeaStaffStatusMemberDto[];
    totalCount: number;
    setFilters: SetFilterResultDto[];
}

export interface LeaStaffStatusMemberDto {
    personId: number;
    location?: string | undefined;
    personName?: string | undefined;
    ein?: string | undefined;
    workEmail?: string | undefined;
    positionClassification?: string | undefined;
    title?: string | undefined;
    position?: string | undefined;
    contentArea?: string | undefined;
    isTeachingRole: boolean;
    hasValidIvp: boolean;
    hasFingerprintIssues: boolean;
    hasDisciplineHistory: boolean;
    isUnderInvestigation: boolean;
    hasValidCertificate?: boolean | undefined;
    isAc?: boolean | undefined;
    isEtc?: boolean | undefined;
    isEsc?: boolean | undefined;
    isAltCert?: boolean | undefined;
}

export interface AgGridQueryModelOfLeaStaffStatusListDto extends AgGridQueryModelBase {
}

export interface GetLeaStaffStatusQuery extends AgGridQueryModelOfLeaStaffStatusListDto {
    leaCodeId: number;
}

export interface LeaStaffStatusCountsDto {
    totalRosterCount: number;
    totalTeachingCount: number;
    totalEmployedStaffCount: number;
    distinctPersonCount: number;
    distinctTeachingPersonCount: number;
    distinctSupportStaffPersonCount: number;
    teachingIvpValidCount: number;
    supportStaffIvpValidCount: number;
    fingerprintIssuesCount: number;
    disciplineHistoryCount: number;
    underInvestigationCount: number;
    validCertificatesCount: number;
    appropriatelyCertifiedCount: number;
    etcCount: number;
    escCount: number;
    altCertCount: number;
}

export interface LeaAlertListDto {
    isSiteUser: boolean;
    invalidContactsExist: boolean;
    missingTitleIStatus: boolean;
    performanceEvaluationOverdue: boolean;
    systemIsLocked: boolean;
    systemLockMessage?: string | undefined;
}

export interface AcademicYearOptionResultDto {
    actionableYearOption: string;
    academicYearOptions: string[];
}

export interface PerformanceEvaluationRecordDto {
    performanceEvaluationId: number;
    leaCodeId: number;
    leaSiteCodeId?: number | undefined;
    fiscalYear: string;
    isWorkingFiscalYear: boolean;
    location?: string | undefined;
    edOrgId?: string | undefined;
    evaluationRole: string;
    ineffectiveCount?: number | undefined;
    developingCount?: number | undefined;
    effectiveCount?: number | undefined;
    highlyEffectiveCount?: number | undefined;
    totalEvaluationCount?: number | undefined;
    staffAssignmentCount?: number | undefined;
    shouldDisplayMismatchWarning?: boolean | undefined;
    isVerified: boolean;
    modifiedBy?: string | undefined;
    modifiedDate?: Date | undefined;
    verifiedBy?: string | undefined;
    verifiedDate?: Date | undefined;
    isUnlocked: boolean;
    isSelected: boolean;
    isSiteEvaluation: boolean;
    hasCurrentTitleIStatus: boolean;
    missingContacts: boolean;
}

export interface GetPerformanceEvaluationsQuery {
    leaCodeId?: number | undefined;
    fiscalYear?: string | undefined;
}

export interface AgGridQueryModelOfPerformanceEvaluationDownloadDto extends AgGridQueryModelBase {
}

export interface DownloadPerformanceEvaluationsQuery extends AgGridQueryModelOfPerformanceEvaluationDownloadDto {
    leaCodeId: number;
    fiscalYear?: string | undefined;
}

export interface UpdatePerformanceEvaluationCountsCommand {
    performanceEvaluationId: number;
    ineffectiveCount?: number | undefined;
    developingCount?: number | undefined;
    effectiveCount?: number | undefined;
    highlyEffectiveCount?: number | undefined;
}

export interface VerifyPerformanceEvaluationsCommand {
    performanceEvaluationIds: number[];
}

export interface ProfessionalDevelopmentNotificationSubscriptionDto {
    professionalDevelopmentNotificationSubscriptionId?: number | undefined;
    userId: number;
    professionalDevelopmentNotificationType: ProfessionalDevelopmentNotificationType;
    professionalDevelopmentNotificationTypeDescription: string;
    isSubscribed: boolean;
}

export enum ProfessionalDevelopmentNotificationType {
    LeaRequestReceived = 0,
    LeaRequestFulfilled = 1,
    LeaRequestRejected = 2,
    EducatorSubmissionVerified = 3,
    EducatorSubmissionRejected = 4,
    PDAwarded = 5,
}

export interface UpdateProfessionalDevelopmentNotificationSubscriptionCommand {
    professionalDevelopmentNotificationSubscriptionId?: number | undefined;
    professionalDevelopmentNotificationType: ProfessionalDevelopmentNotificationType;
    isSubscribed: boolean;
}

export interface LeaProfessionalDevelopmentVerificationRequestDto {
    professionalDevelopmentVerificationRequestId: number;
    personId: number;
    educatorName: string;
    ein: string;
    description: string;
    completionDate: Date;
    hours: number;
    requestDate: Date;
    personDocumentId?: number | undefined;
    supportingDocumentFileName?: string | undefined;
    status: string;
}

export interface ProfessionalDevelopmentRecordResultDto {
    professionalDevelopmentRecordId: number;
    educatorName: string;
    ein: string;
    source: string;
    description: string;
    hours: number;
    completionDate: Date;
    professionalDevelopmentTypeCodeDescription: string;
}

export interface VerifyProfessionalDevelopmentVerificationRequestCommand {
    professionalDevelopmentVerificationRequestId: number;
    professionalDevelopmentTypeCodeId: number;
}

export interface RejectProfessionalDevelopmentVerificationRequestCommand {
    professionalDevelopmentVerificationRequestId: number;
    rejectionDetails: string;
}

export interface FulfillProfessionalDevelopmentRequestCommand {
    professionalDevelopmentRequestId: number;
    leaCodeId: number;
    professionalDevelopmentTypeCodeId?: number | undefined;
    description?: string | undefined;
    hours?: number | undefined;
}

export interface RejectProfessionalDevelopmentRequestCommand {
    professionalDevelopmentRequestId: number;
    leaCodeId: number;
    rejectionDetails?: string | undefined;
}

export interface LeaPDPersonSearchResultDto {
    personId: number;
    lastName: string;
    firstName: string;
    ein: string;
    leaSites?: string | undefined;
    isOnLeaRoster: boolean;
}

export interface LeaPDBulkPersonSearchResultDto {
    einsWithNoMatch: string[];
    matches: LeaPDPersonSearchResultDto[];
}

export interface CreateProfessionalDevelopmentRecordCommand {
    leaCodeId: number;
    personIds: number[];
    professionalDevelopmentTypeCodeId?: number | undefined;
    description?: string | undefined;
    hours?: number | undefined;
    completionDate?: Date | undefined;
}

export interface UpdateProfessionalDevelopmentRecordCommand {
    leaCodeId: number;
    professionalDevelopmentRecordIds: number[];
    description?: string | undefined;
    hours?: number | undefined;
    completionDate?: Date | undefined;
    professionalDevelopmentTypeCodeId?: number | undefined;
}

export interface DeleteProfessionalDevelopmentRecordCommand {
    leaCodeId: number;
    professionalDevelopmentRecordIds: number[];
}

export interface VerifyRemainingProfessionalDevelopmentHoursCommand {
    leaCodeId: number;
    personId: number;
    professionalDevelopmentTypeCodeId?: number | undefined;
    description?: string | undefined;
    completionDate?: Date | undefined;
}

export interface AssignmentOptionsListDto {
    assignmentStatusOptions: SimpleCodeDescriptionDto[];
    positionStatusOptions: SimpleCodeDescriptionDto[];
    modeOfInstructionOptions: SimpleCodeDescriptionDto[];
    rosterRemovalReasonOptions: RosterRemovalReasonDto[];
}

export interface RosterRemovalReasonDto extends SimpleCodeDescriptionDto {
    title: string;
    isAssignmentReason: boolean;
    isLeaReason: boolean;
}

export interface RosterStaffAssignmentDto {
    staffAssignmentId: number;
    title: string;
    assignmentRequiresExitReason: boolean;
    canBeRemovedFromLeaRoster: boolean;
    canBeRemovedFromLeaSiteRoster: boolean;
    leaCodeId: number;
    leaCodeDescription: string;
    leaSiteCodeDescription?: string | undefined;
    isLeaReason: boolean;
    isAssignmentReason: boolean;
}

export interface PositionDetailsForAssignmentDto {
    staffPositionId: number;
    leaCodeId: number;
    positionStatusCodeId: number;
    isTeachingPosition: boolean;
    isSpecialEdPosition: boolean;
    positionContentAreaRequiresExitReason: boolean;
    fiscalYear: string;
}

export interface StaffMemberInfoDto {
    personId: number;
    ein: string;
    educatorStakeholderId?: number | undefined;
    firstName: string;
    lastName: string;
    workEmailAddress?: string | undefined;
}

export interface LeaAuditInfoForConfigDto {
    createdBy?: string | undefined;
    createdDate: Date;
    modifiedBy?: string | undefined;
    modifiedDate?: Date | undefined;
}

export interface ExistingStaffAssignmentForManagementDto extends LeaAuditInfoForConfigDto {
    staffAssignmentId: number;
    canEditAssignment: boolean;
    personId: number;
    leaStaffEmploymentId?: number | undefined;
    leaSiteStaffEmploymentId?: number | undefined;
    workEmailAddress?: string | undefined;
    staffPositionId: number;
    leaCodeId: number;
    fiscalYear?: string | undefined;
    startDate: Date;
    endDate?: Date | undefined;
    assignmentRequiresExitReason?: boolean | undefined;
    rosterRemovalReasonId?: number | undefined;
    assignmentStatusCodeId?: number | undefined;
    fte?: number | undefined;
    periodsTaught?: number | undefined;
    teacherOfRecord?: boolean | undefined;
    comments?: string | undefined;
    modeOfInstructionCodeId?: number | undefined;
    modeOfInstructionDetails?: string | undefined;
    isVerified?: boolean | undefined;
    staffMemberInfo: StaffMemberInfoDto;
    latestYearsOfExperienceFiscalYear?: string | undefined;
    currentFiscalYearYoeExists: boolean;
    yearsOfExperience: StaffYOEDto[];
}

export interface StaffYOEDto {
    positionClassificationCode: string;
    yearsOfExperience: number;
}

export interface StaffPersonYoeDto {
    latestYearsOfExperienceFiscalYear?: string | undefined;
    currentFiscalYearYoeExists: boolean;
    yearsOfExperience: StaffYOEDto[];
}

export interface AddUpdateStaffAssignmentCommand {
    staffAssignmentId?: number | undefined;
    personId?: number | undefined;
    leaStaffEmploymentId?: number | undefined;
    leaSiteStaffEmploymentId?: number | undefined;
    workEmailAddress?: string | undefined;
    staffPositionId?: number | undefined;
    leaCodeId: number;
    fiscalYear?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    rosterRemovalReasonId?: number | undefined;
    assignmentStatusCodeId?: number | undefined;
    fte?: number | undefined;
    periodsTaught?: number | undefined;
    teacherOfRecord?: boolean | undefined;
    comments?: string | undefined;
    modeOfInstructionCodeId?: number | undefined;
    modeOfInstructionDetails?: string | undefined;
    isVerified?: boolean | undefined;
    positionStatusCodeId?: number | undefined;
    administrativeYOE?: number | undefined;
    nonTeachingProfessionalYOE?: number | undefined;
    teachingYOE?: number | undefined;
    classifiedYOE?: number | undefined;
}

export interface RemoveStaffAssignmentCommand {
    staffAssignmentId?: number | undefined;
    leaCodeId: number;
    positionStatusCodeId?: number | undefined;
    assignmentRemovalReasonId?: number | undefined;
    assignmentEndDate?: Date | undefined;
    shouldRemoveFromRoster?: boolean | undefined;
    rosterRemovalReasonId?: number | undefined;
    rosterEndDate?: Date | undefined;
}

export interface VerifyStaffAssignmentsCommand {
    leaCodeId: number;
    staffAssignmentIds: number[];
}

export interface LeaStaffHeaderDto {
    personId: number;
    lastName: string;
    firstName: string;
    middleInitial?: string | undefined;
    ein?: string | undefined;
    fingerprintCardValidityStatus?: string | undefined;
    potentialMismatchedFingerprintAssociation?: PotentialMismatchedDpsFingerprintAssociationDto | undefined;
    personAlerts: Lea2PersonAlertDto[];
    personSpecialPrograms: Lea2EducatorSpecialProgramResultDto[];
    overallPdState: ProfessionalDevelopmentRequirementState;
    isEmployedAtUsersEdOrg: boolean;
    currentEmploymentInfo?: Lea2HeaderEmploymentInfo | undefined;
    duplicateStaffMembers: LeaDuplicateStaffHeaderDto[];
    isPrimaryDuplicateStaffMember: boolean;
    mergedEins: string[];
    educatorStakeholderId?: string | undefined;
}

export interface Lea2PersonAlertDto {
    personAlertId: number;
    display: string;
    code: string;
    tooltipText?: string | undefined;
}

export interface Lea2EducatorSpecialProgramResultDto {
    personSpecialProgramId: number;
    personId: number;
    specialProgramCodeId?: number | undefined;
    specialProgramCodeDescription?: string | undefined;
    specialProgramDescription?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    createdDate: Date;
    createdBy?: string | undefined;
    modifiedDate?: Date | undefined;
    modifiedBy?: string | undefined;
}

export interface Lea2HeaderEmploymentInfo {
    leaCodeId: number;
    lea: string;
    site?: string | undefined;
}

export interface LeaDuplicateStaffHeaderDto {
    personId: number;
    isPrimary: boolean;
}

export interface StaffEmploymentInfoDto {
    firstName: string;
    lastName: string;
    edOrgName: string;
    isEmployedAtUsersEdOrg: boolean;
    needsPdVerified: boolean;
}

export interface LeaStaffInformationDto {
    gender: string;
    ethnicity: string;
    races: string[];
    isUnderInvestigation: boolean;
    hasDisciplinaryHistory: boolean;
}

export interface StaffExamDto {
    testDate: Date;
    state: string;
    code: string;
    description: string;
}

export interface LeaStaffDetailCertificateDto {
    personCertificateId: number;
    personId: number;
    description: string;
    certificateTypeCodeId: number;
    status: string;
    statusCode: string;
    shouldDisplayValidityDates: boolean;
    issueDate: Date;
    expireDate: Date;
    lapsedDate?: Date | undefined;
    hasCertificateDetails: boolean;
    restrictedApprovedAreaDescription?: string | undefined;
    leaDescription?: string | undefined;
    ppiDescription?: string | undefined;
    pdRequirementState: ProfessionalDevelopmentRequirementState;
    allowableDeficiencies: LeaPersonCertificateAllowableDeficiencyDisplayDto2[];
    approvedAreaDescriptions: string[];
    endorsements: EndorsementContextDto2[];
}

export interface LeaPersonCertificateAllowableDeficiencyDisplayDto2 {
    description: string;
    startDate: Date;
    endDate: Date;
}

export interface EndorsementContextDto2 {
    description: string;
    expireDate?: Date | undefined;
}

export interface LeaStaffApplicationDto {
    createdDate: Date;
    serviceItems: LeaStaffServiceItemDto[];
}

export interface LeaStaffServiceItemDto {
    applicationId: number;
    applicationServiceItemId: number;
    serviceCodeDescription: string;
    description?: string | undefined;
    subDescription?: string | undefined;
    currentStatus: string;
    isFinalizedStatus: boolean;
    evaluationPriority: EvaluationPriority;
    rushRequestedBy?: string | undefined;
}

export interface LeaStaffEducationDto {
    degreeDescription: string;
    degreeTypeDescription?: string | undefined;
    majorDescription?: string | undefined;
    institutionDescription?: string | undefined;
    stateCodeId?: number | undefined;
    stateCode?: string | undefined;
    isOutOfCountry: boolean;
    awardDate: Date;
}

export interface UnprofessionalConductFormInformationDto {
    reportingLeaId: number;
    reportingLeaEdOrgId: string;
    reportingLeaDescription: string;
    reporterEmailAddress?: string | undefined;
    reportedPersonId: number;
    reportedStaffName: string;
    reportedEin?: string | undefined;
}

export interface SubmitUnprofessionalConductReportCommand2 {
    reportingLeaId: number;
    reportingLeaEdOrgId: string;
    reportingLeaDescription: string;
    reporterName: string;
    reporterPhoneNumber: string;
    reporterTitle: string;
    reporterEmailAddress: string;
    contactPerson?: string | undefined;
    contactPhone?: string | undefined;
    contactTitle?: string | undefined;
    contactEmail?: string | undefined;
    reportedPersonId: number;
    reportedEducatorName: string;
    reportedEIN?: string | undefined;
    currentEducatorEmploymentSchoolName?: string | undefined;
    violationDate?: Date | undefined;
    violationLocation: string;
    violationDetails: string;
    violationComments?: string | undefined;
    hasReportedToLawEnforcement?: ReportedToLawEnforcementResponse | undefined;
    agencyReportedTo?: string | undefined;
    policeReportNumber?: string | undefined;
}

export interface LeaRushServiceItemCommand extends RushServiceItemCommand {
}

export interface RemoveRushFromServiceItemCommand2 {
    applicationServiceItemId: number;
}

export interface TriggerManualACEvaluationCommand {
    personId: number;
}

export interface ProfessionalDevelopmentRequestResultDto {
    professionalDevelopmentRequestId: number;
    requestingLeaCodeId?: number | undefined;
    requestingLeaCode: string;
    requestingLeaCodeDescription: string;
    targetLeaCodeId: number;
    targetLeaCode: string;
    targetLeaCodeDescription: string;
    personId: number;
    educatorName: string;
    ein: string;
    requestDetails: string;
    pdRequestStatus: string;
    requestedDate: Date;
    modifiedDate?: Date | undefined;
    isRequestingLea: boolean;
    professionalDevelopmentRecord?: ProfessionalDevelopmentRecordResultDto | undefined;
}

export interface LeaStaffPositionsListDto {
    staffPositions: LeaStaffPositionMemberDto[];
    totalStaffPositions: number;
}

export interface LeaStaffPositionMemberDto {
    staffPositionId: number;
    leaCodeDescription: string;
    leaEdOrgId?: string | undefined;
    leaSiteCodeDescription?: string | undefined;
    leaSiteEdOrgId?: string | undefined;
    locationDisplay?: string | undefined;
    title?: string | undefined;
    positionClassificationDescription?: string | undefined;
    positionDescription?: string | undefined;
    contentAreaDescription?: string | undefined;
    positionStatusDescription?: string | undefined;
    positionOpenDate: Date;
    positionCloseDate?: Date | undefined;
    isClosedPosition: boolean;
    missingCurrentTitleIStatus: boolean;
    missingContacts: boolean;
    positionFTE?: number | undefined;
    isVerified?: boolean | undefined;
    staffAssignmentId?: number | undefined;
    assignmentRequiresExitReason: boolean;
    hasVacancyStatus: boolean;
    hasSubfillingVacancyStatus: boolean;
    hasSubfillingFmlaLoaStatus: boolean;
    assignmentFTE?: number | undefined;
    teacherOfRecord?: string | undefined;
    modeOfInstructionDescription?: string | undefined;
    gradeLevelCodes?: string | undefined;
    appropriatelyCertified?: string | undefined;
    assignmentComments?: string | undefined;
}

export interface AgGridQueryModelOfLeaStaffPositionsListDto extends AgGridQueryModelBase {
}

export interface GetLeaStaffPositionsQuery extends AgGridQueryModelOfLeaStaffPositionsListDto {
    leaCodeId?: number | undefined;
    shouldIncludeClosedPositions: boolean;
}

export interface LeaStaffPositionsMetadataDto {
    vacancyCount: number;
    subfillingVacancyCount: number;
    loaFmlaCount: number;
    setFilters: SetFilterResultDto[];
}

export interface LeaStaffAssignmentPersonInformationDto {
    personId?: number | undefined;
    staffLastName?: string | undefined;
    staffFirstName?: string | undefined;
    staffMiddleInitial?: string | undefined;
    staffEin?: string | undefined;
    rawStaffEducatorStakeholderId?: number | undefined;
    staffIvpStatus?: string | undefined;
}

export interface StaffPositionFormOptionsDto {
    positionClassificationOptions: SimpleCodeDescriptionDto[];
    positionStatusOptions: SimpleCodeDescriptionDto[];
    gradeLevelOptions: SimpleCodeDescriptionDto[];
}

export interface PositionOptionDto {
    positionCodeId: number;
    code: string;
    description: string;
    positionClassificationCodeId: number;
}

export interface PositionContentAreaDetailsDto {
    positionContentAreaId: number;
    contentAreaCodeId: number;
    positionCodeId: number;
    requiresExitReason: boolean;
}

export interface ExistingStaffPositionForManagementDto extends LeaAuditInfoForConfigDto {
    staffPositionId: number;
    canEditPosition: boolean;
    leaCodeId: number;
    leaSiteCodeId?: number | undefined;
    locationCode?: string | undefined;
    locationDescription?: string | undefined;
    positionClassificationCodeId: number;
    positionCodeId: number;
    positionStatusCodeId: number;
    contentAreaCodeId: number;
    hasStaffAssignments: boolean;
    activeStaffAssignmentId?: number | undefined;
    positionOpenDate: Date;
    positionCloseDate?: Date | undefined;
    positionLocalIdentifier: string;
    authorizedFTE?: number | undefined;
    additionalPositionDetails?: string | undefined;
    gradeLevelCodeIds: number[];
}

export interface AddUpdateStaffPositionCommand {
    staffPositionId?: number | undefined;
    leaCodeId: number;
    leaSiteCodeId?: number | undefined;
    positionCodeId?: number | undefined;
    contentAreaCodeId?: number | undefined;
    positionStatusCodeId?: number | undefined;
    positionOpenDate?: Date | undefined;
    positionCloseDate?: Date | undefined;
    positionLocalIdentifier?: string | undefined;
    authorizedFTE?: number | undefined;
    additionalPositionDetails?: string | undefined;
    gradeLevelCodeIds: number[];
}

export interface CloseStaffPositionCommand {
    leaCodeId: number;
    staffPositionId?: number | undefined;
    positionCloseDate?: Date | undefined;
}

export interface AgGridQueryModelOfStaffPositionsDownloadDto extends AgGridQueryModelBase {
}

export interface DownloadStaffPositionsQuery extends AgGridQueryModelOfStaffPositionsDownloadDto {
    leaCodeId?: number | undefined;
    shouldIncludeClosedPositions: boolean;
}

export interface LeaStaffRosterReconciliationMemberDto {
    staffAssignmentId: number;
    assignmentEndDate: Date;
    personId: number;
    leaCodeId: number;
    leaSiteCodeId?: number | undefined;
    locationDescription?: string | undefined;
    titlePosition?: string | undefined;
    leaEdOrgId: string;
    ein?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    educatorStakeholderId?: string | undefined;
    leaStaffEmploymentId: number;
    leaSiteStaffEmploymentId?: number | undefined;
    staffPositionId: number;
    hasCurrentTitleIStatus: boolean;
    fiscalYear: string;
}

export interface GetLeaStaffRosterReconciliationQuery {
    leaCodeId: number;
    selectedFiscalYear: string;
}

export interface AddRemovalReasonToStaffAssignmentCommand {
    staffAssignmentIds: number[];
    leaCodeId: number;
    removalReasonId: number;
}

export interface ChangeEndDateForStaffAssignmentCommand {
    staffAssignmentId?: number | undefined;
    leaCodeId: number;
    endDate: Date;
}

export interface LeaCredentialManagementRosterListDto {
    staffRoster: LeaCredentialManagementRosterMemberDto[];
    totalStaffRoster: number;
}

export interface LeaCredentialManagementRosterMemberDto {
    leaStaffEmploymentId: number;
    leaSiteStaffEmploymentId?: number | undefined;
    personId: number;
    leaCodeId: number;
    leaSiteCodeId?: number | undefined;
    locationDescription: string[];
    isSiteStaffEmployment: boolean;
    ivpStatus: string;
    hasInvalidIvpFingerprint: boolean;
    hasExpiredIvpFingerprint: boolean;
    hasDisciplinaryHistory: boolean;
    needsProfessionalDevelopment: boolean;
    hasDeficiencies: boolean;
    hasRenewableCertificates: boolean;
    leaEdOrgId: string;
    ein?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    educatorStakeholderId?: string | undefined;
    isUnderInvestigation: boolean;
    leaStaffRosterCertificates: LeaCredentialManagementRosterCertificateDto[];
}

export interface LeaStaffRosterCertificateDto {
    personCertificateId: number;
    certificateDescription: string;
    isRenewable: boolean;
    validityRange: string;
    monthsToExpiry: number;
    status: string;
    allowableDeficiencies?: string | undefined;
    renewalAppStatus: string;
    professionalDevelopmentRequirementState: ProfessionalDevelopmentRequirementState;
}

export interface LeaCredentialManagementRosterCertificateDto extends LeaStaffRosterCertificateDto {
}

export interface AgGridQueryModelOfLeaCredentialManagementRosterListDto extends AgGridQueryModelBase {
}

export interface GetLeaCredentialManagementRosterQuery extends AgGridQueryModelOfLeaCredentialManagementRosterListDto {
    leaCodeId: number;
}

export interface AgGridQueryModelOfInteger extends AgGridQueryModelBase {
}

export interface GetLeaCredentialManagementRosterCountQuery extends AgGridQueryModelOfInteger {
    leaCodeId: number;
}

export interface LeaStaffRosterListDto {
    staffRoster: LeaStaffRosterMemberDto[];
    totalStaffRoster: number;
}

export interface LeaStaffRosterMemberDto {
    leaStaffEmploymentId: number;
    leaSiteStaffEmploymentId?: number | undefined;
    personId: number;
    leaCodeId: number;
    leaSiteCodeId?: number | undefined;
    locationDescription?: string | undefined;
    staffAssignmentId?: number | undefined;
    assignmentStatus?: string | undefined;
    titlePosition?: string | undefined;
    isVerified?: boolean | undefined;
    hasCurrentTitleIStatus: boolean;
    missingContacts: boolean;
    isSiteStaffEmployment: boolean;
    ivpStatus: string;
    hasInvalidIvpFingerprint: boolean;
    hasExpiredIvpFingerprint: boolean;
    notAppropriatelyCertified?: boolean | undefined;
    acEvaluationDate?: Date | undefined;
    leaEdOrgId: string;
    ein?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    educatorStakeholderId?: string | undefined;
    isUnderInvestigation: boolean;
    isEmptyDistrictEmployment: boolean;
    isEmptySiteEmployment: boolean;
    leaStaffRosterCertificates: LeaStaffRosterCertificateDto[];
}

export interface AgGridQueryModelOfLeaStaffRosterListDto extends AgGridQueryModelBase {
}

export interface GetLeaStaffRosterQuery extends AgGridQueryModelOfLeaStaffRosterListDto {
    leaCodeId: number;
    includeEmptyDistrictEmployments: boolean;
    includeEmptySiteEmployments: boolean;
    includeFilledDistrictEmployments: boolean;
    includeFilledSiteEmployments: boolean;
}

export interface LeaStaffRosterFilterOptionsDto {
    totalCount: number;
    invalidIvpFingerprintCount: number;
    expiredIvpFingerprintCount: number;
    notAppropriatelyCertifiedCount: number;
    isUnderInvestigationCount: number;
    setFilters: SetFilterResultDto[];
}

export interface LeaCredentialRosterFilterOptionsDto {
    invalidIvpFingerprintCount: number;
    expiredIvpFingerprintCount: number;
    notAppropriatelyCertifiedCount: number;
    needsProfessionalDevelopmentCount: number;
    renewableCertificatesCount: number;
    hasDeficienciesCount: number;
    isUnderInvestigationCount: number;
    setFilters: SetFilterResultDto[];
}

export interface GetEmploymentDetailsForRosterRemovalDto {
    leaStaffEmploymentId: number;
    leaSiteStaffEmploymentId?: number | undefined;
    leaSiteCodeId?: number | undefined;
    leaCodeId: number;
    activeStaffAssignmentsCount: number;
    assignmentRequiresExitReason?: boolean | undefined;
    staffAssignmentId?: number | undefined;
}

export interface RemoveFromRosterCommand {
    leaStaffEmploymentId: number;
    leaSiteStaffEmploymentId?: number | undefined;
    leaSiteCodeId?: number | undefined;
    leaCodeId: number;
    employmentEndDate?: Date | undefined;
    rosterRemovalReasonId?: number | undefined;
    staffAssignmentId?: number | undefined;
    assignmentEndDate?: Date | undefined;
    assignmentRemovalReasonId?: number | undefined;
    positionStatusCodeId?: number | undefined;
}

export interface UpdatePersonCertificateProfessionalDevelopmentCommand2 {
    personIds: number[];
}

export interface LocationOptionDto {
    leaCodeId: number;
    leaSiteCodeId?: number | undefined;
    code: string;
    description: string;
}

export interface ExistingStaffEmploymentForManagementDto extends LeaAuditInfoForConfigDto {
    leaStaffEmploymentId?: number | undefined;
    leaSiteStaffEmploymentId?: number | undefined;
    leaSiteCodeId?: number | undefined;
    leaCodeId: number;
    personId?: number | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    workEmailAddress?: string | undefined;
    fiscalYear?: string | undefined;
    isStaffEmployment: boolean;
}

export interface StaffEmploymentUpdateResultsDto {
    leaStaffEmploymentId: number;
    leaSiteStaffEmploymentId?: number | undefined;
    isLeaStaffEmployment: boolean;
}

export interface AddUpdateStaffEmploymentCommand {
    leaCodeId: number;
    leaStaffEmploymentId?: number | undefined;
    leaSiteStaffEmploymentId?: number | undefined;
    leaSiteCodeId?: number | undefined;
    personId?: number | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    workEmailAddress?: string | undefined;
}

export interface AgGridQueryModelOfStaffRosterDownloadDto extends AgGridQueryModelBase {
}

export interface DownloadStaffRosterQuery extends AgGridQueryModelOfStaffRosterDownloadDto {
    leaCodeId: number;
    includeEmptyDistrictEmployments: boolean;
    includeEmptySiteEmployments: boolean;
    includeFilledDistrictEmployments: boolean;
    includeFilledSiteEmployments: boolean;
}

export interface AgGridQueryModelOfLeaCredentialManagementRosterDownloadDto extends AgGridQueryModelBase {
}

export interface DownloadLeaCredentialManagementRosterQuery extends AgGridQueryModelOfLeaCredentialManagementRosterDownloadDto {
    leaCodeId: number;
}

export interface HistoricalSnapshotRecordDto {
    yearTransitionLeaSnapshotTrackingId: number;
    staffPositionId: number;
    fiscalYear?: string | undefined;
    leaSiteCode?: string | undefined;
    leaSiteDescription?: string | undefined;
    leaCode?: string | undefined;
    leaDescription?: string | undefined;
    ein?: string | undefined;
    stakeholderId?: number | undefined;
    lastName?: string | undefined;
    firstName?: string | undefined;
    workEmailAddress?: string | undefined;
    teacherYOE: number;
    administrativeYOE: number;
    professionalNonTeacherYOE: number;
    classifiedYOE: number;
    assignmentStatus?: string | undefined;
    assignmentOpen?: Date | undefined;
    assignmentClose?: Date | undefined;
    isAC?: boolean | undefined;
    assignmentFTE?: number | undefined;
    teacherOfRecord?: boolean | undefined;
    periodsTaught?: number | undefined;
    modeOfInstruction?: string | undefined;
    assignmentComments?: string | undefined;
    removalReason?: string | undefined;
    assignmentVerified?: boolean | undefined;
    title?: string | undefined;
    positionClassification?: string | undefined;
    position?: string | undefined;
    contentArea?: string | undefined;
    positionStatus?: string | undefined;
    positionOpen?: Date | undefined;
    positionClose?: Date | undefined;
    positionFTE?: number | undefined;
    gradeLevels?: string | undefined;
    additionalPositionDetails?: string | undefined;
}

export interface GetHistoricalSnapshotQuery {
    leaCodeId: number;
    fiscalYear: string;
}

export interface DownloadHistoricalSnapshotQuery {
    leaCodeId: number;
    fiscalYear: string;
}

export interface LeaSurveyAssignmentDto {
    surveyAssignmentId: number;
    leaDescription?: string | undefined;
    location?: string | undefined;
    surveyName?: string | undefined;
    surveyDescription?: string | undefined;
    intendedForRoles: string[];
    dueDate?: Date | undefined;
    status?: string | undefined;
    launchUrl?: string | undefined;
    assignmentIsInFinalizedStatus: boolean;
    shouldShowDueDateWarning: boolean;
    surveyIsOverDue: boolean;
    surveyIsPastDue: boolean;
    surveyIsActive: boolean;
    currentUserBelongsToAssignedEdOrg: boolean;
    missingContacts: boolean;
}

export interface SurveyIntendedContactDto {
    roleName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
}

export interface TitleIStatusOptionDto {
    value?: number | undefined;
    label: string;
    disabled: boolean;
}

export interface TitleIStatusManagementQuickFilterCountsDto {
    missingTitleIStatusCount: number;
    nonTitleIStatusCount: number;
    targetedTitleIStatusCount: number;
    schoolWideITitleIStatusCount: number;
    schoolWideIITitleIStatusCount: number;
    schoolWideIIITitleIStatusCount: number;
}

export interface TitleIStatusManagementListDto {
    totalTitleIStatuses: number;
    titleIStatuses: TitleIStatusManagementLocationDto[];
}

export interface TitleIStatusManagementLocationDto {
    leaCodeId: number;
    leaSiteCodeId?: number | undefined;
    leaSiteCode?: string | undefined;
    locationDescription: string;
    leaSiteTitleIStatusId: number;
    previousTitleIStatusCodeId?: number | undefined;
    previousTitleIStatus?: string | undefined;
    titleIStatusCodeId?: number | undefined;
    titleIStatusFiscalYear: string;
    hasMissingTitleIStatus: boolean;
    hasNonTitleIStatus: boolean;
    hasTargetedTitleIStatus: boolean;
    hasSchoolWideITitleIStatus: boolean;
    hasSchoolWideIITitleIStatus: boolean;
    hasSchoolWideIIITitleIStatus: boolean;
    isUnlocked: boolean;
}

export interface AgGridQueryModelOfTitleIStatusManagementListDto extends AgGridQueryModelBase {
}

export interface GetTitleIStatusManagementQuery extends AgGridQueryModelOfTitleIStatusManagementListDto {
    leaCodeId?: number | undefined;
}

export interface SetTitleIStatusCommand {
    titleIStatusCodeId: number;
    leaSiteTitleIStatusIds: number[];
}

export interface WorkforceReconciliationDto {
    batchUploadId: number;
    schoolYear: string;
    workbookFileName: string;
    assignmentsUnlocked: boolean;
    yearsOfExperienceUnlocked: boolean;
    priorSchoolYearEndDate: Date;
    isComplete: boolean;
    currentStep?: BatchUploadReconciliationType | undefined;
    rows: WorkforceReconciliationRowDto[];
    reasons: WorkforceReconciliationReasonDto[];
}

export enum BatchUploadReconciliationType {
    MissingPosition = 0,
    MissingStaff = 1,
    MissingAssignment = 2,
    YoeReview = 3,
}

export interface WorkforceReconciliationRowDto {
    reconciliationItemId: number;
    reconciliationType: BatchUploadReconciliationType;
    recordIdentity: number;
    recordLabel: string;
    currentContext: string;
    resolutionStatus: BatchUploadResolutionStatus;
    endDate?: Date | undefined;
    rosterRemovalReasonId?: number | undefined;
    startDate: Date;
    minimumEndDate: Date;
    maximumEndDate?: Date | undefined;
    causes: string[];
    personId: number;
    isInferred: boolean;
    assignmentChangeType?: BatchUploadChangeType | undefined;
    assignmentResolution?: WorkforceAssignmentResolution | undefined;
    canDeleteErroneousRollover: boolean;
    requiresIntervention: boolean;
    exceptionMessage?: string | undefined;
    rolloverAssignmentCount: number;
    assignmentConflictCount: number;
    employmentScopes: WorkforceEmploymentReconciliationDto[];
    yoeResolution?: WorkforceYoeResolution | undefined;
    yearsOfExperience: BatchUploadYoeReviewValue[];
}

export enum BatchUploadResolutionStatus {
    Unresolved = 0,
    Resolved = 1,
}

export enum BatchUploadChangeType {
    Create = 0,
    Update = 1,
    Close = 2,
    End = 3,
    Reopen = 4,
    Unchanged = 5,
    Delete = 6,
}

export enum WorkforceAssignmentResolution {
    End = 0,
    ErroneousRollover = 1,
}

export interface WorkforceEmploymentReconciliationDto {
    rolloverAssignmentCount: number;
    assignmentConflictCount: number;
    leaSiteStaffEmploymentId?: number | undefined;
    label: string;
    startDate: Date;
    resolution?: WorkforceStaffResolution | undefined;
    endDate?: Date | undefined;
    rosterRemovalReasonId?: number | undefined;
    destinationLeaSiteCodeId?: number | undefined;
    moveDestinations: WorkforceMoveDestinationDto[];
}

export enum WorkforceStaffResolution {
    MovedSites = 0,
    WorkedThenLeft = 1,
    DidNotReturn = 2,
}

export interface WorkforceMoveDestinationDto {
    leaSiteCodeId: number;
    label: string;
    startDate: Date;
}

export enum WorkforceYoeResolution {
    Keep = 0,
    Correct = 1,
}

export interface BatchUploadYoeReviewValue {
    positionClassificationCodeId: number;
    classificationCode: string;
    classificationDescription: string;
    reportedYearsOfExperience?: number | undefined;
    isWorkbookTarget: boolean;
    isAffectedClassification: boolean;
    correctedYearsOfExperience?: number | undefined;
}

export interface WorkforceReconciliationReasonDto {
    rosterRemovalReasonId: number;
    code: string;
    title: string;
    isStaffReason: boolean;
    isAssignmentReason: boolean;
}

export interface PrepareWorkforceReconciliationCommand {
    leaCodeId: number;
    batchUploadId: number;
}

export interface SaveWorkforceReconciliationCommand {
    leaCodeId: number;
    batchUploadId: number;
    reconciliationType: BatchUploadReconciliationType;
    resolutions: WorkforceReconciliationResolutionDto[];
}

export interface WorkforceReconciliationResolutionDto {
    reconciliationItemId: number;
    endDate?: Date | undefined;
    rosterRemovalReasonId?: number | undefined;
    employmentResolutions: WorkforceEmploymentResolutionDto[];
    assignmentResolution?: WorkforceAssignmentResolution | undefined;
    yoeResolution?: WorkforceYoeResolution | undefined;
    yoeCorrections: WorkforceYoeCorrectionDto[];
}

export interface WorkforceEmploymentResolutionDto {
    leaSiteStaffEmploymentId?: number | undefined;
    resolution?: WorkforceStaffResolution | undefined;
    endDate?: Date | undefined;
    rosterRemovalReasonId?: number | undefined;
    destinationLeaSiteCodeId?: number | undefined;
}

export interface WorkforceYoeCorrectionDto {
    positionClassificationCodeId: number;
    yearsOfExperience?: number | undefined;
}

export interface PrepareWorkforcePreviewCommand {
    leaCodeId: number;
    batchUploadId: number;
}

export interface ReturnToWorkforceReconciliationCommand {
    leaCodeId: number;
    batchUploadId: number;
}

export interface WorkforcePreviewDto {
    batchUploadId: number;
    schoolYear: string;
    workbookFileName: string;
    status: BatchUploadStatus;
    summary: BatchUploadChangeSummaryPayloadV1;
    phases: WorkforcePhaseProgressDto[];
    rows: WorkforcePreviewRowDto[];
    yearsOfExperienceRows: WorkforcePreviewYoeRowDto[];
    totalRows: number;
    pageNumber: number;
    pageSize: number;
}

export enum BatchUploadStatus {
    Active = 0,
    Processing = 1,
    RecoveryRequired = 2,
    Completed = 3,
}

export interface BatchUploadChangeSummaryPayloadV1 {
    payloadVersion: number;
    dataType: string;
    counts: BatchUploadChangeCount[];
    assignmentVerificationCount: number;
    yoeWriteCount: number;
    yoeAcknowledgmentCount: number;
    acceptedByUserId?: number | undefined;
    acceptedByReviewerSnapshot?: string | undefined;
    acceptedAt?: Date | undefined;
}

export interface BatchUploadChangeCount {
    recordType: BatchUploadRecordType;
    changeType: BatchUploadChangeType;
    count: number;
}

export enum BatchUploadRecordType {
    Position = 0,
    Staff = 1,
    Assignment = 2,
    YearsOfExperience = 3,
}

export interface WorkforcePhaseProgressDto {
    recordType: BatchUploadRecordType;
    total: number;
    applied: number;
    isComplete: boolean;
}

export interface WorkforcePreviewRowDto {
    stageChangeId: number;
    recordType: BatchUploadRecordType;
    changeType: BatchUploadChangeType;
    detail: BatchUploadStageChangePayloadV1;
}

export interface BatchUploadStageChangePayloadV1 {
    payloadVersion: number;
    dataType: string;
    leaCodeId: number;
    schoolYear: string;
    label: string;
    staffBefore?: BatchUploadStaffState | undefined;
    staffAfter?: BatchUploadStaffState | undefined;
    positionBefore?: BatchUploadPositionState | undefined;
    positionAfter?: BatchUploadPositionState | undefined;
    assignmentBefore?: BatchUploadAssignmentState | undefined;
    assignmentAfter?: BatchUploadAssignmentState | undefined;
    employmentResolutions: BatchUploadEmploymentResolution[];
    assignmentResolution?: BatchUploadAssignmentResolution | undefined;
    reviewFields: BatchUploadReviewField[];
    deletion?: BatchUploadAssignmentDeletion | undefined;
}

export interface BatchUploadStaffState {
    personId: number;
    startDate: Date;
    endDate?: Date | undefined;
    rosterRemovalReasonId?: number | undefined;
    workEmailAddress?: string | undefined;
    sites: BatchUploadSiteState[];
}

export interface BatchUploadSiteState {
    leaSiteStaffEmploymentId?: number | undefined;
    leaSiteCodeId: number;
    startDate: Date;
    endDate?: Date | undefined;
    rosterRemovalReasonId?: number | undefined;
}

export interface BatchUploadPositionState {
    positionLocalIdentifier: string;
    leaSiteCodeId?: number | undefined;
    positionContentAreaId: number;
    positionStatusCodeId: number;
    openDate: Date;
    closeDate?: Date | undefined;
    authorizedFte?: number | undefined;
    additionalPositionDetails?: string | undefined;
    gradeLevelCodeIds: number[];
}

export interface BatchUploadAssignmentState {
    personId: number;
    leaStaffEmploymentId?: number | undefined;
    employmentStartDate: Date;
    leaSiteStaffEmploymentId?: number | undefined;
    leaSiteCodeId?: number | undefined;
    siteStartDate?: Date | undefined;
    staffPositionId?: number | undefined;
    positionLocalIdentifier: string;
    startDate: Date;
    endDate?: Date | undefined;
    rosterRemovalReasonId?: number | undefined;
    assignmentStatusCodeId?: number | undefined;
    fte: number;
    periodsTaught?: number | undefined;
    teacherOfRecord?: boolean | undefined;
    modeOfInstructionCodeId?: number | undefined;
    modeOfInstructionDetails?: string | undefined;
    comments?: string | undefined;
    isVerified: boolean;
}

export interface BatchUploadEmploymentResolution {
    leaSiteStaffEmploymentId?: number | undefined;
    resolution: WorkforceStaffResolution;
    endDate: Date;
    rosterRemovalReasonId: number;
    destinationLeaSiteCodeId?: number | undefined;
}

export interface BatchUploadAssignmentResolution {
    changeType?: BatchUploadChangeType | undefined;
    endDate?: Date | undefined;
    rosterRemovalReasonId?: number | undefined;
    isInferred: boolean;
    noServiceConfirmed: boolean;
    copiedFromStaffAssignmentId?: number | undefined;
    causes: BatchUploadAssignmentCause[];
    exceptionMessage?: string | undefined;
}

export interface BatchUploadAssignmentCause {
    recordType: BatchUploadRecordType;
    recordIdentity: number;
    leaSiteStaffEmploymentId?: number | undefined;
    endDate: Date;
    staffResolution?: WorkforceStaffResolution | undefined;
    rosterRemovalReasonId?: number | undefined;
    explanation: string;
}

export interface BatchUploadReviewField {
    label: string;
    before?: string | undefined;
    after?: string | undefined;
}

export interface BatchUploadAssignmentDeletion {
    copiedFromStaffAssignmentId?: number | undefined;
    evaluationId?: number | undefined;
    snapshotIds: number[];
    historyIds: number[];
}

export interface WorkforcePreviewYoeRowDto {
    stageYoeTargetId: number;
    label: string;
    classificationDescription: string;
    changeType: BatchUploadChangeType;
    before?: number | undefined;
    after: number;
    isDepartureCorrection: boolean;
    reviewResolution?: WorkforceYoeResolution | undefined;
}

export interface WorkforcePreviewSearchDto {
    rows: WorkforcePreviewRowDto[];
    yearsOfExperienceRows: WorkforcePreviewYoeRowDto[];
    totalRows: number;
    pageNumber: number;
    pageSize: number;
}

export interface SubmitWorkforceBatchUploadCommand {
    leaCodeId: number;
    batchUploadId: number;
    attested: boolean;
}

export interface ResumeWorkforceFinalizationCommand {
    leaCodeId: number;
    batchUploadId: number;
    blockingConditionResolved: boolean;
}

export interface DownloadBlankWorkforceWorkbookQuery {
    leaCodeId: number;
}

export interface DownloadCurrentWorkforceWorkbookQuery {
    leaCodeId: number;
}

export interface WorkforceBatchUploadEntryDto {
    state: WorkforceBatchUploadEntryState;
    currentBatch?: WorkforceBatchUploadSummaryDto | undefined;
    latestCompletedBatch?: WorkforceBatchUploadSummaryDto | undefined;
    currentSchoolYear: string;
    currentSchoolYearDisplay: string;
    canStart: boolean;
    canReset: boolean;
    blockedReason?: WorkforceBatchUploadBlockedReason | undefined;
}

export enum WorkforceBatchUploadEntryState {
    ReadyToStart = 0,
    Upload = 1,
    Reconcile = 2,
    Preview = 3,
    Processing = 4,
    RecoveryRequired = 5,
    Completed = 6,
    Blocked = 7,
}

export interface WorkforceBatchUploadSummaryDto {
    batchUploadId: number;
    schoolYear: string;
    status: BatchUploadStatus;
    workflowStage: BatchUploadWorkflowStage;
    currentFinalizationPhase?: BatchUploadFinalizationPhase | undefined;
    backgroundPhase: BatchUploadBackgroundPhase;
    previewPlanErrors?: string[] | undefined;
    workbookValidatedAt?: Date | undefined;
    workbookFileName?: string | undefined;
    createdDate: Date;
    processingStartedAt?: Date | undefined;
    staffCompletedAt?: Date | undefined;
    positionsCompletedAt?: Date | undefined;
    assignmentsCompletedAt?: Date | undefined;
    yearsOfExperienceCompletedAt?: Date | undefined;
    recoveryRequiredAt?: Date | undefined;
    completedAt?: Date | undefined;
}

export enum BatchUploadWorkflowStage {
    Upload = 0,
    Reconcile = 1,
    Preview = 2,
}

export enum BatchUploadFinalizationPhase {
    Staff = 0,
    Positions = 1,
    Assignments = 2,
    YearsOfExperience = 3,
}

export enum BatchUploadBackgroundPhase {
    None = 0,
    Validating = 1,
    PreparingReconciliation = 2,
    Failed = 3,
    PreparingPreview = 4,
}

export enum WorkforceBatchUploadBlockedReason {
    SystemLocked = 0,
    OwnershipConflict = 1,
    InconsistentState = 2,
}

export interface WorkforceBatchUploadHistoryDto {
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    items: WorkforceBatchUploadSummaryDto[];
}

export interface ResetWorkforceBatchUploadCommand {
    leaCodeId: number;
    batchUploadId: number;
}

export interface PersistWorkforceWorkbookResultDto {
    batchUploadId: number;
    workflowStage: BatchUploadWorkflowStage;
}

export interface ValidateWorkforceWorkbookCommand {
    leaCodeId: number;
    batchUploadId: number;
}

export interface WorkforceStoredWorkbookValidationDto {
    result?: WorkforceWorkbookValidationResultDto | undefined;
}

export interface WorkforceWorkbookValidationResultDto {
    batchUploadId: number;
    isValid: boolean;
    workflowStage: BatchUploadWorkflowStage;
    structuralErrors: WorkforceWorkbookStructuralErrorDto[];
    worksheetErrors: WorkforceWorkbookWorksheetErrorGroupDto[];
    warnings: WorkforceWorkbookCellWarningDto[];
    totalErrorCount: number;
    reviewRows?: WorkforceWorkbookReviewRowDto[] | undefined;
    reviewSites?: WorkforceWorkbookReviewSiteDto[] | undefined;
}

export interface WorkforceWorkbookStructuralErrorDto {
    errorCode: string;
    message: string;
    sheetName?: string | undefined;
    cellAddress?: string | undefined;
}

export interface WorkforceWorkbookWorksheetErrorGroupDto {
    sheetName: string;
    cellErrors: WorkforceWorkbookCellErrorDto[];
}

export interface WorkforceWorkbookCellErrorDto {
    rowNumber: number;
    columnNumber: number;
    header: string;
    cellAddress: string;
    errorCode: string;
    message: string;
    relatedCellAddresses?: string[] | undefined;
}

export interface WorkforceWorkbookCellWarningDto {
    sheetName: string;
    rowNumber: number;
    columnNumber: number;
    header: string;
    cellAddress: string;
    warningCode: string;
    message: string;
}

export interface WorkforceWorkbookReviewRowDto {
    sheetName: string;
    rowNumber: number;
    ein?: string | undefined;
    positionLocalIdentifier?: string | undefined;
    siteEdOrgId?: string | undefined;
    linkedEins: string[];
    linkedPositionLocalIdentifiers: string[];
    linkedSiteEdOrgIds: string[];
}

export interface WorkforceWorkbookReviewSiteDto {
    edOrgId: string;
    description: string;
}

export interface ProceedToWorkforceReconciliationResultDto {
    batchUploadId: number;
    workflowStage: BatchUploadWorkflowStage;
    missingPositionCount: number;
    missingStaffCount: number;
    missingAssignmentCount: number;
}

export interface ContinueWorkforceWorkbookRequestDto {
    leaCodeId: number;
    batchUploadId: number;
}

export interface WorkforceLeavePreviewDto {
    schoolYear: string;
    asOfDate: Date;
    currentLeaveStatus: StaffLeaveStatus;
    leaveStatus: StaffLeaveStatus;
    automaticEndReason?: string | undefined;
    hasUnavailableEndReason: boolean;
    hasInvalidCoverageDates: boolean;
    hasConflictingOccupants: boolean;
    hasClosedPositions: boolean;
    assignments: WorkforceLeaveAssignmentDto[];
    coverageAssignments: WorkforceLeaveAssignmentDto[];
}

export enum StaffLeaveStatus {
    None = 0,
    FMLA = 1,
    LOA = 2,
}

export interface WorkforceLeaveAssignmentDto {
    staffAssignmentId: number;
    staffPositionId: number;
    personId: number;
    personName: string;
    position: string;
    positionTitle: string;
    positionFte?: number | undefined;
    positionOpenDate: Date;
    startDate: Date;
}

export interface ChangeWorkforceLeaveCommand {
    leaCodeId: number;
    personId: number;
    leaStaffEmploymentId?: number | undefined;
    schoolYear: string;
    leaveStatus: StaffLeaveStatus;
    expectedLeaveStatus: StaffLeaveStatus;
    confirm: boolean;
    expectedAssignmentIds: number[];
    expectedCoverageAssignmentIds: number[];
}

export interface WorkforceIdentityMatchesDto {
    creationBlocked: boolean;
    matches: WorkforcePersonMatchDto[];
}

export interface WorkforcePersonMatchDto {
    personId: number;
    firstName: string;
    middleName?: string | undefined;
    lastName: string;
    ein?: string | undefined;
    edShId?: string | undefined;
    isAlreadyActiveInLea: boolean;
}

export interface WorkforcePersonIdentityInput {
    leaCodeId: number;
    searchedEin: string;
    ssn: string;
    dateOfBirth?: Date | undefined;
    firstName: string;
    middleName?: string | undefined;
    lastName: string;
}

export interface WorkforcePersonCreationInput extends WorkforcePersonIdentityInput {
    genderCodeId?: number | undefined;
    ethnicityCodeId?: number | undefined;
    raceCodeIds: number[];
}

export interface CheckWorkforcePersonIdentityQuery extends WorkforcePersonCreationInput {
}

export interface CreateWorkforcePersonCommand extends WorkforcePersonCreationInput {
    acknowledgedMatchPersonIds: number[];
}

export interface WorkforceEmploymentOptionsDto {
    schoolYear: string;
    asOfDate: Date;
    operationalStart: Date;
    requiredLeaSiteCodeId?: number | undefined;
    sites: WorkforceEmploymentOptionDto[];
    positions: WorkforceEmploymentPositionDto[];
    modes: WorkforceEmploymentOptionDto[];
    reasons: WorkforceAssignmentEndReasonDto[];
}

export interface WorkforceEmploymentOptionDto {
    id: number;
    description: string;
}

export interface WorkforceEmploymentPositionDto {
    id: number;
    leaSiteCodeId?: number | undefined;
    positionLocalIdentifier: string;
    description: string;
    openDate: Date;
    fte?: number | undefined;
    isTeaching: boolean;
    isSpecialEd: boolean;
    occupantStaffAssignmentId?: number | undefined;
    occupantPersonId?: number | undefined;
    occupantName?: string | undefined;
    occupantStartDate?: Date | undefined;
}

export interface WorkforceAssignmentEndReasonDto {
    rosterRemovalReasonId: number;
    title: string;
    description: string;
}

export interface AddWorkforceStaffCommand {
    leaCodeId: number;
    personId: number;
    schoolYear: string;
    startDate?: Date | undefined;
    workEmail?: string | undefined;
    leaSiteCodeId?: number | undefined;
    staffPositionId?: number | undefined;
    assignmentStartDate?: Date | undefined;
    fte?: number | undefined;
    periodsTaught?: number | undefined;
    modeOfInstructionCodeId?: number | undefined;
    comments?: string | undefined;
    teacherOfRecord?: boolean | undefined;
}

export interface AddWorkforceAssignmentCommand {
    leaCodeId: number;
    personId: number;
    leaStaffEmploymentId: number;
    leaSiteCodeId?: number | undefined;
    staffPositionId?: number | undefined;
    siteEmploymentOnly: boolean;
    schoolYear: string;
    startDate?: Date | undefined;
    fte?: number | undefined;
    periodsTaught?: number | undefined;
    modeOfInstructionCodeId?: number | undefined;
    comments?: string | undefined;
    teacherOfRecord?: boolean | undefined;
    occupantStaffAssignmentId?: number | undefined;
    confirmOccupantEnding: boolean;
    occupantEndDate?: Date | undefined;
    occupantRosterRemovalReasonId?: number | undefined;
}

export interface WorkforcePersonLookupDto {
    hasMoreMatches: boolean;
    matches: WorkforcePersonMatchDto[];
}

export interface SearchWorkforcePersonQuery {
    leaCodeId: number;
    ein?: string | undefined;
    edShId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    ssn?: string | undefined;
}

export interface WorkforceManagementAccessDto {
    hasBatchUploadInProgress: boolean;
    invalidContactsExist: boolean;
    missingTitleIStatus: boolean;
    blockedSites: WorkforceBlockedSiteDto[];
}

export interface WorkforceBlockedSiteDto {
    leaSiteCodeId: number;
    invalidContacts: boolean;
    missingTitleIStatus: boolean;
}

export interface WorkforceOverviewDto {
    leaCodeId: number;
    leaName: string;
    leaSiteCodeId?: number | undefined;
    siteName?: string | undefined;
    schoolYear: string;
    schoolYearDisplay: string;
    asOfDate: Date;
    activeStaffCount: number;
    vacantPositionCount: number;
    verificationProgressAvailable: boolean;
    verifiedStaffCount?: number | undefined;
    needsVerificationCount?: number | undefined;
    percentComplete?: number | undefined;
}

export interface AgGridResponseOfWorkforcePersonRowDto {
    data: WorkforcePersonRowDto[];
    totalCount: number;
}

export interface WorkforcePeopleRosterResponseDto extends AgGridResponseOfWorkforcePersonRowDto {
    entireRosterCount: number;
    notAppropriatelyCertifiedCount: number;
    needsVerificationCount?: number | undefined;
    needsVerificationAvailable: boolean;
    locationOptions: string[];
}

export interface WorkforcePersonRowDto {
    personId: number;
    firstName: string;
    lastName: string;
    ein?: string | undefined;
    educatorStakeholderId?: string | undefined;
    staffMember: string;
    workEmail?: string | undefined;
    locations: string[];
    locationSort: string;
    verificationAvailable: boolean;
    verificationStatus?: WorkforceRosterVerificationStatus | undefined;
    employmentEnded: boolean;
}

export enum WorkforceRosterVerificationStatus {
    NeedsVerification = 0,
    Verified = 1,
}

export interface AgGridQueryModelOfWorkforcePeopleRosterResponseDto extends AgGridQueryModelBase {
}

export interface GetWorkforcePeopleRosterQuery extends AgGridQueryModelOfWorkforcePeopleRosterResponseDto {
    leaCodeId: number;
    queue: WorkforceRosterQueue;
}

export enum WorkforceRosterQueue {
    EntireRoster = 0,
    NotAppropriatelyCertified = 1,
    NeedsVerification = 2,
}

export interface AgGridResponseOfWorkforcePositionDto {
    data: WorkforcePositionDto[];
    totalCount: number;
}

export interface WorkforcePositionsResponseDto extends AgGridResponseOfWorkforcePositionDto {
    filledCount: number;
    vacantCount: number;
    closedCount: number;
    subFillingFmlaLoaCount: number;
    subFillingVacancyCount: number;
    locationOptions: string[];
    schoolYear: string;
    asOfDate: Date;
    canEditPositions: boolean;
}

export interface WorkforcePositionDto {
    staffPositionId: number;
    positionLocalIdentifier: string;
    leaSiteCodeId?: number | undefined;
    siteDescription?: string | undefined;
    title: string;
    classification: string;
    contentArea: string;
    gradeLevels: string[];
    authorizedFTE?: number | undefined;
    status: WorkforcePositionInventoryStatus;
    statusDescription: string;
    isSubFilling: boolean;
    canFillVacancy: boolean;
    canFillPosition: boolean;
    hasAssignmentConflict: boolean;
    currentOccupants: WorkforcePositionOccupantDto[];
}

export enum WorkforcePositionInventoryStatus {
    Filled = 0,
    Vacant = 1,
    Closed = 2,
    SubFillingFmlaLoa = 3,
    SubFillingVacancy = 4,
}

export interface WorkforcePositionOccupantDto {
    personId: number;
    leaStaffEmploymentId: number;
    staffAssignmentId: number;
    firstName: string;
    lastName: string;
    ein?: string | undefined;
    leaveStatus: StaffLeaveStatus;
    isTemporaryCoverage: boolean;
}

export interface AgGridQueryModelOfWorkforcePositionsResponseDto extends AgGridQueryModelBase {
}

export interface GetWorkforcePositionsQuery extends AgGridQueryModelOfWorkforcePositionsResponseDto {
    leaCodeId: number;
    status?: WorkforcePositionInventoryStatus | undefined;
}

export interface ExportWorkforcePeopleRosterQuery {
    leaCodeId: number;
}

export interface ExportWorkforcePositionsQuery {
    leaCodeId: number;
}

export interface WorkforcePositionDetailsDto {
    staffPositionId: number;
    positionLocalIdentifier: string;
    leaSiteCodeId?: number | undefined;
    siteDescription: string;
    canEditSite: boolean;
    siteEditRestrictionReason?: string | undefined;
    hasAssignmentHistory: boolean;
    sites: WorkforcePositionSiteOptionDto[];
    status: WorkforcePositionInventoryStatus;
    statusDescription: string;
    positionClassificationCodeId: number;
    positionCodeId: number;
    contentAreaCodeId: number;
    authorizedFTE?: number | undefined;
    positionOpenDate: Date;
    additionalPositionDetails?: string | undefined;
    gradeLevelCodeIds: number[];
    currentOccupants: WorkforcePositionOccupantDto[];
    schoolYear: string;
    schoolYearLabel: string;
    asOfDate: Date;
    currentYearAssignments: WorkforcePositionAssignmentHistoryDto[];
    classifications: WorkforcePositionOptionDto[];
    positionCodes: WorkforcePositionCodeOptionDto[];
    contentAreas: WorkforcePositionContentAreaOptionDto[];
    gradeLevels: WorkforcePositionOptionDto[];
}

export interface WorkforcePositionSiteOptionDto {
    leaSiteCodeId?: number | undefined;
    description: string;
}

export interface WorkforcePositionAssignmentHistoryDto {
    staffAssignmentId: number;
    personId: number;
    firstName: string;
    lastName: string;
    ein?: string | undefined;
    locationName: string;
    startDate: Date;
    endDate?: Date | undefined;
    fte: number;
    status: WorkforcePositionAssignmentHistoryStatus;
}

export enum WorkforcePositionAssignmentHistoryStatus {
    Current = 0,
    StartsLater = 1,
    Ended = 2,
}

export interface WorkforcePositionOptionDto {
    id: number;
    description: string;
}

export interface WorkforcePositionCodeOptionDto {
    id: number;
    description: string;
    positionClassificationCodeId: number;
    isTeaching: boolean;
}

export interface WorkforcePositionContentAreaOptionDto {
    positionCodeId: number;
    contentAreaCodeId: number;
    description: string;
}

export interface WorkforcePositionLifecycleOptionsDto {
    staffPositionId: number;
    positionLocalIdentifier: string;
    statusDescription: string;
    isClosed: boolean;
    positionOpenDate: Date;
    positionCloseDate?: Date | undefined;
    asOfDate: Date;
    schoolYear: string;
    lastRetainedAssignmentEndDate?: Date | undefined;
    blockingReason?: string | undefined;
    assignments: WorkforcePositionEndingAssignmentDto[];
    reasons: WorkforceAssignmentEndReasonDto[];
}

export interface WorkforcePositionEndingAssignmentDto {
    staffAssignmentId: number;
    personId: number;
    name: string;
    startDate: Date;
}

export interface CloseWorkforcePositionCommand {
    leaCodeId: number;
    staffPositionId: number;
    schoolYear: string;
    positionCloseDate?: Date | undefined;
    confirmAssignmentEndings: boolean;
    staffAssignmentIds: number[];
    rosterRemovalReasonId?: number | undefined;
}

export interface ReopenWorkforcePositionCommand {
    leaCodeId: number;
    staffPositionId: number;
    schoolYear: string;
}

export interface UpdateWorkforcePositionCommand {
    leaCodeId: number;
    staffPositionId: number;
    leaSiteCodeId?: number | undefined;
    positionLocalIdentifier?: string | undefined;
    positionCodeId?: number | undefined;
    contentAreaCodeId?: number | undefined;
    authorizedFTE?: number | undefined;
    positionOpenDate?: Date | undefined;
    additionalPositionDetails?: string | undefined;
    gradeLevelCodeIds: number[];
}

export interface WorkforcePositionCreateOptionsDto {
    leaDescription: string;
    leaLevelLocationLabel: string;
    requiredLeaSiteCodeId?: number | undefined;
    asOfDate: Date;
    sites: WorkforcePositionSiteOptionDto[];
    classifications: WorkforcePositionOptionDto[];
    positionCodes: WorkforcePositionCodeOptionDto[];
    contentAreas: WorkforcePositionContentAreaOptionDto[];
}

export interface CreateWorkforcePositionCommand {
    leaCodeId: number;
    leaSiteCodeId?: number | undefined;
    positionLocalIdentifier?: string | undefined;
    positionCodeId?: number | undefined;
    contentAreaCodeId?: number | undefined;
    authorizedFTE?: number | undefined;
    positionOpenDate?: Date | undefined;
    additionalPositionDetails?: string | undefined;
    gradeLevelCodeIds: number[];
}

export interface WorkforceVacancyFillOptionsDto {
    schoolYear: string;
    asOfDate: Date;
    operationalStart: Date;
    leaDescription: string;
    position: WorkforceVacancyDto;
    modes: WorkforceEmploymentOptionDto[];
}

export interface WorkforceVacancyDto {
    staffPositionId: number;
    positionLocalIdentifier: string;
    title: string;
    classification: string;
    contentArea: string;
    gradeLevels: string[];
    leaSiteCodeId?: number | undefined;
    siteDescription: string;
    openDate: Date;
    authorizedFTE?: number | undefined;
    isTemporaryCoverage: boolean;
    isTeaching: boolean;
    isSpecialEd: boolean;
}

export interface WorkforceVacancyCandidatesDto {
    candidates: WorkforceVacancyCandidateDto[];
    hasMoreCandidates: boolean;
}

export interface WorkforceVacancyCandidateDto {
    personId: number;
    firstName: string;
    lastName: string;
    ein?: string | undefined;
    leaStaffEmploymentId: number;
    employmentStartDate: Date;
    siteEmploymentStartDate?: Date | undefined;
    currentAssignments: WorkforceVacancyCandidateAssignmentDto[];
}

export interface WorkforceVacancyCandidateAssignmentDto {
    staffAssignmentId: number;
    positionLocalIdentifier: string;
    title: string;
    location: string;
    fte: number;
}

export interface SearchWorkforceVacancyCandidatesQuery {
    leaCodeId: number;
    staffPositionId: number;
    searchText?: string | undefined;
}

export interface WorkforceReviewSequenceDto {
    items: WorkforceReviewSequenceItemDto[];
    selectedIndex?: number | undefined;
}

export interface WorkforceReviewSequenceItemDto {
    personId: number;
    firstName: string;
    lastName: string;
}

export interface AgGridQueryModelOfWorkforceReviewSequenceDto extends AgGridQueryModelBase {
}

export interface GetWorkforceReviewSequenceQuery extends AgGridQueryModelOfWorkforceReviewSequenceDto {
    leaCodeId: number;
    queue: WorkforceRosterQueue;
    selectedPersonId: number;
}

export interface WorkforcePersonSummaryDto {
    personId: number;
    firstName: string;
    middleName?: string | undefined;
    lastName: string;
    ein?: string | undefined;
    educatorStakeholderId?: string | undefined;
    workEmail?: string | undefined;
    locations: string[];
    schoolYearLabel: string;
    schoolYear: string;
    fullAuthorizedRosterCount: number;
    verifiedRosterCount: number;
    employmentEnded: boolean;
    isSiteScopedReview: boolean;
    verificationAvailable: boolean;
    verificationReopened: boolean;
    verificationStatus: WorkforceRosterVerificationStatus;
    verificationReady: boolean;
    verificationBlockingReasons: string[];
    verificationCoverageFingerprint?: string | undefined;
    annualExperience: WorkforceAnnualExperienceDto;
    annualExperienceRequired: boolean;
    currentVerification?: WorkforceRosterVerificationEvidenceDto | undefined;
    endedHistoryCount: number;
    leaEmployments: WorkforceLeaEmploymentDto[];
    activeCertificates: WorkforceCredentialDto[];
    activeEndorsements: WorkforceCredentialDto[];
    activeApprovedAreas: WorkforceCredentialDto[];
    certificationStatus: WorkforceCertificationStatus;
    fingerprintCard?: WorkforceFingerprintCardDto | undefined;
    showProfessionalConduct: boolean;
    underInvestigation: boolean;
    hasDisciplinaryHistory: boolean;
}

export interface WorkforceAnnualExperienceDto {
    administrativeYears?: number | undefined;
    classifiedYears?: number | undefined;
    professionalNonTeachingYears?: number | undefined;
    teachingYears?: number | undefined;
}

export interface WorkforceRosterVerificationEvidenceDto {
    verifiedBy: string;
    verifiedAt: Date;
}

export interface WorkforceLeaEmploymentDto {
    leaveStatus: StaffLeaveStatus;
    leaStaffEmploymentId: number;
    leaName: string;
    startDate: Date;
    endDate?: Date | undefined;
    endReasonId?: number | undefined;
    endReason?: string | undefined;
    endReasonDescription?: string | undefined;
    isActive: boolean;
    assignments: WorkforceAssignmentDto[];
    siteEmployments: WorkforceSiteEmploymentDto[];
}

export interface WorkforceAssignmentDto {
    staffAssignmentId: number;
    schoolYear: string;
    startDate: Date;
    endDate?: Date | undefined;
    endReasonId?: number | undefined;
    endReason?: string | undefined;
    endReasonDescription?: string | undefined;
    isActive: boolean;
    fte: number;
    positionId: number;
    positionLocalIdentifier?: string | undefined;
    positionTitle: string;
    positionClassification: string;
    assignmentStatus: string;
    isTemporaryCoverage: boolean;
    certificationStatus: WorkforceCertificationStatus;
    verificationReady: boolean;
    verificationBlockingReasons: string[];
    scheduledEndDate?: Date | undefined;
    scheduledEndReason?: string | undefined;
    scheduledEndReasonDescription?: string | undefined;
}

export enum WorkforceCertificationStatus {
    Unavailable = 0,
    AppropriatelyCertified = 1,
    NotAppropriatelyCertified = 2,
    NotApplicable = 3,
}

export interface WorkforceSiteEmploymentDto {
    leaSiteStaffEmploymentId: number;
    leaSiteCodeId: number;
    siteName: string;
    startDate: Date;
    endDate?: Date | undefined;
    endReasonId?: number | undefined;
    endReason?: string | undefined;
    endReasonDescription?: string | undefined;
    isActive: boolean;
    assignments: WorkforceAssignmentDto[];
}

export interface WorkforceCredentialDto {
    id: number;
    name: string;
    issueDate?: Date | undefined;
    effectiveDate?: Date | undefined;
    expirationDate?: Date | undefined;
    status?: string | undefined;
}

export interface WorkforceFingerprintCardDto {
    cardNumber?: string | undefined;
    applicationNumber?: string | undefined;
    status?: string | undefined;
    expirationDate?: Date | undefined;
}

export interface WorkforceAssignmentDetailsDto {
    staffAssignmentId: number;
    personId: number;
    leaCodeId: number;
    schoolYear: string;
    positionTitle: string;
    positionLocalIdentifier?: string | undefined;
    location: string;
    fte: number;
    startDate: Date;
    periodsTaught?: number | undefined;
    modeOfInstructionCodeId?: number | undefined;
    comments?: string | undefined;
    teacherOfRecord?: boolean | undefined;
    isTeachingPosition: boolean;
    isSpecialEducationTeachingPosition: boolean;
    modeOfInstructionOptions: WorkforceAssignmentModeOptionDto[];
}

export interface WorkforceAssignmentModeOptionDto {
    modeOfInstructionCodeId: number;
    code: string;
    description: string;
}

export interface CorrectWorkforceAssignmentDatesCommand {
    leaCodeId: number;
    staffPositionId: number;
    staffAssignmentId: number;
    schoolYear: string;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
}

export interface SaveWorkforceEmploymentDetailsCommand {
    leaCodeId: number;
    personId: number;
    schoolYear: string;
    leaStaffEmploymentId?: number | undefined;
    leaSiteStaffEmploymentId?: number | undefined;
    startDate?: Date | undefined;
}

export interface SaveWorkforceAssignmentDetailsCommand {
    leaCodeId: number;
    personId: number;
    staffAssignmentId: number;
    schoolYear: string;
    fte?: number | undefined;
    startDate?: Date | undefined;
    periodsTaught?: number | undefined;
    modeOfInstructionCodeId?: number | undefined;
    comments?: string | undefined;
    teacherOfRecord?: boolean | undefined;
}

export interface WorkforceAssignmentEndOptionsDto {
    staffAssignmentId: number;
    canEndLeaEmployment: boolean;
    positionOutcome: string;
    schoolYear: string;
    schoolYearLabel: string;
    asOfDate: Date;
    schoolYearStart: Date;
    staffPositionId: number;
    positionLocalIdentifier?: string | undefined;
    positionTitle: string;
    location: string;
    startDate: Date;
    fte: number;
    reasons: WorkforceAssignmentEndReasonDto[];
}

export interface EndWorkforceAssignmentCommand {
    leaCodeId: number;
    personId: number;
    staffAssignmentId: number;
    schoolYear: string;
    endDate?: Date | undefined;
    rosterRemovalReasonId?: number | undefined;
}

export interface WorkforceDepartureScheduleOptionsDto {
    staffAssignmentId: number;
    leaSiteStaffEmploymentId?: number | undefined;
    assignments: WorkforceDepartureScheduleOptionsDto[];
    schoolYear: string;
    schoolYearLabel: string;
    asOfDate: Date;
    latestScheduledEndDate: Date;
    staffPositionId: number;
    positionLocalIdentifier?: string | undefined;
    positionTitle: string;
    location: string;
    startDate: Date;
    fte: number;
    reasons: WorkforceAssignmentEndReasonDto[];
    scheduledEndDate?: Date | undefined;
    scheduledEndReason?: string | undefined;
    scheduledEndReasonDescription?: string | undefined;
}

export interface ScheduleWorkforceDepartureCommand {
    leaCodeId: number;
    personId: number;
    staffAssignmentId: number;
    leaSiteStaffEmploymentId?: number | undefined;
    schoolYear: string;
    scheduledEndDate?: Date | undefined;
    rosterRemovalReasonId?: number | undefined;
}

export interface CancelWorkforceDepartureCommand {
    leaCodeId: number;
    personId: number;
    staffAssignmentId: number;
    leaSiteStaffEmploymentId?: number | undefined;
    schoolYear: string;
}

export interface WorkforceEmploymentEndPreviewDto {
    leaSiteStaffEmploymentId?: number | undefined;
    siteName: string;
    siteStartDate?: Date | undefined;
    leaStaffEmploymentId?: number | undefined;
    isLeaEmployment: boolean;
    schoolYear: string;
    schoolYearLabel: string;
    asOfDate: Date;
    schoolYearStart: Date;
    leaName: string;
    leaEmploymentStartDate: Date;
    endingSiteEmployments: WorkforceEmploymentEndSiteDto[];
    endingAssignments: WorkforceEmploymentEndAssignmentDto[];
    retainedSiteEmployments: WorkforceEmploymentEndRetainedSiteDto[];
    retainedLeaAssignmentCount: number;
    hasFutureAssignments: boolean;
    reasons: WorkforceEmploymentEndReasonDto[];
}

export interface WorkforceEmploymentEndSiteDto {
    leaSiteStaffEmploymentId: number;
    siteName: string;
    startDate: Date;
}

export interface WorkforceEmploymentEndAssignmentDto {
    staffAssignmentId: number;
    staffPositionId: number;
    positionLocalIdentifier?: string | undefined;
    positionTitle: string;
    siteName?: string | undefined;
    startDate: Date;
    fte: number;
    positionBecomesVacant: boolean;
    positionOutcome: string;
}

export interface WorkforceEmploymentEndRetainedSiteDto {
    leaSiteStaffEmploymentId: number;
    siteName: string;
    currentAssignmentCount: number;
}

export interface WorkforceEmploymentEndReasonDto {
    rosterRemovalReasonId: number;
    title: string;
    description: string;
}

export interface EndWorkforceEmploymentCommand {
    leaCodeId: number;
    personId: number;
    leaSiteStaffEmploymentId?: number | undefined;
    leaStaffEmploymentId?: number | undefined;
    schoolYear: string;
    endDate?: Date | undefined;
    rosterRemovalReasonId?: number | undefined;
}

export interface WorkforceEndedEditOptionsDto {
    kind: WorkforceEndedRecordKind;
    recordId: number;
    label: string;
    startDate: Date;
    endDate: Date;
    rosterRemovalReasonId?: number | undefined;
    rosterRemovalReason?: string | undefined;
    schoolYear: string;
    schoolYearLabel: string;
    asOfDate: Date;
    schoolYearStart: Date;
    cascadingRecordCount: number;
    reasons: WorkforceEndedEditReasonDto[];
}

export enum WorkforceEndedRecordKind {
    Assignment = 0,
    SiteEmployment = 1,
    LeaEmployment = 2,
}

export interface WorkforceEndedEditReasonDto {
    rosterRemovalReasonId: number;
    title: string;
    description: string;
}

export interface WorkforceEndedEditPreviewDto {
    kind: WorkforceEndedRecordKind;
    schoolYear: string;
    schoolYearLabel: string;
    primary: WorkforceEndedEditChangeDto;
    cascadingChanges: WorkforceEndedEditChangeDto[];
    retainedRecords: WorkforceEndedEditRetainedDto[];
    hasCurrentVerification: boolean;
    effects: string[];
}

export interface WorkforceEndedEditChangeDto {
    kind: WorkforceEndedRecordKind;
    label: string;
    startDate: Date;
    previousEndDate: Date;
    previousReason?: string | undefined;
    newEndDate: Date;
    newReason: string;
}

export interface WorkforceEndedEditRetainedDto {
    kind: WorkforceEndedRecordKind;
    label: string;
    startDate: Date;
    endDate: Date;
    reason?: string | undefined;
}

export interface GetWorkforceEndedRecordEditPreviewQuery {
    leaCodeId: number;
    personId: number;
    schoolYear: string;
    staffAssignmentId?: number | undefined;
    leaSiteStaffEmploymentId?: number | undefined;
    leaStaffEmploymentId?: number | undefined;
    endDate?: Date | undefined;
    rosterRemovalReasonId?: number | undefined;
}

export interface EditEndedWorkforceRecordCommand {
    leaCodeId: number;
    personId: number;
    schoolYear: string;
    staffAssignmentId?: number | undefined;
    leaSiteStaffEmploymentId?: number | undefined;
    leaStaffEmploymentId?: number | undefined;
    endDate?: Date | undefined;
    rosterRemovalReasonId?: number | undefined;
}

export interface WorkforceNonReturnPreviewDto {
    isLeaScope: boolean;
    leaStaffEmploymentId: number;
    leaSiteStaffEmploymentId?: number | undefined;
    personName: string;
    leaName: string;
    siteName?: string | undefined;
    schoolYear: string;
    schoolYearLabel: string;
    boundaryDate: Date;
    ineligibleReason?: string | undefined;
    endingSiteEmployments: WorkforceNonReturnSiteEndingDto[];
    assignmentsToDelete: WorkforceRemovedAssignmentDto[];
    willDeleteExperience: boolean;
    retainedExperienceRowCount: number;
    remainingAssignmentsElsewhere: string[];
    retainedSiteEmployments: string[];
    retainedLeaAssignmentCount: number;
    confirmationLabel: string;
    reasons: WorkforceNonReturnReasonDto[];
}

export interface WorkforceNonReturnSiteEndingDto {
    leaSiteStaffEmploymentId: number;
    siteName: string;
}

export interface WorkforceRemovedAssignmentDto {
    staffAssignmentId: number;
    staffPositionId: number;
    positionLocalIdentifier?: string | undefined;
    positionTitle: string;
    siteName?: string | undefined;
    startDate: Date;
    endDate?: Date | undefined;
    fte: number;
    isCarriedForward: boolean;
    isEnded: boolean;
    positionBecomesVacant: boolean;
}

export interface WorkforceNonReturnReasonDto {
    rosterRemovalReasonId: number;
    title: string;
    description: string;
}

export interface CorrectWorkforceNonReturnCommand {
    leaCodeId: number;
    personId: number;
    schoolYear: string;
    leaStaffEmploymentId?: number | undefined;
    leaSiteStaffEmploymentId?: number | undefined;
    rosterRemovalReasonId?: number | undefined;
    confirmNonReturn: boolean;
}

export interface WorkforceErroneousEntryPreviewDto {
    staffAssignmentId?: number | undefined;
    isLeaScope: boolean;
    leaStaffEmploymentId: number;
    leaSiteStaffEmploymentId?: number | undefined;
    personName: string;
    leaName: string;
    siteName?: string | undefined;
    schoolYear: string;
    schoolYearLabel: string;
    employmentStartDate: Date;
    ineligibleReason?: string | undefined;
    deletedSiteEmployments: WorkforceErroneousEntrySiteDto[];
    assignmentsToDelete: WorkforceRemovedAssignmentDto[];
    willDeleteExperience: boolean;
    remainingAssignmentsElsewhere: string[];
    retainedSiteEmployments: string[];
    retainedLeaAssignmentCount: number;
    confirmationLabel: string;
}

export interface WorkforceErroneousEntrySiteDto {
    leaSiteStaffEmploymentId: number;
    siteName: string;
    startDate: Date;
}

export interface DeleteErroneousWorkforceAssignmentCommand {
    leaCodeId: number;
    personId: number;
    schoolYear: string;
    staffAssignmentId: number;
    confirmEnteredInError: boolean;
}

export interface DeleteErroneousWorkforceEmploymentCommand {
    leaCodeId: number;
    personId: number;
    schoolYear: string;
    leaStaffEmploymentId?: number | undefined;
    leaSiteStaffEmploymentId?: number | undefined;
    confirmEnteredInError: boolean;
}

export interface WorkforceTransferOptionsDto {
    staffAssignmentId: number;
    schoolYear: string;
    schoolYearLabel: string;
    asOfDate: Date;
    schoolYearStart: Date;
    leaSiteStaffEmploymentId?: number | undefined;
    leaSiteCodeId?: number | undefined;
    siteName?: string | undefined;
    leavingEndsSourceSiteEmployment: boolean;
    sourceStaffPositionId: number;
    sourcePositionLocalIdentifier?: string | undefined;
    sourcePositionTitle: string;
    sourceStartDate: Date;
    sourceFte: number;
    sourceIsTeaching: boolean;
    sourcePeriodsTaught?: number | undefined;
    sourceModeOfInstructionCodeId?: number | undefined;
    sourceComments?: string | undefined;
    sourceTeacherOfRecord?: boolean | undefined;
    sourcePositionBecomesVacant: boolean;
    locations: WorkforceTransferLocationDto[];
    destinations: WorkforceTransferDestinationDto[];
    reasons: WorkforceAssignmentEndReasonDto[];
    modes: WorkforceEmploymentOptionDto[];
}

export interface WorkforceTransferLocationDto {
    leaSiteCodeId?: number | undefined;
    name: string;
    isSourceLocation: boolean;
    activeSiteEmploymentStartDate?: Date | undefined;
}

export interface WorkforceTransferDestinationDto {
    staffPositionId: number;
    leaSiteCodeId?: number | undefined;
    positionLocalIdentifier?: string | undefined;
    positionTitle: string;
    openDate: Date;
    authorizedFte?: number | undefined;
    isTeaching: boolean;
    isSpecialEd: boolean;
    occupantStaffAssignmentId?: number | undefined;
    occupantPersonId?: number | undefined;
    occupantName?: string | undefined;
    occupantStartDate?: Date | undefined;
}

export interface TransferWorkforceAssignmentCommand {
    leaCodeId: number;
    personId: number;
    staffAssignmentId: number;
    destinationStaffPositionId?: number | undefined;
    schoolYear: string;
    effectiveDate?: Date | undefined;
    rosterRemovalReasonId?: number | undefined;
    fte?: number | undefined;
    periodsTaught?: number | undefined;
    modeOfInstructionCodeId?: number | undefined;
    comments?: string | undefined;
    teacherOfRecord?: boolean | undefined;
    occupantStaffAssignmentId?: number | undefined;
    confirmOccupantEnding: boolean;
    occupantEndDate?: Date | undefined;
    occupantRosterRemovalReasonId?: number | undefined;
}

export interface SaveWorkforceWorkEmailCommand {
    leaCodeId: number;
    personId: number;
    schoolYear: string;
    workEmail: string;
}

export interface SaveWorkforceAnnualStaffDetailsCommand {
    leaCodeId: number;
    personId: number;
    schoolYear: string;
    workEmail: string;
    teachingYears?: number | undefined;
    administrativeYears?: number | undefined;
    professionalNonTeachingYears?: number | undefined;
    classifiedYears?: number | undefined;
}

export interface VerifyWorkforceRosterRecordCommand {
    leaCodeId: number;
    personId: number;
    schoolYear: string;
    attestationAccepted: boolean;
    coverageFingerprint: string;
}

export interface PageAlertManagementDto {
    pageAlertId: number;
    title: string;
    description: string;
    style: PageAlertStyle;
    startDate: Date;
    endDate?: Date | undefined;
    isActive: boolean;
    pages: string[];
    roles: string[];
}

export enum PageAlertStyle {
    Success = 0,
    Warning = 1,
    Error = 2,
    Info = 3,
}

export interface PageAlertDto {
    pageAlertId: number;
    title: string;
    description: string;
    style: PageAlertStyle;
    startDate: Date;
    endDate?: Date | undefined;
}

export interface AddPageAlertCommand {
    title?: string | undefined;
    description?: string | undefined;
    style?: PageAlertStyle | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    pages: string[];
    roles: string[];
}

export interface UpdatePageAlertCommand {
    pageAlertId: number;
    title?: string | undefined;
    description?: string | undefined;
    style?: PageAlertStyle | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    pages: string[];
    roles: string[];
}

export interface DeactivatePageAlertCommand {
    pageAlertId: number;
}

export interface ReceiptForPaymentReversalDto {
    paymentId: number;
    personId: number;
    educatorName: string;
    currentBalance: number;
    applicationDate?: Date | undefined;
    paymentDate: Date;
    totalAmountPaid: number;
    receiptNumber?: number | undefined;
    personAlertDescriptions: string[];
    paymentType: string;
    paymentReversalTypes: PaymentReversalTypeDto[];
}

export interface PaymentReversalTypeDto {
    description: string;
    paymentReversalType: PaymentReversalType;
}

export enum PaymentReversalType {
    ReturnedCheck = 0,
    CreditCardChargeBack = 1,
}

export interface GetReceiptForPaymentReversalQuery {
    receiptNumber: number;
}

export interface AddPaymentReversalCommand {
    paymentReversalType: PaymentReversalType;
    paymentId: number;
}

export interface UpdatePaymentReversalInCollectionsCommand {
    paymentReversalIds: number[];
}

export interface AddAbandonedPaymentReversalsCommand {
    paymentReversalIds: number[];
}

export interface AddReturnedCheckLetterDocumentCommand {
    personId: number;
    paymentId: number;
}

export interface SaveRedepositPaymentInformationCommand {
    personId: number;
    paymentReversalId: number;
    paymentId: number;
    paymentTypeCodeId: number;
    referenceNumber?: string | undefined;
    amountCollected: number;
    amountOwed: number;
}

export interface PaymentReversalForRedepositDto {
    paymentReversalId: number;
    amount: number;
    paymentId: number;
    description: string;
}

export interface PaymentReversalListDto {
    paymentReversals: PaymentReversalDto[];
    totalRecords: number;
}

export interface PaymentReversalDto {
    receiptDate?: Date | undefined;
    receiptNumber: number;
    ein?: string | undefined;
    name?: string | undefined;
    paymentType?: string | undefined;
    reversalAmount: number;
    paymentReversalId: number;
    paymentReversalAge: number;
    isInCollections: boolean;
    is30DaysOld: boolean;
    is90DaysOld: boolean;
    isYearOld: boolean;
}

export interface AgGridQueryModelOfPaymentReversalListDto extends AgGridQueryModelBase {
}

export interface GetCurrentPaymentReversalsQuery extends AgGridQueryModelOfPaymentReversalListDto {
}

export interface PaymentReversalQuickFilterCountsDto {
    thirtyDaysOldCount: number;
    ninetyDaysOldCount: number;
    yearOldCount: number;
    inCollectionsCount: number;
}

export interface PaymentsCollectedReportOperatorsDto {
    userId: number;
    fullName: string;
}

export interface PaymentCollectedByLocationDto {
    locationName: string;
    users: PaymentCollectedByUserDto[];
}

export interface PaymentCollectedByUserDto {
    userName: string;
    paymentsCollected: PaymentsCollectedDto[];
}

export interface PaymentsCollectedDto {
    receiptNumber: number;
    personId: number;
    ein: string;
    educatorName: string;
    referenceNumber: string;
    paymentType: string;
    amount: number;
    createdBy: string;
    locationName: string;
    isRedeposit: boolean;
    isInCollections: boolean;
    snapPayPaymentTransactionId?: string | undefined;
    snapPayAuthorizationCode?: string | undefined;
    snapPayTransactionDate?: string | undefined;
}

export interface GetPaymentsCollectedReportQuery {
    collectedDate?: Date | undefined;
    userId?: number | undefined;
    locationCodeId?: number | undefined;
}

export interface UpdateServiceItemRefundCommand {
    paymentLineItemRefundIds: number[];
}

export interface RefundItemDto {
    receiptDate: Date;
    receiptNumber: number;
    referenceNumber?: string | undefined;
    ein?: string | undefined;
    name: string;
    paymentType: string;
    isLegacyPayment: boolean;
    paymentAmount: number;
    refundRequestDate: Date;
    refundAmount: number;
    refundReason: string;
    requestedBy: string;
    approvedBy: string;
    verifiedW9DocumentId?: number | undefined;
    paymentLineItemRefundId: number;
}

export interface AgGridQueryModelOfIListOfRefundItemDto extends AgGridQueryModelBase {
}

export interface GetRefundsToProcess extends AgGridQueryModelOfIListOfRefundItemDto {
}

export interface UpdatePaymentLineItemCreditToWaitingOnW9Command {
    paymentLineItemRefundIds: number[];
}

export interface PendingApplicationPaymentDto {
    pendingApplicationPaymentId: number;
    createdDate: Date;
    orderId: string;
    amount: number;
    email?: string | undefined;
    ein?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    address?: PendingApplicationPaymentAddressDto | undefined;
}

export interface PendingApplicationPaymentAddressDto {
    line1: string;
    line2?: string | undefined;
    city?: string | undefined;
    stateCode?: string | undefined;
    cityStateProvince?: string | undefined;
    zipCode: string;
    zipPlusFourCode?: string | undefined;
    isOutOfCountry: boolean;
}

export interface ManuallyCompletePendingApplicationPaymentsCommand {
    pendingApplicationPaymentIds: number[];
}

export interface ProfessionalDevelopmentVerificationRequestDto {
    professionalDevelopmentVerificationRequestId: number;
    personId: number;
    educatorName: string;
    ein: string;
    description: string;
    completionDate: Date;
    hours: number;
    requestDate: Date;
    personDocumentId?: number | undefined;
    supportingDocumentFileName?: string | undefined;
    status: string;
}

export interface AssignProfessionalDevelopmentVerificationRequestsCommand {
    professionalDevelopmentVerificationRequestIds: number[];
    assigneeUserId?: number | undefined;
}

export interface CreateProfessionalDevelopmentRequestCommand {
    leaCodeId: number;
    targetLeaCodeId: number;
    personId: number;
    requestDetails: string;
}

export interface EducatorSearchResultList extends PaginationDto {
    educatorSearchResults?: EducatorSearchResultDto[] | undefined;
}

export interface EducatorSearchResultDto {
    personId: number;
    educatorName: string;
    lastActivePhoneNumber?: string | undefined;
    lastActiveEmail?: string | undefined;
    dateOfBirth?: Date | undefined;
    ein: string;
    educatorStakeholderId?: string | undefined;
    ssn: string;
    phoneNumbers: CodeTableSortDto[];
    emails: CodeTableSortDto[];
    alternatePhoneNumbers: string[];
    alternateEmails: string[];
    alternateNames?: string[] | undefined;
    isPrimaryDuplicateEducator?: boolean | undefined;
    isMatchedByMergedEin?: boolean | undefined;
}

export interface CodeTableSortDto {
    value: string;
    createdDate: Date;
    isActive: boolean;
}

export interface GetEducatorSearchQuery {
    lastName?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    dateOfBirth?: Date | undefined;
    ein?: string | undefined;
    ssn?: string | undefined;
    pageNumber: number;
    pageSize: number;
    educatorStakeholderId?: string | undefined;
}

export interface EvaluatorDto {
    userId: number;
    name?: string | undefined;
}

export interface UnassignedServiceListDto {
    unassignedServicesResults: UnassignedServiceDto[];
    totalServices: number;
}

export interface UnassignedServiceSqlQueryDto {
    applicationServiceItemId: number;
    applicationId: number;
    personId: number;
    daysOld?: number | undefined;
    serviceType: string;
    itemDescription?: string | undefined;
    itemSubDescription?: string | undefined;
    ein: string;
    alerts?: string | undefined;
    isRushed: boolean;
    rushRequestedBy?: string | undefined;
    isLinked: boolean;
    qualificationPaths?: string[] | undefined;
}

export interface UnassignedServiceDto extends UnassignedServiceSqlQueryDto {
    linkedApplicationServiceItemIds: number[];
}

export interface GetUnassignedServicesQuery {
    applicationServiceItemIds?: number[] | undefined;
}

export interface AssignEvaluatorCommand {
    userId: number;
    applicationServiceItemIds: number[];
}

export interface UnassignEvaluatorCommand {
    applicationServiceItemIds: number[];
}

export interface UpdateCurrentUserAsEvaluatorCommand {
}

export interface AssignedServiceListDto {
    assignedServicesResults: AssignedServiceDto[];
    totalServices: number;
}

export interface AssignedServiceSqlQueryDto {
    applicationServiceItemId: number;
    applicationId: number;
    personId: number;
    serviceType: string;
    itemDescription?: string | undefined;
    itemSubDescription?: string | undefined;
    ein: string;
    assigneeUserId: number;
    daysOld: number;
    statusAge: number;
    holdingAge: number;
    isOnHold: boolean;
    currentStatusString: string;
    currentStatus: ServiceStatus;
    currentStatusDescription: string;
    hasMaterialsReceived: boolean;
    isReceivedStatus: boolean;
    isAdministrativeReviewStatus: boolean;
    isAdministrativeIncompleteStatus: boolean;
    isSubstantiveReviewStatus: boolean;
    isSubstantiveIncompleteStatus: boolean;
    hasDocumentMaterialsReceived: boolean;
    hasFingerprintMaterialsReceived: boolean;
    hasTestMaterialsReceived: boolean;
    hasPDVerifiedMaterialsReceived: boolean;
    hasTranscriptMaterialsReceived: boolean;
    isLinked: boolean;
    hasActiveCancellationRequest: boolean;
    hasIssuanceValidationFailureDetails: boolean;
    qualificationPathString?: string | undefined;
    evaluationPriorityString: string;
    evaluationPriority: EvaluationPriority;
    isRushed: boolean;
    rushRequestedBy?: string | undefined;
}

export interface AssignedServiceDto extends AssignedServiceSqlQueryDto {
    qualificationPaths: string[];
    linkedApplicationServiceItemIds: number[];
}

export interface GetMyServicesQuery {
    applicationServiceItemIds?: number[] | undefined;
}

export interface AdminQueueDto {
    adminQueueServicesResults: AdminServiceItemDto[];
    totalServices: number;
}

export interface AdminServiceItemSqlQueryDto {
    applicationServiceItemId: number;
    applicationId: number;
    personId: number;
    serviceType: string;
    itemDescription?: string | undefined;
    itemSubDescription?: string | undefined;
    ein: string;
    assigneeUserId?: number | undefined;
    daysOld: number;
    statusAge: number;
    holdingAge: number;
    isOnHold: boolean;
    currentStatusString: string;
    currentStatus: ServiceStatus;
    currentStatusDescription: string;
    hasAppealedStatus: boolean;
    hasFinalSIReviewStatus: boolean;
    assignedEvaluator?: string | undefined;
    isLinked: boolean;
    hasActiveCancellationRequest: boolean;
    hasIssuanceValidationFailureDetails: boolean;
    qualificationPaths?: string[] | undefined;
    evaluationPriorityString: string;
    evaluationPriority: EvaluationPriority;
    isRushed: boolean;
    rushRequestedBy?: string | undefined;
}

export interface AdminServiceItemDto extends AdminServiceItemSqlQueryDto {
    linkedApplicationServiceItemIds: number[];
}

export interface GetAdminServiceItemsQuery {
    applicationServiceItemIds?: number[] | undefined;
}

export interface ExportMyServicesToExcelQuery extends AgGridQueryModelOfByteOf {
}

export interface SurveyMonkeyWebhookEvent {
    event_type?: string | undefined;
    object_type?: string | undefined;
    object_id?: string | undefined;
    name?: string | undefined;
    filter_type?: string | undefined;
    filter_id?: string | undefined;
    event_id?: string | undefined;
    event_datetime: Date;
    resources?: SurveyMonkeyWebhookResources | undefined;
}

export interface SurveyMonkeyWebhookResources {
    collector_id?: string | undefined;
    survey_id?: string | undefined;
    user_id?: string | undefined;
}

export interface Payload {

    [key: string]: any;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}